// THIS IS A GENERATED FILE, DO NOT EDIT IT!
// Regenerate it with: kubit_id=... npm run graphql-codegen
/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigDecimal: { input: number; output: number };
  Date: { input: string; output: string };
  LocalDate: { input: string; output: string };
  Long: { input: number; output: number };
  UserAliasId: { input: string; output: string };
}

export interface IAdminNotification {
  __typename: 'AdminNotification';
  destinationTypes: Array<AdminNotificationDestinationType>;
  event: IAdminNotificationEvent;
}

export enum AdminNotificationDestinationType {
  Email = 'EMAIL',
  Slack = 'SLACK',
}

export interface IAdminNotificationEvent {
  __typename: 'AdminNotificationEvent';
  key: AdminNotificationEventKey;
  name: Scalars['String']['output'];
}

export enum AdminNotificationEventKey {
  AllowedDomainsSettings = 'ALLOWED_DOMAINS_SETTINGS',
  BracketCondition = 'BRACKET_CONDITION',
  BucketDef = 'BUCKET_DEF',
  Cohort = 'COHORT',
  FormatSettings = 'FORMAT_SETTINGS',
  Incident = 'INCIDENT',
  Measure = 'MEASURE',
  ReportSettings = 'REPORT_SETTINGS',
  Role = 'ROLE',
  Schema = 'SCHEMA',
  SchemaConnectionPassword = 'SCHEMA_CONNECTION_PASSWORD',
  User = 'USER',
  UserGroup = 'USER_GROUP',
  VirtualEvent = 'VIRTUAL_EVENT',
}

export interface IAdminNotificationInput {
  destinationTypes: Array<AdminNotificationDestinationType>;
  event: AdminNotificationEventKey;
}

export interface IAdminNotificationSettingPayload {
  __typename: 'AdminNotificationSettingPayload';
  entity: Maybe<IAdminNotificationSettings>;
  errors: Array<IError>;
}

export interface IAdminNotificationSettings {
  __typename: 'AdminNotificationSettings';
  emails: Array<Scalars['String']['output']>;
  notifications: Array<IAdminNotification>;
  slackDestination: Maybe<ISlackDestination>;
}

/** email or slackDestination should be provided according to the notifications. */
export interface IAdminNotificationSettingsInput {
  emails: Array<Scalars['String']['input']>;
  notifications: Array<IAdminNotificationInput>;
  slackDestination: InputMaybe<ISlackDestinationInput>;
}

export type IAlertThreshold = IAlertThresholdAnomaly | IAlertThresholdCustom;

export interface IAlertThresholdAnomaly {
  __typename: 'AlertThresholdAnomaly';
  kind: AlertThresholdKind;
}

export interface IAlertThresholdCompareOp {
  __typename: 'AlertThresholdCompareOp';
  display: Scalars['String']['output'];
  key: AlertThresholdCompareOpKey;
  requireComparison: Maybe<Scalars['Boolean']['output']>;
}

export enum AlertThresholdCompareOpKey {
  Above = 'ABOVE',
  Below = 'BELOW',
  DecreaseBy = 'DECREASE_BY',
  IncreaseBy = 'INCREASE_BY',
}

export interface IAlertThresholdCustom {
  __typename: 'AlertThresholdCustom';
  compareOp: IAlertThresholdCompareOp;
  compareValue: Scalars['BigDecimal']['output'];
  kind: AlertThresholdKind;
  /**  AND/OR - NULL for the last item in the list */
  logicOp: Maybe<ILogicalOperator>;
  valueIsPercent: Scalars['Boolean']['output'];
}

export interface IAlertThresholdCustomInput {
  compareOpKey: AlertThresholdCompareOpKey;
  compareValue: Scalars['BigDecimal']['input'];
  valueIsPercent: Scalars['Boolean']['input'];
}

export interface IAlertThresholdInput {
  /**  must be null if kind = ANOMALY, not null otherwise */
  customThreshold: InputMaybe<IAlertThresholdCustomInput>;
  kind: AlertThresholdKind;
  /**  logic op is NULL for the last item in the list */
  logicOp: InputMaybe<LogicalOperatorKey>;
}

export enum AlertThresholdKind {
  Anomaly = 'ANOMALY',
  Custom = 'CUSTOM',
}

export interface IAlertThresholds {
  __typename: 'AlertThresholds';
  list: Array<IAlertThreshold>;
}

export interface IAlertThresholdsInput {
  list: Array<IAlertThresholdInput>;
}

export interface IAllowedDomainSetting {
  __typename: 'AllowedDomainSetting';
  allowedDomains: Array<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  editedAt: Scalars['Date']['output'];
  editor: IUser;
}

export interface IAllowedDomainSettingEditInput {
  allowedDomains: Array<Scalars['String']['input']>;
}

export interface IAllowedDomainSettingEditPayload {
  __typename: 'AllowedDomainSettingEditPayload';
  entity: Maybe<IAllowedDomainSetting>;
  errors: Array<IError>;
}

/**  -------- Model Types -----------  */
export interface IAnalysesPaginated {
  __typename: 'AnalysesPaginated';
  entities: Array<IAnalysis>;
  pageInfo: IPageInfo;
}

export interface IAnalysesRun extends IScheduleRun {
  __typename: 'AnalysesRun';
  createdAt: Scalars['Date']['output'];
  /** Null might be returned for FAILED outcome. */
  entityUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  outcome: ScheduleRunOutcome;
  runAt: Scalars['Date']['output'];
  schedule: ISchedule;
  /**
   * Null might be returned for the below situations:
   * - FAILED outcome
   * - The creator of the entity hasn't logged in the app. (See KB-7403 for details.)
   * - ... (There might be causes.)
   */
  screenshotUrl: Maybe<Scalars['String']['output']>;
}

export interface IAnalysis {
  container: Maybe<IAnalysisContainer>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  data: IAnalysisData;
  datePicker: IDatePicker;
  definition: Scalars['String']['output'];
  description: Scalars['String']['output'];
  display: Scalars['String']['output'];
  end: Scalars['LocalDate']['output'];
  errorStatus: Maybe<AnalysisErrorStatus>;
  /**
   * Estimated analysis duration determined at submit time (in seconds).
   * Only available for running queries - to be used for progress indication,
   */
  estimatedDuration: Maybe<Scalars['Int']['output']>;
  executedAt: Scalars['Date']['output'];
  /**  Null means hide the "Export to CSV" functionality. */
  exportUrl: Maybe<Scalars['String']['output']>;
  failureMsg: Maybe<Scalars['String']['output']>;
  groupbys: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  kind: AnalysisKind;
  /**  True means live data. */
  live: Scalars['Boolean']['output'];
  /**
   * The cached (in Kobol DB) last result from a "Summarize with AI" operation.
   * Note that getting this is not protected by the feature flag, the actual mutation
   * producing these is.
   */
  llmSummary: Maybe<ILlmSubjectSummary>;
  /**  True means it cannot be further refreshed in dashboards because max days cap limit is reached. */
  locked: Scalars['Boolean']['output'];
  /**  Null means root analysis. */
  parent: Maybe<Scalars['ID']['output']>;
  pref: IAnalysisPref;
  /** Formula-specific properties */
  query: IFormula;
  /**  Id of the query template which is different with the final query(query template + input). */
  queryId: Scalars['ID']['output'];
  queryType: QueryType;
  /**
   * The SQL used to produce this result
   * Directives are not inherited by the implementors. Each implementation also needs to specify the
   * directive explicitly
   */
  referenceSql: Maybe<Scalars['String']['output']>;
  /**
   * A rich text summary/description for the report, initially generated from AI (llmSummary) response
   * but can be edited manually afterwards.
   */
  richTextSummary: Maybe<IAnalysisRichTextSummary>;
  schema: ISchema;
  start: Scalars['LocalDate']['output'];
  /**  Please specify these properties after data, status, errorStatus, executedAt and synoposis. */
  status: AnalysisStatus;
  timeUnit: TimeUnit;
}

export interface IAnalysisCancelInput {
  analysisId: Scalars['ID']['input'];
}

export interface IAnalysisCancelPayload {
  __typename: 'AnalysisCancelPayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export type IAnalysisContainer =
  | IAnalysisDashboardContainer
  | IAnalysisWorkspaceContainer;

export interface IAnalysisCopyInput {
  analysisId: Scalars['ID']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  display: InputMaybe<Scalars['String']['input']>;
  pref: InputMaybe<IAnalysisPrefInput>;
  schemaId: Scalars['String']['input'];
}

export interface IAnalysisCopyPayload {
  __typename: 'AnalysisCopyPayload';
  entity: Maybe<IAnalysis>;
  errors: Array<IError>;
}

/** If none of the parameter is specified for the customization, a copy of the original analysis will be returned. */
export interface IAnalysisCustomizeInput {
  analysisId: Scalars['ID']['input'];
  /**
   * Null, preserve the original sample percentage.
   * 100, no sampling.
   */
  samplePercentage: InputMaybe<Scalars['Int']['input']>;
}

export interface IAnalysisCustomizePayload {
  __typename: 'AnalysisCustomizePayload';
  entity: Maybe<IAnalysis>;
  errors: Array<IError>;
}

export interface IAnalysisDashboardContainer {
  __typename: 'AnalysisDashboardContainer';
  baseId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  isLatestInstance: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permission: IEntityPermission;
}

export interface IAnalysisData {
  /**
   * This field gives information if the query returned any data or not. If no data is returned by the query, this
   * field will be TRUE.
   * TRUE can be returned in the following cases:
   * - analysis status is PENDING, RUNNING, FAILED
   * - analysis status is SUCCESS and query did not return any data
   */
  isEmpty: Scalars['Boolean']['output'];
}

export interface IAnalysisDeleteSummaryRichTextInput {
  analysisId: Scalars['ID']['input'];
}

export interface IAnalysisDeleteSummaryRichTextPayload {
  __typename: 'AnalysisDeleteSummaryRichTextPayload';
  entity: Maybe<Scalars['String']['output']>;
  errors: Array<IError>;
}

export enum AnalysisErrorStatus {
  /**  cannot upgrade named entities */
  EntityUpgradeError = 'ENTITY_UPGRADE_ERROR',
  /**  error from some service we depend on, like picon/screenshot/S3 */
  ServiceError = 'SERVICE_ERROR',
  /**  query SQL syntax error (from the warehouse) */
  SqlError = 'SQL_ERROR',
  /**  query timeout */
  Timeout = 'TIMEOUT',
  /**  unexpected failure (e.g. Kobol bug), shouldn't have (m)any of these */
  Unexpected = 'UNEXPECTED',
  /**  different (than timeout and SQL syntax) query error */
  Unknown = 'UNKNOWN',
}

export interface IAnalysisFilter {
  expressionFilter: InputMaybe<IExpressionFilterInput>;
  funnelFilter: InputMaybe<IFunnelFilterInput>;
}

export interface IAnalysisInfoInput {
  analysisId: Scalars['ID']['input'];
  /**  Optional */
  description: Scalars['String']['input'];
  /**  Optional */
  display: Scalars['String']['input'];
}

export interface IAnalysisInfoPayload {
  __typename: 'AnalysisInfoPayload';
  entity: Maybe<Scalars['String']['output']>;
  errors: Array<IError>;
}

export enum AnalysisKind {
  Base = 'BASE',
  Groupby = 'GROUPBY',
}

export interface IAnalysisPref {
  __typename: 'AnalysisPref';
  aliasReplacements: Array<IUserAliasReplacement>;
  /**  If empty, show default display. */
  chartPref: Scalars['String']['output'];
}

export interface IAnalysisPrefInput {
  aliases: InputMaybe<Array<IUserAliasPrefInput>>;
  chartPref: InputMaybe<Scalars['String']['input']>;
}

export interface IAnalysisPrepareCohort {
  __typename: 'AnalysisPrepareCohort';
  analysis: IAnalysis;
  expressionMeasure: Maybe<IMeasure>;
}

export interface IAnalysisPrepareCohortBreakdownInput {
  globalFilterSliceKeys: InputMaybe<Array<Scalars['String']['input']>>;
  removeAllBreakdowns: Scalars['Boolean']['input'];
}

export interface IAnalysisPrepareCohortInput {
  analysisId: Scalars['ID']['input'];
  breakdownEdit: InputMaybe<IAnalysisPrepareCohortBreakdownInput>;
  expressionCohort: InputMaybe<IExpressionPrepareCohortInput>;
  schema: Scalars['String']['input'];
}

export interface IAnalysisPrepareCohortPayload {
  __typename: 'AnalysisPrepareCohortPayload';
  entity: Maybe<IAnalysisPrepareCohort>;
  errors: Array<IError>;
}

export interface IAnalysisRichTextSummary {
  __typename: 'AnalysisRichTextSummary';
  richText: IRichText;
  showInDashboard: Scalars['Boolean']['output'];
}

export interface IAnalysisScheduleEntity {
  __typename: 'AnalysisScheduleEntity';
  alertThresholds: IAlertThresholds;
  item: IAnalysis;
}

export interface IAnalysisSetPrefInput {
  analysisId: Scalars['ID']['input'];
  pref: IAnalysisPrefInput;
}

export interface IAnalysisSetPrefPayload {
  __typename: 'AnalysisSetPrefPayload';
  entity: Maybe<Scalars['String']['output']>;
  errors: Array<IError>;
}

export interface IAnalysisSetShowSummaryInDashboardInput {
  analysisId: Scalars['ID']['input'];
  showInDashboard: Scalars['Boolean']['input'];
}

export interface IAnalysisSetShowSummaryInDashboardPayload {
  __typename: 'AnalysisSetShowSummaryInDashboardPayload';
  entity: Maybe<Scalars['String']['output']>;
  errors: Array<IError>;
}

export interface IAnalysisSetSummaryRichTextInput {
  analysisId: Scalars['ID']['input'];
  richText: Scalars['String']['input'];
}

export interface IAnalysisSetSummaryRichTextPayload {
  __typename: 'AnalysisSetSummaryRichTextPayload';
  entity: Maybe<Scalars['String']['output']>;
  errors: Array<IError>;
}

/**  for PENDING, RUNNING and FAILED data will be empty. */
export enum AnalysisStatus {
  /**  Analysis execution is cancelled by user. */
  Cancelled = 'CANCELLED',
  /**  Failed to analyze the analysis. */
  Failed = 'FAILED',
  /**  The analysis hasn't been analyzed. To start it, invoke the analysis api. */
  Pending = 'PENDING',
  /**  The analysis is being analyzed. Please wait for several minutes. */
  Running = 'RUNNING',
  /**  The analysis was analyzed successfully and the data is ready. */
  Success = 'SUCCESS',
}

export interface IAnalysisVisit {
  __typename: 'AnalysisVisit';
  /** Analysis creation time */
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  description: Scalars['String']['output'];
  display: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  queryType: QueryType;
  status: AnalysisStatus;
  visitedAt: Scalars['Date']['output'];
}

export interface IAnalysisVisitInput {
  analysisId: Scalars['ID']['input'];
}

export interface IAnalysisVisitPayload {
  __typename: 'AnalysisVisitPayload';
  errors: Array<IError>;
  visit: Maybe<IAnalysisVisit>;
}

export interface IAnalysisVisitsPaginated {
  __typename: 'AnalysisVisitsPaginated';
  entities: Array<IAnalysisVisit>;
  pageInfo: IPageInfo;
}

export interface IAnalysisWorkspaceContainer {
  __typename: 'AnalysisWorkspaceContainer';
  baseId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

export interface IAnalyticsConfig {
  __typename: 'AnalyticsConfig';
  enabled: Scalars['Boolean']['output'];
  segment: Maybe<ISegmentConfig>;
}

export interface IAnnotation {
  __typename: 'Annotation';
  imageUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface IAnyEvent extends IEventValue {
  __typename: 'AnyEvent';
  kind: EventKind;
  name: Scalars['String']['output'];
}

export interface IAnyFieldValue {
  __typename: 'AnyFieldValue';
  name: Scalars['String']['output'];
}

export interface IAnyTableEvent extends IEventValue {
  __typename: 'AnyTableEvent';
  key: Scalars['String']['output'];
  kind: EventKind;
  name: Scalars['String']['output'];
}

export interface IArrayObjectContext {
  rootField: Scalars['String']['input'];
}

export interface IArrayObjectPredicate {
  __typename: 'ArrayObjectPredicate';
  elementPredicates: Array<ISimplePredicate>;
}

export interface IArrayObjectPredicateInput {
  /**
   * Filters for the object by its properties. Fields are supposed to be nested fields and every field path should
   * contain the root field.
   */
  elementPredicates: Array<ISimplePredicateInput>;
}

export interface IAttribution {
  __typename: 'Attribution';
  key: AttributionKey;
  name: Scalars['String']['output'];
}

export enum AttributionKey {
  First = 'FIRST',
  Linear = 'LINEAR',
}

export enum AuthType {
  UserPassword = 'USER_PASSWORD',
  UserPrivateKey = 'USER_PRIVATE_KEY',
}

export interface IAvailableRetentionUnit {
  __typename: 'AvailableRetentionUnit';
  cohortUnit: TimeUnit;
  retentionUnits: Array<TimeUnit>;
}

export interface IBasicBucketDef {
  __typename: 'BasicBucketDef';
  buckets: Array<IBucket>;
  enumBucketField: Maybe<IField>;
  enumBucketSplitOthers: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  kind: BucketKind;
  type: BucketDefType;
}

export interface IBasicBucketDefInput {
  bucketsKind: BucketKind;
  dateBuckets: InputMaybe<Array<IDateBucketInput>>;
  enumBucketField: InputMaybe<Scalars['String']['input']>;
  enumBucketSchemaId: InputMaybe<Scalars['ID']['input']>;
  enumBucketSplitOthers: InputMaybe<Scalars['Boolean']['input']>;
  enumBuckets: InputMaybe<Array<IEnumBucketInput>>;
  /**  one of these below must be set */
  rangeBuckets: InputMaybe<Array<IRangeBucketInput>>;
}

export interface IBasicCohortInput {
  compoundCohort: InputMaybe<IBasicCompoundCohortInput>;
  simpleCohort: InputMaybe<IBasicSimpleCohortInput>;
  /**
   * The type will decide which cohort input is picked.
   * For example, if type is SIMPLE, simpleCohort will be picked.
   */
  type: CohortType;
}

export interface IBasicCompoundCohortInput {
  logicOps: Array<LogicalOperatorKey>;
  simpleCohorts: Array<ISimpleCohortInput>;
}

export interface IBasicCompoundMeasureInput {
  formula: InputMaybe<Scalars['String']['input']>;
  measures: Array<ISimpleMeasureInput>;
}

export interface IBasicConnectionInput {
  authType: InputMaybe<AuthType>;
  jdbcUrl: Scalars['String']['input'];
  password: InputMaybe<Scalars['String']['input']>;
  privateKey: InputMaybe<IPrivateKeyInput>;
  strategy: StrategyKind;
  timeout: InputMaybe<Scalars['Int']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
}

export interface IBasicConnectionMeta {
  __typename: 'BasicConnectionMeta';
  authType: Maybe<AuthType>;
  jdbcUrl: Scalars['String']['output'];
  strategy: StrategyKind;
  timeout: Maybe<Scalars['Int']['output']>;
  username: Maybe<Scalars['String']['output']>;
}

/**  This is a special EventCondition which can hold only basic events. */
export interface IBasicEventCondition {
  __typename: 'BasicEventCondition';
  events: Array<IBasicEventValue>;
  field: Maybe<IField>;
  filter: Maybe<IFilter>;
}

export interface IBasicEventConditionInput {
  events: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filter: InputMaybe<IFilterInput>;
}

export interface IBasicEventEditCategoryInput {
  basicEventKeys: Array<Scalars['String']['input']>;
  categoryIds: Array<Scalars['ID']['input']>;
  schema: Scalars['String']['input'];
}

export interface IBasicEventEditCategoryPayload {
  __typename: 'BasicEventEditCategoryPayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IBasicEventRenameInput {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  schema: Scalars['String']['input'];
}

export interface IBasicEventRenamePayload {
  __typename: 'BasicEventRenamePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IBasicEventToggleInput {
  disabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  schema: Scalars['String']['input'];
}

export interface IBasicEventTogglePayload {
  __typename: 'BasicEventTogglePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IBasicEventUpdateDescriptionInput {
  basicEventKey: Scalars['String']['input'];
  description: Scalars['String']['input'];
  schema: Scalars['String']['input'];
}

export interface IBasicEventUpdateDescriptionPayload {
  __typename: 'BasicEventUpdateDescriptionPayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IBasicEventValue extends IEventValue {
  __typename: 'BasicEventValue';
  categories: Array<IEntityCategory>;
  isFavorite: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  kind: EventKind;
  tableNames: Array<Scalars['String']['output']>;
  value: IBasicFieldValue;
}

export interface IBasicExpressionCohortInput {
  analysisId: Scalars['ID']['input'];
  measureId: InputMaybe<Scalars['ID']['input']>;
  operator: ExpressionCohortOperatorKey;
  operatorValues: Array<Scalars['BigDecimal']['input']>;
  percentileFilter: InputMaybe<IPercentileFilterInput>;
}

export interface IBasicFieldValue {
  __typename: 'BasicFieldValue';
  description: Maybe<Scalars['String']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface IBasicFilter extends IFilter {
  __typename: 'BasicFilter';
  conditions: Array<ICondition>;
  logicOps: Array<ILogicalOperator>;
  type: FilterType;
}

export interface IBasicFilterInput {
  conditions: InputMaybe<Array<InputMaybe<IConditionInput>>>;
  logicOps: InputMaybe<Array<InputMaybe<LogicalOperatorKey>>>;
}

export interface IBasicFunnelCohortInput {
  analysisId: Scalars['ID']['input'];
  /**
   * Optional configuration that is applicable only for cohorts with fixed cohort date where the reference funnel report
   * does not use Partition Day.
   * The value of the property should always be less or equal to the fixed cohort date.
   */
  durationStartDate: InputMaybe<Scalars['LocalDate']['input']>;
  /**
   * Required when operator is reference funnel report does not use partition Day. Specifies a window length in days
   * which will be used to extend the date range in the reference funnel starting from the selected fixed cohort date.
   */
  lookForwardWindow: InputMaybe<Scalars['Int']['input']>;
  operator: FunnelCohortOperatorKey;
  /**
   * When operator = CONVERTED_ON, values >= 0;
   * When operator = DROP_XX, values >= 1.
   */
  operatorValues: Array<Scalars['Int']['input']>;
  timeToConvert: InputMaybe<ITimeToConvertInput>;
}

export interface IBasicMeasureCohortInput {
  measure: IMeasureInput;
  operator: MeasureCohortOperatorKey;
  operatorValues: Array<Scalars['BigDecimal']['input']>;
  percentileFilter: InputMaybe<IPercentileFilterInput>;
}

export interface IBasicMeasureInput {
  compound: InputMaybe<IBasicCompoundMeasureInput>;
  format: InputMaybe<IMeasureDisplayFormatInput>;
  rollingControl: InputMaybe<IRollingControlInput>;
  simple: InputMaybe<IBasicSimpleMeasureInput>;
  type: MeasureType;
}

export interface IBasicPerformedCohortInput {
  eventConditions: Array<IEventConditionInput>;
  operator: PerformedCohortOperatorKey;
  operatorValues: Array<Scalars['Int']['input']>;
}

export interface IBasicRetentionCohortInput {
  analysisId: InputMaybe<Scalars['ID']['input']>;
  /**
   * Optional configuration that is applicable only for cohorts with fixed cohort date where the reference retention
   * report has Attribution First.
   * The value of the property should always be less or equal to the fixed cohort date.
   */
  durationStartDate: InputMaybe<Scalars['LocalDate']['input']>;
  /**
   * Required when operator is one of RETAINED_SINCE, NOT_RETAINED_SINCE, RETAINED, NOT_RETAINED, RETURNED.
   * Specifies a window length which will be used to compute the max extension window length for the reference report
   * used in the retention cohort.
   */
  lookForwardWindow: InputMaybe<Scalars['Int']['input']>;
  /** When operator = RETAINED_XXX/NOT_RETAINED_XXX, time window must be OVERALL. */
  operator: RetentionCohortOperatorKey;
  operatorValues: Array<Scalars['Int']['input']>;
  /** Required when operator is RETURNED. */
  returnedOperator: InputMaybe<RelationalOperatorKey>;
}

export interface IBasicSimpleCohortInput {
  /** Optional configuration on cohort absolute date range computation. */
  datePicker: InputMaybe<IDatePickerInput>;
  expressionCohort: InputMaybe<IBasicExpressionCohortInput>;
  filter: InputMaybe<IFilterInput>;
  funnelCohort: InputMaybe<IBasicFunnelCohortInput>;
  measureCohort: InputMaybe<IBasicMeasureCohortInput>;
  performedCohort: InputMaybe<IBasicPerformedCohortInput>;
  retentionCohort: InputMaybe<IBasicRetentionCohortInput>;
  /** Required. Null is just for backward compatibility. */
  subject: Scalars['String']['input'];
  timeWindow: TimeWindowKey;
  timeWindowValues: Array<Scalars['Int']['input']>;
  /**
   * The type will decide which cohort input is picked.
   * For example, if type is PERFORMED, performedInput will be picked.
   */
  type: SimpleCohortTypeKey;
}

export interface IBasicSimpleMeasureInput {
  eventConditions: InputMaybe<Array<InputMaybe<IEventConditionInput>>>;
  formula: InputMaybe<Scalars['String']['input']>;
  function: InputMaybe<Scalars['String']['input']>;
  percentile: InputMaybe<Scalars['Float']['input']>;
}

export interface IBigQueryConnectionInput {
  account: Scalars['String']['input'];
  computeProjectId: InputMaybe<Scalars['String']['input']>;
  dataset: Scalars['String']['input'];
  keyPlain: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  timeout: Scalars['Int']['input'];
}

export interface IBigQueryConnectionMeta {
  __typename: 'BigQueryConnectionMeta';
  account: Scalars['String']['output'];
  computeProjectId: Maybe<Scalars['String']['output']>;
  dataset: Scalars['String']['output'];
  jdbcUrl: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  strategy: StrategyKind;
  timeout: Maybe<Scalars['Int']['output']>;
}

export interface IBrazeCohortImportInput {
  cohortId: InputMaybe<Scalars['ID']['input']>;
  end: InputMaybe<Scalars['LocalDate']['input']>;
  start: InputMaybe<Scalars['LocalDate']['input']>;
}

export interface IBrazeCohortImportPayload {
  __typename: 'BrazeCohortImportPayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IBrazeCohortImportRun extends IScheduleRun {
  __typename: 'BrazeCohortImportRun';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  importedUsers: Scalars['Int']['output'];
  outcome: ScheduleRunOutcome;
  runAt: Scalars['Date']['output'];
  schedule: ISchedule;
}

export interface IBreakdown {
  __typename: 'Breakdown';
  cohortRefs: Array<ICohortRef>;
  groupbys: Array<IBreakdownField>;
  order: Order;
  overall: Scalars['Boolean']['output'];
}

/**  -------- Model Types -----------  */
export interface IBreakdownConfig {
  __typename: 'BreakdownConfig';
  defaultOrder: Order;
  orders: Array<Order>;
}

export interface IBreakdownCriteria {
  __typename: 'BreakdownCriteria';
  controlGroup: Scalars['String']['output'];
  field: IField;
  variants: Array<Scalars['String']['output']>;
}

export interface IBreakdownCriteriaInput {
  control: Scalars['String']['input'];
  fieldKey: Scalars['String']['input'];
  variants: Array<Scalars['String']['input']>;
}

export interface IBreakdownField {
  __typename: 'BreakdownField';
  bucketDef: Maybe<IBucketDef>;
  field: IField;
  /**
   *  A single predicate can be attached to a breakdown. The predicate will have the
   *  same field as the breakdown.
   */
  predicate: Maybe<IPredicate>;
}

export interface IBreakdownFieldInput {
  /**  Optional. Null means no bucketing. */
  bucketDefInput: InputMaybe<IBucketDefInput>;
  field: InputMaybe<Scalars['String']['input']>;
  /**
   *  Optional predicate (breakdown filter). The predicate field MUST be the same as
   *  the breakdown field. Server will throw an error otherwise.
   */
  predicate: InputMaybe<IPredicateInput>;
}

export interface IBreakdownInput {
  /**  At most five cohorts for now. Cohorts must have the same subject. */
  cohortRefs: Array<ICohortRefInput>;
  /**  At most two groupbys for now. */
  groupbys: InputMaybe<Array<InputMaybe<IBreakdownFieldInput>>>;
  order: Order;
  /**  Whether to include the base result. Default is False. */
  overall: InputMaybe<Scalars['Boolean']['input']>;
}

export type IBucket = IDateBucket | IEnumBucket | IRangeBucket;

/**  -------- Model Types -----------  */
export type IBucketDef = IBasicBucketDef | INamedBucketDef;

export interface IBucketDefInput {
  basicBucketDefInput: InputMaybe<IBasicBucketDefInput>;
  namedBucketDefInput: InputMaybe<INamedBucketDefInput>;
  type: BucketDefType;
}

export enum BucketDefType {
  Basic = 'BASIC',
  Named = 'NAMED',
}

export enum BucketKind {
  Date = 'DATE',
  Enum = 'ENUM',
  Range = 'RANGE',
}

export interface ICategory {
  __typename: 'Category';
  /**  Number of changed tags */
  badge: Scalars['Int']['output'];
  kind: TagKind;
  tags: Array<ITag>;
}

export interface ICategoryBadgeArgs {
  since: InputMaybe<Scalars['Int']['input']>;
}

export interface ICdwObjectPathComponent {
  __typename: 'CdwObjectPathComponent';
  /** This would be something like 'Schema', 'Data Set, 'Database', etc, warehouse-specific */
  displayType: Scalars['String']['output'];
  /** the actual container object name */
  name: Scalars['String']['output'];
}

export interface ICdwObjectsContainer {
  __typename: 'CdwObjectsContainer';
  /** These can be expanded/browsed further */
  containers: Array<ICdwObjectPathComponent>;
  /** The last item is the name, empty path is the 'root' list of objects */
  path: Array<ICdwObjectPathComponent>;
  /** Tables would be available for selection to include in the Model */
  tables: Array<ICdwTable>;
}

/** A Table object present in the Customer Data Warehouse. Subject to be used for inclusion in Data Model */
export interface ICdwTable {
  __typename: 'CdwTable';
  /** The (short) table name, normally unique within the database/schema/etc container */
  shortName: Scalars['String']['output'];
  /**
   * The qualified table name, the way it would be usable in SQL queries by Kobol.
   * Whether it is fully qualified or relative in the context of the schema config is up to Kobol.
   */
  sqlName: Scalars['String']['output'];
}

export interface IChannel {
  __typename: 'Channel';
  /**  Number of changed messages */
  badge: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  kind: Maybe<ChannelKind>;
  lastViewedAt: Scalars['Int']['output'];
  messages: Array<IMessage>;
  name: Scalars['String']['output'];
  /** @deprecated Obsoleted. Will be removed after KBT-450. */
  slackConfigs: Array<ISlackConfig>;
  users: Array<IUser>;
}

export interface IChannelBadgeArgs {
  since: InputMaybe<Scalars['Int']['input']>;
}

export interface IChannelMessagesArgs {
  since: InputMaybe<Scalars['Int']['input']>;
}

export interface IChannelCreateInput {
  /**  Can't create MAIN channel */
  kind: ChannelKind;
  /**  For DIRECT, use "creator name:other user name" */
  name: Scalars['String']['input'];
  /**  Including creator's user_id */
  userIds: InputMaybe<Array<Scalars['ID']['input']>>;
  wsId: Scalars['ID']['input'];
}

export interface IChannelCreatePayload {
  __typename: 'ChannelCreatePayload';
  entity: Maybe<IChannel>;
  errors: Array<IError>;
}

export enum ChannelKind {
  Direct = 'DIRECT',
  Main = 'MAIN',
}

export interface IChannelNotification {
  __typename: 'ChannelNotification';
  badge: Scalars['Int']['output'];
  channelId: Scalars['ID']['output'];
}

export interface IChannelView {
  __typename: 'ChannelView';
  channelId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
  viewedAt: Scalars['Int']['output'];
}

export interface IChannelViewInput {
  channelId: Scalars['ID']['input'];
}

export interface IChannelViewPayload {
  __typename: 'ChannelViewPayload';
  entity: Maybe<IChannelView>;
  errors: Array<IError>;
}

export interface IChartControl {
  __typename: 'ChartControl';
  /**  Default chart kind to display. */
  default: ChartKind;
  measureControls: Array<IMeasureControl>;
}

export enum ChartKind {
  Bar = 'BAR',
  ComparativeLine = 'COMPARATIVE_LINE',
  /**  Funnel */
  Funnel = 'FUNNEL',
  Geo = 'GEO',
  /**  Expression */
  Line = 'LINE',
  PercentStackedArea = 'PERCENT_STACKED_AREA',
  StackedColumn = 'STACKED_COLUMN',
}

export type ICohort =
  | ICompoundCohort
  | IExpressionCohort
  | IFunnelCohort
  | IMeasureCohort
  | IPerformedCohort
  | IRetentionCohort;

export interface ICohortCompare {
  __typename: 'CohortCompare';
  /**  Expand events: breakdown the event by the specified fields and treat them as independent steps. Up to 3 */
  expandEvents: Array<ICompareExpandEvent>;
  /** Merge events: merge several events into one on each step. Up to 3. */
  mergeEvents: Array<ICompareMergeEvent>;
}

export interface ICohortCompareInput {
  expandEvents: Array<ICompareExpandEventInput>;
  mergeEvents: Array<ICompareMergeEventInput>;
}

export interface ICohortConfig {
  __typename: 'CohortConfig';
  defaultSamplingRate: Scalars['Int']['output'];
  expressionConfig: IExpressionCohortConfig;
  funnelConfig: IFunnelCohortConfig;
  logicOps: Array<ILogicalOperator>;
  measureConfig: IMeasureCohortConfig;
  performedConfig: IPerformedCohortConfig;
  retentionConfig: IRetentionCohortConfig;
  simpleCohortTypes: Array<ISimpleCohortType>;
}

export interface ICohortDate {
  __typename: 'CohortDate';
  date: Scalars['String']['output'];
  interval: IDateInterval;
}

export interface ICohortExecuteConfig {
  __typename: 'CohortExecuteConfig';
  cohortConfig: ICohortConfig;
  defaultDatePicker: IDatePicker;
  /** A date which is supposed to used as the end date when there is no user selection. */
  defaultEnd: Scalars['LocalDate']['output'];
  defaultOperation: ICohortSampleOperation;
  /** A date which is supposed to used as the start date when there is no user selection. */
  defaultStart: Scalars['LocalDate']['output'];
  /** A date on/after which data is considered to be live. */
  liveStartDate: Scalars['LocalDate']['output'];
  operations: Array<ICohortSampleOperation>;
  timezone: Scalars['String']['output'];
}

export interface ICohortExecuteInput {
  cohort: ICohortInput;
  compareInput: InputMaybe<ICohortCompareInput>;
  datePicker: IDatePickerInput;
  description: InputMaybe<Scalars['String']['input']>;
  display: InputMaybe<Scalars['String']['input']>;
  /**
   * The list LLM Natural Language prompts (and response) used to generate this input. These should be
   * ordered in the reverse chronological order (i.e. newest/last message should be first)
   * Empty list if this input was not generated by a prompt.
   */
  llmChatMessages: Array<ILlmChatMessageInput>;
  /** Required for compound cohort. */
  operation: InputMaybe<CohortSampleOperationKey>;
  sampleAbsolute: InputMaybe<Scalars['Int']['input']>;
  samplePercentage: InputMaybe<Scalars['Int']['input']>;
  schemaId: Scalars['ID']['input'];
  /** Optional reference to analysis which was used as basis of this query */
  sourceId: InputMaybe<Scalars['ID']['input']>;
}

export interface ICohortExecutePayload {
  __typename: 'CohortExecutePayload';
  entity: Maybe<IAnalysis>;
  errors: Array<IError>;
}

export interface ICohortInput {
  basicCohort: InputMaybe<IBasicCohortInput>;
  namedCohort: InputMaybe<INamedCohortInput>;
  /**
   * The type will decide which cohort input is picked.
   * For example, if type is NAMED, namedCohort will be picked.
   */
  versionType: VersionType;
}

export interface ICohortNote {
  __typename: 'CohortNote';
  cohort: ICohort;
}

export interface ICohortRef {
  __typename: 'CohortRef';
  cohort: ICohort;
  props: ICohortRefProps;
}

/** A reference to a cohort in a query + additional on-demand properties. */
export interface ICohortRefInput {
  cohort: ICohortInput;
  props: ICohortRefPropsInput;
}

export interface ICohortRefProps {
  __typename: 'CohortRefProps';
  dateRange: Maybe<IDateRange>;
  samplePercentage: Scalars['Int']['output'];
}

export interface ICohortRefPropsInput {
  datePicker: InputMaybe<IDatePickerInput>;
  /** Sample the subjects by percentage between 0 ~ 100. */
  samplePercentage: Scalars['Int']['input'];
}

export interface ICohortSample extends IAnalysis {
  __typename: 'CohortSample';
  container: Maybe<IAnalysisContainer>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  /**  Override data type from interface. */
  data: ICohortSampleData;
  datePicker: IDatePicker;
  definition: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diagnosable: Scalars['Boolean']['output'];
  display: Scalars['String']['output'];
  end: Scalars['LocalDate']['output'];
  errorStatus: Maybe<AnalysisErrorStatus>;
  /**
   * Estimated analysis duration determined at submit time (in seconds).
   * Only available for running queries - to be used for progress indication,
   */
  estimatedDuration: Maybe<Scalars['Int']['output']>;
  executedAt: Scalars['Date']['output'];
  exportUrl: Maybe<Scalars['String']['output']>;
  failureMsg: Maybe<Scalars['String']['output']>;
  groupbys: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  kind: AnalysisKind;
  live: Scalars['Boolean']['output'];
  llmSummary: Maybe<ILlmSubjectSummary>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<Scalars['ID']['output']>;
  pref: IAnalysisPref;
  /**  Override query type from interface. */
  query: ICohortSampleQuery;
  queryId: Scalars['ID']['output'];
  queryType: QueryType;
  /**  The SQL used to produce this result  */
  referenceSql: Maybe<Scalars['String']['output']>;
  richTextSummary: Maybe<IAnalysisRichTextSummary>;
  schema: ISchema;
  start: Scalars['LocalDate']['output'];
  status: AnalysisStatus;
  timeUnit: TimeUnit;
}

export interface ICohortSampleData extends IAnalysisData {
  __typename: 'CohortSampleData';
  isEmpty: Scalars['Boolean']['output'];
  live: Scalars['Boolean']['output'];
  subjectName: Scalars['String']['output'];
  summary: Maybe<ICohortSampleDataSummary>;
  tables: Array<ICohortSampleTable>;
}

export interface ICohortSampleDataSummary {
  __typename: 'CohortSampleDataSummary';
  number: Scalars['Float']['output'];
  text: Scalars['String']['output'];
}

export interface ICohortSampleOperation {
  __typename: 'CohortSampleOperation';
  key: CohortSampleOperationKey;
  /** When building the compound cohort, please use the key of this logical operator in the BasicCompoundCohortInput. */
  logicOp: ILogicalOperator;
  name: Scalars['String']['output'];
}

export enum CohortSampleOperationKey {
  And = 'AND',
  Compare = 'COMPARE',
  Or = 'OR',
}

export interface ICohortSampleQuery extends IFormula {
  __typename: 'CohortSampleQuery';
  cohort: ICohort;
  /**  Defined when operation is Compare  */
  compare: Maybe<ICohortCompare>;
  dateRange: Maybe<IDateRange>;
  /**
   * Will contain the Natural Language conversation used to populate this Formula builder. The messages
   * would be ordered the same way they were sent by Caprica in the CohortExecuteInput which should be -
   * newest first.
   * Empty list if this formula was not created with the help of a LLM.
   */
  llmChatMessages: Array<ILlmChatMessage>;
  /** Defined for compound cohort. */
  operation: Maybe<ICohortSampleOperation>;
  sampleAbsolute: Maybe<Scalars['Int']['output']>;
  samplePercentage: Maybe<Scalars['Int']['output']>;
  schema: ISchema;
}

export interface ICohortSampleTable {
  __typename: 'CohortSampleTable';
  /** @deprecated to be removed - start using summary field to construct the text to be displayed */
  caption: ICohortSampleTableCaption;
  columns: Array<ICohortSampleTableColumn>;
  summary: ICohortSampleTableSummary;
}

/**  TODO Will be dropped next release */
export interface ICohortSampleTableCaption {
  __typename: 'CohortSampleTableCaption';
  caption: Maybe<Scalars['String']['output']>;
}

export interface ICohortSampleTableCell {
  __typename: 'CohortSampleTableCell';
  value: Scalars['String']['output'];
}

export interface ICohortSampleTableColumn {
  __typename: 'CohortSampleTableColumn';
  cells: Array<ICohortSampleTableCell>;
  columnType: CohortSampleTableColumnType;
  header: ICohortSampleTableHeader;
}

export enum CohortSampleTableColumnType {
  Number = 'NUMBER',
  Ratio = 'RATIO',
  Text = 'TEXT',
}

export interface ICohortSampleTableHeader {
  __typename: 'CohortSampleTableHeader';
  header: Scalars['String']['output'];
  subheader: Maybe<Scalars['String']['output']>;
  tooltip: Scalars['String']['output'];
}

export interface ICohortSampleTableSummary {
  __typename: 'CohortSampleTableSummary';
  tableSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
}

export interface ICohortSampleTemplate {
  __typename: 'CohortSampleTemplate';
  datePicker: IDatePicker;
  end: Scalars['LocalDate']['output'];
  query: ICohortSampleQuery;
  start: Scalars['LocalDate']['output'];
}

/**  Rename to CohortBrazeExportScheduleEntity. */
export interface ICohortScheduleEntity {
  __typename: 'CohortScheduleEntity';
  brazeRemoveOutdated: Scalars['Boolean']['output'];
  item: ICohort;
}

export interface ICohortStartRow {
  __typename: 'CohortStartRow';
  cohortStart: IRetentionCohortStart;
  returnIntervals: Array<IRetentionInterval>;
  rowIndices: Array<Scalars['Int']['output']>;
}

export enum CohortType {
  Compound = 'COMPOUND',
  Simple = 'SIMPLE',
}

export type IColumnDefinitionMeta =
  | IMappedStringDefinitionMeta
  | IRawSqlDefinitionMeta;

export interface IColumnDefinitionMetas {
  __typename: 'ColumnDefinitionMetas';
  list: Array<IColumnDefinitionMeta>;
  tableKey: Scalars['String']['output'];
}

/**  ---- input types */
export interface IColumnWithTypeInput {
  column: Scalars['String']['input'];
  typeInput: IDataModelFieldTypeInput;
}

export interface IComment {
  __typename: 'Comment';
  attachedImageEmbed: Maybe<IImageEmbed>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  mentions: Array<IUser>;
  message: Maybe<IRichText>;
  reactions: Array<ICommentReaction>;
}

export interface ICommentImageEmbedAddPayload {
  __typename: 'CommentImageEmbedAddPayload';
  errors: Array<IError>;
  uploadConfig: Maybe<IConversationThreadCommentImageEmbedUploadConfig>;
}

export interface ICommentInput {
  attachedImageEmbedId: InputMaybe<Scalars['ID']['input']>;
  message: InputMaybe<IRichTextInput>;
}

export interface ICommentReaction {
  __typename: 'CommentReaction';
  emojiKey: Scalars['String']['output'];
  users: Array<IUser>;
}

export interface ICommentReactionAddInput {
  commentId: Scalars['ID']['input'];
  emojiKey: Scalars['String']['input'];
  entity: IConversationEntityInput;
  threadId: Scalars['ID']['input'];
}

export interface ICommentReactionDeleteInput {
  commentId: Scalars['ID']['input'];
  emojiKey: Scalars['String']['input'];
  entity: IConversationEntityInput;
  threadId: Scalars['ID']['input'];
}

export interface ICompareExpandEvent {
  __typename: 'CompareExpandEvent';
  eventCondition: IEventCondition;
  /** Which event field should be included in expansion */
  field: IField;
}

export interface ICompareExpandEventInput {
  eventCondition: IEventConditionInput;
  field: Scalars['String']['input'];
}

export interface ICompareMergeEvent {
  __typename: 'CompareMergeEvent';
  /** Condition which has to be met for the event to be merged. Null if no condition */
  eventConditions: Array<IEventCondition>;
  isNameAutoGenerated: Scalars['Boolean']['output'];
  /** The name (alias) of the merged event. By default it is '<first event> (+X events)' */
  name: Scalars['String']['output'];
}

export interface ICompareMergeEventInput {
  eventConditions: Array<IEventConditionInput>;
  name: InputMaybe<Scalars['String']['input']>;
}

export interface IComparisonConfig {
  __typename: 'ComparisonConfig';
  offset: Scalars['Long']['output'];
  timeUnit: TimeUnit;
}

export interface IComparisonConfigInput {
  offset: Scalars['Long']['input'];
  timeUnit: TimeUnit;
}

export interface ICompoundCohort {
  __typename: 'CompoundCohort';
  categories: Array<IEntityCategory>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  logicOps: Array<ILogicalOperator>;
  /**
   * This is either the cohort name (for NamedCohort)
   * or a Kobol-generated (breakdown) name (like Cohort 1)
   * or can be null for an anonymous BasicCohort used as a global filter.
   */
  name: Maybe<Scalars['String']['output']>;
  schema: ISchema;
  simpleCohorts: Array<ISimpleCohort>;
  userAlias: IUserAliasQueryCohort;
  version: Maybe<IVersion>;
}

export interface ICompoundMeasure {
  __typename: 'CompoundMeasure';
  categories: Array<IEntityCategory>;
  format: Maybe<IMeasureDisplayFormat>;
  formula: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  measures: Array<ISimpleMeasure>;
  name: Scalars['String']['output'];
  rollingControl: Maybe<IRollingControl>;
  schema: ISchema;
  userAlias: IUserAliasQueryMeasure;
  version: Maybe<IVersion>;
}

export interface ICompoundMeasureInput {
  basicMeasure: InputMaybe<IBasicCompoundMeasureInput>;
  namedMeasure: InputMaybe<INamedCompoundMeasureInput>;
  type: MeasureVersionType;
}

export interface ICompoundMeasureProperties {
  __typename: 'CompoundMeasureProperties';
  measures: Array<ISimpleMeasureProperties>;
  resultFilter: Maybe<IMeasureFilter>;
}

export interface ICompoundMeasurePropertiesInput {
  measures: Array<ISimpleMeasurePropertiesInput>;
  resultFilter: InputMaybe<IMeasureFilterInput>;
}

export interface ICondition {
  __typename: 'Condition';
  logicOps: Array<ILogicalOperator>;
  predicates: Array<IPredicate>;
}

export interface IConditionInput {
  logicOps: InputMaybe<Array<InputMaybe<LogicalOperatorKey>>>;
  predicates: InputMaybe<Array<InputMaybe<IPredicateInput>>>;
}

export interface IConfidenceInterval {
  __typename: 'ConfidenceInterval';
  lowerBound: Scalars['Float']['output'];
  upperBound: Scalars['Float']['output'];
}

export interface IConnectionInput {
  basic: InputMaybe<IBasicConnectionInput>;
  bigQuery: InputMaybe<IBigQueryConnectionInput>;
}

export type IConnectionMeta = IBasicConnectionMeta | IBigQueryConnectionMeta;

export interface IContingency {
  __typename: 'Contingency';
  falseNegative: Scalars['Long']['output'];
  falsePositive: Scalars['Long']['output'];
  trueNegative: Scalars['Long']['output'];
  truePositive: Scalars['Long']['output'];
}

export interface IContractPeriod {
  __typename: 'ContractPeriod';
  end: Scalars['LocalDate']['output'];
  start: Scalars['LocalDate']['output'];
}

export interface IConversationEntity {
  __typename: 'ConversationEntity';
  id: Scalars['ID']['output'];
  type: ConversationThreadEntityType;
}

export interface IConversationEntityInput {
  id: Scalars['ID']['input'];
  type: ConversationThreadEntityType;
}

export interface IConversationThread {
  __typename: 'ConversationThread';
  comments: Array<IComment>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  entity: IConversationEntity;
  hasUnreadComments: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isResolved: Scalars['Boolean']['output'];
  participants: Array<IUser>;
}

export interface IConversationThreadCommentImageEmbedUploadConfig {
  __typename: 'ConversationThreadCommentImageEmbedUploadConfig';
  imageEmbed: IImageEmbed;
  postUploadConfig: IPostUploadConfig;
}

export enum ConversationThreadEntityType {
  Analysis = 'ANALYSIS',
  Dashboard = 'DASHBOARD',
}

export interface IConversationThreadPayload {
  __typename: 'ConversationThreadPayload';
  errors: Array<IError>;
  thread: Maybe<IConversationThread>;
}

export interface IConversationThreadResolvePayload {
  __typename: 'ConversationThreadResolvePayload';
  errors: Array<IError>;
  resolved: Maybe<Scalars['Boolean']['output']>;
}

export interface IConversionWindowPartition {
  __typename: 'ConversionWindowPartition';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface ICorrelation {
  __typename: 'Correlation';
  correlation: Scalars['Float']['output'];
  marginOfError: Scalars['Float']['output'];
  /**  Negative Predictive Value */
  npv: Scalars['Float']['output'];
  /**  Proportion Above Threshold */
  pat: Scalars['Float']['output'];
  /**  Positive Predictive Value */
  ppv: Scalars['Float']['output'];
  predictionLevel: Scalars['String']['output'];
  sensitivity: Scalars['Float']['output'];
  specificity: Scalars['Float']['output'];
}

export interface ICorrelationKind {
  __typename: 'CorrelationKind';
  display: Scalars['String']['output'];
  key: Scalars['String']['output'];
}

export interface ICriteriaInput {
  breakdownCriteria: InputMaybe<IBreakdownCriteriaInput>;
  criteriaMode: SignificanceModeKey;
  experimentCriteria: InputMaybe<IExperimentCriteriaInput>;
  segmentCriteria: InputMaybe<ISegmentCriteriaInput>;
}

export enum Currency {
  Aud = 'AUD',
  Cad = 'CAD',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Jpy = 'JPY',
  Usd = 'USD',
}

export interface ICurrentEndDateMeta {
  __typename: 'CurrentEndDateMeta';
  kind: EndDateConfigKind;
}

/** Exactly one of the members must be set */
export interface ICustomColumnDefinitionInput {
  mappedString: InputMaybe<IMappedStringDefinitionInput>;
  rawSql: InputMaybe<IRawSqlDefinitionInput>;
}

export interface ICustomJoinMeta {
  __typename: 'CustomJoinMeta';
  description: Scalars['String']['output'];
}

export interface ICustomerInfo {
  __typename: 'CustomerInfo';
  analyticsConfig: IAnalyticsConfig;
  createdAt: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  warehouse: Scalars['String']['output'];
}

export interface ICustomerPlan {
  __typename: 'CustomerPlan';
  maxSchemas: Maybe<IMaxSchemas>;
  maxSeats: Maybe<IMaxSeats>;
  mtuPlan: Maybe<IMtuPlan>;
}

export interface ICustomerSetMtuReportInput {
  analysisId: Scalars['ID']['input'];
}

export interface ICustomerSetMtuReportPayload {
  __typename: 'CustomerSetMTUReportPayload';
  analysis: Maybe<IAnalysis>;
  errors: Array<IError>;
}

export interface IDashboard {
  __typename: 'Dashboard';
  baseId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  description: Scalars['String']['output'];
  /** "exportUrl" only works for instance. Template will always have NULL for this property. */
  exportUrl: Maybe<Scalars['String']['output']>;
  filter: Maybe<IDashboardFilter>;
  id: Scalars['ID']['output'];
  /**
   * Default means that this instance is applicable to be displayed when no particular instance is requested
   * when loading the template. Customized Dashboards are never default. Non-default instance are should not be
   * used as basis for edit because they indirectly alter the charts (date ranges, global filters) and could override
   * the initial set of charts on the Dashboard
   */
  isDefault: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  /**
   * Latest instance in a dashboard can be either the template itself or a dashboard instance with a template. This
   * field will be true only of the current dashboard (no matter if it is template or instance) is the latest one which
   * can be edited. Dashboards which can be edited have "isDefault" field set to true, i.e. dashboard instances with
   * dashboard filters are not considered as latest and thus cannot be edited. Edit operation include everything but
   * set/unset dashboard filter.
   */
  isLatestInstance: Scalars['Boolean']['output'];
  isLatestVersion: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isSharedWithMe: Scalars['Boolean']['output'];
  /**
   * The cached (in Kobol DB) last result from a "Summarize with AI" operation.
   * Note that getting this is not protected by the feature flag, the actual mutation
   * producing these is.
   */
  llmSummary: Maybe<ILlmSubjectSummary>;
  name: Scalars['String']['output'];
  /** The path to the containing sub-folder. Empty path means root folder. */
  path: Array<ISubFolder>;
  permission: IEntityPermission;
  refreshedAt: Scalars['Date']['output'];
  rows: Array<IDashboardRow>;
  schedules: Array<ISchedule>;
  slackDestination: Maybe<ISlackDestination>;
  /** @deprecated Switch to editedAt */
  updatedAt: Scalars['Date']['output'];
  versionCreatedAt: Scalars['Date']['output'];
  versionCreator: IUser;
  versionEditedAt: Scalars['Date']['output'];
  versionEditor: IUser;
}

export interface IDashboardAddAnalysesInput {
  analyses: Array<IDashboardAnalysisInput>;
  baseId: Scalars['ID']['input'];
}

export interface IDashboardAnalysisAddInput {
  analysis: IDashboardAnalysisInput;
  baseId: Scalars['ID']['input'];
}

export interface IDashboardAnalysisAddPayload {
  __typename: 'DashboardAnalysisAddPayload';
  analysis: Maybe<IAnalysis>;
  errors: Array<IError>;
}

export interface IDashboardAnalysisColumn {
  __typename: 'DashboardAnalysisColumn';
  analysis: IAnalysis;
  colSpan: Maybe<Scalars['Int']['output']>;
}

export interface IDashboardAnalysisGridUpdateInput {
  analysisId: Scalars['ID']['input'];
}

export interface IDashboardAnalysisInput {
  analysisId: Scalars['ID']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  pref: InputMaybe<IAnalysisPrefInput>;
}

export interface IDashboardBaseFromTemplateIdResponse {
  __typename: 'DashboardBaseFromTemplateIdResponse';
  baseId: Scalars['ID']['output'];
}

export interface IDashboardCloneInput {
  description: InputMaybe<Scalars['String']['input']>;
  instanceId: Scalars['ID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
}

export type IDashboardColumn =
  | IDashboardAnalysisColumn
  | IDashboardExternalEmbedColumn
  | IDashboardImageEmbedColumn
  | IDashboardRichTextColumn;

export interface IDashboardColumnGridUpdateInput {
  analysis: InputMaybe<IDashboardAnalysisGridUpdateInput>;
  colSpan: InputMaybe<Scalars['Int']['input']>;
  externalEmbed: InputMaybe<IDashboardExternalEmbedGridUpdateInput>;
  imageEmbed: InputMaybe<IImageEmbedGridUpdateInput>;
  richText: InputMaybe<IRichTextGridUpdateInput>;
  type: DashboardColumnType;
}

export enum DashboardColumnType {
  Analysis = 'ANALYSIS',
  ExternalEmbed = 'EXTERNAL_EMBED',
  ImageEmbed = 'IMAGE_EMBED',
  RichText = 'RICH_TEXT',
}

export interface IDashboardConfig {
  __typename: 'DashboardConfig';
  defaultDatePicker: IDatePicker;
  defaultEnd: Scalars['LocalDate']['output'];
  defaultStart: Scalars['LocalDate']['output'];
  /** List of logical operators to use on Dashboard Filter */
  logicOps: Array<ILogicalOperator>;
}

export interface IDashboardCreateInput {
  analyses: Array<IDashboardAnalysisInput>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
}

export interface IDashboardDeleteInput {
  baseId: InputMaybe<Scalars['ID']['input']>;
}

export interface IDashboardDeletePayload {
  __typename: 'DashboardDeletePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IDashboardDuplicateAnalysisInput {
  analysis: IDashboardAnalysisInput;
  baseId: Scalars['ID']['input'];
  instanceId: InputMaybe<Scalars['ID']['input']>;
}

export interface IDashboardExecuteInput {
  filter: IDashboardFilterInput;
  instanceId: Scalars['ID']['input'];
}

export interface IDashboardExecutePayload {
  __typename: 'DashboardExecutePayload';
  dashboard: Maybe<IDashboard>;
  errors: Array<IError>;
}

export interface IDashboardExternalEmbedAddInput {
  baseId: Scalars['ID']['input'];
  externalEmbed: IDashboardExternalEmbedInput;
}

export interface IDashboardExternalEmbedAddPayload {
  __typename: 'DashboardExternalEmbedAddPayload';
  errors: Array<IError>;
  externalEmbed: Maybe<IExternalEmbed>;
}

export interface IDashboardExternalEmbedColumn {
  __typename: 'DashboardExternalEmbedColumn';
  colSpan: Maybe<Scalars['Int']['output']>;
  externalEmbed: IExternalEmbed;
}

export interface IDashboardExternalEmbedEditInput {
  baseId: Scalars['ID']['input'];
  externalEmbedId: Scalars['ID']['input'];
  instanceId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
}

export interface IDashboardExternalEmbedEditPayload {
  __typename: 'DashboardExternalEmbedEditPayload';
  errors: Array<IError>;
  externalEmbed: Maybe<IExternalEmbed>;
}

export interface IDashboardExternalEmbedGridUpdateInput {
  externalEmbedId: Scalars['ID']['input'];
}

export interface IDashboardExternalEmbedInput {
  url: Scalars['String']['input'];
}

export interface IDashboardFilter {
  __typename: 'DashboardFilter';
  datePicker: Maybe<IDatePicker>;
  dateRange: Maybe<IDateRange>;
  filter: Maybe<IFilter>;
  schema: Maybe<ISchema>;
}

/** At lease specify one filter property in this input. */
export interface IDashboardFilterInput {
  datePicker: InputMaybe<IDatePickerInput>;
  filter: InputMaybe<IFilterInput>;
  /** Required when filter is specified. */
  schemaId: InputMaybe<Scalars['String']['input']>;
}

export interface IDashboardFolder {
  __typename: 'DashboardFolder';
  /**  null for root folder */
  id: Maybe<Scalars['ID']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  /**  "/" for root folder */
  name: Scalars['String']['output'];
  /**  null for top-level (and root) folders */
  parentId: Maybe<Scalars['ID']['output']>;
  /**  parents path from root to this folder (including it). empty list for root folder */
  path: Array<ISubFolder>;
  subFolders: Array<ISubFolder>;
  /**
   *  note that Caprica only uses these for the left-hand side menu and only requests
   *  small subset of all fields
   */
  templates: Array<IDashboard>;
}

export interface IDashboardFolderPayload {
  __typename: 'DashboardFolderPayload';
  entity: Maybe<IDashboardFolder>;
  errors: Array<IError>;
}

export interface IDashboardGridUpdateInput {
  baseId: Scalars['ID']['input'];
  instanceId: Scalars['ID']['input'];
  rows: Array<IDashboardRowGridUpdateInput>;
}

export interface IDashboardImageEmbedColumn {
  __typename: 'DashboardImageEmbedColumn';
  colSpan: Maybe<Scalars['Int']['output']>;
  imageEmbed: IImageEmbed;
}

export interface IDashboardImageEmbedEditInput {
  baseId: Scalars['ID']['input'];
  imageEmbedId: Scalars['ID']['input'];
  instanceId: Scalars['ID']['input'];
}

export interface IDashboardImageEmbedPayload {
  __typename: 'DashboardImageEmbedPayload';
  errors: Array<IError>;
  uploadConfig: Maybe<IDashboardImageEmbedUploadConfig>;
}

export interface IDashboardImageEmbedPostUploadConfigInput {
  dashboardBaseId: Scalars['ID']['input'];
}

export interface IDashboardImageEmbedUploadConfig {
  __typename: 'DashboardImageEmbedUploadConfig';
  imageEmbed: IImageEmbed;
  postUploadConfig: IPostUploadConfig;
}

export interface IDashboardMoveInput {
  baseId: Scalars['ID']['input'];
  /** Null represents the root folder. */
  folderId: InputMaybe<Scalars['ID']['input']>;
}

export interface IDashboardNameEditInput {
  baseId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  instanceId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface IDashboardNote {
  __typename: 'DashboardNote';
  dashboard: IDashboard;
}

export interface IDashboardPayload {
  __typename: 'DashboardPayload';
  entity: Maybe<IDashboard>;
  errors: Array<IError>;
}

export interface IDashboardPermissions {
  __typename: 'DashboardPermissions';
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  /**
   *  Special flag to tell Caprica to hide/disable the "lock/unlock" toggle in the edit
   *  view even if the user otherwise has permissions to edit the dashboard
   *  (only owner and kubit user can toggle that)
   */
  canEditLocked: Scalars['Boolean']['output'];
}

export interface IDashboardRefreshInput {
  baseId: Scalars['ID']['input'];
}

export interface IDashboardRefreshPayload {
  __typename: 'DashboardRefreshPayload';
  dashboard: Maybe<IDashboard>;
  errors: Array<IError>;
}

export interface IDashboardReplaceAnalysisInput {
  baseId: Scalars['ID']['input'];
  instanceId: InputMaybe<Scalars['ID']['input']>;
  newAnalysis: IDashboardAnalysisInput;
  targetAnalysisId: Scalars['ID']['input'];
}

export interface IDashboardReplaceAnalysisPayload {
  __typename: 'DashboardReplaceAnalysisPayload';
  entity: Maybe<IDashboard>;
  errors: Array<IError>;
  newAnalysisId: Maybe<Scalars['ID']['output']>;
  warningMessage: Maybe<Scalars['String']['output']>;
}

export interface IDashboardRichTextAddInput {
  baseId: Scalars['ID']['input'];
  richText: IRichTextInput;
}

export interface IDashboardRichTextAddPayload {
  __typename: 'DashboardRichTextAddPayload';
  errors: Array<IError>;
  richText: Maybe<IRichText>;
}

export interface IDashboardRichTextColumn {
  __typename: 'DashboardRichTextColumn';
  colSpan: Maybe<Scalars['Int']['output']>;
  richText: IRichText;
}

export interface IDashboardRichTextEditInput {
  baseId: Scalars['ID']['input'];
  html: Scalars['String']['input'];
  instanceId: Scalars['ID']['input'];
  richTextId: Scalars['ID']['input'];
}

export interface IDashboardRichTextEditPayload {
  __typename: 'DashboardRichTextEditPayload';
  errors: Array<IError>;
  richText: Maybe<IRichText>;
}

export interface IDashboardRow {
  __typename: 'DashboardRow';
  columns: Array<IDashboardColumn>;
  id: Scalars['ID']['output'];
  minHeight: Maybe<Scalars['Int']['output']>;
}

export interface IDashboardRowGridUpdateInput {
  columns: Array<IDashboardColumnGridUpdateInput>;
  minHeight: InputMaybe<Scalars['Int']['input']>;
}

export interface IDashboardScheduleEntity {
  __typename: 'DashboardScheduleEntity';
  alertAnalyses: Array<IAnalysis>;
  item: IDashboard;
}

export interface IDashboardSetFilterInput {
  baseId: Scalars['ID']['input'];
  /** Null will WIPE OUT the saved filter. */
  filter: InputMaybe<IDashboardFilterInput>;
  instanceId: InputMaybe<Scalars['ID']['input']>;
}

export interface IDashboardTemplateGroup {
  __typename: 'DashboardTemplateGroup';
  entities: Array<IDashboard>;
  scope: DashboardTemplateScope;
}

export enum DashboardTemplateScope {
  CreatedByMe = 'CREATED_BY_ME',
  Favorite = 'FAVORITE',
  Published = 'PUBLISHED',
  SharedWithMe = 'SHARED_WITH_ME',
}

export interface IDashboardUnpublishInput {
  baseId: Scalars['ID']['input'];
}

export interface IDashboardUnpublishPayload {
  __typename: 'DashboardUnpublishPayload';
  entity: Maybe<IDashboard>;
  errors: Array<IError>;
}

export interface IDashboardVisit {
  __typename: 'DashboardVisit';
  baseId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  display: Scalars['String']['output'];
  visitedAt: Scalars['Date']['output'];
}

export interface IDashboardVisitInput {
  baseId: Scalars['ID']['input'];
}

export interface IDashboardVisitPayload {
  __typename: 'DashboardVisitPayload';
  errors: Array<IError>;
  visit: Maybe<IDashboardVisit>;
}

export interface IDataModelAddDerivedFieldInput {
  column: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  filter: Scalars['Boolean']['input'];
  groupby: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  rawSql: IRawSqlDefinitionInput;
  typeInput: IDataModelFieldTypeInput;
}

export interface IDataModelAddDimensionInput {
  installTemporals: InputMaybe<IDataModelTemporalColumnsInput>;
  join: IDataModelJoinInput;
  sqlTableName: Scalars['String']['input'];
  /** schemaKey.viewKey will be used if unset */
  tableKey: InputMaybe<Scalars['String']['input']>;
  viewKey: Scalars['String']['input'];
}

export interface IDataModelAddFactTableInput {
  eventTemporals: IDataModelTemporalColumnsInput;
  installTemporals: InputMaybe<IDataModelTemporalColumnsInput>;
  sqlTableName: Scalars['String']['input'];
  tableKey: Scalars['String']['input'];
}

export interface IDataModelAddFieldInput {
  /**  The *table* column name */
  column: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  filter: Scalars['Boolean']['input'];
  groupby: Scalars['Boolean']['input'];
  /**
   * This should be globally unique across all fields in the schema.
   * For now Caprica should put the uppercase viewColumn here
   */
  key: Scalars['String']['input'];
  /** name is optional, the column will be used as name if unset */
  name: InputMaybe<Scalars['String']['input']>;
  /** Can reference a pre-existing or a new table (part of the same input) */
  tableKey: Scalars['String']['input'];
  typeInput: IDataModelFieldTypeInput;
  /**
   * This should be globally unique across all fields in the schema.
   * Caprica would generate this as follows:
   *     * use the table column if the name is not already taken
   *     * use a string like "${viewKey}_${column}", if not already taken.
   *     * in the unlikely case that this is also taken, caprica will append
   *     an underscore and unique (consecutive) number. e.g "${viewKey}_${column}_1",
   *     "${viewKey}_${column}_2", etc.
   * Providing a duplicate view column (or field key) will cause the DSL update to fail.
   */
  viewColumn: Scalars['String']['input'];
  /** Can reference a pre-existing or a new view (part of the same input) */
  viewKey: Scalars['String']['input'];
}

export interface IDataModelAddSubjectInput {
  fieldKey: Scalars['String']['input'];
  subjectName: Scalars['String']['input'];
}

export interface IDataModelCdwObjectsResult {
  __typename: 'DataModelCdwObjectsResult';
  errors: Array<Scalars['String']['output']>;
  result: Maybe<ICdwObjectsContainer>;
}

export interface IDataModelCreateInput {
  /** Any new derived field definitions */
  addDerivedFields: Array<IDataModelAddDerivedFieldInput>;
  /** Newly added Dimensions */
  addDimensions: Array<IDataModelAddDimensionInput>;
  /** Newly added Fact Union Tables */
  addFactTables: Array<IDataModelAddFactTableInput>;
  /** All new fields across the added Fact or Dimension tables */
  addFields: Array<IDataModelAddFieldInput>;
  addFunnelPartitions: Array<IFunnelPartitionInput>;
  /** All newly defined subjects. */
  addSubjects: Array<IDataModelAddSubjectInput>;
  /** null means - use defaults */
  dataRefresh: InputMaybe<IDataRefreshConfigInput>;
  dataSource: IDataSourceInput;
  description: InputMaybe<Scalars['String']['input']>;
  disabled: Scalars['Boolean']['input'];
  /** Moved out of DataSourceInput. To become mandatory */
  endDate: InputMaybe<IEndDateConfigInput>;
  /** All new table columns mapped to existing Fact Union tables */
  extendFactFields: Array<IDataModelExtendFactFieldInput>;
  factViewKey: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Null means to use default values (100%) */
  sampling: InputMaybe<ISamplingConfigInput>;
  schema: Scalars['String']['input'];
}

export interface IDataModelEditColumnDefinitionInput {
  column: Scalars['String']['input'];
  customDefinition: ICustomColumnDefinitionInput;
  tableKey: Scalars['String']['input'];
  viewKey: Scalars['String']['input'];
}

export interface IDataModelEditJoinInput {
  join: InputMaybe<IDataModelJoinInput>;
  viewKey: Scalars['String']['input'];
}

export interface IDataModelEditTableInput {
  installTemporals: InputMaybe<IDataModelTemporalColumnsInput>;
  /** To be exposed to SEs only - update sql table name in-place */
  sqlTableName: InputMaybe<Scalars['String']['input']>;
  tableKey: Scalars['String']['input'];
  viewKey: Scalars['String']['input'];
}

export interface IDataModelExtendFactFieldInput {
  column: Scalars['String']['input'];
  fieldKey: Scalars['String']['input'];
  tableKey: Scalars['String']['input'];
  typeInput: IDataModelFieldTypeInput;
}

export interface IDataModelFieldTypeInput {
  fieldClass: FieldClass;
  type: FieldType;
  typeParams: InputMaybe<IFieldTypeParamsInput>;
}

export interface IDataModelJoinInput {
  /** one-to-one conditions */
  conditions: Array<IDataModelJoinPairInput>;
  /** optional sqlCondition - advanced feature */
  sqlCondition: InputMaybe<Scalars['String']['input']>;
  /** non-null value means this is a temporal join */
  temporalCondition: InputMaybe<IDataModelJoinTemporalConditionInput>;
}

export interface IDataModelJoinPairInput {
  dimTableColumn: Scalars['String']['input'];
  factFieldKey: Scalars['String']['input'];
  relOp: JoinConditionOperator;
}

export interface IDataModelJoinTemporalConditionInput {
  /** Required when using Between join type */
  dimSecondTemporalKey: InputMaybe<Scalars['String']['input']>;
  /**
   * A temporal (date/time) field key. Normally, when defining a new Dimension,
   * that field must be also part of the addedFields Inputs.
   */
  dimTemporalKey: Scalars['String']['input'];
  /**
   * Should normally point to the event timestamp/date column.
   * Can be null for First/Last Ever
   */
  factTemporalKey: InputMaybe<Scalars['String']['input']>;
  /** One of the supported join types */
  joinType: TemporalJoinType;
}

export interface IDataModelPayload {
  __typename: 'DataModelPayload';
  entity: Maybe<ISchemaDataModel>;
  errors: Array<IError>;
}

export interface IDataModelSamplingConfig {
  __typename: 'DataModelSamplingConfig';
  cohort: Maybe<Scalars['Int']['output']>;
  default: Maybe<Scalars['Int']['output']>;
}

export interface IDataModelSubjectRef {
  __typename: 'DataModelSubjectRef';
  fieldKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subjectKey: Scalars['String']['output'];
  viewKey: Scalars['String']['output'];
}

export interface IDataModelTemporalColumnRef {
  __typename: 'DataModelTemporalColumnRef';
  column: Scalars['String']['output'];
  /** @deprecated Shuld not be needed any more. */
  isAutoGenerated: Scalars['Boolean']['output'];
  tableKey: Scalars['String']['output'];
}

export interface IDataModelTemporalColumnsInput {
  date: InputMaybe<Scalars['String']['input']>;
  dayOfWeek: InputMaybe<Scalars['String']['input']>;
  fourWeek: InputMaybe<Scalars['String']['input']>;
  hourOfDay: InputMaybe<Scalars['String']['input']>;
  month: InputMaybe<Scalars['String']['input']>;
  quarter: InputMaybe<Scalars['String']['input']>;
  ts: InputMaybe<Scalars['String']['input']>;
  week: InputMaybe<Scalars['String']['input']>;
  year: InputMaybe<Scalars['String']['input']>;
}

export interface IDataModelTemporalFieldRef {
  __typename: 'DataModelTemporalFieldRef';
  columnRefs: Array<IDataModelTemporalColumnRef>;
  fieldKey: Scalars['String']['output'];
}

export interface IDataModelTemporalFieldRefs {
  __typename: 'DataModelTemporalFieldRefs';
  /** Always present - whether from db or derived from ts */
  date: IDataModelTemporalFieldRef;
  /** These below are normally derived from the date */
  dayOfWeek: IDataModelTemporalFieldRef;
  fourWeek: IDataModelTemporalFieldRef;
  /** Normally - derived from the timestamp */
  hourOfDay: Maybe<IDataModelTemporalFieldRef>;
  month: IDataModelTemporalFieldRef;
  quarter: IDataModelTemporalFieldRef;
  /** required for Event Temporals, Optional for Install Temporals */
  ts: Maybe<IDataModelTemporalFieldRef>;
  /** Install temporals can live in a dimension */
  viewKey: Scalars['String']['output'];
  week: IDataModelTemporalFieldRef;
  year: IDataModelTemporalFieldRef;
}

export interface IDataModelTestConnectionResult {
  __typename: 'DataModelTestConnectionResult';
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

export interface IDataModelUpdateFieldInput {
  deprecated: InputMaybe<Scalars['Boolean']['input']>;
  /** This is only allowed for derived fields and can be used to update their definition */
  derivedDefinition: InputMaybe<IDerivedFieldDefinitionInput>;
  description: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<Scalars['Boolean']['input']>;
  groupby: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  name: InputMaybe<Scalars['String']['input']>;
}

export interface IDataModelUpdateInput {
  /** Any new derived field definitions */
  addDerivedFields: Array<IDataModelAddDerivedFieldInput>;
  /** Newly added Dimensions */
  addDimensions: Array<IDataModelAddDimensionInput>;
  /** Newly added Fact Union Tables */
  addFactTables: Array<IDataModelAddFactTableInput>;
  /** All new fields across the added Fact or Dimension tables */
  addFields: Array<IDataModelAddFieldInput>;
  addFunnelPartitions: Array<IFunnelPartitionInput>;
  /** All newly defined subjects. These must reference either pre-existing or newly added fields. */
  addSubjects: Array<IDataModelAddSubjectInput>;
  /**
   * Caprica should send the schema version it used to base this input on.
   * Kobol will reject the input if this number does not match the current version.
   */
  basedOnVersion: Scalars['Int']['input'];
  /** null means - no change */
  dataRefresh: InputMaybe<IDataRefreshConfigInput>;
  /** Null means - no change */
  dataSource: InputMaybe<IDataSourceInput>;
  /** null means no change. Use empty string to remove */
  description: InputMaybe<Scalars['String']['input']>;
  /** Null means - no change */
  disabled: InputMaybe<Scalars['Boolean']['input']>;
  /** Updates for *existing* column definitions */
  editColumns: Array<IDataModelEditColumnDefinitionInput>;
  /** (Limited) Changes to existing fields */
  editFields: Array<IDataModelUpdateFieldInput>;
  /** Changes to existing dimensions join conditions */
  editJoins: Array<IDataModelEditJoinInput>;
  /** Allows setting Install Temporals on existing tables. Possibly more in the future */
  editTables: Array<IDataModelEditTableInput>;
  /** Null means - no change */
  endDate: InputMaybe<IEndDateConfigInput>;
  /** All new table columns mapped to existing Fact Union tables */
  extendFactFields: Array<IDataModelExtendFactFieldInput>;
  /** Null means - no change */
  sampling: InputMaybe<ISamplingConfigInput>;
  schema: Scalars['String']['input'];
  /** Null means - no change */
  updatedName: InputMaybe<Scalars['String']['input']>;
}

export enum DataRefresh {
  /** Refresh is not supported (e.g. temporal or linear numeric fields). */
  NotSupported = 'NOT_SUPPORTED',
  /** Skip the refresh if the minimum refresh interval hasn't been reached. */
  Skipped = 'SKIPPED',
  /** The refresh has been started asynchronously in the backend. */
  Started = 'STARTED',
}

/** all members are nullble. null means no change. */
export interface IDataRefreshConfigInput {
  lookBackSeconds: InputMaybe<Scalars['Long']['input']>;
  minimumRefreshSeconds: InputMaybe<Scalars['Long']['input']>;
  pfvMaxNumOfValuesPerKey: InputMaybe<Scalars['Int']['input']>;
  pfvStringMaxLength: InputMaybe<Scalars['Int']['input']>;
}

export interface IDataRefreshConfigMeta {
  __typename: 'DataRefreshConfigMeta';
  /** @deprecated No longer supported */
  lookBackDays: Scalars['Long']['output'];
  lookBackSeconds: Scalars['Long']['output'];
  minimumRefreshSeconds: Scalars['Long']['output'];
  pfvMaxNumOfValuesPerKey: Scalars['Int']['output'];
  pfvStringMaxLength: Scalars['Int']['output'];
}

export interface IDataRefreshMeta {
  __typename: 'DataRefreshMeta';
  latestRefreshAt: Maybe<Scalars['Date']['output']>;
  refreshState: DataRefreshState;
}

export enum DataRefreshState {
  /** Refresh is in progress. */
  Running = 'RUNNING',
  /** No refresh is in progress. */
  Stable = 'STABLE',
}

export interface IDataSourceInput {
  connection: IConnectionInput;
  dateDt: InputMaybe<Scalars['String']['input']>;
}

export interface IDataTable extends IAnalysis {
  __typename: 'DataTable';
  /**  Control how chart should be displayed. */
  chartControl: IChartControl;
  comparisonConfig: Maybe<IComparisonConfig>;
  comparisonData: Maybe<IDataTableData>;
  container: Maybe<IAnalysisContainer>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  /**  Override data type from interface. */
  data: IDataTableData;
  datePicker: IDatePicker;
  /**  do we need this? */
  definition: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diagnosable: Scalars['Boolean']['output'];
  display: Scalars['String']['output'];
  end: Scalars['LocalDate']['output'];
  errorStatus: Maybe<AnalysisErrorStatus>;
  /**
   * Estimated analysis duration determined at submit time (in seconds).
   * Only available for running queries - to be used for progress indication,
   */
  estimatedDuration: Maybe<Scalars['Int']['output']>;
  executedAt: Scalars['Date']['output'];
  exportUrl: Maybe<Scalars['String']['output']>;
  failureMsg: Maybe<Scalars['String']['output']>;
  groupbys: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**  do we need this? */
  incidents: Array<IIncident>;
  isFavorite: Scalars['Boolean']['output'];
  kind: AnalysisKind;
  live: Scalars['Boolean']['output'];
  llmSummary: Maybe<ILlmSubjectSummary>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<Scalars['ID']['output']>;
  pref: IAnalysisPref;
  /** Data Table - specific properties */
  query: IDataTableQuery;
  queryId: Scalars['ID']['output'];
  queryType: QueryType;
  /**  The SQL used to produce this result  */
  referenceSql: Maybe<Scalars['String']['output']>;
  richTextSummary: Maybe<IAnalysisRichTextSummary>;
  schema: ISchema;
  start: Scalars['LocalDate']['output'];
  status: AnalysisStatus;
  timeUnit: TimeUnit;
}

export interface IDataTableColumn {
  __typename: 'DataTableColumn';
  /**
   *  null means there is no measure for that day or the base measure is 0.
   *  This list will be empty if overall is false in Breakdown.
   */
  basePercents: Array<Maybe<Scalars['Float']['output']>>;
  key: Scalars['String']['output'];
  measureKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**  null means there is no measure for that day */
  values: Array<Maybe<Scalars['Float']['output']>>;
}

export interface IDataTableConfig {
  __typename: 'DataTableConfig';
  basicConfig: IQueryBasicConfig;
  defaultFormulaSamplingRate: Scalars['Int']['output'];
  defaultSubject: ISubject;
  defaultTimeUnit: TimeUnit;
  measureFunctions: Array<IMeasureFunction>;
  measureRelOps: Array<IRelationalOperator>;
  settings: Array<IDataTableQuerySetting>;
  subjects: Array<ISubject>;
  timeUnits: Array<TimeUnit>;
}

export interface IDataTableData extends IAnalysisData {
  __typename: 'DataTableData';
  base: Maybe<IDataTableSlice>;
  columns: Array<IDataTableColumn>;
  dates: Array<Scalars['String']['output']>;
  isEmpty: Scalars['Boolean']['output'];
  /**
   *  Correspond to dates. E.g., live[i] represents if dates[i] is live.
   *  Not fit (empty) in these situations: 1. date kind = Trigger; 2. subject + breakdown + all time.
   */
  live: Array<Scalars['Boolean']['output']>;
  slices: Array<IDataTableSlice>;
}

export interface IDataTableExecuteInput {
  /**  Breakdowns which can be by field or segment/cohort  */
  breakdown: InputMaybe<IBreakdownInput>;
  /**  Global filters by cohort  */
  cohortRefs: Array<ICohortRefInput>;
  comparisonConfig: InputMaybe<IComparisonConfigInput>;
  /**  Only EVENT and INSTALL date kinds are allowed  */
  dateKind: DateKindKey;
  datePicker: IDatePickerInput;
  description: InputMaybe<Scalars['String']['input']>;
  display: InputMaybe<Scalars['String']['input']>;
  /**  Global filters by field  */
  filter: InputMaybe<IFilterInput>;
  /**
   * The list LLM Natural Language prompts (and response) used to generate this input. These should be
   * ordered in the reverse chronological order (i.e. newest/last message should be first)
   * Empty list if this input was not generated by a prompt.
   */
  llmChatMessages: Array<ILlmChatMessageInput>;
  /**  Data table measures which can be simple or compound  */
  measures: Array<IMeasureInput>;
  /**  Measure properties in data table formula. MeasureInput and MeasurePropertiesInput are position based  */
  measuresProperties: Array<IMeasurePropertiesInput>;
  /**  Formula Sampling Rate  */
  samplePercentage: InputMaybe<Scalars['Int']['input']>;
  schemaId: Scalars['ID']['input'];
  /**
   * Selected builder settings.
   * Null value results in DataTableQuerySettingKey.ALL for backwards compatibility until UI changes are implemented.
   * Empty list results in no additional settings selection, i.e. default builder configs.
   */
  settings: InputMaybe<Array<DataTableQuerySettingKey>>;
  /**  Optional reference to analysis which was used as basis of this query  */
  sourceId: InputMaybe<Scalars['ID']['input']>;
  /**  Only meaningful to install date kind, i.e. dateKind = INSTALL  */
  timeWindow: InputMaybe<Scalars['Int']['input']>;
  unit: TimeUnit;
}

export interface IDataTableExecutePayload {
  __typename: 'DataTableExecutePayload';
  entity: Maybe<IAnalysis>;
  errors: Array<IError>;
}

export interface IDataTableQuery extends IFormula {
  __typename: 'DataTableQuery';
  breakdown: Maybe<IBreakdown>;
  cohortRefs: Array<ICohortRef>;
  config: IDataTableConfig;
  /** data table - specific properties */
  dateKind: IDateKind;
  filter: Maybe<IFilter>;
  /** Any LLM chat messages which were used to create this Formula */
  llmChatMessages: Array<ILlmChatMessage>;
  measures: Array<IMeasure>;
  measuresProperties: Array<IMeasureProperties>;
  samplePercentage: Maybe<Scalars['Int']['output']>;
  /** analyzable-specific properties */
  schema: ISchema;
  settings: Array<DataTableQuerySettingKey>;
  timeUnit: TimeUnit;
  timeWindow: Maybe<Scalars['Int']['output']>;
}

export interface IDataTableQuerySetting {
  __typename: 'DataTableQuerySetting';
  key: DataTableQuerySettingKey;
  name: Scalars['String']['output'];
}

/**  -------- Model Types -----------  */
export enum DataTableQuerySettingKey {
  Sampling = 'SAMPLING',
}

export interface IDataTableSlice extends ISlice {
  __typename: 'DataTableSlice';
  /**  list of fields to display that produced this slice  */
  hint: Array<ISliceNameHint>;
  key: Scalars['String']['output'];
  /**  column indices  */
  measures: Array<Scalars['Int']['output']>;
  /**  Base slice (DAU), dim value for single dim drill down (CN, US ...), array for multi-dim ([CN, 9.7.6]). */
  name: Scalars['String']['output'];
  rank: Maybe<Scalars['Int']['output']>;
  userAlias: IUserAliasSlice;
}

export interface IDataTableTemplate {
  __typename: 'DataTableTemplate';
  comparisonConfig: Maybe<IComparisonConfig>;
  datePicker: IDatePicker;
  end: Scalars['LocalDate']['output'];
  query: IDataTableQuery;
  start: Scalars['LocalDate']['output'];
}

export interface IDateBucket {
  __typename: 'DateBucket';
  isCustomName: Scalars['Boolean']['output'];
  kind: BucketKind;
  maxDate: Maybe<Scalars['LocalDate']['output']>;
  minDate: Maybe<Scalars['LocalDate']['output']>;
  /**  default: "<min", "min-max", ">=max" */
  name: Scalars['String']['output'];
}

export interface IDateBucketInput {
  maxDate: InputMaybe<Scalars['LocalDate']['input']>;
  minDate: InputMaybe<Scalars['LocalDate']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
}

export interface IDateInterval {
  __typename: 'DateInterval';
  end: Scalars['LocalDate']['output'];
  start: Scalars['LocalDate']['output'];
}

export interface IDateKind {
  __typename: 'DateKind';
  key: DateKindKey;
  name: Scalars['String']['output'];
  /** TODO remove the schemaId param after KBT-534 deploy, obsolete */
  supportedTimeUnits: Array<TimeUnit>;
}

export enum DateKindKey {
  Event = 'EVENT',
  Install = 'INSTALL',
  Trigger = 'TRIGGER',
}

export type IDatePicker =
  | IDatePickerFixed
  | IDatePickerLast
  | IDatePickerLastFull
  | IDatePickerSince
  | IDatePickerStartOf;

export interface IDatePickerFixed {
  __typename: 'DatePickerFixed';
  end: Scalars['LocalDate']['output'];
  start: Scalars['LocalDate']['output'];
}

export interface IDatePickerFixedInput {
  end: Scalars['LocalDate']['input'];
  start: Scalars['LocalDate']['input'];
}

export interface IDatePickerInput {
  fixed: InputMaybe<IDatePickerFixedInput>;
  last: InputMaybe<IDatePickerLastInput>;
  lastFull: InputMaybe<IDatePickerLastFullInput>;
  next: InputMaybe<IDatePickerNextInput>;
  since: InputMaybe<IDatePickerSinceInput>;
  startOf: InputMaybe<IDatePickerStartOfInput>;
  type: DatePickerType;
}

export interface IDatePickerLast {
  __typename: 'DatePickerLast';
  period: Scalars['Int']['output'];
  unit: TimeUnit;
}

export interface IDatePickerLastFull {
  __typename: 'DatePickerLastFull';
  period: Scalars['Int']['output'];
  unit: TimeUnit;
}

export interface IDatePickerLastFullInput {
  period: Scalars['Int']['input'];
  unit: TimeUnit;
}

export interface IDatePickerLastInput {
  period: Scalars['Int']['input'];
  unit: TimeUnit;
}

export interface IDatePickerNextInput {
  period: Scalars['Int']['input'];
  unit: TimeUnit;
}

export interface IDatePickerSince {
  __typename: 'DatePickerSince';
  start: Scalars['LocalDate']['output'];
}

export interface IDatePickerSinceInput {
  start: Scalars['LocalDate']['input'];
}

export interface IDatePickerStartOf {
  __typename: 'DatePickerStartOf';
  unit: TimeUnit;
}

export interface IDatePickerStartOfInput {
  unit: TimeUnit;
}

export enum DatePickerType {
  Fixed = 'FIXED',
  Last = 'LAST',
  LastFull = 'LAST_FULL',
  Since = 'SINCE',
  StartOf = 'START_OF',
}

export interface IDateRange {
  __typename: 'DateRange';
  end: Scalars['LocalDate']['output'];
  start: Scalars['LocalDate']['output'];
}

export interface IDateRangeInput {
  end: Scalars['LocalDate']['input'];
  start: Scalars['LocalDate']['input'];
}

export interface IDateRangeLimit {
  __typename: 'DateRangeLimit';
  maxDays: Scalars['Long']['output'];
  timeUnit: TimeUnit;
}

export interface IDerivedFieldDefinitionInput {
  rawSql: IRawSqlDefinitionInput;
}

export type IDerivedFieldDefinitionMeta =
  | IHardCodedDerivedFieldMeta
  | IRawSqlDerivedFieldMeta;

/**  This is more or less the same as FiledValue but has an extra isRenamed prop. */
export interface IDictionaryBasicEvent {
  __typename: 'DictionaryBasicEvent';
  /** This is now deprecated and to be removed once Caprica switches to entityCategories */
  categories: Array<IEventCategory>;
  description: Maybe<Scalars['String']['output']>;
  /** This will be renamed to just categories once the name is free */
  entityCategories: Array<IEntityCategory>;
  isDisabled: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  isRenamed: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tableNames: Array<Scalars['String']['output']>;
}

export interface IDictionaryBasicEventsConfig {
  __typename: 'DictionaryBasicEventsConfig';
  /** @deprecated Probably not used at all. */
  hasMore: Maybe<Scalars['Boolean']['output']>;
  values: Array<IDictionaryBasicEvent>;
}

export interface IDimensionDataModel {
  __typename: 'DimensionDataModel';
  /**
   * Deprecated - to be removed. Definitions are now available via TableField.typeParams
   * @deprecated No longer supported
   */
  customColumnDefinitions: Array<IColumnDefinitionMetas>;
  fields: Array<ISchemaFieldMeta>;
  join: IJoinMeta;
  key: Scalars['String']['output'];
  tableKeys: Array<Scalars['String']['output']>;
}

export interface IDuration {
  __typename: 'Duration';
  /** The unit of the <value> */
  timeUnit: TimeUnit;
  /** The duration of the window in <timeUnit>s */
  value: Scalars['Int']['output'];
}

export interface IDurationInput {
  /** The unit of the <value> */
  timeUnit: TimeUnit;
  /** The duration of the window in <timeUnit>s */
  value: Scalars['Int']['input'];
}

export interface IEndDateConfigInput {
  kind: InputMaybe<EndDateConfigKind>;
  rollingCount: InputMaybe<Scalars['Int']['input']>;
  rollingTimeUnit: InputMaybe<EndDateTimeUnitKind>;
  startTimeUnit: InputMaybe<EndDateTimeUnitKind>;
  staticDate: InputMaybe<Scalars['String']['input']>;
  staticDateAsLiveStart: Scalars['Boolean']['input'];
}

export enum EndDateConfigKind {
  Current = 'CURRENT',
  Rolling = 'ROLLING',
  Start = 'START',
  Static = 'STATIC',
}

export type IEndDateConfigMeta =
  | ICurrentEndDateMeta
  | IRollingEndDateMeta
  | IStartEndDateMeta
  | IStaticEndDateMeta;

export enum EndDateTimeUnitKind {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Week = 'WEEK',
}

export interface IEntityCategoriesPaginated {
  __typename: 'EntityCategoriesPaginated';
  entities: Array<IEntityCategory>;
  pageInfo: IPageInfo;
}

export interface IEntityCategory {
  __typename: 'EntityCategory';
  /** null means default color */
  color: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEmpty: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  schema: ISchema;
}

export interface IEntityCategoryCreateInput {
  /** null means default color */
  color: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  schema: Scalars['ID']['input'];
}

export interface IEntityCategoryCreatePayload {
  __typename: 'EntityCategoryCreatePayload';
  entity: Maybe<IEntityCategory>;
  errors: Array<IError>;
}

export interface IEntityCategoryDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IEntityCategoryDeletePayload {
  __typename: 'EntityCategoryDeletePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IEntityCategoryDetails {
  __typename: 'EntityCategoryDetails';
  category: Maybe<IEntityCategory>;
  /** allows caprica to gray out/delete empty categories */
  isEmpty: Maybe<Scalars['Boolean']['output']>;
}

export interface IEntityCategoryEditInput {
  /** null color means to leave unchanged, set to empty string to reset to default */
  color: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** null name means to leave the name unchanged */
  name: InputMaybe<Scalars['String']['input']>;
}

export interface IEntityCategoryEditPayload {
  __typename: 'EntityCategoryEditPayload';
  entity: Maybe<IEntityCategory>;
  errors: Array<IError>;
}

export interface IEntityPermission {
  __typename: 'EntityPermission';
  /** Default role for users who aren't assigned with any role. */
  defaultPublicRole: EntityRole;
  entityId: Scalars['ID']['output'];
  entityType: PermissionEntityType;
  /**
   * The owner is also covered in "roleAssignments", i.e. there is an assignment indicating
   * that the owner is assigned to which user. Though, still exposing the owner separately
   * for the convenience to the client.
   */
  owner: IUser;
  /** The full list of role assignments indicating which role is assigned to which users and groups. */
  roleAssignments: Array<IEntityRoleAssignment>;
}

export interface IEntityPermissionConfig {
  __typename: 'EntityPermissionConfig';
  roles: Array<EntityRole>;
}

export interface IEntityPermissionEditInput {
  defaultPublicRole: EntityRole;
  entityId: Scalars['ID']['input'];
  entityType: PermissionEntityType;
  roleAssignments: Array<IEntityRoleAssignmentInput>;
}

export interface IEntityPermissionEditPayload {
  __typename: 'EntityPermissionEditPayload';
  entity: Maybe<IEntityPermission>;
  errors: Array<IError>;
}

export enum EntityRole {
  Editor = 'EDITOR',
  Manager = 'MANAGER',
  Owner = 'OWNER',
  Viewer = 'VIEWER',
}

export interface IEntityRoleAssignment {
  __typename: 'EntityRoleAssignment';
  groups: Array<IUserGroup>;
  role: EntityRole;
  users: Array<IUser>;
}

export interface IEntityRoleAssignmentInput {
  groupIds: Array<Scalars['ID']['input']>;
  role: EntityRole;
  userIds: Array<Scalars['ID']['input']>;
}

export interface IEnumBucket {
  __typename: 'EnumBucket';
  isCustomName: Scalars['Boolean']['output'];
  kind: BucketKind;
  /**  default: "[first_value, ... , last_value]", "[Other]" */
  name: Scalars['String']['output'];
  values: Array<IBasicFieldValue>;
}

export interface IEnumBucketInput {
  name: InputMaybe<Scalars['String']['input']>;
  values: Array<Scalars['String']['input']>;
}

export interface IError {
  __typename: 'Error';
  field: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
}

/**
 * These are the error types returned in errors.extensions.classification.
 * For now no query/mutation is using them. It's just for client to import and generate the full list.
 */
export enum ErrorType {
  /** Invalid parameters in the input. */
  BadRequest = 'BAD_REQUEST',
  /** For now, internally it's mapped to the general checked exception. */
  Forbidden = 'FORBIDDEN',
  /** A general error if none of the above error is resolved. */
  InternalError = 'INTERNAL_ERROR',
  /** Miss permission on the operation. */
  MissingPermission = 'MISSING_PERMISSION',
  /** Not found the resource. */
  NotFound = 'NOT_FOUND',
  /** Unauthorized access like from disabled users or expired session. */
  Unauthorized = 'UNAUTHORIZED',
}

export interface IEventCategory {
  __typename: 'EventCategory';
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
}

export interface IEventCondition {
  __typename: 'EventCondition';
  events: Array<IEventValue>;
  field: Maybe<IField>;
  filter: Maybe<IFilter>;
}

export interface IEventConditionInput {
  events: InputMaybe<Array<IEventInput>>;
  /**  Measure function specific, e.g. "Count Event" doesn't have this field. */
  field: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<IFilterInput>;
}

export interface IEventCorrelation {
  __typename: 'EventCorrelation';
  event: Scalars['String']['output'];
  /**  corresponds to a cell in the chart. */
  eventDayCorrelations: Array<IEventDayCorrelation>;
}

export interface IEventDayCorrelation {
  __typename: 'EventDayCorrelation';
  /**  relative day against a user's start date when he joined the source cohort */
  day: Scalars['Int']['output'];
  /**  By default, threshold starts from ">= 1". E.g. >= 1, >= 2, ... */
  frequencyCorrelations: Array<IEventFrequencyCorrelation>;
  /**  index of the strongest event frequency correlation */
  strongestEventFrequencyCorrelation: Scalars['Int']['output'];
}

export interface IEventFrequencyCorrelation {
  __typename: 'EventFrequencyCorrelation';
  contingency: IContingency;
  correlation: ICorrelation;
  userStatus: IUserStatus;
}

/**
 * When kind = ANY, no need to specify any properties.
 * When kind = ANY_TABLE, only anyTableEventKey should be specified.
 * When kind = BASIC, only basicEventName should be specified.
 * When kind = VIRTUAL, only virtualEventId should be specified.
 */
export interface IEventInput {
  anyTableEventKey: InputMaybe<Scalars['String']['input']>;
  basicEventName: InputMaybe<Scalars['String']['input']>;
  kind: EventKind;
  virtualEventId: InputMaybe<Scalars['ID']['input']>;
}

/**  -------- Model Types -----------  */
export enum EventKind {
  Any = 'ANY',
  AnyTable = 'ANY_TABLE',
  Basic = 'BASIC',
  Virtual = 'VIRTUAL',
}

export interface IEventLogInput {
  category: InputMaybe<Scalars['String']['input']>;
  context: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  target: InputMaybe<Scalars['String']['input']>;
  ts: InputMaybe<Scalars['Long']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
}

export interface IEventLogPayload {
  __typename: 'EventLogPayload';
  errors: Array<IError>;
}

export interface IEventRefreshInput {
  schemaId: Scalars['ID']['input'];
}

export interface IEventRefreshPayload {
  __typename: 'EventRefreshPayload';
  entity: Maybe<DataRefresh>;
  errors: Array<IError>;
}

export interface IEventValue {
  kind: EventKind;
}

export interface IExecuteBasicInput {
  /**  Optional */
  breakdown: InputMaybe<IBreakdownInput>;
  cohortRefs: Array<ICohortRefInput>;
  /**
   *  Optional, for now only allowed with Expression and
   *  when dateKind != trigger and Histogram is NOT on
   */
  comparisonConfig: InputMaybe<IComparisonConfigInput>;
  /**
   *  key of date kind
   *  TODO why this field is string? It should be DateKindKey
   */
  dateKind: Scalars['String']['input'];
  datePicker: IDatePickerInput;
  description: InputMaybe<Scalars['String']['input']>;
  display: InputMaybe<Scalars['String']['input']>;
  /**  Optional */
  filter: InputMaybe<IFilterInput>;
  /**  Formula Sampling Rate */
  samplePercentage: InputMaybe<Scalars['Int']['input']>;
  schemaId: Scalars['ID']['input'];
  /** Optional reference to analysis which was used as basis of this query */
  sourceId: InputMaybe<Scalars['ID']['input']>;
  /**  Only meaningful to INSTALL date kind. */
  timeWindow: InputMaybe<Scalars['Int']['input']>;
  unit: TimeUnit;
}

export interface IExperiment {
  __typename: 'Experiment';
  experimentField: IField;
  variantField: IField;
}

export interface IExperimentControlGroup {
  __typename: 'ExperimentControlGroup';
  field: IField;
  value: Scalars['String']['output'];
}

export interface IExperimentCriteria {
  __typename: 'ExperimentCriteria';
  controlGroup: Scalars['String']['output'];
  experiment: Scalars['String']['output'];
  experimentField: IField;
  variants: Array<Scalars['String']['output']>;
  variationField: IField;
}

export interface IExperimentCriteriaInput {
  control: Scalars['String']['input'];
  experiment: Scalars['String']['input'];
  variants: Array<Scalars['String']['input']>;
}

export interface IExperimentResult {
  __typename: 'ExperimentResult';
  hypothesesStats: Array<IHypothesisStatsData>;
  nullHypothesisStats: INullHypothesisStatsData;
}

export interface IExperimentVariant {
  __typename: 'ExperimentVariant';
  field: IField;
  value: Scalars['String']['output'];
}

/**  -------- Model Types -----------  */
export interface IExpression extends IAnalysis {
  __typename: 'Expression';
  /**  Control how chart should be displayed. */
  chartControl: IChartControl;
  /**  if set - this is a comparison analysis */
  comparisonConfig: Maybe<IComparisonConfig>;
  comparisonData: Maybe<IExpressionData>;
  container: Maybe<IAnalysisContainer>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  /**  Override data type from interface. */
  data: IExpressionData;
  datePicker: IDatePicker;
  definition: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diagnosable: Scalars['Boolean']['output'];
  display: Scalars['String']['output'];
  end: Scalars['LocalDate']['output'];
  errorStatus: Maybe<AnalysisErrorStatus>;
  /**
   * Estimated analysis duration determined at submit time (in seconds).
   * Only available for running queries - to be used for progress indication,
   */
  estimatedDuration: Maybe<Scalars['Int']['output']>;
  executedAt: Scalars['Date']['output'];
  exportUrl: Maybe<Scalars['String']['output']>;
  failureMsg: Maybe<Scalars['String']['output']>;
  geo: Geo;
  groupbys: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incidents: Array<IIncident>;
  isFavorite: Scalars['Boolean']['output'];
  kind: AnalysisKind;
  live: Scalars['Boolean']['output'];
  llmSummary: Maybe<ILlmSubjectSummary>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<Scalars['ID']['output']>;
  pref: IAnalysisPref;
  /** Expression-specific properties */
  query: IExpressionQuery;
  queryId: Scalars['ID']['output'];
  queryType: QueryType;
  /**  The SQL used to produce this result  */
  referenceSql: Maybe<Scalars['String']['output']>;
  richTextSummary: Maybe<IAnalysisRichTextSummary>;
  schema: ISchema;
  start: Scalars['LocalDate']['output'];
  status: AnalysisStatus;
  timeUnit: TimeUnit;
}

export interface IExpressionCohort {
  __typename: 'ExpressionCohort';
  analysis: IExpression;
  categories: Array<IEntityCategory>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  datePicker: Maybe<IDatePicker>;
  /** @deprecated Switch to DatePicker */
  end: Maybe<Scalars['LocalDate']['output']>;
  filter: Maybe<IFilter>;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  measureId: Scalars['ID']['output'];
  /**
   * This is either the cohort name (for NamedCohort)
   * or a Kobol-generated (breakdown) name (like Cohort 1)
   * or can be null for an anonymous BasicCohort used as a global filter.
   */
  name: Maybe<Scalars['String']['output']>;
  operator: IExpressionCohortOperator;
  operatorValues: Array<Scalars['BigDecimal']['output']>;
  percentileFilter: Maybe<IPercentileFilter>;
  schema: ISchema;
  /** @deprecated Switch to DatePicker */
  start: Maybe<Scalars['LocalDate']['output']>;
  subject: ISubject;
  timeWindow: ITimeWindow;
  timeWindowValues: Array<Scalars['Int']['output']>;
  type: ISimpleCohortType;
  userAlias: IUserAliasQueryCohort;
  version: Maybe<IVersion>;
}

export interface IExpressionCohortConfig extends ISimpleCohortConfig {
  __typename: 'ExpressionCohortConfig';
  defaultSubject: ISubject;
  defaultTimeWindow: ITimeWindow;
  operators: Array<IExpressionCohortOperator>;
  percentileOperators: Array<IRelationalOperator>;
  subjects: Array<ISubject>;
  timeWindows: Array<ITimeWindow>;
}

export interface IExpressionCohortOperator {
  __typename: 'ExpressionCohortOperator';
  key: ExpressionCohortOperatorKey;
  name: Scalars['String']['output'];
}

export enum ExpressionCohortOperatorKey {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  Greaterorequal = 'GREATEROREQUAL',
  Greaterthan = 'GREATERTHAN',
  Lessorequal = 'LESSOREQUAL',
  Lessthan = 'LESSTHAN',
  Notequal = 'NOTEQUAL',
}

export interface IExpressionColumn {
  __typename: 'ExpressionColumn';
  /**
   *  null means there is no measure for that day or the base measure is 0.
   *  This list will be empty if overall is false in Breakdown.
   */
  basePercents: Array<Maybe<Scalars['Float']['output']>>;
  /**  ignores null values */
  cumulativeSum: IExpressionCumulativeSum;
  key: Scalars['String']['output'];
  measureKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentsPreviousValue: Array<Maybe<Scalars['Float']['output']>>;
  reading: Maybe<IReading>;
  /**  null means there is no measure for that day */
  values: Array<Maybe<Scalars['Float']['output']>>;
}

export interface IExpressionCumulativeSum {
  __typename: 'ExpressionCumulativeSum';
  display: Scalars['String']['output'];
  values: Array<Scalars['Float']['output']>;
}

export interface IExpressionData extends IAnalysisData {
  __typename: 'ExpressionData';
  base: Maybe<IExpressionSlice>;
  columns: Array<IExpressionColumn>;
  /** @deprecated switch to xAxis field */
  dates: Array<Scalars['String']['output']>;
  isEmpty: Scalars['Boolean']['output'];
  /**
   *  Correspond to dates. E.g., live[i] represents if dates[i] is live.
   *  Not fit (empty) in these situations: 1. date kind = Trigger; 2. subject + breakdown + all time.
   */
  live: Array<Scalars['Boolean']['output']>;
  slices: Array<IExpressionSlice>;
  /**  Statistics among all the groups for a single date. Only meaningful to histogram chart(when subject bucketing is enabled). */
  statistics: Array<IExpressionStatistics>;
  xAxis: Maybe<IExpressionModeXAxis>;
}

export interface IExpressionFilterInput {
  dateKinds: Array<DateKindKey>;
  hasRollingControl: InputMaybe<Scalars['Boolean']['input']>;
  modes: InputMaybe<Array<ExpressionModeKey>>;
}

/** Configuration for HISTOGRAM mode. */
export interface IExpressionHistogramConfig {
  __typename: 'ExpressionHistogramConfig';
  defaultSubject: ISubject;
  mode: IExpressionMode;
  settings: Array<IExpressionQuerySetting>;
  subjectBucketKinds: Array<BucketKind>;
  subjects: Array<ISubject>;
}

/** Configuration for IMPACT mode. */
export interface IExpressionImpactConfig {
  __typename: 'ExpressionImpactConfig';
  defaultSubject: ISubject;
  mode: IExpressionMode;
  settings: Array<IExpressionQuerySetting>;
  subjects: Array<ISubject>;
}

export interface IExpressionInput {
  includeMissingDates: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The list LLM Natural Language prompts (and response) used to generate this input. These should be
   * ordered in the reverse chronological order (i.e. newest/last message should be first)
   * Empty list if this input was not generated by a prompt.
   */
  llmChatMessages: Array<ILlmChatMessageInput>;
  measure: IMeasureInput;
  /**  Measure properties in expression formula. MeasureInput and ExpressionMeasurePropsInput are position based  */
  measureProperties: IMeasurePropertiesInput;
  mode: InputMaybe<ExpressionModeKey>;
  /**  The name of the result measure.  */
  name: InputMaybe<Scalars['String']['input']>;
  /**
   * Selected builder settings.
   * Null value results in ExpressionQuerySettingKey.ALL for backwards compatibility until UI changes are implemented.
   * Empty list results in no additional settings selection, i.e. default builder configs.
   */
  settings: InputMaybe<Array<ExpressionQuerySettingKey>>;
  subject: InputMaybe<Scalars['String']['input']>;
  /**  Optional. Null means no bucketing. */
  subjectBucketDefInput: InputMaybe<IBucketDefInput>;
  /**  Only meaningful to IMPACT_PERIOD. */
  triggerCondition: InputMaybe<IEventConditionInput>;
  /**  Only meaningful to IMPACT_PERIOD. */
  triggerSubject: InputMaybe<Scalars['String']['input']>;
}

export interface IExpressionMode {
  __typename: 'ExpressionMode';
  key: ExpressionModeKey;
  name: Scalars['String']['output'];
}

export interface IExpressionModeConfigs {
  __typename: 'ExpressionModeConfigs';
  histogramConfig: IExpressionHistogramConfig;
  impactConfig: IExpressionImpactConfig;
  queryConfig: IExpressionQueryConfig;
}

export enum ExpressionModeKey {
  Histogram = 'HISTOGRAM',
  Impact = 'IMPACT',
  Query = 'QUERY',
}

export type IExpressionModeXAxis =
  | IHistogramModeXAxis
  | IImpactAnalysisModeXAxis
  | IQueryModeXAxis;

export interface IExpressionPrepareCohortInput {
  measureId: Scalars['ID']['input'];
}

export interface IExpressionQuery extends IFormula {
  __typename: 'ExpressionQuery';
  breakdown: Maybe<IBreakdown>;
  cohortRefs: Array<ICohortRef>;
  compoundMeasureUserAlias: Maybe<IUserAliasQueryMeasure>;
  config: Maybe<IQueryConfig>;
  dateKind: IDateKind;
  filter: Maybe<IFilter>;
  includeMissingDates: Maybe<Scalars['Boolean']['output']>;
  isNameAutoGenerated: Maybe<Scalars['Boolean']['output']>;
  /** Any LLM chat messages which were used to create this Formula */
  llmChatMessages: Array<ILlmChatMessage>;
  measure: IMeasure;
  measureProperties: IMeasureProperties;
  mode: IExpressionMode;
  name: Maybe<Scalars['String']['output']>;
  samplePercentage: Maybe<Scalars['Int']['output']>;
  /** analyzable-specific properties */
  schema: ISchema;
  settings: Array<ExpressionQuerySettingKey>;
  /** expression-specific properties */
  subject: Maybe<ISubject>;
  subjectBucketDef: Maybe<IBucketDef>;
  timeUnit: TimeUnit;
  timeWindow: Maybe<Scalars['Int']['output']>;
  triggerCondition: Maybe<IEventCondition>;
  triggerSubject: Maybe<ISubject>;
}

/** Configuration for QUERY mode. */
export interface IExpressionQueryConfig {
  __typename: 'ExpressionQueryConfig';
  mode: IExpressionMode;
  settings: Array<IExpressionQuerySetting>;
}

export interface IExpressionQuerySetting {
  __typename: 'ExpressionQuerySetting';
  key: ExpressionQuerySettingKey;
  name: Scalars['String']['output'];
}

export enum ExpressionQuerySettingKey {
  Sampling = 'SAMPLING',
}

export interface IExpressionSlice extends ISlice {
  __typename: 'ExpressionSlice';
  /**  list of fields to display that produced this slice  */
  hint: Array<ISliceNameHint>;
  key: Scalars['String']['output'];
  /**  Base slice (DAU), dim value for single dim drill down (CN, US ...), array for multi-dim ([CN, 9.7.6]). */
  name: Scalars['String']['output'];
  rank: Maybe<Scalars['Int']['output']>;
  /**
   * Optional result measure for this slice (D2R), column index, i.e. ExpressionData.columns[measure].
   * Result measure column index exists only of the measure has user defined formula.
   */
  resultMeasureColumnIndex: Maybe<Scalars['Int']['output']>;
  userAlias: IUserAliasSlice;
  /**  Variables to compute the complex measure (D2_DAU, D1_DAU), column index. */
  variables: Array<Scalars['Int']['output']>;
}

export interface IExpressionStatistics {
  __typename: 'ExpressionStatistics';
  avg: Maybe<Scalars['Float']['output']>;
  max: Maybe<Scalars['Float']['output']>;
  median: Maybe<Scalars['Float']['output']>;
  min: Maybe<Scalars['Float']['output']>;
  /**  95th percentile */
  percentile: Maybe<Scalars['Float']['output']>;
  stddev: Maybe<Scalars['Float']['output']>;
}

export interface IExpressionTemplate {
  __typename: 'ExpressionTemplate';
  comparisonConfig: Maybe<IComparisonConfig>;
  datePicker: IDatePicker;
  end: Scalars['LocalDate']['output'];
  query: IExpressionQuery;
  start: Scalars['LocalDate']['output'];
  timeUnit: TimeUnit;
}

export interface IExternalEmbed {
  __typename: 'ExternalEmbed';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
}

export interface IFactDataModel {
  __typename: 'FactDataModel';
  /**
   * Deprecated - to be removed. Definitions are now available via TableField.typeParams
   * @deprecated No longer supported
   */
  customColumnDefinitions: Array<IColumnDefinitionMetas>;
  fields: Array<ISchemaFieldMeta>;
  key: Scalars['String']['output'];
  tableKeys: Array<Scalars['String']['output']>;
}

export interface IFavoriteAnalysisInput {
  analysisId: Scalars['ID']['input'];
  isFavorite: Scalars['Boolean']['input'];
}

export interface IFavoriteBasicEventInput {
  eventKey: Scalars['String']['input'];
  isFavorite: Scalars['Boolean']['input'];
  schema: Scalars['ID']['input'];
}

export enum FavoriteEntityType {
  Analysis = 'ANALYSIS',
  BasicEvent = 'BASIC_EVENT',
  BucketDef = 'BUCKET_DEF',
  Cohort = 'COHORT',
  Dashboard = 'DASHBOARD',
  Field = 'FIELD',
  Filter = 'FILTER',
  Measure = 'MEASURE',
  VirtualEvent = 'VIRTUAL_EVENT',
}

export interface IFavoriteFieldInput {
  fieldKey: Scalars['String']['input'];
  isFavorite: Scalars['Boolean']['input'];
  schema: Scalars['ID']['input'];
}

export interface IFavoritePayload {
  __typename: 'FavoritePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IFavoriteVersionEntityInput {
  entityId: Scalars['ID']['input'];
  entityType: FavoriteEntityType;
  /** Required after KB-8015. Nullable is to be backward compatible. */
  isFavorite: Scalars['Boolean']['input'];
}

export enum Feature {
  AiAdmin = 'AI_ADMIN',
  AiCreateReport = 'AI_CREATE_REPORT',
  AiDebug = 'AI_DEBUG',
  AiExplain = 'AI_EXPLAIN',
  Braze = 'BRAZE',
  CseAdmin = 'CSE_ADMIN',
  DataModeler = 'DATA_MODELER',
  DataModelerEdit = 'DATA_MODELER_EDIT',
  DataModelerEditSe = 'DATA_MODELER_EDIT_SE',
  ExternalEmbed = 'EXTERNAL_EMBED',
  Geo = 'GEO',
  KubitAnalytics = 'KUBIT_ANALYTICS',
  Prediction = 'PREDICTION',
  ShowSql = 'SHOW_SQL',
  Significance = 'SIGNIFICANCE',
  Workspace = 'WORKSPACE',
}

export interface IField {
  __typename: 'Field';
  bucketKinds: Array<BucketKind>;
  categories: Array<IEntityCategory>;
  column: Scalars['String']['output'];
  /** only derived fields will have this */
  derivedDefinition: Maybe<IDerivedFieldDefinitionMeta>;
  description: Maybe<Scalars['String']['output']>;
  isFactField: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isGeo: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Only available for nested fields. */
  nestedFieldMetadata: Maybe<INestedFieldMetadata>;
  pfv: IParentFieldValue;
  relOps: Array<IRelationalOperator>;
  searchable: Scalars['Boolean']['output'];
  tableNames: Array<Scalars['String']['output']>;
  type: FieldType;
  valueHint: Scalars['String']['output'];
}

/**
 *  the Event, Subject and event Temporals are special and will likely
 *  have to be indicated as such in the UI. Everything else is BASIC
 */
export enum FieldClass {
  Basic = 'BASIC',
  Event = 'EVENT',
  Subject = 'SUBJECT',
  Temporal = 'TEMPORAL',
}

export enum FieldContext {
  Breakdown = 'BREAKDOWN',
  Filter = 'FILTER',
  Inspect = 'INSPECT',
  Measure = 'MEASURE',
}

export interface IFieldEditCategoryInput {
  categoryIds: InputMaybe<Array<Scalars['ID']['input']>>;
  fieldKeys: InputMaybe<Array<Scalars['ID']['input']>>;
  schema: Scalars['ID']['input'];
}

export interface IFieldEditCategoryPayload {
  __typename: 'FieldEditCategoryPayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IFieldOperands {
  __typename: 'FieldOperands';
  fields: Array<IField>;
}

export interface IFieldOperandsInput {
  fieldKeys: Array<Scalars['String']['input']>;
  schemaId: Scalars['ID']['input'];
}

export interface IFieldPartition {
  __typename: 'FieldPartition';
  field: IField;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface IFieldRefreshInput {
  fieldKey: Scalars['ID']['input'];
  schemaId: Scalars['ID']['input'];
}

export interface IFieldRefreshPayload {
  __typename: 'FieldRefreshPayload';
  entity: Maybe<DataRefresh>;
  errors: Array<IError>;
}

export enum FieldType {
  Array = 'ARRAY',
  ArrayObject = 'ARRAY_OBJECT',
  Bool = 'BOOL',
  Date = 'DATE',
  Datetime = 'DATETIME',
  DayOfWeek = 'DAY_OF_WEEK',
  Double = 'DOUBLE',
  Float = 'FLOAT',
  FourWeek = 'FOUR_WEEK',
  HourOfDay = 'HOUR_OF_DAY',
  Integer = 'INTEGER',
  Json = 'JSON',
  Map = 'MAP',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  String = 'STRING',
  Struct = 'STRUCT',
  Timestamp = 'TIMESTAMP',
  Week = 'WEEK',
  Year = 'YEAR',
}

/**
 *  our field type key is not sufficient to fully qualify types -this object
 *  encapsulates such extra properties which allow us to fully define Kobol types
 */
export interface IFieldTypeParams {
  __typename: 'FieldTypeParams';
  arrayItemType: Maybe<FieldType>;
  /** The presence of this implies a Virtual Column */
  customDefinition: Maybe<IColumnDefinitionMeta>;
  fixedTz: Maybe<Scalars['String']['output']>;
  linearDistribution: Scalars['Boolean']['output'];
  /** Map will have this prop */
  mapDefinition: Maybe<IMapDefinitionMeta>;
  /** Struct and Array Of Struct will have this prop */
  structDefinition: Maybe<IStructDefinitionMeta>;
}

export interface IFieldTypeParamsInput {
  /** required for ARRAY fields */
  arrayItemType: InputMaybe<FieldType>;
  /** Having this set means a virtual field with custom definition */
  customDefinition: InputMaybe<ICustomColumnDefinitionInput>;
  /**
   * set to a tz name to use TIMESTAMP_FIXED_TZ or TIMESTAMP_TZ,
   * if an empty string is provided, use TIMESTAMP_TZ (with the default customer tz).
   * if the tz provided is the same as the customer default tz, TIMESTAMP_TZ will be used too
   */
  fixedTz: InputMaybe<Scalars['String']['input']>;
  /** optional, can force INTEGER_LINEAR */
  linearDistribution: Scalars['Boolean']['input'];
  /** Required if type is Map */
  mapDefinition: InputMaybe<IMapDefinitionInput>;
  /** Required if type is Struct OR arrayItemType is Struct */
  structDefinition: InputMaybe<IStructDefinitionInput>;
}

export type IFieldValue = IAnyFieldValue | IBasicFieldValue;

export interface IFieldValueInput {
  type: FieldValueType;
  /** Required when type = BASIC. */
  valueKey: InputMaybe<Scalars['String']['input']>;
}

export interface IFieldValueParent {
  __typename: 'FieldValueParent';
  key: Scalars['String']['output'];
}

export enum FieldValueType {
  Any = 'ANY',
  Basic = 'BASIC',
}

export interface IFilter {
  conditions: Array<ICondition>;
  logicOps: Array<ILogicalOperator>;
  type: FilterType;
}

export interface IFilterInput {
  basicFilter: InputMaybe<IBasicFilterInput>;
  namedFilter: InputMaybe<INamedFilterInput>;
  type: FilterType;
}

export enum FilterType {
  Basic = 'BASIC',
  Named = 'NAMED',
}

export interface IFlow extends ISlice {
  __typename: 'Flow';
  /**  list of fields to display that produced this slice  */
  hint: Array<ISliceNameHint>;
  /**  Unique identifier among all the flows. */
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rank: Maybe<Scalars['Int']['output']>;
  steps: Array<IFlowStep>;
  userAlias: IUserAliasSlice;
}

export interface IFlowStep {
  __typename: 'FlowStep';
  /**  Count of distinct subjects. */
  count: Scalars['Float']['output'];
  currentEvent: Scalars['String']['output'];
  nextEvent: Scalars['String']['output'];
  /**  Step number of the current edge. */
  seq: Scalars['Int']['output'];
}

export interface IFormatSetting {
  __typename: 'FormatSetting';
  currency: Currency;
  date: Scalars['String']['output'];
  locale: Locale;
  time: TimeFormat;
}

export interface IFormatSettingConfig {
  __typename: 'FormatSettingConfig';
  currencies: Array<Currency>;
  dateFormats: Array<Scalars['String']['output']>;
  defaultCurrency: Currency;
  defaultDateFormat: Scalars['String']['output'];
  defaultLocale: Locale;
  defaultTimeFormat: TimeFormat;
  locales: Array<Locale>;
  timeFormats: Array<TimeFormat>;
}

export interface IFormatSettingEditInput {
  currency: Currency;
  date: Scalars['String']['input'];
  locale: Locale;
  time: TimeFormat;
}

export interface IFormatSettingEditPayload {
  __typename: 'FormatSettingEditPayload';
  entity: Maybe<IFormatSetting>;
  errors: Array<IError>;
}

export interface IFormula {
  schema: ISchema;
}

export interface IFormulaConfig {
  __typename: 'FormulaConfig';
  timezone: Scalars['String']['output'];
  weekStart: WeekStart;
}

/**
 * The union of all supported Template types. Each of these should have enough information for Caprica to
 * populate a valid builder of the corresponding type. Generally - a subset of the respective Analysis
 * properties.
 */
export type IFormulaTemplate =
  | ICohortSampleTemplate
  | IDataTableTemplate
  | IExpressionTemplate
  | IFunnelTemplate
  | IPathTemplate
  | IRetentionTemplate
  | ISignificanceTemplate;

export interface IFunnel extends IAnalysis {
  __typename: 'Funnel';
  /**  Control how chart should be displayed */
  chartControl: IChartControl;
  container: Maybe<IAnalysisContainer>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  /**  Override data type from interface. */
  data: IFunnelData;
  datePicker: IDatePicker;
  definition: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diagnosable: Scalars['Boolean']['output'];
  display: Scalars['String']['output'];
  end: Scalars['LocalDate']['output'];
  errorStatus: Maybe<AnalysisErrorStatus>;
  /**
   * Estimated analysis duration determined at submit time (in seconds).
   * Only available for running queries - to be used for progress indication,
   */
  estimatedDuration: Maybe<Scalars['Int']['output']>;
  executedAt: Scalars['Date']['output'];
  exportUrl: Maybe<Scalars['String']['output']>;
  failureMsg: Maybe<Scalars['String']['output']>;
  groupbys: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incidents: Array<IIncident>;
  isFavorite: Scalars['Boolean']['output'];
  kind: AnalysisKind;
  live: Scalars['Boolean']['output'];
  llmSummary: Maybe<ILlmSubjectSummary>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<Scalars['ID']['output']>;
  pref: IAnalysisPref;
  /** funnel-specific properties */
  query: IFunnelQuery;
  queryId: Scalars['ID']['output'];
  queryType: QueryType;
  /**  The SQL used to produce this result  */
  referenceSql: Maybe<Scalars['String']['output']>;
  richTextSummary: Maybe<IAnalysisRichTextSummary>;
  schema: ISchema;
  start: Scalars['LocalDate']['output'];
  status: AnalysisStatus;
  timeUnit: TimeUnit;
}

export interface IFunnelCohort {
  __typename: 'FunnelCohort';
  analysis: IFunnel;
  categories: Array<IEntityCategory>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  datePicker: Maybe<IDatePicker>;
  durationStartDate: Maybe<Scalars['LocalDate']['output']>;
  /** @deprecated Switch to DatePicker */
  end: Maybe<Scalars['LocalDate']['output']>;
  filter: Maybe<IFilter>;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  lookForwardWindow: Maybe<Scalars['Int']['output']>;
  /**
   * This is either the cohort name (for NamedCohort)
   * or a Kobol-generated (breakdown) name (like Cohort 1)
   * or can be null for an anonymous BasicCohort used as a global filter.
   */
  name: Maybe<Scalars['String']['output']>;
  operator: IFunnelCohortOperator;
  operatorValues: Array<Scalars['Int']['output']>;
  schema: ISchema;
  /** @deprecated Switch to DatePicker */
  start: Maybe<Scalars['LocalDate']['output']>;
  subject: ISubject;
  timeToConvert: Maybe<ITimeToConvertConfig>;
  timeWindow: ITimeWindow;
  timeWindowValues: Array<Scalars['Int']['output']>;
  type: ISimpleCohortType;
  userAlias: IUserAliasQueryCohort;
  version: Maybe<IVersion>;
}

export interface IFunnelCohortConfig extends ISimpleCohortConfig {
  __typename: 'FunnelCohortConfig';
  defaultSubject: ISubject;
  defaultTimeWindow: ITimeWindow;
  operators: Array<IFunnelCohortOperator>;
  subjects: Array<ISubject>;
  timeWindows: Array<ITimeWindow>;
  ttcConfig: ITimeToConvertCohortConfig;
}

export interface IFunnelCohortOperator {
  __typename: 'FunnelCohortOperator';
  key: FunnelCohortOperatorKey;
  name: Scalars['String']['output'];
}

export enum FunnelCohortOperatorKey {
  ConvertedOn = 'CONVERTED_ON',
  DropOffBefore = 'DROP_OFF_BEFORE',
  DropOffSince = 'DROP_OFF_SINCE',
}

export interface IFunnelColumn {
  __typename: 'FunnelColumn';
  funnelModeSliceKey: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  measureKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**  Relative percents against previous steps. */
  percents: Array<IFunnelPercent>;
  sliceKey: Scalars['String']['output'];
  statistics: Maybe<IFunnelStatistics>;
  /**  nulls in `values` are not expected, definition is nullable to keep schema consistent with ExpressionColumn where nulls are allowed */
  values: Array<Maybe<Scalars['Float']['output']>>;
}

/**  -------- Model Types -----------  */
export interface IFunnelConfig {
  __typename: 'FunnelConfig';
  basicConfig: IQueryBasicConfig;
  customOrders: Array<IFunnelOrder>;
  defaultCustomOrder: IFunnelOrder;
  defaultFormulaSamplingRate: Scalars['Int']['output'];
  defaultGroupby: IGroupby;
  defaultMode: IFunnelMode;
  groupbys: Array<IGroupby>;
  modeConfigs: Array<IFunnelModeConfig>;
  modes: Array<IFunnelMode>;
  settings: Array<IFunnelQuerySetting>;
}

export interface IFunnelConversionXAxis {
  __typename: 'FunnelConversionXAxis';
  cohortDates: Array<ICohortDate>;
}

export interface IFunnelData extends IAnalysisData {
  __typename: 'FunnelData';
  base: Maybe<IFunnelSlice>;
  columns: Array<IFunnelColumn>;
  /** @deprecated dates are available only in conversion mode, and this info is now available in FunnelFrequencyXAxis type */
  dates: Array<Scalars['String']['output']>;
  /** @deprecated Moved into FunnelQuery, please switch to FunnelQuery.modeSlices field */
  funnelModeSlices: Array<IFunnelModeSlice>;
  isEmpty: Scalars['Boolean']['output'];
  /**  Correspond to dates. E.g., live[i] represents if dates[i] is live. */
  live: Array<Scalars['Boolean']['output']>;
  slices: Array<IFunnelSlice>;
  xAxis: Maybe<IFunnelXAxis>;
}

export enum FunnelDefaultConversionRateSetting {
  Absolute = 'ABSOLUTE',
  Relative = 'RELATIVE',
}

export interface IFunnelDistributionBucket {
  __typename: 'FunnelDistributionBucket';
  endExclusive: Scalars['Int']['output'];
  startInclusive: Scalars['Int']['output'];
}

export interface IFunnelExecuteInput {
  basicInput: InputMaybe<IExecuteBasicInput>;
  groupby: InputMaybe<GroupbyKey>;
  /**
   * The list LLM Natural Language prompts (and response) used to generate this input. These should be
   * ordered in the reverse chronological order (i.e. newest/last message should be first)
   * Empty list if this input was not generated by a prompt.
   */
  llmChatMessages: Array<ILlmChatMessageInput>;
  mode: FunnelModeKey;
  negativeSteps: InputMaybe<Array<InputMaybe<IFunnelStepInput>>>;
  order: InputMaybe<FunnelOrderKey>;
  partitions: Array<IPartitionInput>;
  /**
   * Selected builder settings.
   * Null value results in FunnelQuerySettingKey.ALL for backwards compatibility until UI changes are implemented.
   * Empty list results in no additional settings selection, i.e. default builder configs.
   */
  settings: InputMaybe<Array<FunnelQuerySettingKey>>;
  stepConversions: Array<IFunnelStepConversionInput>;
  /**  Either SEQUENCE or EXACT. Only meaningful to when order = CUSTOM. */
  stepOrders: InputMaybe<Array<InputMaybe<FunnelOrderKey>>>;
  /**  Order matters. At least one step input. */
  steps: InputMaybe<Array<InputMaybe<IFunnelStepInput>>>;
  subject: InputMaybe<Scalars['String']['input']>;
}

export interface IFunnelFilterInput {
  dateKinds: Array<DateKindKey>;
  modes: Array<FunnelModeKey>;
}

export interface IFunnelFrequencyXAxis {
  __typename: 'FunnelFrequencyXAxis';
  buckets: Array<IFunnelDistributionBucket>;
}

export interface IFunnelMetric {
  __typename: 'FunnelMetric';
  convertedOnStep: Scalars['Int']['output'];
  funnel: IFunnel;
  /** Defined only if the referenced funnel has mode time to convert */
  ttcMetric: Maybe<FunnelTimeToConvertMetric>;
}

export interface IFunnelMetricInput {
  analysisId: Scalars['ID']['input'];
  convertedOnStep: Scalars['Int']['input'];
  /** Defined only if the referenced funnel has mode time to convert */
  ttcMetric: InputMaybe<FunnelTimeToConvertMetric>;
}

export interface IFunnelMode {
  __typename: 'FunnelMode';
  key: FunnelModeKey;
  name: Scalars['String']['output'];
}

export interface IFunnelModeConfig {
  __typename: 'FunnelModeConfig';
  defaultOrder: IFunnelOrder;
  defaultPartition: IPartition;
  defaultPartitionValue: IPartitionValue;
  defaultPartitionWindowTimeUnit: TimeUnit;
  defaultSubject: ISubject;
  defaultTimeUnit: TimeUnit;
  mode: IFunnelMode;
  orders: Array<IFunnelOrder>;
  partitionWindowTimeUnits: Array<TimeUnit>;
  partitions: Array<IPartition>;
  subjects: Array<ISubject>;
  timeUnits: Array<TimeUnit>;
}

export enum FunnelModeKey {
  Conversion = 'CONVERSION',
  Frequency = 'FREQUENCY',
  TimeToConvert = 'TIME_TO_CONVERT',
}

export interface IFunnelModeSlice {
  __typename: 'FunnelModeSlice';
  key: Scalars['String']['output'];
  /**
   * List of allowed measure selections with boolean flags. Measures can vary depending on the Funnel Mode and
   * number of steps.
   * Frequency mode has N - 1 measures and each measure is available as a single step selection.
   *
   * Time to Convert mode has N measures. Every two consecutive steps are available as valid selection. Also all steps
   * are valid selection to present the time to convert for the entire funnel. Two steps funnel is a special case because
   * time to convert between step1 and step2 is actually the time to convert for the entire funnel.
   *
   * Conversion mode does not have FunnelModeSlice for now.
   *
   * Each FunnelColumn has a mapping to FunnelModeSlice by key.
   */
  measureSelection: Array<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
}

export interface IFunnelOrder {
  __typename: 'FunnelOrder';
  key: FunnelOrderKey;
  name: Scalars['String']['output'];
}

export enum FunnelOrderKey {
  Any = 'ANY',
  Custom = 'CUSTOM',
  Exact = 'EXACT',
  Sequence = 'SEQUENCE',
}

export interface IFunnelPartition {
  __typename: 'FunnelPartition';
  fieldKey: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface IFunnelPartitionInput {
  fieldKey: Scalars['String']['input'];
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
}

export interface IFunnelPercent {
  __typename: 'FunnelPercent';
  bounceCounts: Array<Maybe<Scalars['Float']['output']>>;
  bouncePercents: Array<Maybe<Scalars['Float']['output']>>;
  /**  Key of the relative base step. Unique within one column. */
  key: Scalars['String']['output'];
  reading: Maybe<IReading>;
  /**  null means the previous step count is 0. */
  values: Array<Maybe<Scalars['Float']['output']>>;
}

export interface IFunnelQuery extends IFormula {
  __typename: 'FunnelQuery';
  breakdown: Maybe<IBreakdown>;
  cohortRefs: Array<ICohortRef>;
  config: Maybe<IFunnelConfig>;
  dateKind: IDateKind;
  filter: Maybe<IFilter>;
  groupby: Maybe<IGroupby>;
  /** Any LLM chat messages which were used to create this Formula */
  llmChatMessages: Array<ILlmChatMessage>;
  mode: Maybe<IFunnelMode>;
  modeSlices: Array<IFunnelModeSlice>;
  negativeSteps: Array<IFunnelStep>;
  order: IFunnelOrder;
  partitions: Array<IPartitionValue>;
  samplePercentage: Maybe<Scalars['Int']['output']>;
  schema: ISchema;
  settings: Array<FunnelQuerySettingKey>;
  stepOrders: Array<IFunnelOrder>;
  steps: Array<IFunnelStep>;
  subject: Maybe<ISubject>;
  timeUnit: TimeUnit;
  timeWindow: Maybe<Scalars['Int']['output']>;
}

export interface IFunnelQuerySetting {
  __typename: 'FunnelQuerySetting';
  key: FunnelQuerySettingKey;
  name: Scalars['String']['output'];
}

export enum FunnelQuerySettingKey {
  GroupBy = 'GROUP_BY',
  Partition = 'PARTITION',
  Sampling = 'SAMPLING',
}

export interface IFunnelSetting {
  __typename: 'FunnelSetting';
  defaultConversionRate: FunnelDefaultConversionRateSetting;
}

export interface IFunnelSettingEditInput {
  defaultConversionRate: FunnelDefaultConversionRateSetting;
}

export interface IFunnelSlice extends ISlice {
  __typename: 'FunnelSlice';
  /**  list of fields to display that produced this slice  */
  hint: Array<ISliceNameHint>;
  key: Scalars['String']['output'];
  /**  Column index of the first step. */
  measure: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rank: Maybe<Scalars['Int']['output']>;
  userAlias: IUserAliasSlice;
  /**  Column indices of the rest steps. */
  variables: Array<Scalars['Int']['output']>;
}

export interface IFunnelStatistics {
  __typename: 'FunnelStatistics';
  avg: Maybe<Scalars['Float']['output']>;
  median: Maybe<Scalars['Float']['output']>;
}

export interface IFunnelStep {
  __typename: 'FunnelStep';
  conversionWindow: Maybe<IDuration>;
  name: Maybe<Scalars['String']['output']>;
  seq: Maybe<Scalars['Int']['output']>;
  stepConditions: Array<IEventCondition>;
  /**  Opaque ID to key aliases */
  userAlias: IUserAliasQueryStep;
}

export interface IFunnelStepConversionInput {
  conversionWindow: InputMaybe<IDurationInput>;
  seq: Scalars['Int']['input'];
}

export interface IFunnelStepInput {
  /**  For normal step, if name is not specified, it will be generated by backend. E.g. "s1". */
  name: InputMaybe<Scalars['String']['input']>;
  /**  For negative step, it means the position (0 ~ n) of the negative step. */
  seq: InputMaybe<Scalars['Int']['input']>;
  stepConditions: InputMaybe<Array<InputMaybe<IEventConditionInput>>>;
}

export interface IFunnelTemplate {
  __typename: 'FunnelTemplate';
  datePicker: IDatePicker;
  end: Scalars['LocalDate']['output'];
  query: IFunnelQuery;
  start: Scalars['LocalDate']['output'];
  timeUnit: TimeUnit;
}

export enum FunnelTimeToConvertMetric {
  Average = 'AVERAGE',
  Median = 'MEDIAN',
}

export interface IFunnelTimeToConvertXAxis {
  __typename: 'FunnelTimeToConvertXAxis';
  buckets: Array<IFunnelDistributionBucket>;
  timeUnit: TimeUnit;
}

export type IFunnelXAxis =
  | IFunnelConversionXAxis
  | IFunnelFrequencyXAxis
  | IFunnelTimeToConvertXAxis;

export enum Geo {
  Na = 'NA',
  UsCensusDivision = 'US_CENSUS_DIVISION',
  UsCensusRegion = 'US_CENSUS_REGION',
  UsDma = 'US_DMA',
  UsState = 'US_STATE',
}

export interface IGeoConfig {
  __typename: 'GeoConfig';
  mapFileUrl: Maybe<Scalars['String']['output']>;
}

export interface IGlobalConfig {
  __typename: 'GlobalConfig';
  /** @deprecated this configuration is removed */
  dateRangeLimits: Array<IDateRangeLimit>;
  /** @deprecated Default end date should be schema specific. Use from formula builder (QueryConfig, RetentionConfig, ...) */
  defaultEnd: Scalars['LocalDate']['output'];
  enabledFeatures: Array<Feature>;
  formatSetting: IFormatSetting;
  llmApiEnabled: Scalars['Boolean']['output'];
  preventBasicEventMetadataUpdates: Scalars['Boolean']['output'];
  reportSetting: IReportSetting;
  slackSupportLink: Scalars['String']['output'];
  timeUnits: Array<TimeUnit>;
  timezone: Scalars['String']['output'];
}

export interface IGroupby {
  __typename: 'Groupby';
  key: GroupbyKey;
  name: Scalars['String']['output'];
}

export enum GroupbyKey {
  Global = 'GLOBAL',
  Starting = 'STARTING',
}

export interface IHardCodedDerivedFieldMeta {
  __typename: 'HardCodedDerivedFieldMeta';
  description: Scalars['String']['output'];
}

export interface IHighlight {
  __typename: 'Highlight';
  date: Scalars['String']['output'];
  text: Scalars['String']['output'];
  value: Scalars['Float']['output'];
}

export interface IHistogramModeXAxis {
  __typename: 'HistogramModeXAxis';
  buckets: Array<Scalars['String']['output']>;
}

export interface IHypothesis {
  __typename: 'Hypothesis';
  /**  For Z-test only(is_categorical = false). It will be available only for Measure and Query metrics  */
  mean: Scalars['Float']['output'];
  /**
   * For Chi-square test only(is_categorical = true), the count of converted (or observed event). It will be
   * available only in Retention and Funnel metric.
   */
  observedCount: Scalars['Int']['output'];
  /**  Total sample size for the hypothesis  */
  sampleSize: Scalars['Int']['output'];
  /**  For Z-test only(is_categorical = false). It will be available only for Measure and Query metrics  */
  standardDeviation: Scalars['Float']['output'];
  /**  Name of the variant  */
  variant: Scalars['String']['output'];
}

export interface IHypothesisStatsData {
  __typename: 'HypothesisStatsData';
  /**  Chance to outperform null hypothesis  */
  chanceToOutperform: Scalars['Float']['output'];
  /**  Confidence interval for the hypothesis  */
  confidenceInterval: IConfidenceInterval;
  /**  Conversion rate (Chi-square test only)  */
  conversionRate: Scalars['Float']['output'];
  /**  Critical value  */
  criticalValue: Scalars['Float']['output'];
  /**  Delta(absolute performance) difference (both)  */
  delta: Scalars['Float']['output'];
  /**  Degrees of freedom  */
  dof: Scalars['Float']['output'];
  /**  Cohen's d for Welch's t-test, Cramér's V for Chi-Square test  */
  effectSize: Scalars['Float']['output'];
  /**
   * Optional error result. If present we should render it and ignore all other data in HypothesisStatsData
   * which has default values
   */
  errorMessage: Maybe<Scalars['String']['output']>;
  /**  Number of executed simulations  */
  executedSimulations: Scalars['Int']['output'];
  /**  Lift(relative performance) difference (both)  */
  lift: Scalars['Float']['output'];
  /**  Probability value  */
  pValue: Scalars['Float']['output'];
  /**  Time taken for simulations execution  */
  simulationsExecutionTime: Scalars['Float']['output'];
  /**  Standard error (Welch's t-test only)  */
  standardError: Scalars['Float']['output'];
  /**  Statistical power  */
  statisticalPower: Scalars['Float']['output'];
  /**  Statistical significance  */
  statisticalSignificance: Scalars['Boolean']['output'];
  /**  t-value for Welch's t-test, Chi-Square statistic for Chi-Square test  */
  testScore: Scalars['Float']['output'];
}

export interface IIdSearchEntity {
  __typename: 'IdSearchEntity';
  /** Not null for named entities (e.g., Named Measure). */
  baseId: Maybe<Scalars['ID']['output']>;
  categories: Array<IEntityCategory>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  /** Description about the entity's content. */
  detail: Scalars['String']['output'];
  editedAt: Scalars['Date']['output'];
  editor: IUser;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Null if the entity (e.g., Workspace) is not schema specific. */
  schema: Maybe<ISchema>;
  type: SearchEntityType;
  updatedAt: Scalars['Date']['output'];
}

export interface IImageEmbed {
  __typename: 'ImageEmbed';
  id: Scalars['ID']['output'];
  serveUrl: Scalars['String']['output'];
}

export interface IImageEmbedGridUpdateInput {
  imageEmbedId: Scalars['ID']['input'];
}

export interface IImageEmbedInput {
  imageEmbedId: Scalars['ID']['input'];
}

export interface IImageEmbedNote {
  __typename: 'ImageEmbedNote';
  imageEmbed: IImageEmbed;
}

export interface IImpactAnalysisModeXAxis {
  __typename: 'ImpactAnalysisModeXAxis';
  periods: Array<Scalars['String']['output']>;
}

/**  -------- Model Types -----------  */
export interface IIncident {
  __typename: 'Incident';
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  description: Scalars['String']['output'];
  end: Scalars['LocalDate']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  start: Scalars['LocalDate']['output'];
  type: IIncidentType;
}

export interface IIncidentCreateInput {
  description: InputMaybe<Scalars['String']['input']>;
  end: InputMaybe<Scalars['LocalDate']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  start: InputMaybe<Scalars['LocalDate']['input']>;
  typeId: InputMaybe<Scalars['ID']['input']>;
}

export interface IIncidentCreatePayload {
  __typename: 'IncidentCreatePayload';
  entity: Maybe<IIncident>;
  errors: Array<IError>;
}

export interface IIncidentDeleteInput {
  incidentId: InputMaybe<Scalars['ID']['input']>;
}

export interface IIncidentDeletePayload {
  __typename: 'IncidentDeletePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IIncidentEditInput {
  description: InputMaybe<Scalars['String']['input']>;
  end: InputMaybe<Scalars['LocalDate']['input']>;
  incidentId: InputMaybe<Scalars['ID']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  start: InputMaybe<Scalars['LocalDate']['input']>;
  typeId: InputMaybe<Scalars['ID']['input']>;
}

export interface IIncidentEditPayload {
  __typename: 'IncidentEditPayload';
  entity: Maybe<IIncident>;
  errors: Array<IError>;
}

export interface IIncidentType {
  __typename: 'IncidentType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

export interface IInspectError {
  __typename: 'InspectError';
  message: Scalars['String']['output'];
  status: AnalysisErrorStatus;
}

export interface IInspectSetting {
  __typename: 'InspectSetting';
  schemaInspectSettings: Array<ISchemaInspectSetting>;
}

export interface IInspectSettingEditInput {
  schemaInspectSettings: Array<ISchemaInspectSettingEditInput>;
}

export interface IInspectSubjectData {
  __typename: 'InspectSubjectData';
  inspectTable: IInspectSubjectTable;
  /** @deprecated switch to inspectTable field */
  table: Maybe<ICohortSampleTable>;
}

export interface IInspectSubjectInput {
  end: Scalars['LocalDate']['input'];
  fieldKeys: Array<Scalars['String']['input']>;
  schemaId: Scalars['ID']['input'];
  start: Scalars['LocalDate']['input'];
  subject: Scalars['String']['input'];
  subjectId: Scalars['String']['input'];
}

export interface IInspectSubjectPayload {
  __typename: 'InspectSubjectPayload';
  data: Maybe<IInspectSubjectData>;
  error: Maybe<IInspectError>;
  errors: Array<IError>;
  exportUrl: Maybe<Scalars['String']['output']>;
}

export interface IInspectSubjectTable {
  __typename: 'InspectSubjectTable';
  columns: Array<IInspectSubjectTableTableColumn>;
  summary: IInspectSubjectTableSummary;
}

export interface IInspectSubjectTableCell {
  __typename: 'InspectSubjectTableCell';
  value: Scalars['String']['output'];
}

export interface IInspectSubjectTableHeader {
  __typename: 'InspectSubjectTableHeader';
  field: IField;
}

export interface IInspectSubjectTableSummary {
  __typename: 'InspectSubjectTableSummary';
  tableSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
}

export interface IInspectSubjectTableTableColumn {
  __typename: 'InspectSubjectTableTableColumn';
  cells: Array<IInspectSubjectTableCell>;
  header: IInspectSubjectTableHeader;
}

export enum JoinConditionOperator {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEqual = 'NOT_EQUAL',
}

export type IJoinMeta = ICustomJoinMeta | ITableJoinMeta;

export interface IKeySearchEntity {
  __typename: 'KeySearchEntity';
  categories: Array<IEntityCategory>;
  /** Description about the entity's content. */
  detail: Scalars['String']['output'];
  /**
   * Entities (e.g., Field) which don't support "disable" function will always have "isDisabled = false",
   * which is for the convenience/consistency to the client.
   */
  isDisabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  schema: ISchema;
  type: SearchEntityType;
}

export interface ILLmConfigInput {
  /** Can be null if there is already an API key OR enabled is false. */
  apiKey: InputMaybe<Scalars['String']['input']>;
  assistantInstructions: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  modelName: Scalars['String']['input'];
  organizationId: InputMaybe<Scalars['String']['input']>;
  projectId: InputMaybe<Scalars['String']['input']>;
}

export enum LlmAbTestGroup {
  Default = 'DEFAULT',
  Test = 'TEST',
}

export interface ILlmAttachment {
  __typename: 'LlmAttachment';
  llmFileId: Scalars['String']['output'];
  /** Only available for attachments uploaded by us */
  originalS3Key: Maybe<Scalars['String']['output']>;
}

export interface ILlmChatMessage {
  __typename: 'LlmChatMessage';
  /**
   * For now these are only useful as part of the explain functionality debug info and may be removed
   * unless more use cases show up.
   */
  attachments: Array<ILlmAttachment>;
  createdAt: Maybe<Scalars['Date']['output']>;
  sender: LlmChatMessageSender;
  text: Scalars['String']['output'];
}

/**  --- create report */
export interface ILlmChatMessageInput {
  /**
   * The "unix timestamp" of the message.
   * Please use something like moment(message.createdAt).unix() on the LlmChatMessage.createdAt property
   * as returned by Kobol. Setting this correctly does NOT remove the need of all inputs to be ordered correctly -
   * newest should be first.
   */
  createdAtUnixTimestamp: Scalars['Long']['input'];
  sender: LlmChatMessageSender;
  text: Scalars['String']['input'];
}

export enum LlmChatMessageSender {
  Assistant = 'ASSISTANT',
  User = 'USER',
}

export interface ILlmConfig {
  __typename: 'LlmConfig';
  /** The current "summarize report" instructions. Will be null if not a kubit admin */
  assistantInstructions: Maybe<Scalars['String']['output']>;
  /**
   * The Kobol default "summarize report" instructions - to be used for Reset function.
   * Will be null if not a kubit admin
   */
  defaultAssistantInstructions: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  modelName: Scalars['String']['output'];
  organizationId: Maybe<Scalars['String']['output']>;
  projectId: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  showInstructions: Maybe<Scalars['Boolean']['output']>;
}

export interface ILlmConversation {
  __typename: 'LlmConversation';
  messages: ILlmConversationMessages;
  schemaId: Maybe<Scalars['String']['output']>;
}

export type ILlmConversationMessage =
  | ILlmConversationResponseError
  | ILlmConversationResponseFormula
  | ILlmConversationResponseText
  | ILlmConversationUserPrompt;

export interface ILlmConversationMessages {
  __typename: 'LlmConversationMessages';
  list: Array<ILlmConversationMessage>;
}

export interface ILlmConversationPromptInput {
  abTestGroup: LlmAbTestGroup;
  maxContext: Scalars['Int']['input'];
  prompt: Scalars['String']['input'];
  requestType: LlmPromptRequestType;
  schemaId: Scalars['String']['input'];
}

export interface ILlmConversationResponseError {
  __typename: 'LlmConversationResponseError';
  abTestGroup: LlmAbTestGroup;
  createdAt: Scalars['Date']['output'];
  debugInfo: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  responseTimeMs: Scalars['Long']['output'];
}

export interface ILlmConversationResponseFormula {
  __typename: 'LlmConversationResponseFormula';
  abTestGroup: LlmAbTestGroup;
  createdAt: Scalars['Date']['output'];
  debugInfo: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  queryDefinition: Scalars['String']['output'];
  queryId: Scalars['ID']['output'];
  queryType: QueryType;
  responseTimeMs: Scalars['Long']['output'];
}

export interface ILlmConversationResponseText {
  __typename: 'LlmConversationResponseText';
  abTestGroup: LlmAbTestGroup;
  createdAt: Scalars['Date']['output'];
  debugInfo: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  responseTimeMs: Scalars['Long']['output'];
}

export interface ILlmConversationUserPrompt {
  __typename: 'LlmConversationUserPrompt';
  abTestGroup: LlmAbTestGroup;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
}

export interface ILlmCreateFormulaTemplate {
  __typename: 'LlmCreateFormulaTemplate';
  /**
   * The user Prompt input, converted to a chat message.
   * This message should be provided in any future requests previousMessages, from the same builder context.
   * Note that the template itself will also carry the full list of llmChatMessages (including this one) and
   * these can be used as the next request previousMessages too
   */
  promptMessage: ILlmChatMessage;
  /**
   * The AI response message. Can be synthetic (generated by us) in certain cases of errors.
   * This message should be provided in any future requests previousMessages, from the same builder context.
   * It should be the first message in the new list, keeping the newest-first order
   * Note that the template itself will also carry the full list of llmChatMessages (including this one) and
   * these can be used as the next request previousMessages too
   */
  responseMessage: ILlmChatMessage;
  /** A Formula template generated by the prompt. Can be null if the AI failed to generate a Formula */
  template: Maybe<IFormulaTemplate>;
}

export interface ILlmCreateFormulaTemplateInput {
  abTestGroup: LlmAbTestGroup;
  /**
   * The list of previous messages from the same (builder) conversation, converted to Inputs.
   * Order should be - most-recent first.
   */
  previousMessages: Array<ILlmChatMessageInput>;
  prompt: Scalars['String']['input'];
  queryType: QueryType;
  schemaId: Scalars['String']['input'];
}

export interface ILlmCreateFormulaTemplatePayload {
  __typename: 'LlmCreateFormulaTemplatePayload';
  entity: Maybe<ILlmCreateFormulaTemplate>;
  errors: Array<IError>;
}

export interface ILlmInvalidateSummaryInput {
  subject: InputMaybe<ILlmSubjectInput>;
}

export interface ILlmInvalidateSummaryPayload {
  __typename: 'LlmInvalidateSummaryPayload';
  entity: Maybe<Scalars['String']['output']>;
  errors: Array<IError>;
}

export interface ILlmProcessPromptPayload {
  __typename: 'LlmProcessPromptPayload';
  entity: Maybe<ILlmConversationMessages>;
  errors: Array<IError>;
}

/**  --- "general"/debug chat interface */
export enum LlmPromptRequestType {
  CreateCohortSample = 'CREATE_COHORT_SAMPLE',
  CreateDataTable = 'CREATE_DATA_TABLE',
  CreateExpression = 'CREATE_EXPRESSION',
  CreateFunnel = 'CREATE_FUNNEL',
  CreatePath = 'CREATE_PATH',
  CreateRetention = 'CREATE_RETENTION',
  CreateSignificance = 'CREATE_SIGNIFICANCE',
}

export interface ILlmResetConversationInput {
  schemaId: Scalars['String']['input'];
}

export interface ILlmResetConversationPayload {
  __typename: 'LlmResetConversationPayload';
  entity: Maybe<Scalars['String']['output']>;
  errors: Array<IError>;
}

export interface ILlmSubjectInput {
  id: Scalars['ID']['input'];
  kind: LlmSubjectKind;
  /** Can be null for Dashboards: Must be set to the correct report schema for Reports */
  schemaId: InputMaybe<Scalars['String']['input']>;
  /**
   * The S3 key of a "screenshot" (image) of the chart (uploaded by Caprica via pre-signed URL),
   * to be sent as an attachment to the LLM. Can be null for certain report types (e.g. Significance).
   */
  screenshotS3Key: InputMaybe<Scalars['String']['input']>;
}

export enum LlmSubjectKind {
  Analysis = 'ANALYSIS',
  Dashboard = 'DASHBOARD',
}

export interface ILlmSubjectSummary {
  __typename: 'LlmSubjectSummary';
  /** The response converted into "rich text"/html format */
  richText: Scalars['String']['output'];
  /** The sections which were requested to get this response */
  sections: ILlmSummarySections;
  /** The original response received from AI */
  text: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
}

export interface ILlmSummarizeInput {
  /**
   * This should contain the "raw" numbers displayed on the chart, it can be CSV or JSON-like text.
   * Or null, if not applicable.
   */
  clientRawData: InputMaybe<Scalars['String']['input']>;
  /** An extra prompt to include in the request. This is hidden by default, for now. */
  prompt: InputMaybe<Scalars['String']['input']>;
  sections: ILlmSummarizeSectionsInput;
  subject: ILlmSubjectInput;
}

export interface ILlmSummarizePayload {
  __typename: 'LlmSummarizePayload';
  entity: Maybe<ILlmSummarizeResponse>;
  errors: Array<IError>;
}

export interface ILlmSummarizeResponse {
  __typename: 'LlmSummarizeResponse';
  error: Scalars['Boolean']['output'];
  summary: Maybe<ILlmSubjectSummary>;
  /** Exposed for debug purposes only, for now */
  thread: Array<ILlmChatMessage>;
}

export interface ILlmSummarizeSectionsInput {
  executiveSummary: Scalars['Boolean']['input'];
  keyInsights: Scalars['Boolean']['input'];
  recommendations: Scalars['Boolean']['input'];
  summaryStatistics: Scalars['Boolean']['input'];
}

export interface ILlmSummarySections {
  __typename: 'LlmSummarySections';
  executiveSummary: Scalars['Boolean']['output'];
  keyInsights: Scalars['Boolean']['output'];
  recommendations: Scalars['Boolean']['output'];
  summaryStatistics: Scalars['Boolean']['output'];
}

export interface ILlmUpdateConfigPayload {
  __typename: 'LlmUpdateConfigPayload';
  entity: Maybe<ILlmConfig>;
  errors: Array<IError>;
}

export enum Locale {
  DaDk = 'DA_DK',
  DeDe = 'DE_DE',
  EnCa = 'EN_CA',
  EnGb = 'EN_GB',
  EnIn = 'EN_IN',
  EnUs = 'EN_US',
  EsEs = 'ES_ES',
  EsMx = 'ES_MX',
  FrFr = 'FR_FR',
  ItIt = 'IT_IT',
  PtBr = 'PT_BR',
}

export interface ILogicalOperator {
  __typename: 'LogicalOperator';
  key: LogicalOperatorKey;
  name: Scalars['String']['output'];
}

export enum LogicalOperatorKey {
  And = 'AND',
  Or = 'OR',
}

export interface IMtuPlan {
  __typename: 'MTUPlan';
  contractPeriod: IContractPeriod;
  included: Array<IPlanFeature>;
  mtuLimit: Maybe<Scalars['Int']['output']>;
  mtuReport: Maybe<IAnalysis>;
  notIncluded: Array<IPlanFeature>;
  overageCharge: Scalars['String']['output'];
  refreshQuota: IScheduledRefreshStatus;
}

export interface IManageBasicEventInput {
  eventKey: Scalars['String']['input'];
  isManaged: InputMaybe<Scalars['Boolean']['input']>;
  schema: Scalars['ID']['input'];
}

export interface IManageEntityPayload {
  __typename: 'ManageEntityPayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IManageFieldInput {
  fieldKey: Scalars['String']['input'];
  isManaged: InputMaybe<Scalars['Boolean']['input']>;
  schema: Scalars['ID']['input'];
}

export interface IManageVersionEntityInput {
  entityId: Scalars['ID']['input'];
  entityType: ManagedEntityType;
  isManaged: InputMaybe<Scalars['Boolean']['input']>;
}

export enum ManagedEntityType {
  BasicEvent = 'BASIC_EVENT',
  BucketDef = 'BUCKET_DEF',
  Cohort = 'COHORT',
  Field = 'FIELD',
  Filter = 'FILTER',
  Measure = 'MEASURE',
  VirtualEvent = 'VIRTUAL_EVENT',
}

export interface IMapDefinitionInput {
  keyType: FieldType;
  valueType: FieldType;
}

export interface IMapDefinitionMeta {
  __typename: 'MapDefinitionMeta';
  keyType: FieldType;
  valueType: FieldType;
}

export interface IMappedStringDefinitionInput {
  mapElse: InputMaybe<Scalars['String']['input']>;
  mapNull: InputMaybe<Scalars['String']['input']>;
  mappedColumn: Scalars['String']['input'];
  values: Array<IMappedValuePairInput>;
}

export interface IMappedStringDefinitionMeta {
  __typename: 'MappedStringDefinitionMeta';
  column: Scalars['String']['output'];
  mapElse: Maybe<Scalars['String']['output']>;
  mapNull: Maybe<Scalars['String']['output']>;
  mappedColumn: Scalars['String']['output'];
  values: Array<IMappedValuePair>;
}

export interface IMappedValuePair {
  __typename: 'MappedValuePair';
  mapped: Scalars['String']['output'];
  original: Scalars['String']['output'];
}

export interface IMappedValuePairInput {
  mapped: Scalars['String']['input'];
  original: Scalars['String']['input'];
}

export interface IMaxSchemas {
  __typename: 'MaxSchemas';
  availableSchemas: Scalars['Int']['output'];
  maxSchemas: Scalars['Int']['output'];
  usedSchemas: Scalars['Int']['output'];
}

export interface IMaxSeats {
  __typename: 'MaxSeats';
  availableSeats: Scalars['Int']['output'];
  maxSeats: Scalars['Int']['output'];
  occupiedSeats: Scalars['Int']['output'];
}

export type IMeasure = ICompoundMeasure | ISimpleMeasure;

export interface IMeasureCohort {
  __typename: 'MeasureCohort';
  categories: Array<IEntityCategory>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  datePicker: Maybe<IDatePicker>;
  /** @deprecated Switch to DatePicker */
  end: Maybe<Scalars['LocalDate']['output']>;
  filter: Maybe<IFilter>;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  measure: IMeasure;
  /**
   * This is either the cohort name (for NamedCohort)
   * or a Kobol-generated (breakdown) name (like Cohort 1)
   * or can be null for an anonymous BasicCohort used as a global filter.
   */
  name: Maybe<Scalars['String']['output']>;
  operator: IMeasureCohortOperator;
  operatorValues: Array<Scalars['BigDecimal']['output']>;
  percentileFilter: Maybe<IPercentileFilter>;
  schema: ISchema;
  /** @deprecated Switch to DatePicker */
  start: Maybe<Scalars['LocalDate']['output']>;
  subject: ISubject;
  timeWindow: ITimeWindow;
  timeWindowValues: Array<Scalars['Int']['output']>;
  type: ISimpleCohortType;
  userAlias: IUserAliasQueryCohort;
  version: Maybe<IVersion>;
}

export interface IMeasureCohortConfig extends ISimpleCohortConfig {
  __typename: 'MeasureCohortConfig';
  defaultSubject: ISubject;
  defaultTimeWindow: ITimeWindow;
  functions: Array<IMeasureFunction>;
  operators: Array<IMeasureCohortOperator>;
  percentileOperators: Array<IRelationalOperator>;
  subjects: Array<ISubject>;
  timeWindows: Array<ITimeWindow>;
}

export interface IMeasureCohortOperator {
  __typename: 'MeasureCohortOperator';
  key: MeasureCohortOperatorKey;
  name: Scalars['String']['output'];
}

export enum MeasureCohortOperatorKey {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  Greaterorequal = 'GREATEROREQUAL',
  Greaterthan = 'GREATERTHAN',
  Lessorequal = 'LESSOREQUAL',
  Lessthan = 'LESSTHAN',
  Notequal = 'NOTEQUAL',
}

export interface IMeasureControl {
  __typename: 'MeasureControl';
  /**  List of available chart kinds. */
  charts: Array<ChartKind>;
  isCountFunction: Scalars['Boolean']['output'];
  isResultKey: Scalars['Boolean']['output'];
  /**  measure/step key */
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**  Opaque ID to key aliases */
  userAlias: IUserAliasQuery;
}

export interface IMeasureDisplayFormat {
  __typename: 'MeasureDisplayFormat';
  calculationUnit: Maybe<MeasureDisplayFormatOperator>;
  calculationValue: Maybe<Scalars['Float']['output']>;
  decimalPlace: Maybe<Scalars['Int']['output']>;
  kind: Maybe<MeasureDisplayFormatKind>;
  unit: Maybe<Scalars['String']['output']>;
}

export interface IMeasureDisplayFormatInput {
  calculationUnit: InputMaybe<MeasureDisplayFormatOperator>;
  calculationValue: InputMaybe<Scalars['Float']['input']>;
  decimalPlace: InputMaybe<Scalars['Int']['input']>;
  kind: InputMaybe<MeasureDisplayFormatKind>;
  unit: InputMaybe<Scalars['String']['input']>;
}

export enum MeasureDisplayFormatKind {
  Currency = 'CURRENCY',
  Number = 'NUMBER',
  Percent = 'PERCENT',
}

export enum MeasureDisplayFormatOperator {
  Divide = 'DIVIDE',
  Multiply = 'MULTIPLY',
}

export interface IMeasureFilter {
  __typename: 'MeasureFilter';
  relOp: IRelationalOperator;
  values: Array<Scalars['BigDecimal']['output']>;
}

export interface IMeasureFilterInput {
  relOp: RelationalOperatorKey;
  values: Array<Scalars['BigDecimal']['input']>;
}

export interface IMeasureFormulaInput {
  formula: Scalars['String']['input'];
  variables: Array<Scalars['String']['input']>;
}

export interface IMeasureFormulaValidationResult {
  __typename: 'MeasureFormulaValidationResult';
  validationError: Maybe<Scalars['String']['output']>;
}

export interface IMeasureFunction {
  __typename: 'MeasureFunction';
  fieldRequired: Scalars['Boolean']['output'];
  /** If the measure (e.g. average, median, percentile) requires the "overall" always to be true. */
  forceBreakdownOverall: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**  If true, pass percentile in measure input. */
  requirePercentile: Scalars['Boolean']['output'];
}

export interface IMeasureInput {
  compound: InputMaybe<ICompoundMeasureInput>;
  format: InputMaybe<IMeasureDisplayFormatInput>;
  rollingControl: InputMaybe<IRollingControlInput>;
  simple: InputMaybe<ISimpleMeasureInput>;
  type: MeasureType;
}

export interface IMeasureMetric {
  __typename: 'MeasureMetric';
  measure: IMeasure;
}

export interface IMeasureMetricInput {
  measureId: Scalars['ID']['input'];
}

export type IMeasureProperties =
  | ICompoundMeasureProperties
  | ISimpleMeasureProperties;

export interface IMeasurePropertiesInput {
  compound: InputMaybe<ICompoundMeasurePropertiesInput>;
  simple: InputMaybe<ISimpleMeasurePropertiesInput>;
  type: MeasureType;
}

export enum MeasureType {
  Compound = 'COMPOUND',
  Simple = 'SIMPLE',
}

/**  -------- Model Types -----------  */
export enum MeasureVersionType {
  Basic = 'BASIC',
  Named = 'NAMED',
}

export interface IMessage {
  __typename: 'Message';
  analysis: Maybe<IAnalysis>;
  annotation: Maybe<IAnnotation>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  formatted: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  parent: Maybe<Scalars['ID']['output']>;
  tags: Array<ITag>;
  text: Scalars['String']['output'];
}

export interface IMessageCreateInput {
  analysisId: InputMaybe<Scalars['ID']['input']>;
  channelId: Scalars['ID']['input'];
  formatted: Scalars['String']['input'];
  key: Scalars['String']['input'];
  metadata: IMetadataInput;
  parent: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
}

export interface IMessageCreatePayload {
  __typename: 'MessageCreatePayload';
  entity: Maybe<IMessage>;
  errors: Array<IError>;
}

export interface IMessageDeleteInput {
  id: Scalars['ID']['input'];
}

export interface IMessageDeletePayload {
  __typename: 'MessageDeletePayload';
  errors: Array<IError>;
  id: Maybe<Scalars['ID']['output']>;
}

export interface IMessagesAfterPayload {
  __typename: 'MessagesAfterPayload';
  channelId: Maybe<Scalars['ID']['output']>;
  messages: Maybe<Array<Maybe<IMessage>>>;
}

export interface IMessagesBeforePayload {
  __typename: 'MessagesBeforePayload';
  channelId: Maybe<Scalars['ID']['output']>;
  hasMore: Maybe<Scalars['Boolean']['output']>;
  messages: Maybe<Array<Maybe<IMessage>>>;
}

export interface IMetadataInput {
  landingUrl: Scalars['String']['input'];
  mentions: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface IMetricInput {
  funnelMetric: InputMaybe<IFunnelMetricInput>;
  measureMetric: InputMaybe<IMeasureMetricInput>;
  metricType: MetricTypeKey;
  queryMetric: InputMaybe<IQueryMetricInput>;
  retentionMetric: InputMaybe<IRetentionMetricInput>;
}

export interface IMetricType {
  __typename: 'MetricType';
  key: MetricTypeKey;
  name: Scalars['String']['output'];
}

/**  -------- Model Types -----------  */
export enum MetricTypeKey {
  Funnel = 'FUNNEL',
  Measure = 'MEASURE',
  Query = 'QUERY',
  Retention = 'RETENTION',
}

export interface IMovingAverage {
  __typename: 'MovingAverage';
  display: Scalars['String']['output'];
  /**  Null for the first N measures. Also ignore nulls in latter measures. */
  values: Array<Maybe<Scalars['Float']['output']>>;
}

export interface IMovingSum {
  __typename: 'MovingSum';
  display: Scalars['String']['output'];
  /**  Null for the first N measures. Also ignore nulls in latter measures. */
  values: Array<Maybe<Scalars['Float']['output']>>;
}

export interface IMutation {
  __typename: 'Mutation';
  adminNotificationSettingsSet: IAdminNotificationSettingPayload;
  allowedDomainSettingEdit: IAllowedDomainSettingEditPayload;
  analysisCancel: IAnalysisCancelPayload;
  analysisCopy: IAnalysisCopyPayload;
  analysisCustomize: IAnalysisCustomizePayload;
  analysisDeleteSummaryRichText: IAnalysisDeleteSummaryRichTextPayload;
  analysisInfo: IAnalysisInfoPayload;
  analysisPrepareCohort: IAnalysisPrepareCohortPayload;
  analysisSetChartPref: IAnalysisSetPrefPayload;
  analysisSetShowSummaryInDashboard: IAnalysisSetShowSummaryInDashboardPayload;
  analysisSetSummaryRichText: IAnalysisSetSummaryRichTextPayload;
  analysisVisit: IAnalysisVisitPayload;
  basicEventAddCategory: IBasicEventEditCategoryPayload;
  basicEventRemoveCategory: IBasicEventEditCategoryPayload;
  basicEventRename: IBasicEventRenamePayload;
  basicEventToggle: IBasicEventTogglePayload;
  basicEventUpdateDescription: IBasicEventUpdateDescriptionPayload;
  /**  Internally schedule an one-time cohort import */
  brazeCohortImport: IBrazeCohortImportPayload;
  channelCreate: IChannelCreatePayload;
  channelView: IChannelViewPayload;
  cohortExecute: ICohortExecutePayload;
  conversationCommentReactionAdd: IConversationThreadPayload;
  conversationCommentReactionDelete: IConversationThreadPayload;
  conversationThreadCommentAdd: IConversationThreadPayload;
  conversationThreadCommentDelete: IConversationThreadPayload;
  conversationThreadCommentImageEmbedAdd: ICommentImageEmbedAddPayload;
  conversationThreadCommentUpdate: IConversationThreadPayload;
  conversationThreadRead: IConversationThreadPayload;
  conversationThreadResolve: IConversationThreadResolvePayload;
  conversationThreadStart: IConversationThreadPayload;
  /** Create new upload config for image embed */
  createDashboardImageEmbedUploadConfig: IDashboardImageEmbedUploadConfig;
  createSchedule: IScheduleCreatePayload;
  createScratchpadImageEmbedUploadConfig: IScratchpadImageEmbedUploadConfig;
  customerSetMTUReport: ICustomerSetMtuReportPayload;
  /** Append new analyses from source ids in current dashboard. Every analysis is appended as a new row */
  dashboardAddAnalyses: IDashboardPayload;
  /** Append a new analysis from source in current dashboard. Added analysis is appended as a new row */
  dashboardAnalysisAdd: IDashboardAnalysisAddPayload;
  /** Creates a new dashboard from source dashboard. */
  dashboardClone: IDashboardPayload;
  /** Create a new dashboard with initial version 1. */
  dashboardCreate: IDashboardPayload;
  /** Delete dashboard. */
  dashboardDelete: IDashboardDeletePayload;
  /** Duplicate target analysis as adding the new copy at the end of the dashboard, i.e. as a new row. */
  dashboardDuplicateAnalysis: IDashboardPayload;
  /** Creates new filtered instance with the defined filters. Can later be used for clone. */
  dashboardExecute: IDashboardExecutePayload;
  /**
   * Creates a new empty external embed container which can be later edited. This mutation has to be followed by
   * dashboardGridUpdate in order to correctly place the new external embed resource within the dashboard.
   */
  dashboardExternalEmbedAdd: IDashboardExternalEmbedAddPayload;
  /** Update external embed url within a dashboard. Edit can be performed only over the current dashboard version. */
  dashboardExternalEmbedEdit: IDashboardExternalEmbedEditPayload;
  /** Create new dashboard folder */
  dashboardFolderCreate: IDashboardFolderPayload;
  /** Delete folder */
  dashboardFolderDelete: ISubFolderDeletePayload;
  /** Move folder */
  dashboardFolderMove: IDashboardFolderPayload;
  /** Rename folder */
  dashboardFolderRename: IDashboardFolderPayload;
  /**
   * Update dashboard content layout. This is supposed to be used in UI while drag & drop functionality is used to
   * re-arrange dashboard content.
   */
  dashboardGridUpdate: IDashboardPayload;
  /** Create new upload config for image embed and add the image embed as last row in the current dashboard */
  dashboardImageEmbedAdd: IDashboardImageEmbedPayload;
  /** Prepare new upload config to allow in-place edit of the image content within the current dashboard */
  dashboardImageEmbedEdit: Maybe<IDashboardImageEmbedPayload>;
  /** Move dashboard to a folder and mark the dashboard as published. */
  dashboardMove: IDashboardPayload;
  /** Edit dashboard name and description. */
  dashboardNameEdit: IDashboardPayload;
  /** Refresh current dashboard manually. Refresh creates new dashboard version. */
  dashboardRefresh: IDashboardRefreshPayload;
  /** Replace target analysis into the dashboard. The dashboard needs to be unfiltered and it should be latest version. */
  dashboardReplaceAnalysis: IDashboardReplaceAnalysisPayload;
  /**
   * Creates a new empty rich text which can be later edited. This mutation has to be followed by dashboardGridUpdate
   * in order to correctly place the new rich text within the dashboard.
   */
  dashboardRichTextAdd: IDashboardRichTextAddPayload;
  /** Update rich text definition within a dashboard. Edit can be performed only over the current dashboard version. */
  dashboardRichTextEdit: IDashboardRichTextEditPayload;
  /**
   * Set dashboard filter as part of the dashboard definition which will create a new dashboard version. Defined filter
   * will not be used for dashboard refresh.
   */
  dashboardSetFilter: IDashboardPayload;
  /** Unpublish dashboard, i.e. it will not be visible to other viewers. */
  dashboardUnpublish: IDashboardUnpublishPayload;
  /** Record that dashboard is visited by the logged in user */
  dashboardVisit: IDashboardVisitPayload;
  dataModelCreate: IDataModelPayload;
  dataModelUpdate: IDataModelPayload;
  dataTableExecute: IDataTableExecutePayload;
  deleteSchedule: IScheduleDeletePayload;
  entityCategoryCreate: IEntityCategoryCreatePayload;
  entityCategoryDelete: IEntityCategoryDeletePayload;
  entityCategoryEdit: IEntityCategoryEditPayload;
  entityPermissionEdit: IEntityPermissionEditPayload;
  eventLog: IEventLogPayload;
  eventRefresh: IEventRefreshPayload;
  favoriteAnalysis: IFavoritePayload;
  favoriteBasicEvent: IFavoritePayload;
  favoriteField: IFavoritePayload;
  favoriteVersionEntity: IFavoritePayload;
  fieldAddCategory: IFieldEditCategoryPayload;
  fieldRefresh: IFieldRefreshPayload;
  fieldRemoveCategory: IFieldEditCategoryPayload;
  formatSettingEdit: IFormatSettingEditPayload;
  funnelExecute: IQueryExecutePayload;
  incidentCreate: IIncidentCreatePayload;
  incidentDelete: IIncidentDeletePayload;
  incidentEdit: IIncidentEditPayload;
  inspectSubject: Maybe<IInspectSubjectPayload>;
  /** Process a user prompt and generate a report template out of it. */
  llmCreateFormulaTemplate: ILlmCreateFormulaTemplatePayload;
  /** Remove an existing entity summary. Requires respective Summarize With AI permission */
  llmInvalidateSummary: Maybe<ILlmInvalidateSummaryPayload>;
  /** Append a user prompt to the current LLM Conversation (and expect a response message back). */
  llmProcessConversationPrompt: ILlmProcessPromptPayload;
  /** Delete all previous messages in this user schema conversation */
  llmResetConversation: ILlmResetConversationPayload;
  /**
   * Get an entity description (summary). The result will be recorded with the entity and available to all users
   * accessing it. Requires respective Summarize With AI permission
   */
  llmSummarizeEntity: ILlmSummarizePayload;
  /** Admin API, requires Admin Settings update permissions */
  llmUpdateApiConfig: ILlmUpdateConfigPayload;
  manageBasicEvent: IManageEntityPayload;
  manageField: IManageEntityPayload;
  manageVersionEntity: IManageEntityPayload;
  messageCreate: IMessageCreatePayload;
  messageDelete: IMessageDeletePayload;
  namedBucketDefAddCategory: INamedEntityEditCategoryPayload;
  namedBucketDefCreate: INamedBucketDefCreatePayload;
  namedBucketDefDelete: INamedBucketDefDeletePayload;
  namedBucketDefEdit: INamedBucketDefEditPayload;
  namedBucketDefRemoveCategory: INamedEntityEditCategoryPayload;
  /** Add a category (tag) to a cohort. Does NOT create a new version */
  namedCohortAddCategory: INamedEntityEditCategoryPayload;
  namedCohortCreate: INamedCohortCreatePayload;
  namedCohortDisable: INamedCohortDisablePayload;
  namedCohortEdit: INamedCohortEditPayload;
  /** Remove a category (tag) from a cohort. Does NOT create a new version */
  namedCohortRemoveCategory: INamedEntityEditCategoryPayload;
  namedFilterAddCategory: INamedEntityEditCategoryPayload;
  namedFilterCreate: INamedFilterCreatePayload;
  namedFilterDelete: INamedFilterDeletePayload;
  namedFilterEdit: INamedFilterEditPayload;
  namedFilterRemoveCategory: INamedEntityEditCategoryPayload;
  /** Add a category (tag) to a measure. Does NOT create a new version */
  namedMeasureAddCategory: INamedEntityEditCategoryPayload;
  namedMeasureCreate: INamedMeasureCreatePayload;
  namedMeasureDelete: INamedMeasureDeletePayload;
  namedMeasureEdit: INamedMeasureEditPayload;
  /** Remove a category (tag) from a measure. Does NOT create a new version */
  namedMeasureRemoveCategory: INamedEntityEditCategoryPayload;
  pathExecute: IPathExecutePayload;
  pauseSchedule: ISchedulePausePayload;
  predictionExecute: IPredictionExecutePayload;
  queryExecute: IQueryExecutePayload;
  reportSettingEdit: IReportSettingEditPayload;
  resumeSchedule: IScheduleResumePayload;
  retentionExecute: IRetentionExecutePayload;
  roleCreate: IRoleCreatePayload;
  roleDefault: IRoleDefaultPayload;
  roleDisable: IRoleDisablePayload;
  roleEdit: IRoleEditPayload;
  roleEnable: IRoleEnablePayload;
  scratchpadCreate: IScratchpadCreatePayload;
  scratchpadDelete: IScratchpadDeletePayload;
  scratchpadEdit: IScratchpadEditPayload;
  scratchpadNoteAdd: IScratchpadNoteAddPayload;
  scratchpadNoteDelete: IScratchpadNoteDeletePayload;
  scratchpadNoteMove: IScratchpadNoteMovePayload;
  scratchpadTextNoteEdit: IScratchpadTextNoteEditPayload;
  scratchpadVisit: IScratchpadVisitPayload;
  significanceExecute: ISignificanceExecutePayload;
  /**
   * Not support connecting schedule, because of the technical difficulty in permission check.
   * Please connect schedule through ScheduleInput.
   */
  slackConnect: ISlackConnectPayload;
  slackDisconnect: ISlackDisconnectPayload;
  slackOAuthCallback: ISlackOAuthCallbackPayload;
  slackOAuthStart: ISlackOAuthStartPayload;
  slackUninstall: ISlackUninstallPayload;
  tagCreate: ITagCreatePayload;
  tagUpdate: ITagUpdatePayload;
  tileAdd: ITilePayload;
  tileDelete: ITilePayload;
  tileUpdate: ITilePayload;
  triggerSchedule: IScheduleTriggerPayload;
  /**  Updating schedule doesn't support one-time execution */
  updateSchedule: IScheduleCreatePayload;
  userDisable: IUserDisablePayload;
  userEdit: IUserEditPayload;
  userEnable: IUserEnablePayload;
  userGroupCreate: IUserGroupCreatePayload;
  userGroupDisable: IUserGroupDisablePayload;
  userGroupEdit: IUserGroupEditPayload;
  userGroupEnable: IUserGroupEnablePayload;
  userInvite: IUserInvitePayload;
  userInviteResend: IUserInviteResendPayload;
  userLogin: IUserLoginPayload;
  userLogout: IUserLogoutPayload;
  userRevoke: IUserRevokePayload;
  userSettingUpdate: IUserSettingPayload;
  virtualEventAddCategory: INamedEntityEditCategoryPayload;
  virtualEventCreate: IVirtualEventCreatePayload;
  virtualEventDelete: IVirtualEventDeletePayload;
  virtualEventEdit: IVirtualEventEditPayload;
  virtualEventRemoveCategory: INamedEntityEditCategoryPayload;
  workspaceCreate: IWorkspaceCreatePayload;
  workspaceDelete: IWorkspaceDeletePayload;
  workspaceEdit: IWorkspaceEditPayload;
  workspaceScratchpadConvert: IWorkspaceScratchpadConvertPayload;
  wsAddAnalyses: IWsAddAnalysesPayload;
  wsDeleteAnalysis: IWsDeleteAnalysisPayload;
  wsReplaceAnalysis: IWsReplaceAnalysisPayload;
}

export interface IMutationAdminNotificationSettingsSetArgs {
  input: IAdminNotificationSettingsInput;
}

export interface IMutationAllowedDomainSettingEditArgs {
  input: IAllowedDomainSettingEditInput;
}

export interface IMutationAnalysisCancelArgs {
  input: IAnalysisCancelInput;
}

export interface IMutationAnalysisCopyArgs {
  input: IAnalysisCopyInput;
}

export interface IMutationAnalysisCustomizeArgs {
  input: IAnalysisCustomizeInput;
}

export interface IMutationAnalysisDeleteSummaryRichTextArgs {
  input: IAnalysisDeleteSummaryRichTextInput;
}

export interface IMutationAnalysisInfoArgs {
  input: IAnalysisInfoInput;
}

export interface IMutationAnalysisPrepareCohortArgs {
  input: IAnalysisPrepareCohortInput;
}

export interface IMutationAnalysisSetChartPrefArgs {
  input: IAnalysisSetPrefInput;
}

export interface IMutationAnalysisSetShowSummaryInDashboardArgs {
  input: IAnalysisSetShowSummaryInDashboardInput;
}

export interface IMutationAnalysisSetSummaryRichTextArgs {
  input: IAnalysisSetSummaryRichTextInput;
}

export interface IMutationAnalysisVisitArgs {
  input: IAnalysisVisitInput;
}

export interface IMutationBasicEventAddCategoryArgs {
  input: IBasicEventEditCategoryInput;
}

export interface IMutationBasicEventRemoveCategoryArgs {
  input: IBasicEventEditCategoryInput;
}

export interface IMutationBasicEventRenameArgs {
  input: IBasicEventRenameInput;
}

export interface IMutationBasicEventToggleArgs {
  input: IBasicEventToggleInput;
}

export interface IMutationBasicEventUpdateDescriptionArgs {
  input: IBasicEventUpdateDescriptionInput;
}

export interface IMutationBrazeCohortImportArgs {
  input: IBrazeCohortImportInput;
}

export interface IMutationChannelCreateArgs {
  input: IChannelCreateInput;
}

export interface IMutationChannelViewArgs {
  input: IChannelViewInput;
}

export interface IMutationCohortExecuteArgs {
  input: ICohortExecuteInput;
}

export interface IMutationConversationCommentReactionAddArgs {
  input: ICommentReactionAddInput;
}

export interface IMutationConversationCommentReactionDeleteArgs {
  input: ICommentReactionDeleteInput;
}

export interface IMutationConversationThreadCommentAddArgs {
  input: IThreadCommentAddInput;
}

export interface IMutationConversationThreadCommentDeleteArgs {
  input: IThreadCommentDeleteInput;
}

export interface IMutationConversationThreadCommentUpdateArgs {
  input: IThreadCommentUpdateInput;
}

export interface IMutationConversationThreadReadArgs {
  input: IThreadReadInput;
}

export interface IMutationConversationThreadResolveArgs {
  input: IThreadResolveInput;
}

export interface IMutationConversationThreadStartArgs {
  input: IThreadStartInput;
}

export interface IMutationCreateDashboardImageEmbedUploadConfigArgs {
  input: IDashboardImageEmbedPostUploadConfigInput;
}

export interface IMutationCreateScheduleArgs {
  input: IScheduleInput;
}

export interface IMutationCreateScratchpadImageEmbedUploadConfigArgs {
  input: IScratchpadImageEmbedPostUploadConfigInput;
}

export interface IMutationCustomerSetMtuReportArgs {
  input: ICustomerSetMtuReportInput;
}

export interface IMutationDashboardAddAnalysesArgs {
  input: IDashboardAddAnalysesInput;
}

export interface IMutationDashboardAnalysisAddArgs {
  input: IDashboardAnalysisAddInput;
}

export interface IMutationDashboardCloneArgs {
  input: IDashboardCloneInput;
}

export interface IMutationDashboardCreateArgs {
  input: IDashboardCreateInput;
}

export interface IMutationDashboardDeleteArgs {
  input: IDashboardDeleteInput;
}

export interface IMutationDashboardDuplicateAnalysisArgs {
  input: IDashboardDuplicateAnalysisInput;
}

export interface IMutationDashboardExecuteArgs {
  input: IDashboardExecuteInput;
}

export interface IMutationDashboardExternalEmbedAddArgs {
  input: IDashboardExternalEmbedAddInput;
}

export interface IMutationDashboardExternalEmbedEditArgs {
  input: IDashboardExternalEmbedEditInput;
}

export interface IMutationDashboardFolderCreateArgs {
  input: InputMaybe<ISubFolderCreateInput>;
}

export interface IMutationDashboardFolderDeleteArgs {
  input: InputMaybe<ISubFolderDeleteInput>;
}

export interface IMutationDashboardFolderMoveArgs {
  input: InputMaybe<ISubFolderMoveInput>;
}

export interface IMutationDashboardFolderRenameArgs {
  input: InputMaybe<ISubFolderRenameInput>;
}

export interface IMutationDashboardGridUpdateArgs {
  input: IDashboardGridUpdateInput;
}

export interface IMutationDashboardImageEmbedAddArgs {
  input: IDashboardImageEmbedPostUploadConfigInput;
}

export interface IMutationDashboardImageEmbedEditArgs {
  input: IDashboardImageEmbedEditInput;
}

export interface IMutationDashboardMoveArgs {
  input: IDashboardMoveInput;
}

export interface IMutationDashboardNameEditArgs {
  input: IDashboardNameEditInput;
}

export interface IMutationDashboardRefreshArgs {
  input: IDashboardRefreshInput;
}

export interface IMutationDashboardReplaceAnalysisArgs {
  input: IDashboardReplaceAnalysisInput;
}

export interface IMutationDashboardRichTextAddArgs {
  input: IDashboardRichTextAddInput;
}

export interface IMutationDashboardRichTextEditArgs {
  input: IDashboardRichTextEditInput;
}

export interface IMutationDashboardSetFilterArgs {
  input: IDashboardSetFilterInput;
}

export interface IMutationDashboardUnpublishArgs {
  input: IDashboardUnpublishInput;
}

export interface IMutationDashboardVisitArgs {
  input: IDashboardVisitInput;
}

export interface IMutationDataModelCreateArgs {
  input: IDataModelCreateInput;
}

export interface IMutationDataModelUpdateArgs {
  input: IDataModelUpdateInput;
}

export interface IMutationDataTableExecuteArgs {
  input: IDataTableExecuteInput;
}

export interface IMutationDeleteScheduleArgs {
  id: Scalars['ID']['input'];
}

export interface IMutationEntityCategoryCreateArgs {
  input: IEntityCategoryCreateInput;
}

export interface IMutationEntityCategoryDeleteArgs {
  input: IEntityCategoryDeleteInput;
}

export interface IMutationEntityCategoryEditArgs {
  input: IEntityCategoryEditInput;
}

export interface IMutationEntityPermissionEditArgs {
  input: IEntityPermissionEditInput;
}

export interface IMutationEventLogArgs {
  input: IEventLogInput;
}

export interface IMutationEventRefreshArgs {
  input: IEventRefreshInput;
}

export interface IMutationFavoriteAnalysisArgs {
  input: IFavoriteAnalysisInput;
}

export interface IMutationFavoriteBasicEventArgs {
  input: IFavoriteBasicEventInput;
}

export interface IMutationFavoriteFieldArgs {
  input: IFavoriteFieldInput;
}

export interface IMutationFavoriteVersionEntityArgs {
  input: IFavoriteVersionEntityInput;
}

export interface IMutationFieldAddCategoryArgs {
  input: IFieldEditCategoryInput;
}

export interface IMutationFieldRefreshArgs {
  input: IFieldRefreshInput;
}

export interface IMutationFieldRemoveCategoryArgs {
  input: IFieldEditCategoryInput;
}

export interface IMutationFormatSettingEditArgs {
  input: IFormatSettingEditInput;
}

export interface IMutationFunnelExecuteArgs {
  input: IFunnelExecuteInput;
}

export interface IMutationIncidentCreateArgs {
  input: IIncidentCreateInput;
}

export interface IMutationIncidentDeleteArgs {
  input: IIncidentDeleteInput;
}

export interface IMutationIncidentEditArgs {
  input: IIncidentEditInput;
}

export interface IMutationInspectSubjectArgs {
  input: IInspectSubjectInput;
}

export interface IMutationLlmCreateFormulaTemplateArgs {
  input: ILlmCreateFormulaTemplateInput;
}

export interface IMutationLlmInvalidateSummaryArgs {
  input: InputMaybe<ILlmInvalidateSummaryInput>;
}

export interface IMutationLlmProcessConversationPromptArgs {
  input: ILlmConversationPromptInput;
}

export interface IMutationLlmResetConversationArgs {
  input: ILlmResetConversationInput;
}

export interface IMutationLlmSummarizeEntityArgs {
  input: ILlmSummarizeInput;
}

export interface IMutationLlmUpdateApiConfigArgs {
  input: ILLmConfigInput;
}

export interface IMutationManageBasicEventArgs {
  input: Array<IManageBasicEventInput>;
}

export interface IMutationManageFieldArgs {
  input: Array<IManageFieldInput>;
}

export interface IMutationManageVersionEntityArgs {
  input: Array<IManageVersionEntityInput>;
}

export interface IMutationMessageCreateArgs {
  input: IMessageCreateInput;
}

export interface IMutationMessageDeleteArgs {
  input: IMessageDeleteInput;
}

export interface IMutationNamedBucketDefAddCategoryArgs {
  input: InputMaybe<INamedEntityEditCategoryInput>;
}

export interface IMutationNamedBucketDefCreateArgs {
  input: INamedBucketDefCreateInput;
}

export interface IMutationNamedBucketDefDeleteArgs {
  input: INamedBucketDefDeleteInput;
}

export interface IMutationNamedBucketDefEditArgs {
  input: INamedBucketDefEditInput;
}

export interface IMutationNamedBucketDefRemoveCategoryArgs {
  input: InputMaybe<INamedEntityEditCategoryInput>;
}

export interface IMutationNamedCohortAddCategoryArgs {
  input: INamedEntityEditCategoryInput;
}

export interface IMutationNamedCohortCreateArgs {
  input: INamedCohortCreateInput;
}

export interface IMutationNamedCohortDisableArgs {
  input: INamedCohortDisableInput;
}

export interface IMutationNamedCohortEditArgs {
  input: INamedCohortEditInput;
}

export interface IMutationNamedCohortRemoveCategoryArgs {
  input: INamedEntityEditCategoryInput;
}

export interface IMutationNamedFilterAddCategoryArgs {
  input: INamedEntityEditCategoryInput;
}

export interface IMutationNamedFilterCreateArgs {
  input: INamedFilterCreateInput;
}

export interface IMutationNamedFilterDeleteArgs {
  input: INamedFilterDeleteInput;
}

export interface IMutationNamedFilterEditArgs {
  input: INamedFilterEditInput;
}

export interface IMutationNamedFilterRemoveCategoryArgs {
  input: INamedEntityEditCategoryInput;
}

export interface IMutationNamedMeasureAddCategoryArgs {
  input: INamedEntityEditCategoryInput;
}

export interface IMutationNamedMeasureCreateArgs {
  input: INamedMeasureCreateInput;
}

export interface IMutationNamedMeasureDeleteArgs {
  input: INamedMeasureDeleteInput;
}

export interface IMutationNamedMeasureEditArgs {
  input: INamedMeasureEditInput;
}

export interface IMutationNamedMeasureRemoveCategoryArgs {
  input: INamedEntityEditCategoryInput;
}

export interface IMutationPathExecuteArgs {
  input: IPathExecuteInput;
}

export interface IMutationPauseScheduleArgs {
  id: Scalars['ID']['input'];
}

export interface IMutationPredictionExecuteArgs {
  input: IPredictionExecuteInput;
}

export interface IMutationQueryExecuteArgs {
  input: IQueryExecuteInput;
}

export interface IMutationReportSettingEditArgs {
  input: IReportSettingEditInput;
}

export interface IMutationResumeScheduleArgs {
  id: Scalars['ID']['input'];
}

export interface IMutationRetentionExecuteArgs {
  input: IRetentionExecuteInput;
}

export interface IMutationRoleCreateArgs {
  input: IRoleCreateInput;
}

export interface IMutationRoleDefaultArgs {
  input: IRoleDefaultInput;
}

export interface IMutationRoleDisableArgs {
  input: IRoleDisableInput;
}

export interface IMutationRoleEditArgs {
  input: IRoleEditInput;
}

export interface IMutationRoleEnableArgs {
  input: IRoleEnableInput;
}

export interface IMutationScratchpadCreateArgs {
  input: IScratchpadCreateInput;
}

export interface IMutationScratchpadDeleteArgs {
  input: IScratchpadDeleteInput;
}

export interface IMutationScratchpadEditArgs {
  input: IScratchpadEditInput;
}

export interface IMutationScratchpadNoteAddArgs {
  input: IScratchpadNoteAddInput;
}

export interface IMutationScratchpadNoteDeleteArgs {
  input: IScratchpadNoteDeleteInput;
}

export interface IMutationScratchpadNoteMoveArgs {
  input: IScratchpadNoteMoveInput;
}

export interface IMutationScratchpadTextNoteEditArgs {
  input: IScratchpadTextNoteEditInput;
}

export interface IMutationScratchpadVisitArgs {
  input: IScratchpadVisitInput;
}

export interface IMutationSignificanceExecuteArgs {
  input: ISignificanceExecuteInput;
}

export interface IMutationSlackConnectArgs {
  input: ISlackConnectInput;
}

export interface IMutationSlackDisconnectArgs {
  input: ISlackDisconnectInput;
}

export interface IMutationSlackOAuthCallbackArgs {
  input: ISlackOAuthCallbackInput;
}

export interface IMutationTagCreateArgs {
  input: ITagCreateInput;
}

export interface IMutationTagUpdateArgs {
  input: ITagUpdateInput;
}

export interface IMutationTileAddArgs {
  input: InputMaybe<ITileAddInput>;
}

export interface IMutationTileDeleteArgs {
  input: InputMaybe<ITileDeleteInput>;
}

export interface IMutationTileUpdateArgs {
  input: InputMaybe<ITileUpdateInput>;
}

export interface IMutationTriggerScheduleArgs {
  id: Scalars['ID']['input'];
}

export interface IMutationUpdateScheduleArgs {
  id: Scalars['ID']['input'];
  input: IScheduleInput;
}

export interface IMutationUserDisableArgs {
  input: IUserDisableInput;
}

export interface IMutationUserEditArgs {
  input: IUserEditInput;
}

export interface IMutationUserEnableArgs {
  input: IUserEnableInput;
}

export interface IMutationUserGroupCreateArgs {
  input: IUserGroupCreateInput;
}

export interface IMutationUserGroupDisableArgs {
  input: IUserGroupDisableInput;
}

export interface IMutationUserGroupEditArgs {
  input: IUserGroupEditInput;
}

export interface IMutationUserGroupEnableArgs {
  input: IUserGroupEnableInput;
}

export interface IMutationUserInviteArgs {
  input: IUserInvitesInput;
}

export interface IMutationUserInviteResendArgs {
  input: IUserInviteResendInput;
}

export interface IMutationUserRevokeArgs {
  input: IUserRevokeInput;
}

export interface IMutationUserSettingUpdateArgs {
  input: IUserSettingUpdateInput;
}

export interface IMutationVirtualEventAddCategoryArgs {
  input: INamedEntityEditCategoryInput;
}

export interface IMutationVirtualEventCreateArgs {
  input: IVirtualEventCreateInput;
}

export interface IMutationVirtualEventDeleteArgs {
  input: IVirtualEventDeleteInput;
}

export interface IMutationVirtualEventEditArgs {
  input: IVirtualEventEditInput;
}

export interface IMutationVirtualEventRemoveCategoryArgs {
  input: INamedEntityEditCategoryInput;
}

export interface IMutationWorkspaceCreateArgs {
  input: IWorkspaceCreateInput;
}

export interface IMutationWorkspaceDeleteArgs {
  input: IWorkspaceDeleteInput;
}

export interface IMutationWorkspaceEditArgs {
  input: IWorkspaceEditInput;
}

export interface IMutationWorkspaceScratchpadConvertArgs {
  input: IWorkspaceScratchpadConvertInput;
}

export interface IMutationWsAddAnalysesArgs {
  input: IWsAddAnalysesInput;
}

export interface IMutationWsDeleteAnalysisArgs {
  input: IWsDeleteAnalysisInput;
}

export interface IMutationWsReplaceAnalysisArgs {
  input: IWorkspaceReplaceAnalysisInput;
}

export interface INamedBucketDef {
  __typename: 'NamedBucketDef';
  buckets: Array<IBucket>;
  categories: Array<IEntityCategory>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  description: Maybe<Scalars['String']['output']>;
  editedAt: Scalars['Date']['output'];
  editor: IUser;
  enumBucketField: Maybe<IField>;
  enumBucketSplitOthers: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isLatestVersion: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  kind: BucketKind;
  name: Scalars['String']['output'];
  type: BucketDefType;
  version: Scalars['Int']['output'];
}

export interface INamedBucketDefCreateInput {
  basicInput: IBasicBucketDefInput;
  categories: InputMaybe<Array<Scalars['ID']['input']>>;
  comment: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
}

export interface INamedBucketDefCreatePayload {
  __typename: 'NamedBucketDefCreatePayload';
  entity: Maybe<INamedBucketDef>;
  errors: Array<IError>;
}

export interface INamedBucketDefDeleteInput {
  bucketDefId: Scalars['ID']['input'];
}

export interface INamedBucketDefDeletePayload {
  __typename: 'NamedBucketDefDeletePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface INamedBucketDefEditInput {
  basicInput: InputMaybe<IBasicBucketDefInput>;
  bucketDefId: Scalars['ID']['input'];
  categories: InputMaybe<Array<Scalars['ID']['input']>>;
  comment: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
}

export interface INamedBucketDefEditPayload {
  __typename: 'NamedBucketDefEditPayload';
  entity: Maybe<INamedBucketDef>;
  errors: Array<IError>;
}

export interface INamedBucketDefInput {
  bucketDefId: Scalars['ID']['input'];
}

export interface INamedBucketDefPaginated {
  __typename: 'NamedBucketDefPaginated';
  entities: Array<INamedBucketDef>;
  pageInfo: IPageInfo;
}

export interface INamedCohortCreateInput {
  categories: InputMaybe<Array<Scalars['ID']['input']>>;
  cohort: IBasicCohortInput;
  comment: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  schemaId: Scalars['ID']['input'];
}

export interface INamedCohortCreatePayload {
  __typename: 'NamedCohortCreatePayload';
  entity: Maybe<ICohort>;
  errors: Array<IError>;
}

export interface INamedCohortDisableInput {
  cohortId: Scalars['ID']['input'];
}

export interface INamedCohortDisablePayload {
  __typename: 'NamedCohortDisablePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface INamedCohortEditInput {
  categories: InputMaybe<Array<Scalars['ID']['input']>>;
  cohort: InputMaybe<IBasicCohortInput>;
  comment: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
}

export interface INamedCohortEditPayload {
  __typename: 'NamedCohortEditPayload';
  entity: Maybe<ICohort>;
  errors: Array<IError>;
}

export interface INamedCohortInput {
  /** Cohort id not version id (though they're same in Cohort). */
  id: InputMaybe<Scalars['ID']['input']>;
}

export interface INamedCohortsPaginated {
  __typename: 'NamedCohortsPaginated';
  entities: Array<ICohort>;
  pageInfo: IPageInfo;
}

export interface INamedCompoundMeasureInput {
  versionId: Scalars['ID']['input'];
}

export interface INamedEntityEditCategoryInput {
  categoryIds: Array<Scalars['ID']['input']>;
  entityIds: Array<Scalars['ID']['input']>;
}

export interface INamedEntityEditCategoryPayload {
  __typename: 'NamedEntityEditCategoryPayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface INamedFilter extends IFilter {
  __typename: 'NamedFilter';
  categories: Array<IEntityCategory>;
  comment: Scalars['String']['output'];
  conditions: Array<ICondition>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  description: Scalars['String']['output'];
  editedAt: Scalars['Date']['output'];
  editor: IUser;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isLatestVersion: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  logicOps: Array<ILogicalOperator>;
  name: Scalars['String']['output'];
  schema: ISchema;
  type: FilterType;
  version: Scalars['Int']['output'];
}

export interface INamedFilterCreateInput {
  categories: InputMaybe<Array<Scalars['ID']['input']>>;
  comment: InputMaybe<Scalars['String']['input']>;
  conditions: InputMaybe<Array<InputMaybe<IConditionInput>>>;
  description: InputMaybe<Scalars['String']['input']>;
  logicOps: InputMaybe<Array<InputMaybe<LogicalOperatorKey>>>;
  name: Scalars['String']['input'];
  schema: Scalars['String']['input'];
}

export interface INamedFilterCreatePayload {
  __typename: 'NamedFilterCreatePayload';
  entity: Maybe<INamedFilter>;
  errors: Array<IError>;
}

export interface INamedFilterDeleteInput {
  id: Scalars['ID']['input'];
}

export interface INamedFilterDeletePayload {
  __typename: 'NamedFilterDeletePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface INamedFilterEditInput {
  categories: InputMaybe<Array<Scalars['ID']['input']>>;
  comment: InputMaybe<Scalars['String']['input']>;
  conditions: InputMaybe<Array<IConditionInput>>;
  description: InputMaybe<Scalars['String']['input']>;
  logicOps: InputMaybe<Array<LogicalOperatorKey>>;
  name: InputMaybe<Scalars['String']['input']>;
  /**  This is the one where the edition is applied. */
  namedFilterId: Scalars['ID']['input'];
}

export interface INamedFilterEditPayload {
  __typename: 'NamedFilterEditPayload';
  entity: Maybe<INamedFilter>;
  errors: Array<IError>;
}

export interface INamedFilterInput {
  namedFilterId: InputMaybe<Scalars['ID']['input']>;
}

export interface INamedFilterPaginated {
  __typename: 'NamedFilterPaginated';
  entities: Array<INamedFilter>;
  pageInfo: IPageInfo;
}

export interface INamedMeasureCreateInput {
  categories: InputMaybe<Array<Scalars['ID']['input']>>;
  comment: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  measure: IBasicMeasureInput;
  name: Scalars['String']['input'];
  schema: Scalars['ID']['input'];
}

export interface INamedMeasureCreatePayload {
  __typename: 'NamedMeasureCreatePayload';
  entity: Maybe<IMeasure>;
  errors: Array<IError>;
}

export interface INamedMeasureDeleteInput {
  id: Scalars['ID']['input'];
}

export interface INamedMeasureDeletePayload {
  __typename: 'NamedMeasureDeletePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface INamedMeasureEditInput {
  categories: InputMaybe<Array<Scalars['ID']['input']>>;
  comment: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  measure: InputMaybe<IBasicMeasureInput>;
  name: InputMaybe<Scalars['String']['input']>;
  namedMeasureId: Scalars['ID']['input'];
}

export interface INamedMeasureEditPayload {
  __typename: 'NamedMeasureEditPayload';
  entity: Maybe<IMeasure>;
  errors: Array<IError>;
}

export interface INamedMeasuresPaginated {
  __typename: 'NamedMeasuresPaginated';
  entities: Array<IMeasure>;
  pageInfo: IPageInfo;
}

export interface INamedSimpleMeasureInput {
  versionId: Scalars['ID']['input'];
}

export interface INestedFieldConfig {
  __typename: 'NestedFieldConfig';
  keys: Array<Scalars['String']['output']>;
  types: Array<FieldType>;
}

export interface INestedFieldMetadata {
  __typename: 'NestedFieldMetadata';
  fieldKey: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: FieldType;
}

export interface INonePartition {
  __typename: 'NonePartition';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface INote {
  __typename: 'Note';
  content: INoteContent;
  id: Scalars['ID']['output'];
  seq: Scalars['Int']['output'];
}

export type INoteContent =
  | ICohortNote
  | IDashboardNote
  | IImageEmbedNote
  | IReportNote
  | IRichTextNote;

export interface INotification {
  __typename: 'Notification';
  wsNotifications: Array<IWorkspaceNotification>;
}

export interface INullHypothesisStatsData {
  __typename: 'NullHypothesisStatsData';
  /**  Conversion rate (Chi-square test only)  */
  conversionRate: Maybe<Scalars['Float']['output']>;
  /**
   * Optional error result. If present we should render it and ignore all other data in NullHypothesisStatsData
   * which has default values
   */
  errorMessage: Maybe<Scalars['String']['output']>;
  /**  Standard error (Welch's t-test only)  */
  standardError: Maybe<Scalars['Float']['output']>;
}

export enum OperandType {
  Field = 'FIELD',
  Value = 'VALUE',
}

export type IOperands = IFieldOperands | IValueOperands;

export interface IOperandsInput {
  fieldOperands: InputMaybe<IFieldOperandsInput>;
  type: OperandType;
  valueOperands: InputMaybe<IValueOperandsInput>;
}

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC',
}

export interface IPageInfo {
  __typename: 'PageInfo';
  /**  The index of the first item in the returned page */
  first: Scalars['Int']['output'];
  /**  If there is more items remaining to be fetched */
  hasMore: Scalars['Boolean']['output'];
  /**  The index of the last item in the returned page */
  last: Scalars['Int']['output'];
  /**  total number of items available */
  total: Scalars['Int']['output'];
}

export interface IPaginatedDashboardTemplates {
  __typename: 'PaginatedDashboardTemplates';
  entities: Array<IDashboard>;
  pageInfo: IPageInfo;
}

export interface IPagination {
  /**  after index, default 0 */
  after: InputMaybe<Scalars['Int']['input']>;
  /**  number of items to fetch, if empty or zero, means all */
  first: InputMaybe<Scalars['Int']['input']>;
}

export interface IParentFieldValue {
  __typename: 'ParentFieldValue';
  /**
   * If the field supports refresh.
   * For example, fields like country or app version supports refresh,
   * while fields like event date (temporal) or session duration (linear number) doesn't support refresh.
   */
  refreshable: Scalars['Boolean']['output'];
  /**
   * Parent of the field value.
   * For example, in significance report, Experiment ID is the parent of Variant ID.
   */
  valueParent: Maybe<IFieldValueParent>;
}

export type IPartition =
  | IConversionWindowPartition
  | IFieldPartition
  | INonePartition;

export interface IPartitionInput {
  /** If the partition is WINDOW, the length of the conversion window. Null otherwise */
  conversionWindowInput: InputMaybe<IDurationInput>;
  /** The key of the partition */
  partition: Scalars['String']['input'];
}

export interface IPartitionValue {
  __typename: 'PartitionValue';
  /** If the partition is WINDOW, the length of the conversion window. Null otherwise */
  conversionWindow: Maybe<IDuration>;
  /** The partition */
  partition: IPartition;
}

export interface IPath extends IAnalysis {
  __typename: 'Path';
  container: Maybe<IAnalysisContainer>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  /**  Override data type from interface. */
  data: IPathData;
  datePicker: IDatePicker;
  definition: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diagnosable: Scalars['Boolean']['output'];
  direction: IPathDirection;
  display: Scalars['String']['output'];
  end: Scalars['LocalDate']['output'];
  errorStatus: Maybe<AnalysisErrorStatus>;
  /**
   * Estimated analysis duration determined at submit time (in seconds).
   * Only available for running queries - to be used for progress indication,
   */
  estimatedDuration: Maybe<Scalars['Int']['output']>;
  executedAt: Scalars['Date']['output'];
  exportUrl: Maybe<Scalars['String']['output']>;
  failureMsg: Maybe<Scalars['String']['output']>;
  groupbys: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  kind: AnalysisKind;
  live: Scalars['Boolean']['output'];
  llmSummary: Maybe<ILlmSubjectSummary>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<Scalars['ID']['output']>;
  pref: IAnalysisPref;
  /**  Override query type from interface. */
  query: IPathQuery;
  queryId: Scalars['ID']['output'];
  queryType: QueryType;
  /**  The SQL used to produce this result  */
  referenceSql: Maybe<Scalars['String']['output']>;
  richTextSummary: Maybe<IAnalysisRichTextSummary>;
  schema: ISchema;
  start: Scalars['LocalDate']['output'];
  status: AnalysisStatus;
  timeUnit: TimeUnit;
}

/**  -------- Model Types -----------  */
export interface IPathConfig {
  __typename: 'PathConfig';
  breakdownConfig: IBreakdownConfig;
  cohortConfig: ICohortConfig;
  defaultDatePicker: IDatePicker;
  /**  A date which is supposed to used as the end date when there is no user selection. */
  defaultEnd: Scalars['LocalDate']['output'];
  defaultFormulaSamplingRate: Scalars['Int']['output'];
  defaultGroupby: IGroupby;
  defaultMode: IPathMode;
  defaultPartition: IPartition;
  defaultPartitionWindowTimeUnit: TimeUnit;
  /**  A date which is supposed to used as the start date when there is no user selection. */
  defaultStart: Scalars['LocalDate']['output'];
  defaultSubject: ISubject;
  directions: Array<IPathDirection>;
  groupbys: Array<IGroupby>;
  /**  A date on/after which data is considered to be live. */
  liveStartDate: Scalars['LocalDate']['output'];
  logicOps: Array<ILogicalOperator>;
  modes: Array<IPathMode>;
  partitionWindowTimeUnits: Array<TimeUnit>;
  partitions: Array<IPartition>;
  settings: Array<IPathQuerySetting>;
  subjects: Array<ISubject>;
  timezone: Scalars['String']['output'];
}

export interface IPathData extends IAnalysisData {
  __typename: 'PathData';
  isEmpty: Scalars['Boolean']['output'];
  modeValue: IPathModeValue;
}

export interface IPathDirection {
  __typename: 'PathDirection';
  key: PathDirectionKey;
  name: Scalars['String']['output'];
}

export enum PathDirectionKey {
  Backward = 'BACKWARD',
  Forward = 'FORWARD',
}

export interface IPathExecuteInput {
  breakdown: InputMaybe<IBreakdownInput>;
  cohortRefs: Array<ICohortRefInput>;
  datePicker: IDatePickerInput;
  description: InputMaybe<Scalars['String']['input']>;
  direction: PathDirectionKey;
  display: InputMaybe<Scalars['String']['input']>;
  endConditions: Array<IEventConditionInput>;
  /**  Expand events: Breakdown the event by the specified fields and treat them as independent steps. Up to 3 */
  expandEvents: InputMaybe<Array<IPathExpandEventInput>>;
  filter: InputMaybe<IFilterInput>;
  /** Fold events: fold several steps into one. Up to 3. */
  foldEvents: InputMaybe<Array<IPathFoldEventInput>>;
  groupby: GroupbyKey;
  /**
   * The list LLM Natural Language prompts (and response) used to generate this input. These should be
   * ordered in the reverse chronological order (i.e. newest/last message should be first)
   * Empty list if this input was not generated by a prompt.
   */
  llmChatMessages: Array<ILlmChatMessageInput>;
  /** Merge events: merge several events into one on each step. Up to 3. */
  mergeEvents: InputMaybe<Array<IPathMergeEventInput>>;
  /**
   * Produce Sankey or Top Paths data
   * FIXME: optional for backward compatibility until Caprica catches up
   */
  mode: InputMaybe<PathModeKey>;
  partitions: Array<IPartitionInput>;
  /** Formula sampling rate */
  samplePercentage: InputMaybe<Scalars['Int']['input']>;
  schemaId: Scalars['ID']['input'];
  /**
   * Selected builder settings.
   * Null value results in PathQuerySettingKey.ALL for backwards compatibility until UI changes are implemented.
   * Empty list results in no additional settings selection, i.e. default builder configs.
   */
  settings: InputMaybe<Array<PathQuerySettingKey>>;
  /** Optional reference to analysis which was used as basis of this query */
  sourceId: InputMaybe<Scalars['ID']['input']>;
  startConditions: Array<IEventConditionInput>;
  /**  If null, use default subject. */
  subject: InputMaybe<Scalars['String']['input']>;
}

export interface IPathExecutePayload {
  __typename: 'PathExecutePayload';
  entity: Maybe<IAnalysis>;
  errors: Array<IError>;
}

export interface IPathExpandEvent {
  __typename: 'PathExpandEvent';
  eventCondition: IEventCondition;
  /** Which event field should be included in expansion */
  field: IField;
}

export interface IPathExpandEventInput {
  /** Which event (+ condition when) should to be expanded */
  eventCondition: IEventConditionInput;
  /** The field to include in the expand */
  field: Scalars['String']['input'];
}

export interface IPathFoldEvent {
  __typename: 'PathFoldEvent';
  eventCondition: IEventCondition;
}

export interface IPathFoldEventInput {
  /** Which event (+ condition when) should to be folded */
  eventCondition: IEventConditionInput;
}

export interface IPathMergeEvent {
  __typename: 'PathMergeEvent';
  /** Condition which has to be met for the event to be merged. Null if no condition */
  eventConditions: Array<IEventCondition>;
  isNameAutoGenerated: Scalars['Boolean']['output'];
  /** The name (alias) of the merged event. By default it is '<first event> (+X events)' */
  name: Scalars['String']['output'];
}

export interface IPathMergeEventInput {
  /** Which event (+ condition when) should to be merged */
  eventConditions: Array<IEventConditionInput>;
  /** The name (alias) of the resulting merged event. Optional. */
  name: InputMaybe<Scalars['String']['input']>;
}

export interface IPathMode {
  __typename: 'PathMode';
  key: PathModeKey;
  name: Scalars['String']['output'];
}

export enum PathModeKey {
  Sankey = 'SANKEY',
  TopPaths = 'TOP_PATHS',
}

export type IPathModeValue = ISankeyPathModeValue | ITopPathsPathModeValue;

export interface IPathQuery extends IFormula {
  __typename: 'PathQuery';
  breakdown: Maybe<IBreakdown>;
  cohortRefs: Array<ICohortRef>;
  direction: IPathDirection;
  endConditions: Array<IEventCondition>;
  /**  Expand events: breakdown the event by the specified fields and treat them as independent steps. Up to 3 */
  expandEvents: Array<IPathExpandEvent>;
  filter: Maybe<IFilter>;
  /** Fold events: fold several steps into one. Up to 3. */
  foldEvents: Array<IPathFoldEvent>;
  groupby: Maybe<IGroupby>;
  /** Any LLM chat messages which were used to create this Formula */
  llmChatMessages: Array<ILlmChatMessage>;
  /** Merge events: merge several events into one on each step. Up to 3. */
  mergeEvents: Array<IPathMergeEvent>;
  mode: IPathMode;
  partitions: Array<IPartitionValue>;
  samplePercentage: Maybe<Scalars['Int']['output']>;
  schema: ISchema;
  settings: Array<PathQuerySettingKey>;
  startConditions: Array<IEventCondition>;
  subject: Maybe<ISubject>;
}

export interface IPathQuerySetting {
  __typename: 'PathQuerySetting';
  key: PathQuerySettingKey;
  name: Scalars['String']['output'];
}

export enum PathQuerySettingKey {
  GroupBy = 'GROUP_BY',
  Partition = 'PARTITION',
  Sampling = 'SAMPLING',
}

export interface IPathTemplate {
  __typename: 'PathTemplate';
  datePicker: IDatePicker;
  end: Scalars['LocalDate']['output'];
  query: IPathQuery;
  start: Scalars['LocalDate']['output'];
}

export interface IPercentileFilter {
  __typename: 'PercentileFilter';
  operator: IRelationalOperator;
  values: Array<Scalars['Int']['output']>;
}

/** A percentile filter which is applied over the measure value. Currently available only in Query and Measure cohorts. */
export interface IPercentileFilterInput {
  operator: RelationalOperatorKey;
  values: Array<Scalars['Int']['input']>;
}

export interface IPerformedCohort {
  __typename: 'PerformedCohort';
  categories: Array<IEntityCategory>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  datePicker: Maybe<IDatePicker>;
  /** @deprecated Switch to DatePicker */
  end: Maybe<Scalars['LocalDate']['output']>;
  eventConditions: Array<IEventCondition>;
  filter: Maybe<IFilter>;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  /**
   * This is either the cohort name (for NamedCohort)
   * or a Kobol-generated (breakdown) name (like Cohort 1)
   * or can be null for an anonymous BasicCohort used as a global filter.
   */
  name: Maybe<Scalars['String']['output']>;
  operator: IPerformedCohortOperator;
  operatorValues: Array<Scalars['Int']['output']>;
  schema: ISchema;
  /** @deprecated Switch to DatePicker */
  start: Maybe<Scalars['LocalDate']['output']>;
  subject: ISubject;
  timeWindow: ITimeWindow;
  timeWindowValues: Array<Scalars['Int']['output']>;
  type: ISimpleCohortType;
  userAlias: IUserAliasQueryCohort;
  version: Maybe<IVersion>;
}

export interface IPerformedCohortConfig extends ISimpleCohortConfig {
  __typename: 'PerformedCohortConfig';
  defaultSubject: ISubject;
  defaultTimeWindow: ITimeWindow;
  operators: Array<IPerformedCohortOperator>;
  subjects: Array<ISubject>;
  timeWindows: Array<ITimeWindow>;
}

export interface IPerformedCohortOperator {
  __typename: 'PerformedCohortOperator';
  key: PerformedCohortOperatorKey;
  name: Scalars['String']['output'];
}

export enum PerformedCohortOperatorKey {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  False = 'FALSE',
  Greaterorequal = 'GREATEROREQUAL',
  Greaterthan = 'GREATERTHAN',
  Lessorequal = 'LESSOREQUAL',
  Lessthan = 'LESSTHAN',
  Notequal = 'NOTEQUAL',
  True = 'TRUE',
}

export interface IPermission {
  __typename: 'Permission';
  action: PermissionAction;
  /** Schemas that can accept the permission. */
  assignableSchemas: Array<ISchema>;
  key: PermissionKey;
  /** E.g., "View Dashboard Schedule". */
  name: Scalars['String']['output'];
}

export enum PermissionAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Na = 'NA',
  Read = 'READ',
  Update = 'UPDATE',
}

export interface IPermissionAssignment {
  __typename: 'PermissionAssignment';
  permission: IPermission;
  schemas: Array<ISchema>;
}

export interface IPermissionAssignmentInput {
  permissionKey: PermissionKey;
  schemaIds: Array<Scalars['String']['input']>;
}

export interface IPermissionConfig {
  __typename: 'PermissionConfig';
  allSchema: ISchema;
  enablePermissionControl: Scalars['Boolean']['output'];
  schemas: Array<ISchema>;
}

export enum PermissionEntityType {
  Analysis = 'ANALYSIS',
  BucketDef = 'BUCKET_DEF',
  Category = 'CATEGORY',
  Cohort = 'COHORT',
  Dashboard = 'DASHBOARD',
  DashboardFolder = 'DASHBOARD_FOLDER',
  DataModel = 'DATA_MODEL',
  Event = 'EVENT',
  Field = 'FIELD',
  Filter = 'FILTER',
  Incident = 'INCIDENT',
  Measure = 'MEASURE',
  Permission = 'PERMISSION',
  Role = 'ROLE',
  Schedule = 'SCHEDULE',
  Scratchpad = 'SCRATCHPAD',
  User = 'USER',
  UserGroup = 'USER_GROUP',
  VirtualEvent = 'VIRTUAL_EVENT',
}

export enum PermissionKey {
  AccessAnalytics = 'ACCESS_ANALYTICS',
  AdminCreate = 'ADMIN_CREATE',
  AdminDelete = 'ADMIN_DELETE',
  AdminEdit = 'ADMIN_EDIT',
  AdminRead = 'ADMIN_READ',
  AdminSettingEdit = 'ADMIN_SETTING_EDIT',
  AiSummarize = 'AI_SUMMARIZE',
  AnalysisCreate = 'ANALYSIS_CREATE',
  AnalysisEdit = 'ANALYSIS_EDIT',
  AnalysisRead = 'ANALYSIS_READ',
  AnalysisScheduleCreate = 'ANALYSIS_SCHEDULE_CREATE',
  AnalysisScheduleDelete = 'ANALYSIS_SCHEDULE_DELETE',
  AnalysisScheduleEdit = 'ANALYSIS_SCHEDULE_EDIT',
  AnalysisScheduleRead = 'ANALYSIS_SCHEDULE_READ',
  BucketDefCreate = 'BUCKET_DEF_CREATE',
  BucketDefDelete = 'BUCKET_DEF_DELETE',
  BucketDefEdit = 'BUCKET_DEF_EDIT',
  BucketDefRead = 'BUCKET_DEF_READ',
  /**
   *     INCIDENT_CREATE,
   *     INCIDENT_EDIT,
   *     INCIDENT_READ,
   *     INCIDENT_DELETE,
   */
  CategoryCreate = 'CATEGORY_CREATE',
  CategoryDelete = 'CATEGORY_DELETE',
  CategoryEdit = 'CATEGORY_EDIT',
  CategoryRead = 'CATEGORY_READ',
  CohortBrazeExportCreate = 'COHORT_BRAZE_EXPORT_CREATE',
  CohortBrazeExportDelete = 'COHORT_BRAZE_EXPORT_DELETE',
  CohortBrazeExportEdit = 'COHORT_BRAZE_EXPORT_EDIT',
  CohortBrazeExportRead = 'COHORT_BRAZE_EXPORT_READ',
  CohortCreate = 'COHORT_CREATE',
  CohortDelete = 'COHORT_DELETE',
  CohortEdit = 'COHORT_EDIT',
  CohortRead = 'COHORT_READ',
  CohortReportCreate = 'COHORT_REPORT_CREATE',
  CohortReportEdit = 'COHORT_REPORT_EDIT',
  CohortReportRead = 'COHORT_REPORT_READ',
  CohortSubjectInspect = 'COHORT_SUBJECT_INSPECT',
  DashboardCreate = 'DASHBOARD_CREATE',
  DashboardDelete = 'DASHBOARD_DELETE',
  DashboardEdit = 'DASHBOARD_EDIT',
  DashboardFolderCreate = 'DASHBOARD_FOLDER_CREATE',
  DashboardFolderDelete = 'DASHBOARD_FOLDER_DELETE',
  DashboardFolderEdit = 'DASHBOARD_FOLDER_EDIT',
  DashboardFolderMoveTo = 'DASHBOARD_FOLDER_MOVE_TO',
  DashboardMoveTo = 'DASHBOARD_MOVE_TO',
  DashboardRead = 'DASHBOARD_READ',
  DashboardScheduleCreate = 'DASHBOARD_SCHEDULE_CREATE',
  DashboardScheduleDelete = 'DASHBOARD_SCHEDULE_DELETE',
  DashboardScheduleEdit = 'DASHBOARD_SCHEDULE_EDIT',
  DashboardScheduleRead = 'DASHBOARD_SCHEDULE_READ',
  DataModelCreate = 'DATA_MODEL_CREATE',
  DataModelEdit = 'DATA_MODEL_EDIT',
  DataModelView = 'DATA_MODEL_VIEW',
  DataRefresh = 'DATA_REFRESH',
  EventEdit = 'EVENT_EDIT',
  EventRead = 'EVENT_READ',
  FieldEdit = 'FIELD_EDIT',
  FieldRead = 'FIELD_READ',
  FilterCreate = 'FILTER_CREATE',
  FilterDelete = 'FILTER_DELETE',
  FilterEdit = 'FILTER_EDIT',
  FilterRead = 'FILTER_READ',
  ManageAllEntities = 'MANAGE_ALL_ENTITIES',
  MeasureCreate = 'MEASURE_CREATE',
  MeasureDelete = 'MEASURE_DELETE',
  MeasureEdit = 'MEASURE_EDIT',
  MeasureRead = 'MEASURE_READ',
  ScratchpadCreate = 'SCRATCHPAD_CREATE',
  ScratchpadDelete = 'SCRATCHPAD_DELETE',
  ScratchpadEdit = 'SCRATCHPAD_EDIT',
  ScratchpadRead = 'SCRATCHPAD_READ',
  UserInvite = 'USER_INVITE',
  VirtualEventCreate = 'VIRTUAL_EVENT_CREATE',
  VirtualEventDelete = 'VIRTUAL_EVENT_DELETE',
  VirtualEventEdit = 'VIRTUAL_EVENT_EDIT',
  VirtualEventRead = 'VIRTUAL_EVENT_READ',
}

export interface IPermissionsPaginated {
  __typename: 'PermissionsPaginated';
  entities: Array<IPermission>;
  pageInfo: IPageInfo;
}

export interface IPlanFeature {
  __typename: 'PlanFeature';
  display: Scalars['String']['output'];
  subFeatures: Array<Maybe<Scalars['String']['output']>>;
}

export interface IPostUploadConfig {
  __typename: 'PostUploadConfig';
  amzAlgorithm: Scalars['String']['output'];
  amzCredential: Scalars['String']['output'];
  amzDate: Scalars['String']['output'];
  amzSecurityToken: Maybe<Scalars['String']['output']>;
  amzSignature: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  key: Scalars['String']['output'];
  policy: Scalars['String']['output'];
}

export type IPredicate = IArrayObjectPredicate | ISimplePredicate;

export interface IPredicateInput {
  arrayObjectPredicate: InputMaybe<IArrayObjectPredicateInput>;
  simplePredicate: InputMaybe<ISimplePredicateInput>;
}

export interface IPrediction extends IAnalysis {
  __typename: 'Prediction';
  container: Maybe<IAnalysisContainer>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  /**  Override data type from interface. */
  data: IPredictionData;
  datePicker: IDatePicker;
  definition: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diagnosable: Scalars['Boolean']['output'];
  display: Scalars['String']['output'];
  end: Scalars['LocalDate']['output'];
  errorStatus: Maybe<AnalysisErrorStatus>;
  /**
   * Estimated analysis duration determined at submit time (in seconds).
   * Only available for running queries - to be used for progress indication,
   */
  estimatedDuration: Maybe<Scalars['Int']['output']>;
  executedAt: Scalars['Date']['output'];
  exportUrl: Maybe<Scalars['String']['output']>;
  failureMsg: Maybe<Scalars['String']['output']>;
  groupbys: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  kind: AnalysisKind;
  live: Scalars['Boolean']['output'];
  llmSummary: Maybe<ILlmSubjectSummary>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<Scalars['ID']['output']>;
  pref: IAnalysisPref;
  /**  Override query type from interface. */
  query: IPredictionQuery;
  queryId: Scalars['ID']['output'];
  queryType: QueryType;
  /**  The SQL used to produce this result  */
  referenceSql: Maybe<Scalars['String']['output']>;
  richTextSummary: Maybe<IAnalysisRichTextSummary>;
  schema: ISchema;
  start: Scalars['LocalDate']['output'];
  status: AnalysisStatus;
  timeUnit: TimeUnit;
}

/**  -------- Model Types -----------  */
export interface IPredictionConfig {
  __typename: 'PredictionConfig';
  cohortConfig: ICohortConfig;
  defaultDatePicker: IDatePicker;
  /**  A date which is supposed to used as the end date when there is no user selection. */
  defaultEnd: Scalars['LocalDate']['output'];
  /**  A date which is supposed to used as the start date when there is no user selection. */
  defaultStart: Scalars['LocalDate']['output'];
  /**  A date on/after which data is considered to be live. */
  liveStartDate: Scalars['LocalDate']['output'];
  logicOps: Array<ILogicalOperator>;
  timezone: Scalars['String']['output'];
}

export interface IPredictionData extends IAnalysisData {
  __typename: 'PredictionData';
  correlationKinds: Array<ICorrelationKind>;
  /**  each corresponds to a row in the chart */
  eventCorrelations: Array<IEventCorrelation>;
  events: Array<Scalars['String']['output']>;
  isEmpty: Scalars['Boolean']['output'];
}

export interface IPredictionExecuteInput {
  datePicker: IDatePickerInput;
  description: InputMaybe<Scalars['String']['input']>;
  display: InputMaybe<Scalars['String']['input']>;
  /**  Optional */
  eventCondition: InputMaybe<IEventConditionInput>;
  samplePercentage: InputMaybe<Scalars['Int']['input']>;
  schemaId: Scalars['ID']['input'];
  sourceCohortRef: ICohortRefInput;
  /** Optional reference to analysis which was used as basis of this query */
  sourceId: InputMaybe<Scalars['ID']['input']>;
  targetCohortRef: ICohortRefInput;
  window: Scalars['Int']['input'];
}

export interface IPredictionExecutePayload {
  __typename: 'PredictionExecutePayload';
  entity: Maybe<IAnalysis>;
  errors: Array<IError>;
}

export interface IPredictionQuery extends IFormula {
  __typename: 'PredictionQuery';
  eventCondition: Maybe<IEventCondition>;
  samplePercentage: Maybe<Scalars['Int']['output']>;
  /** analyzable-specific properties */
  schema: ISchema;
  /** prediction-specific properties */
  sourceCohortRef: ICohortRef;
  targetCohortRef: ICohortRef;
  window: Scalars['Int']['output'];
}

/**  ---- model/viewer types */
export interface IPreviewColumnData {
  __typename: 'PreviewColumnData';
  column: Scalars['String']['output'];
  type: FieldType;
  /** A value can be NULL */
  values: Array<Maybe<Scalars['String']['output']>>;
}

export interface IPreviewColumnsData {
  __typename: 'PreviewColumnsData';
  columns: Array<IPreviewColumnData>;
  errors: Array<Scalars['String']['output']>;
  /** Can be null in cases of certain errors */
  sqlQuery: Maybe<Scalars['String']['output']>;
}

export interface IPrivateKeyInput {
  key: Scalars['String']['input'];
  password: InputMaybe<Scalars['String']['input']>;
}

export interface IQuery {
  __typename: 'Query';
  absoluteTimePeriodCompute: IDateRange;
  adminNotificationSettings: IAdminNotificationSettings;
  allowedDomainSetting: Maybe<IAllowedDomainSetting>;
  analysis: Maybe<IAnalysis>;
  anyEvent: IAnyEvent;
  anyTableEvent: IAnyTableEvent;
  anyTableEvents: Array<IAnyTableEvent>;
  basicEvent: Maybe<IBasicEventValue>;
  channel: Maybe<IChannel>;
  cohortExecuteConfig: ICohortExecuteConfig;
  conversationThreads: Array<IConversationThread>;
  customerInfo: ICustomerInfo;
  customerPlan: ICustomerPlan;
  dashboard: IDashboard;
  dashboardConfig: IDashboardConfig;
  /** Retrieve the contents of a given folder, used for browsing folders. */
  dashboardFolder: IDashboardFolder;
  /** If live is true, return a live dashboard. Otherwise return last refreshed dashboard. */
  dashboardFromTemplate: IDashboard;
  dashboardTemplates: IPaginatedDashboardTemplates;
  dashboardTemplatesByScope: Array<IDashboardTemplateGroup>;
  dataModelListCdwObjects: IDataModelCdwObjectsResult;
  /**
   * List all CDW table columns.
   * To be used with new (draft) schemas, results only include what is available from the CDW table.
   */
  dataModelListCdwTableColumns: ITableColumnPaginated;
  /**
   * List all CDW table columns.
   * To be used when requesting columns for existing Schema data source.
   * Results will include any custom column/DSL definitions, in addition to what comes
   * from the CDW.
   */
  dataModelListSchemaTableColumns: ITableColumnPaginated;
  dataModelPreviewColumnsData: IPreviewColumnsData;
  dataModelTestConnection: IDataModelTestConnectionResult;
  dataTableConfig: IDataTableConfig;
  defaultRole: IRole;
  dictionaryBasicEvents: Maybe<IDictionaryBasicEventsConfig>;
  /**  this is for the categories management page, no filtering by entity type, for now. */
  entityCategories: Maybe<IEntityCategoriesPaginated>;
  entityConversationThreads: Array<IConversationThread>;
  entityPermissionConfig: IEntityPermissionConfig;
  eventRefreshMeta: IDataRefreshMeta;
  field: Maybe<IField>;
  fieldRefreshMeta: IDataRefreshMeta;
  fieldValues: Array<IFieldValue>;
  fields: Maybe<Array<IField>>;
  /** Called together with dashboard() on page load, to retrieve its folder. */
  folderOfDashboard: IDashboardFolder;
  formatSettingConfig: IFormatSettingConfig;
  formulaConfig: IFormulaConfig;
  /**  Initial call for funnel builder */
  funnelConfig: Maybe<IFunnelConfig>;
  geoConfig: IGeoConfig;
  globalConfig: IGlobalConfig;
  incidentTypes: Maybe<Array<Maybe<IIncidentType>>>;
  incidents: Maybe<Array<Maybe<IIncident>>>;
  /** Get current llm API Config */
  llmConfig: ILlmConfig;
  /** Get the current user (per-schema) AI conversation. */
  llmSchemaConversation: Maybe<ILlmConversation>;
  /**
   * Get an UploadEntity with pre-signed URL to upload a Dashboard or Report screenshot to S3 and
   * then pass the UploadEntity objectKey as a screenshotS3Key in chat mutation
   */
  llmTempImagePreUpload: IUploadEntity;
  measureFormulaValidate: IMeasureFormulaValidationResult;
  messagesAfter: Maybe<IMessagesAfterPayload>;
  messagesBefore: Maybe<IMessagesBeforePayload>;
  namedBucket: INamedBucketDef;
  namedBucketDefs: Maybe<INamedBucketDefPaginated>;
  namedCohort: ICohort;
  /** Return all versions instances for a given (version instance) id. */
  namedCohortVersions: Array<ICohort>;
  namedCohorts: INamedCohortsPaginated;
  namedFilter: INamedFilter;
  namedFilters: Maybe<INamedFilterPaginated>;
  namedMeasure: IMeasure;
  namedMeasures: Maybe<INamedMeasuresPaginated>;
  nestedField: Maybe<INestedFieldConfig>;
  notification: Maybe<INotification>;
  pathConfig: Maybe<IPathConfig>;
  permissionConfig: IPermissionConfig;
  permissions: IPermissionsPaginated;
  preUpload: Maybe<IUploadEntity>;
  /**  Initial call for prediction builder */
  predictionConfig: Maybe<IPredictionConfig>;
  /**  Initial call for default query builder */
  queryConfig: Maybe<IQueryConfig>;
  recentActivity: Array<IRecentActivity>;
  retentionConfig: Maybe<IRetentionConfig>;
  role: IRole;
  roles: IRolesPaginated;
  scheduleConfig: Maybe<IScheduleConfig>;
  scheduleGet: ISchedule;
  scheduleHistory: Maybe<Array<Maybe<IScheduleRun>>>;
  schemaConfig: Maybe<ISchemaConfig>;
  schemaDataModel: ISchemaDataModel;
  scratchpadGet: IScratchpad;
  scratchpads: IScratchpadsPayload;
  search: ISearchPaginated;
  /**  Return analyses with basic info only (no query and data). */
  searchAnalysis: Maybe<IAnalysesPaginated>;
  searchAnalysisVisits: Maybe<IAnalysisVisitsPaginated>;
  searchSchedules: Maybe<ISchedulePaginated>;
  searchTags: ISearchTagPayload;
  significanceConfig: ISignificanceConfig;
  slackConnection: Maybe<ISlackConnection>;
  /**
   * Get the destination entities (e.g. member or channel) from the installed slack workspace.
   * According to the business requirements, we only return one member (session user) for now.
   */
  slackDestinationEntities: ISlackDestinationEntities;
  tilesGet: ITilesPayload;
  user: IUser;
  userGroup: IUserGroup;
  userGroups: IUserGroupsPaginated;
  userSetting: Maybe<IUserSetting>;
  userSettingList: Array<IUserSetting>;
  users: IUsersPaginated;
  virtualEvent: IVirtualEvent;
  /**
   * Return all version instances for given (version instance) id
   * (including the one corresponding to the requested id).
   */
  virtualEventVersions: Maybe<Array<IVirtualEvent>>;
  virtualEvents: Maybe<IVirtualEventPaginated>;
  workspace: Maybe<IWorkspace>;
  workspaceList: Maybe<IWorkspacePaginated>;
}

export interface IQueryAbsoluteTimePeriodComputeArgs {
  input: IRelativeTimePeriodComputeInput;
}

export interface IQueryAnalysisArgs {
  analysisId: Scalars['ID']['input'];
  fillData?: Scalars['Boolean']['input'];
  refresh?: Scalars['Boolean']['input'];
}

export interface IQueryAnyTableEventArgs {
  key: Scalars['String']['input'];
  schemaId: Scalars['ID']['input'];
}

export interface IQueryAnyTableEventsArgs {
  schemaId: Scalars['ID']['input'];
}

export interface IQueryBasicEventArgs {
  key: Scalars['String']['input'];
  schemaId: Scalars['ID']['input'];
}

export interface IQueryChannelArgs {
  id: Scalars['ID']['input'];
}

export interface IQueryCohortExecuteConfigArgs {
  schemaId: Scalars['ID']['input'];
}

export interface IQueryConversationThreadsArgs {
  ids: Array<Scalars['ID']['input']>;
}

export interface IQueryDashboardArgs {
  id: Scalars['ID']['input'];
}

export interface IQueryDashboardFolderArgs {
  folderId?: InputMaybe<Scalars['ID']['input']>;
}

export interface IQueryDashboardFromTemplateArgs {
  baseId: Scalars['ID']['input'];
}

export interface IQueryDashboardTemplatesArgs {
  favoriteOnly: Scalars['Boolean']['input'];
  isPublished: InputMaybe<Scalars['Boolean']['input']>;
  pagination: IPagination;
  sharedWithMeOnly?: Scalars['Boolean']['input'];
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryDashboardTemplatesByScopeArgs {
  scopes: Array<DashboardTemplateScope>;
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryDataModelListCdwObjectsArgs {
  connection?: InputMaybe<IConnectionInput>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  schema: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryDataModelListCdwTableColumnsArgs {
  connection: IConnectionInput;
  pagination?: IPagination;
  sqlTableName: Scalars['String']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryDataModelListSchemaTableColumnsArgs {
  connection?: InputMaybe<IConnectionInput>;
  pagination?: IPagination;
  schema: Scalars['String']['input'];
  sqlTableName?: InputMaybe<Scalars['String']['input']>;
  tableKey?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  viewKey?: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryDataModelPreviewColumnsDataArgs {
  connection: InputMaybe<IConnectionInput>;
  draftColumns: Array<IColumnWithTypeInput>;
  expandReferences?: Scalars['Boolean']['input'];
  limit?: Scalars['Int']['input'];
  schema: InputMaybe<Scalars['String']['input']>;
  selectColumns: Array<IColumnWithTypeInput>;
  sqlTableName: InputMaybe<Scalars['String']['input']>;
  tableKey: InputMaybe<Scalars['String']['input']>;
  timeConfig?: InputMaybe<ITimeConfigInput>;
}

export interface IQueryDataModelTestConnectionArgs {
  connection: IConnectionInput;
}

export interface IQueryDataTableConfigArgs {
  schemaId: Scalars['ID']['input'];
}

export interface IQueryDictionaryBasicEventsArgs {
  schemaId: Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryEntityCategoriesArgs {
  includes: Array<Scalars['ID']['input']>;
  pagination: IPagination;
  schemaIds: Array<Scalars['ID']['input']>;
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryEntityConversationThreadsArgs {
  ids: Array<IConversationEntityInput>;
}

export interface IQueryEventRefreshMetaArgs {
  schemaId: Scalars['ID']['input'];
}

export interface IQueryFieldArgs {
  key: Scalars['String']['input'];
  schemaId: Scalars['ID']['input'];
}

export interface IQueryFieldRefreshMetaArgs {
  fieldKey: InputMaybe<Scalars['String']['input']>;
  schemaId: Scalars['ID']['input'];
}

export interface IQueryFieldValuesArgs {
  events?: InputMaybe<Array<IEventInput>>;
  fieldKey: Scalars['ID']['input'];
  includeAny?: Scalars['Boolean']['input'];
  includeValues: Array<Scalars['String']['input']>;
  parents: Array<Scalars['String']['input']>;
  schemaId: Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryFieldsArgs {
  context: FieldContext;
  events?: Array<IEventInput>;
  func: InputMaybe<Scalars['String']['input']>;
  includeFields?: Array<Scalars['String']['input']>;
  schemaId: Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryFolderOfDashboardArgs {
  dashboardBaseId: Scalars['ID']['input'];
}

export interface IQueryFormulaConfigArgs {
  schemaId: Scalars['String']['input'];
}

export interface IQueryFunnelConfigArgs {
  schemaId: Scalars['ID']['input'];
}

export interface IQueryIncidentsArgs {
  end: InputMaybe<Scalars['LocalDate']['input']>;
  keyword: InputMaybe<Scalars['String']['input']>;
  start: InputMaybe<Scalars['LocalDate']['input']>;
  typeIds: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
}

export interface IQueryLlmSchemaConversationArgs {
  limit?: Scalars['Int']['input'];
  schemaId: Scalars['String']['input'];
}

export interface IQueryMeasureFormulaValidateArgs {
  input: IMeasureFormulaInput;
}

export interface IQueryMessagesAfterArgs {
  channelId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
}

export interface IQueryMessagesBeforeArgs {
  channelId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
  messageId: Scalars['ID']['input'];
}

export interface IQueryNamedBucketArgs {
  id: Scalars['ID']['input'];
}

export interface IQueryNamedBucketDefsArgs {
  field: InputMaybe<Scalars['String']['input']>;
  includes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  kinds: InputMaybe<Array<InputMaybe<BucketKind>>>;
  pagination?: InputMaybe<IPagination>;
  schemaId: InputMaybe<Scalars['ID']['input']>;
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryNamedCohortArgs {
  id: Scalars['ID']['input'];
}

export interface IQueryNamedCohortVersionsArgs {
  id: Scalars['ID']['input'];
}

export interface IQueryNamedCohortsArgs {
  includeCompound?: Scalars['Boolean']['input'];
  includes?: Array<Scalars['ID']['input']>;
  pagination?: IPagination;
  schemaId: InputMaybe<Scalars['ID']['input']>;
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryNamedFilterArgs {
  id: Scalars['ID']['input'];
}

export interface IQueryNamedFiltersArgs {
  includes?: Array<Scalars['ID']['input']>;
  pagination?: IPagination;
  schemaId: Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryNamedMeasureArgs {
  id: Scalars['ID']['input'];
}

export interface IQueryNamedMeasuresArgs {
  includes?: Array<Scalars['ID']['input']>;
  pagination?: IPagination;
  schemaId: Scalars['ID']['input'];
  searchNamedMeasureOption: InputMaybe<SearchNamedMeasureOption>;
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryNestedFieldArgs {
  context: FieldContext;
  events?: InputMaybe<Array<IEventInput>>;
  field: Scalars['String']['input'];
  func: InputMaybe<Scalars['String']['input']>;
  includeValues?: Array<Scalars['String']['input']>;
  schemaId: Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryPathConfigArgs {
  schemaId: Scalars['ID']['input'];
}

export interface IQueryPermissionsArgs {
  pagination: IPagination;
}

export interface IQueryPreUploadArgs {
  id: Scalars['ID']['input'];
  kind: UploadKind;
}

export interface IQueryPredictionConfigArgs {
  schemaId: Scalars['ID']['input'];
}

export interface IQueryQueryConfigArgs {
  schemaId: Scalars['ID']['input'];
}

export interface IQueryRetentionConfigArgs {
  schemaId: Scalars['ID']['input'];
}

export interface IQueryRoleArgs {
  id: Scalars['ID']['input'];
}

export interface IQueryRolesArgs {
  includeDisabled: Scalars['Boolean']['input'];
  includes: Array<Scalars['ID']['input']>;
  pagination: IPagination;
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryScheduleGetArgs {
  id: Scalars['ID']['input'];
}

export interface IQueryScheduleHistoryArgs {
  pagination: IPagination;
  scheduleId: Scalars['ID']['input'];
}

export interface IQuerySchemaDataModelArgs {
  schema: Scalars['String']['input'];
}

export interface IQueryScratchpadGetArgs {
  id: Scalars['ID']['input'];
}

export interface IQuerySearchArgs {
  activeSchemas?: Scalars['Boolean']['input'];
  categoryIds: Array<Scalars['ID']['input']>;
  editorIds?: Array<Scalars['ID']['input']>;
  failedReports?: Scalars['Boolean']['input'];
  favoriteOnly?: Scalars['Boolean']['input'];
  isDisabled: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdateDateRange: InputMaybe<IDateRangeInput>;
  pagination: IPagination;
  queryTypes: Array<QueryType>;
  schemaIds: Array<Scalars['ID']['input']>;
  term: InputMaybe<Scalars['String']['input']>;
  timezone: InputMaybe<Scalars['String']['input']>;
  types: Array<SearchEntityType>;
}

export interface IQuerySearchAnalysisArgs {
  favoriteOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<IAnalysisFilter>;
  includes?: Array<Scalars['ID']['input']>;
  kind: InputMaybe<AnalysisKind>;
  pagination: IPagination;
  queryTypes?: Array<QueryType>;
  schemaIds?: Array<Scalars['ID']['input']>;
  statuses?: Array<InputMaybe<AnalysisStatus>>;
  term: InputMaybe<Scalars['String']['input']>;
  userOnly?: Scalars['Boolean']['input'];
}

export interface IQuerySearchAnalysisVisitsArgs {
  pagination: IPagination;
  queryTypes?: Array<QueryType>;
  schemaIds?: Array<Scalars['ID']['input']>;
  statuses?: Array<InputMaybe<AnalysisStatus>>;
}

export interface IQuerySearchSchedulesArgs {
  includes: Array<Scalars['ID']['input']>;
  pagination: IPagination;
  schemaKey: InputMaybe<Scalars['String']['input']>;
  term: InputMaybe<Scalars['String']['input']>;
  types: Array<ScheduleType>;
}

export interface IQuerySearchTagsArgs {
  managedOnly?: Scalars['Boolean']['input'];
  schemaId: Scalars['ID']['input'];
  searchTerm: InputMaybe<Scalars['String']['input']>;
  tags: Array<ITagOptionInput>;
}

export interface IQuerySignificanceConfigArgs {
  schemaId: Scalars['ID']['input'];
}

export interface IQuerySlackConnectionArgs {
  input: ISlackSourceInput;
}

export interface IQuerySlackDestinationEntitiesArgs {
  channelLimit: Scalars['Int']['input'];
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryUserArgs {
  id: Scalars['ID']['input'];
}

export interface IQueryUserGroupArgs {
  id: Scalars['ID']['input'];
}

export interface IQueryUserGroupsArgs {
  includeDisabled: Scalars['Boolean']['input'];
  includes: Array<Scalars['ID']['input']>;
  pagination: IPagination;
  term: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<UserGroupType>;
}

export interface IQueryUserSettingArgs {
  kind: UserSettingKind;
}

export interface IQueryUsersArgs {
  includes: Array<Scalars['ID']['input']>;
  pagination: IPagination;
  term: InputMaybe<Scalars['String']['input']>;
  userStates?: Array<UserState>;
}

export interface IQueryVirtualEventArgs {
  id: Scalars['ID']['input'];
}

export interface IQueryVirtualEventVersionsArgs {
  virtualEventId: Scalars['ID']['input'];
}

export interface IQueryVirtualEventsArgs {
  includes?: Array<Scalars['ID']['input']>;
  pagination?: IPagination;
  schemaId: Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryWorkspaceArgs {
  id: Scalars['ID']['input'];
}

export interface IQueryWorkspaceListArgs {
  includes?: Array<Scalars['ID']['input']>;
  pagination: IPagination;
  term: InputMaybe<Scalars['String']['input']>;
}

export interface IQueryBasicConfig {
  __typename: 'QueryBasicConfig';
  breakdownConfig: IBreakdownConfig;
  cohortConfig: ICohortConfig;
  dateKinds: Array<IDateKind>;
  /**  Last N days depending on the date diff between default start and end. */
  defaultDatePicker: IDatePicker;
  /**  A date which is supposed to used as the end date when there is no user selection. */
  defaultEnd: Scalars['LocalDate']['output'];
  /**  A date which is supposed to used as the start date when there is no user selection. */
  defaultStart: Scalars['LocalDate']['output'];
  /**  A date on/after which data is considered to be live. */
  liveStartDate: Scalars['LocalDate']['output'];
  logicOps: Array<ILogicalOperator>;
  timezone: Scalars['String']['output'];
}

export interface IQueryConfig {
  __typename: 'QueryConfig';
  basicConfig: IQueryBasicConfig;
  defaultFormulaSamplingRate: Scalars['Int']['output'];
  defaultMode: IExpressionMode;
  /** @deprecated Will be removed after KB-7438. Please use the one in ExpressionHistogramConfig. */
  defaultSubject: ISubject;
  defaultTimeUnit: TimeUnit;
  measureFunctions: Array<IMeasureFunction>;
  measureRelOps: Array<IRelationalOperator>;
  modeConfigs: IExpressionModeConfigs;
  modes: Array<IExpressionMode>;
  /** @deprecated Will be removed after KB-7438. Please use the one in each ExpressionModeConfig. */
  settings: Array<IExpressionQuerySetting>;
  /** @deprecated Will be removed after KB-7438. Please use the one in ExpressionHistogramConfig. */
  subjectBucketKinds: Array<BucketKind>;
  /** @deprecated Will be removed after KB-7438. Please use the one in ExpressionHistogramConfig. */
  subjects: Array<ISubject>;
  /** @deprecated Will be removed after KB-7438. Please use the one in ExpressionImpactConfig. */
  triggerSubjects: Array<ISubject>;
}

export interface IQueryExecuteInput {
  basicInput: IExecuteBasicInput;
  expression: IExpressionInput;
}

export interface IQueryExecutePayload {
  __typename: 'QueryExecutePayload';
  entity: Maybe<IAnalysis>;
  errors: Array<IError>;
}

export interface IQueryMetric {
  __typename: 'QueryMetric';
  expression: IExpression;
  measure: IMeasure;
}

export interface IQueryMetricInput {
  analysisId: Scalars['ID']['input'];
  measureId: Scalars['ID']['input'];
}

export interface IQueryModeXAxis {
  __typename: 'QueryModeXAxis';
  cohortDates: Array<ICohortDate>;
}

export enum QueryType {
  CohortSample = 'COHORT_SAMPLE',
  DataTable = 'DATA_TABLE',
  Expression = 'EXPRESSION',
  Funnel = 'FUNNEL',
  Path = 'PATH',
  Prediction = 'PREDICTION',
  Retention = 'RETENTION',
  Significance = 'SIGNIFICANCE',
}

export interface IRangeBucket {
  __typename: 'RangeBucket';
  isCustomName: Scalars['Boolean']['output'];
  kind: BucketKind;
  max: Maybe<Scalars['BigDecimal']['output']>;
  min: Maybe<Scalars['BigDecimal']['output']>;
  /**  default: "<min", "min-max", ">=max" */
  name: Scalars['String']['output'];
}

export interface IRangeBucketInput {
  max: InputMaybe<Scalars['BigDecimal']['input']>;
  min: InputMaybe<Scalars['BigDecimal']['input']>;
  /**  optional */
  name: InputMaybe<Scalars['String']['input']>;
}

export interface IRawSqlDefinitionInput {
  fullDataRequired: Scalars['Boolean']['input'];
  rawSql: Scalars['String']['input'];
}

export interface IRawSqlDefinitionMeta {
  __typename: 'RawSqlDefinitionMeta';
  column: Scalars['String']['output'];
  fullDataRequired: Scalars['Boolean']['output'];
  rawSql: Scalars['String']['output'];
}

export interface IRawSqlDerivedFieldMeta {
  __typename: 'RawSqlDerivedFieldMeta';
  fullDataRequired: Scalars['Boolean']['output'];
  rawSql: Scalars['String']['output'];
}

export interface IReading {
  __typename: 'Reading';
  highlights: Array<IHighlight>;
  /**  MA, later can add trend line, range (min, max, avg, 95-percentile) etc. */
  ma: Maybe<IMovingAverage>;
  ma30: Maybe<IMovingAverage>;
  ms7: Maybe<IMovingSum>;
  ms30: Maybe<IMovingSum>;
  /**  Pearson Correlation Coefficient, correlation between this column and the matching column in the Base slice. */
  pcc: Scalars['Float']['output'];
}

export type IRecentActivity = IRecentAnalysisVisit | IRecentDashboardVisit;

export interface IRecentAnalysisVisit {
  __typename: 'RecentAnalysisVisit';
  analysisId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  description: Scalars['String']['output'];
  display: Scalars['String']['output'];
  isFavorite: Scalars['Boolean']['output'];
  lastEditor: IUser;
  queryType: QueryType;
  status: AnalysisStatus;
  visitedAt: Scalars['Date']['output'];
}

export interface IRecentDashboardVisit {
  __typename: 'RecentDashboardVisit';
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  dashboardBaseId: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  display: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  lastEditor: IUser;
  visitedAt: Scalars['Date']['output'];
}

/**  -------- Model Types -----------  */
export interface IRelationalOperator {
  __typename: 'RelationalOperator';
  key: RelationalOperatorKey;
  name: Scalars['String']['output'];
  supportCaseInsensitive: Scalars['Boolean']['output'];
  /**  Use relOp values by default, otherwise using field values. */
  values: Array<Scalars['String']['output']>;
}

/**  Operators supporting lookup: EQUAL, NOTEQUAL. */
export enum RelationalOperatorKey {
  Between = 'BETWEEN',
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equal = 'EQUAL',
  Exists = 'EXISTS',
  Greaterorequal = 'GREATEROREQUAL',
  Greaterthan = 'GREATERTHAN',
  IsEmpty = 'IS_EMPTY',
  Lessorequal = 'LESSOREQUAL',
  Lessthan = 'LESSTHAN',
  Matches = 'MATCHES',
  Notequal = 'NOTEQUAL',
  NotContains = 'NOT_CONTAINS',
  NotEndsWith = 'NOT_ENDS_WITH',
  NotMatches = 'NOT_MATCHES',
  NotStartsWith = 'NOT_STARTS_WITH',
  StartsWith = 'STARTS_WITH',
}

export interface IRelativeTimePeriodComputeInput {
  datePicker: IDatePickerInput;
  endDate: Scalars['LocalDate']['input'];
  schemaId: InputMaybe<Scalars['String']['input']>;
}

export interface IReportNote {
  __typename: 'ReportNote';
  analysis: IAnalysis;
}

export interface IReportSetting {
  __typename: 'ReportSetting';
  funnel: IFunnelSetting;
  inspect: IInspectSetting;
}

export interface IReportSettingEditInput {
  funnel: InputMaybe<IFunnelSettingEditInput>;
  inspect: InputMaybe<IInspectSettingEditInput>;
}

export interface IReportSettingEditPayload {
  __typename: 'ReportSettingEditPayload';
  entity: Maybe<IReportSetting>;
  errors: Array<IError>;
}

export interface IRetention extends IAnalysis {
  __typename: 'Retention';
  container: Maybe<IAnalysisContainer>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  /**  Override data type from interface. */
  data: IRetentionData;
  datePicker: IDatePicker;
  definition: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diagnosable: Scalars['Boolean']['output'];
  display: Scalars['String']['output'];
  end: Scalars['LocalDate']['output'];
  errorStatus: Maybe<AnalysisErrorStatus>;
  /**
   * Estimated analysis duration determined at submit time (in seconds).
   * Only available for running queries - to be used for progress indication,
   */
  estimatedDuration: Maybe<Scalars['Int']['output']>;
  executedAt: Scalars['Date']['output'];
  exportUrl: Maybe<Scalars['String']['output']>;
  failureMsg: Maybe<Scalars['String']['output']>;
  groupbys: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  kind: AnalysisKind;
  live: Scalars['Boolean']['output'];
  llmSummary: Maybe<ILlmSubjectSummary>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<Scalars['ID']['output']>;
  pref: IAnalysisPref;
  /** retention-specific properties */
  query: IRetentionQuery;
  queryId: Scalars['ID']['output'];
  queryType: QueryType;
  /**  The SQL used to produce this result  */
  referenceSql: Maybe<Scalars['String']['output']>;
  richTextSummary: Maybe<IAnalysisRichTextSummary>;
  schema: ISchema;
  start: Scalars['LocalDate']['output'];
  status: AnalysisStatus;
  timeUnit: TimeUnit;
}

export interface IRetentionCalculation {
  __typename: 'RetentionCalculation';
  key: RetentionCalculationKey;
  name: Scalars['String']['output'];
}

export enum RetentionCalculationKey {
  /**
   * Based on the initial (starting event) cohort (Day/Week/Month 0). Independently finds users who meet the "return"
   * criteria and were part of the starting event retention cohort period, regardless of whether or not they were in
   * the cohort for the previous period.
   */
  Normal = 'NORMAL',
  /**
   * Based on the previous (Day/Week/Month N-1) cohort. Finds users who meet "return" criteria and were part of the
   * previous period (initial or return period). Users must continually meet the "return" criteria period over period.
   */
  Rolling = 'ROLLING',
  /**
   * While N-Day/Normal retention tells the percentage of users who come back and fire the return event on a specific
   * day, unbounded retention tells how many of your users fire that return event on a specific day or later. If a new
   * user is inactive on days 1, 2, and 3 but active on day 4, the user will be counted as day 1, 2, 3, and 4 retained.
   */
  Unbounded = 'UNBOUNDED',
}

export interface IRetentionCalculationWindow {
  __typename: 'RetentionCalculationWindow';
  key: RetentionCalculationWindowKey;
  name: Scalars['String']['output'];
}

export enum RetentionCalculationWindowKey {
  /**
   * Considers that starting event timestamp to be the beginning of that user’s Day 0. In other words, Day 0 runs for
   * the first 24 hours after the user fires the starting event. Day 1 runs from hour 24 to hour 48, Day 2 from hour 48
   * to hour 72, and so on. Under this approach, each day will be exactly the same length, no matter when the user fired
   * the starting event.
   */
  Rolling_24Hours = 'ROLLING_24_HOURS',
  /**
   * Daily calendar dates start when the calendar day starts, and end when the calendar day ends. Under this approach
   * starting event day may be shorter compared to the rest of the days.
   */
  StrictCalendarDate = 'STRICT_CALENDAR_DATE',
}

export interface IRetentionCohort {
  __typename: 'RetentionCohort';
  analysis: IRetention;
  categories: Array<IEntityCategory>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  datePicker: Maybe<IDatePicker>;
  durationStartDate: Maybe<Scalars['LocalDate']['output']>;
  /** @deprecated Switch to DatePicker */
  end: Maybe<Scalars['LocalDate']['output']>;
  filter: Maybe<IFilter>;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  lookForwardWindow: Maybe<Scalars['Int']['output']>;
  /**
   * This is either the cohort name (for NamedCohort)
   * or a Kobol-generated (breakdown) name (like Cohort 1)
   * or can be null for an anonymous BasicCohort used as a global filter.
   */
  name: Maybe<Scalars['String']['output']>;
  operator: IRetentionCohortOperator;
  operatorValues: Array<Scalars['Int']['output']>;
  returnedOperator: Maybe<IRelationalOperator>;
  schema: ISchema;
  /** @deprecated Switch to DatePicker */
  start: Maybe<Scalars['LocalDate']['output']>;
  subject: ISubject;
  timeWindow: ITimeWindow;
  timeWindowValues: Array<Scalars['Int']['output']>;
  type: ISimpleCohortType;
  userAlias: IUserAliasQueryCohort;
  version: Maybe<IVersion>;
}

export interface IRetentionCohortConfig extends ISimpleCohortConfig {
  __typename: 'RetentionCohortConfig';
  defaultSubject: ISubject;
  defaultTimeWindow: ITimeWindow;
  operators: Array<IRetentionCohortOperator>;
  returnedOperators: Array<IRelationalOperator>;
  subjects: Array<ISubject>;
  timeWindows: Array<ITimeWindow>;
}

export interface IRetentionCohortOperator {
  __typename: 'RetentionCohortOperator';
  key: RetentionCohortOperatorKey;
  name: Scalars['String']['output'];
}

export enum RetentionCohortOperatorKey {
  NotRetained = 'NOT_RETAINED',
  NotRetainedOn = 'NOT_RETAINED_ON',
  NotRetainedSince = 'NOT_RETAINED_SINCE',
  Retained = 'RETAINED',
  RetainedBetween = 'RETAINED_BETWEEN',
  RetainedOn = 'RETAINED_ON',
  RetainedSince = 'RETAINED_SINCE',
  Returned = 'RETURNED',
}

export interface IRetentionCohortStart {
  __typename: 'RetentionCohortStart';
  actualInterval: IRetentionInterval;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startInterval: IRetentionInterval;
}

export interface IRetentionConfig {
  __typename: 'RetentionConfig';
  attributions: Array<IAttribution>;
  availableRetentionUnits: Array<IAvailableRetentionUnit>;
  breakdownConfig: IBreakdownConfig;
  calculationWindows: Array<IRetentionCalculationWindow>;
  calculations: Array<IRetentionCalculation>;
  cohortConfig: ICohortConfig;
  cohortUnits: Array<TimeUnit>;
  defaultAttribution: IAttribution;
  defaultCalculation: IRetentionCalculation;
  defaultCalculationWindow: IRetentionCalculationWindow;
  defaultDatePicker: IDatePicker;
  /**  A date which is supposed to used as the end date when there is no user selection. */
  defaultEnd: Scalars['LocalDate']['output'];
  defaultFormulaSamplingRate: Scalars['Int']['output'];
  defaultGroupby: IGroupby;
  defaultRetentionView: IRetentionView;
  /**  A date which is supposed to used as the start date when there is no user selection. */
  defaultStart: Scalars['LocalDate']['output'];
  defaultSubject: ISubject;
  groupbys: Array<IGroupby>;
  /**  A date on/after which data is considered to be live. */
  liveStartDate: Scalars['LocalDate']['output'];
  logicOps: Array<ILogicalOperator>;
  retentionUnits: Array<TimeUnit>;
  retentionViews: Array<IRetentionView>;
  settings: Array<IRetentionQuerySetting>;
  subjects: Array<ISubject>;
  timezone: Scalars['String']['output'];
}

export interface IRetentionData extends IAnalysisData {
  __typename: 'RetentionData';
  base: Maybe<IRetentionSlice>;
  isEmpty: Scalars['Boolean']['output'];
  /**  Correlates to dates, e.g., live[i] contains live information for the row lead by dates[i]. */
  live: Array<IRetentionLive>;
  rows: Array<IRetentionRow>;
  slices: Array<IRetentionSlice>;
  tableRowSelector: Maybe<IRetentionTableRowSelector>;
}

export interface IRetentionExecuteInput {
  attribution: AttributionKey;
  breakdown: InputMaybe<IBreakdownInput>;
  /** How to calculate the retention. If null, RetentionCalculationKey.NORMAL is assumed */
  calculation: RetentionCalculationKey;
  /** How to calculate the retention windows. If null, RetentionCalculationWindowKey.STRICT_CALENDAR_DATE is assumed */
  calculationWindow: RetentionCalculationWindowKey;
  cohortRefs: Array<ICohortRefInput>;
  cohortUnit: TimeUnit;
  customTimeBrackets: Array<Scalars['Int']['input']>;
  datePicker: IDatePickerInput;
  description: InputMaybe<Scalars['String']['input']>;
  display: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<IFilterInput>;
  groupby: GroupbyKey;
  /**
   * The list LLM Natural Language prompts (and response) used to generate this input. These should be
   * ordered in the reverse chronological order (i.e. newest/last message should be first)
   * Empty list if this input was not generated by a prompt.
   */
  llmChatMessages: Array<ILlmChatMessageInput>;
  /**  Must be smaller or equal to cohortUnit. */
  retentionUnit: TimeUnit;
  retentionView: RetentionViewKey;
  /**
   * For backward compatibility, set empty list as default values,
   * but pass the parameter explicitly because the default value will be removed soon.
   */
  returnConditions: Array<IEventConditionInput>;
  /** Formula Sampling Rate */
  samplePercentage: InputMaybe<Scalars['Int']['input']>;
  schemaId: Scalars['ID']['input'];
  /**
   * Selected builder settings.
   * Null value results in RetentionQuerySettingKey.ALL for backwards compatibility until UI changes are implemented.
   * Empty list results in no additional settings selection, i.e. default builder configs.
   */
  settings: InputMaybe<Array<RetentionQuerySettingKey>>;
  /** Optional reference to analysis which was used as basis of this query */
  sourceId: InputMaybe<Scalars['ID']['input']>;
  /**
   * For backward compatibility, set empty list as default values,
   * but pass the parameter explicitly because the default value will be removed soon.
   */
  startConditions: Array<IEventConditionInput>;
  subject: InputMaybe<Scalars['String']['input']>;
  /**  Null means no time window. */
  timeWindow: InputMaybe<Scalars['Int']['input']>;
}

export interface IRetentionExecutePayload {
  __typename: 'RetentionExecutePayload';
  entity: Maybe<IAnalysis>;
  errors: Array<IError>;
}

export interface IRetentionInterval {
  __typename: 'RetentionInterval';
  end: Scalars['LocalDate']['output'];
  start: Scalars['LocalDate']['output'];
}

export interface IRetentionLive {
  __typename: 'RetentionLive';
  /**  sync with startIdentities */
  cohortLive: Scalars['Boolean']['output'];
  /**  sync with returnIdentities */
  retentionLive: Array<Scalars['Boolean']['output']>;
}

export interface IRetentionMetric {
  __typename: 'RetentionMetric';
  retention: IRetention;
}

export interface IRetentionMetricInput {
  analysisId: Scalars['ID']['input'];
}

export interface IRetentionOverTimeTableRowSelector {
  __typename: 'RetentionOverTimeTableRowSelector';
  columns: Array<IRetentionCohortStart>;
  rows: Array<IReturnPeriodRow>;
}

export interface IRetentionQuery extends IFormula {
  __typename: 'RetentionQuery';
  attribution: Maybe<IAttribution>;
  breakdown: Maybe<IBreakdown>;
  /** How the retention is calculated: based on the initial cohort (NORMAL) or based on previous "return" cohort (ROLLING) */
  calculation: IRetentionCalculation;
  calculationWindow: IRetentionCalculationWindow;
  cohortRefs: Array<ICohortRef>;
  cohortUnit: TimeUnit;
  customTimeBrackets: Array<Scalars['Int']['output']>;
  filter: Maybe<IFilter>;
  groupby: Maybe<IGroupby>;
  /** Any LLM chat messages which were used to create this Formula */
  llmChatMessages: Array<ILlmChatMessage>;
  retentionUnit: TimeUnit;
  returnConditions: Array<IEventCondition>;
  samplePercentage: Maybe<Scalars['Int']['output']>;
  schema: ISchema;
  settings: Array<RetentionQuerySettingKey>;
  startConditions: Array<IEventCondition>;
  subject: Maybe<ISubject>;
  timeWindow: Maybe<Scalars['Int']['output']>;
  view: IRetentionView;
}

export interface IRetentionQuerySetting {
  __typename: 'RetentionQuerySetting';
  key: RetentionQuerySettingKey;
  name: Scalars['String']['output'];
}

/**  -------- Model Types -----------  */
export enum RetentionQuerySettingKey {
  Attribution = 'ATTRIBUTION',
  GroupBy = 'GROUP_BY',
  Sampling = 'SAMPLING',
}

export interface IRetentionRow {
  __typename: 'RetentionRow';
  /** Absolute count = startIdentities - returnIdentities */
  churnIdentities: Array<Scalars['Float']['output']>;
  /** Percents = 100% - retentions%. Null if startIdentities = 0 */
  churns: Array<Maybe<Scalars['Float']['output']>>;
  /** Unique identity. */
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Percents = returnIdentities / startIdentities. Null if startIdentities = 0 */
  retentions: Array<Maybe<Scalars['Float']['output']>>;
  returnIdentities: Array<Scalars['Float']['output']>;
  startIdentities: Scalars['Float']['output'];
}

export interface IRetentionRowTooltip {
  __typename: 'RetentionRowTooltip';
  dnDisplayValues: Array<Scalars['String']['output']>;
}

export interface IRetentionSlice extends ISlice {
  __typename: 'RetentionSlice';
  /**  list of fields to display that produced this slice  */
  hint: Array<ISliceNameHint>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rank: Maybe<Scalars['Int']['output']>;
  /**  Correspond to the dates. */
  rowIndices: Array<Scalars['Int']['output']>;
  userAlias: IUserAliasSlice;
}

export interface IRetentionStandardAverage {
  __typename: 'RetentionStandardAverage';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rowIndices: Array<Scalars['Int']['output']>;
}

export interface IRetentionStandardTableRowSelector {
  __typename: 'RetentionStandardTableRowSelector';
  avgRetention: IRetentionStandardAverage;
  columns: Array<IReturnPeriod>;
  rows: Array<ICohortStartRow>;
}

export type IRetentionTableRowSelector =
  | IRetentionOverTimeTableRowSelector
  | IRetentionStandardTableRowSelector;

export interface IRetentionTemplate {
  __typename: 'RetentionTemplate';
  datePicker: IDatePicker;
  end: Scalars['LocalDate']['output'];
  query: IRetentionQuery;
  start: Scalars['LocalDate']['output'];
}

export interface IRetentionView {
  __typename: 'RetentionView';
  key: RetentionViewKey;
  name: Scalars['String']['output'];
}

export enum RetentionViewKey {
  /** Retention view allows all well-known Retention configurations. */
  Retention = 'RETENTION',
  /**
   * Retention over time shows your retention data over time.
   * You might want to know how a new release has affected your product’s Day 1 retention rates,
   * or if a new training program has had an impact on your Day 14 retention rates.
   */
  RetentionOverTime = 'RETENTION_OVER_TIME',
  /**
   * The usage interval shows the percentage of users who’ve fired the selected event(s) with a specified daily,
   * weekly, or monthly median frequency. In order words return events are computed as median for each user's starting
   * event day.
   */
  UsageInterval = 'USAGE_INTERVAL',
  /** When you select the Usage Interval Over Time view, you’ll see how the median frequency between events changes over time. */
  UsageIntervalOverTime = 'USAGE_INTERVAL_OVER_TIME',
}

export interface IReturnPeriod {
  __typename: 'ReturnPeriod';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface IReturnPeriodRow {
  __typename: 'ReturnPeriodRow';
  returnIntervals: Array<IRetentionInterval>;
  returnPeriod: IReturnPeriod;
  rowIndices: Array<Scalars['Int']['output']>;
}

export interface IRichText {
  __typename: 'RichText';
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
}

export interface IRichTextGridUpdateInput {
  richTextId: Scalars['ID']['input'];
}

export interface IRichTextInput {
  html: Scalars['String']['input'];
}

export interface IRichTextNote {
  __typename: 'RichTextNote';
  richText: IRichText;
}

export interface IRole {
  __typename: 'Role';
  active: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissionAssignments: Array<IPermissionAssignment>;
  type: RoleType;
}

export interface IRoleCreateInput {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  permissionAssignments: Array<IPermissionAssignmentInput>;
}

export interface IRoleCreatePayload {
  __typename: 'RoleCreatePayload';
  entity: Maybe<IRole>;
  errors: Array<IError>;
}

export interface IRoleDefaultInput {
  roleId: Scalars['ID']['input'];
}

export interface IRoleDefaultPayload {
  __typename: 'RoleDefaultPayload';
  errors: Array<IError>;
}

/** Not support disabling these roles: admin, default. */
export interface IRoleDisableInput {
  roleId: Scalars['ID']['input'];
}

export interface IRoleDisablePayload {
  __typename: 'RoleDisablePayload';
  disabled: Maybe<Scalars['Boolean']['output']>;
  errors: Array<IError>;
}

/** Not support editing an admin role. */
export interface IRoleEditInput {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** Optional. Null means no change. (IMPORTANT) Empty will wipe out all the existing assignments. */
  permissionAssignments: InputMaybe<Array<IPermissionAssignmentInput>>;
  roleId: Scalars['ID']['input'];
}

export interface IRoleEditPayload {
  __typename: 'RoleEditPayload';
  entity: Maybe<IRole>;
  errors: Array<IError>;
}

/** Not support enabling these roles: admin. */
export interface IRoleEnableInput {
  roleId: Scalars['ID']['input'];
}

export interface IRoleEnablePayload {
  __typename: 'RoleEnablePayload';
  enabled: Maybe<Scalars['Boolean']['output']>;
  errors: Array<IError>;
}

export enum RoleType {
  Admin = 'ADMIN',
  Custom = 'CUSTOM',
}

export interface IRolesPaginated {
  __typename: 'RolesPaginated';
  entities: Array<IRole>;
  pageInfo: IPageInfo;
}

export interface IRollingControl {
  __typename: 'RollingControl';
  function: RollingControlFunction;
  window: Scalars['Int']['output'];
}

export enum RollingControlFunction {
  Avg = 'AVG',
  Sum = 'SUM',
  Window = 'WINDOW',
}

export interface IRollingControlInput {
  function: RollingControlFunction;
  window: Scalars['Int']['input'];
}

export interface IRollingEndDateMeta {
  __typename: 'RollingEndDateMeta';
  kind: EndDateConfigKind;
  rollingCount: Scalars['Int']['output'];
  rollingTimeUnit: EndDateTimeUnitKind;
}

export interface ISamplingConfigInput {
  cohort: Scalars['Int']['input'];
  default: Scalars['Int']['input'];
}

export interface ISankeyPathModeValue {
  __typename: 'SankeyPathModeValue';
  base: Maybe<IFlow>;
  flows: Array<IFlow>;
}

export interface ISchedule {
  __typename: 'Schedule';
  alertOnly: Scalars['Boolean']['output'];
  /** The user who created this schedule */
  creator: IUser;
  /**  null if it's a one-time execution. */
  cron: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  editedAt: Scalars['Date']['output'];
  editor: IUser;
  emailList: Array<Scalars['String']['output']>;
  /**
   *  Comma separated email address.
   * @deprecated Please switch to emailList.
   */
  emails: Scalars['String']['output'];
  entity: IScheduleEntity;
  /**
   *  For dashboard, the entityId must be the template id.
   *  Deprecated in favor of entity
   */
  entityId: Scalars['ID']['output'];
  entityUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastRunAt: Maybe<Scalars['Date']['output']>;
  lastRunStatus: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nextRunAt: Maybe<Scalars['Date']['output']>;
  paused: Scalars['Boolean']['output'];
  /**
   * A list of users corresponding to the email specified in "emails" attribute.
   * If there is no user for an email, return NULL.
   * If one email matches multiple users, return the most recent one.
   */
  recipients: Array<Maybe<IUser>>;
  /** Only supported when type is ANALYSIS or DASHBOARD. */
  slackDestination: Maybe<ISlackDestination>;
  /** Null if one-time execution. In which timezone the schedule is running */
  timezone: Maybe<Scalars['String']['output']>;
  type: ScheduleType;
}

/**  -------- Model Types -----------  */
export interface IScheduleConfig {
  __typename: 'ScheduleConfig';
  alertThresholdCompareOps: Array<IAlertThresholdCompareOp>;
  domains: Array<Scalars['String']['output']>;
  limits: Array<IScheduleTypeLimit>;
  names: Array<Scalars['String']['output']>;
  types: Array<ScheduleType>;
}

export interface IScheduleCreatePayload {
  __typename: 'ScheduleCreatePayload';
  errors: Array<IError>;
  schedule: Maybe<ISchedule>;
}

export interface IScheduleDeletePayload {
  __typename: 'ScheduleDeletePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export type IScheduleEntity =
  | IAnalysisScheduleEntity
  | ICohortScheduleEntity
  | IDashboardScheduleEntity;

export interface IScheduleInput {
  /** Only relevant for type DASHBOARD, when empty all analysis should be checked for alerts */
  alertAnalysisIds: Array<Scalars['ID']['input']>;
  /**  Optional. Default is false. If true, the email will be sent only the scheduler detects anomalies. */
  alertOnly: InputMaybe<Scalars['Boolean']['input']>;
  /**  alertThresholds is only allowed with Analysis Schedules */
  alertThresholds: InputMaybe<IAlertThresholdsInput>;
  /**
   * Whether to delete (in braze) previously imported users, not part of this batch.
   * Not subject to change after initial schedule creation so ignored on edit operation
   */
  brazeRemoveOutdated: InputMaybe<Scalars['Boolean']['input']>;
  /**
   *  We support three type of cron frequence: DAILY, MONTHLY and WEEKLY. Below are examples:
   *    DAILY: FREQ=DAILY;INTERVAL=<interval, default 1>;BYSECOND=<second>;BYMINUTE=<minute>;BYHOUR=<list of hour>
   *    MONTHLY: FREQ=MONTHLY;INTERVAL=<interval, default 1>;BYMONTHDAY=<days of the month>;BYSECOND=<second>;BYMINUTE=<minute>;BYHOUR=<list of hour>
   *    WEEKLY: FREQ=WEEKLY;INTERVAL<interval, default 1>;BYDAY=<days of week>;BYSECOND=<second>;BYMINUTE=<minute>;BYHOUR=<list of hour>
   *    MONTHLY specific weekday: FREQ=MONTHLY;INTERVAL<interval, default 1>;BYDAY=<number><day of week>;BYSECOND=<second>;BYMINUTE=<minute>;BYHOUR=<list of hour>
   *  Null means it's a one-time execution.
   */
  cron: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  /**  Comma separated email address. The domain of each email should be the same as customer's domain. */
  emailList: Array<Scalars['String']['input']>;
  /**  As for dashboard, the entityId must be the template Id. */
  entityId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  /**  Whether the job should be paused. This is only meaningful when cron is also specified, */
  paused: InputMaybe<Scalars['Boolean']['input']>;
  /** Only supported when type is ANALYSIS or DASHBOARD. */
  slackDestination: InputMaybe<ISlackDestinationInput>;
  /**
   * Optional. Browser's timezone, preferably as time zone database name like "America/Los_Angeles" but also works a
   * timezone abbreviation like "PST" but not recommended because it doesn't capture daylight saving time rules
   */
  timezone: InputMaybe<Scalars['String']['input']>;
  type: ScheduleType;
}

export interface ISchedulePaginated {
  __typename: 'SchedulePaginated';
  entities: Array<ISchedule>;
  pageInfo: IPageInfo;
}

export interface ISchedulePausePayload {
  __typename: 'SchedulePausePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IScheduleResumePayload {
  __typename: 'ScheduleResumePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IScheduleRun {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  outcome: ScheduleRunOutcome;
  runAt: Scalars['Date']['output'];
  schedule: ISchedule;
}

export enum ScheduleRunOutcome {
  Anomaly = 'ANOMALY',
  Failed = 'FAILED',
  Normal = 'NORMAL',
}

export interface IScheduleTriggerPayload {
  __typename: 'ScheduleTriggerPayload';
  errors: Array<IError>;
  /** @deprecated Get message from triggered field */
  message: Maybe<Scalars['String']['output']>;
  triggered: Maybe<IScheduleTriggered>;
}

export interface IScheduleTriggered {
  __typename: 'ScheduleTriggered';
  message: Scalars['String']['output'];
  schedule: ISchedule;
}

export enum ScheduleType {
  Analysis = 'ANALYSIS',
  BrazeCohortImport = 'BRAZE_COHORT_IMPORT',
  Dashboard = 'DASHBOARD',
}

export interface IScheduleTypeLimit {
  __typename: 'ScheduleTypeLimit';
  exceeded: Scalars['Boolean']['output'];
  maxCount: Maybe<Scalars['Int']['output']>;
  type: ScheduleType;
}

export interface IScheduledRefreshStatus {
  __typename: 'ScheduledRefreshStatus';
  activeCount: Scalars['Int']['output'];
  limit: Maybe<Scalars['Int']['output']>;
}

export interface ISchema {
  __typename: 'Schema';
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isInternal: Scalars['Boolean']['output'];
  latestDataAt: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  /** Certain schemas (e.g. Kubit Analytics) require an extra permission to be accessible */
  requiredPermission: Maybe<PermissionKey>;
  supportsAnyEvent: Scalars['Boolean']['output'];
}

/**  -------- Model Types -----------  */
export interface ISchemaConfig {
  __typename: 'SchemaConfig';
  /** All (including inactive/disabled) schemas */
  allSchemas: Array<ISchema>;
  /**
   * This can be null, if there are no active schemas.
   * In that case the UI should redirect all other URLs to DataModeler.
   */
  defaultSchemaId: Maybe<Scalars['ID']['output']>;
  /** Active schemas */
  schemas: Array<ISchema>;
}

/** --- The schema data model fields */
export interface ISchemaDataModel {
  __typename: 'SchemaDataModel';
  dataRefresh: IDataRefreshConfigMeta;
  derivedFields: Array<ISchemaFieldMeta>;
  description: Maybe<Scalars['String']['output']>;
  dimensions: Array<IDimensionDataModel>;
  disabled: Scalars['Boolean']['output'];
  dsConfig: ISchemaDsConfig;
  eventTemporals: IDataModelTemporalFieldRefs;
  fact: IFactDataModel;
  funnelPartitions: Array<IFunnelPartition>;
  /** optional */
  installTemporals: Maybe<IDataModelTemporalFieldRefs>;
  key: Scalars['String']['output'];
  lockedTtlSeconds: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  sampling: IDataModelSamplingConfig;
  subjects: Array<IDataModelSubjectRef>;
  tables: Array<ITableMeta>;
  version: Scalars['Int']['output'];
}

/** This object encapsulates the Schema DS config. Limited use for now, to be extended in the future */
export interface ISchemaDsConfig {
  __typename: 'SchemaDsConfig';
  connection: IConnectionMeta;
  dateDt: Maybe<Scalars['String']['output']>;
  endDate: IEndDateConfigMeta;
  path: Array<ICdwObjectPathComponent>;
  timezone: Scalars['String']['output'];
  weekStart: WeekStart;
}

export interface ISchemaFieldMeta {
  __typename: 'SchemaFieldMeta';
  column: Scalars['String']['output'];
  deprecated: Scalars['Boolean']['output'];
  /** only derived fields will have this */
  derivedDefinition: Maybe<IDerivedFieldDefinitionMeta>;
  description: Maybe<Scalars['String']['output']>;
  fieldClass: FieldClass;
  filter: Scalars['Boolean']['output'];
  groupby: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** can be empty list for derived fields */
  tableFields: Array<ITableField>;
  type: FieldType;
}

export interface ISchemaInspectSetting {
  __typename: 'SchemaInspectSetting';
  fields: Array<IField>;
  schema: ISchema;
}

export interface ISchemaInspectSettingEditInput {
  fieldKeys: Array<Scalars['String']['input']>;
  schemaKey: Scalars['String']['input'];
}

export interface IScratchpad {
  __typename: 'Scratchpad';
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  editedAt: Scalars['Date']['output'];
  editor: IUser;
  id: Scalars['ID']['output'];
  notes: Maybe<Array<Maybe<INote>>>;
  permission: IEntityPermission;
  shared: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
}

export interface IScratchpadCohortInput {
  cohortId: Scalars['ID']['input'];
}

export interface IScratchpadCreateInput {
  title: Scalars['String']['input'];
}

export interface IScratchpadCreatePayload {
  __typename: 'ScratchpadCreatePayload';
  entity: Maybe<IScratchpad>;
  errors: Array<IError>;
}

export interface IScratchpadDashboardInput {
  baseId: Scalars['ID']['input'];
}

export interface IScratchpadDeleteInput {
  scratchpadId: Scalars['ID']['input'];
}

export interface IScratchpadDeletePayload {
  __typename: 'ScratchpadDeletePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IScratchpadEditInput {
  scratchpadId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}

export interface IScratchpadEditPayload {
  __typename: 'ScratchpadEditPayload';
  entity: Maybe<IScratchpad>;
  errors: Array<IError>;
}

export interface IScratchpadImageEmbedPostUploadConfigInput {
  scratchpadId: Scalars['ID']['input'];
}

export interface IScratchpadImageEmbedUploadConfig {
  __typename: 'ScratchpadImageEmbedUploadConfig';
  imageEmbed: IImageEmbed;
  postUploadConfig: IPostUploadConfig;
}

export interface IScratchpadNoteAddInput {
  cohort: InputMaybe<IScratchpadCohortInput>;
  dashboard: InputMaybe<IScratchpadDashboardInput>;
  imageEmbed: InputMaybe<IImageEmbedInput>;
  noteType: ScratchpadNoteType;
  report: InputMaybe<IScratchpadReportInput>;
  richText: InputMaybe<IRichTextInput>;
  scratchpadId: Scalars['ID']['input'];
  seq: InputMaybe<Scalars['Int']['input']>;
}

export interface IScratchpadNoteAddPayload {
  __typename: 'ScratchpadNoteAddPayload';
  entity: Maybe<IScratchpad>;
  errors: Array<IError>;
}

export interface IScratchpadNoteDeleteInput {
  noteId: Scalars['ID']['input'];
  scratchpadId: Scalars['ID']['input'];
}

export interface IScratchpadNoteDeletePayload {
  __typename: 'ScratchpadNoteDeletePayload';
  entity: Maybe<IScratchpad>;
  errors: Array<IError>;
}

export interface IScratchpadNoteMoveInput {
  noteId: Scalars['ID']['input'];
  scratchpadId: Scalars['ID']['input'];
  seq: Scalars['Int']['input'];
}

export interface IScratchpadNoteMovePayload {
  __typename: 'ScratchpadNoteMovePayload';
  entity: Maybe<IScratchpad>;
  errors: Array<IError>;
}

export enum ScratchpadNoteType {
  Cohort = 'COHORT',
  Dashboard = 'DASHBOARD',
  Image = 'IMAGE',
  Report = 'REPORT',
  Text = 'TEXT',
}

export interface IScratchpadReportInput {
  analysisId: Scalars['ID']['input'];
}

export interface IScratchpadTextNoteEditInput {
  html: Scalars['String']['input'];
  noteId: Scalars['ID']['input'];
  scratchpadId: Scalars['ID']['input'];
}

export interface IScratchpadTextNoteEditPayload {
  __typename: 'ScratchpadTextNoteEditPayload';
  entity: Maybe<IRichTextNote>;
  errors: Array<IError>;
}

export interface IScratchpadVisitInput {
  scratchpadId: Scalars['ID']['input'];
}

export interface IScratchpadVisitPayload {
  __typename: 'ScratchpadVisitPayload';
  entity: Maybe<IScratchpad>;
  errors: Array<IError>;
}

export interface IScratchpadsPayload {
  __typename: 'ScratchpadsPayload';
  entities: Array<IScratchpad>;
}

export interface ISearchAnalysis {
  __typename: 'SearchAnalysis';
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  /** Description about the entity's content. */
  detail: Scalars['String']['output'];
  editedAt: Scalars['Date']['output'];
  editor: IUser;
  id: Scalars['ID']['output'];
  /** Always false for now, for the convenience/consistency to the client. */
  isDisabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  queryType: QueryType;
  schema: ISchema;
  status: AnalysisStatus;
  type: SearchEntityType;
  updatedAt: Scalars['Date']['output'];
}

export interface ISearchDashboard {
  __typename: 'SearchDashboard';
  baseId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  /** Description about the entity's content. */
  detail: Scalars['String']['output'];
  editedAt: Scalars['Date']['output'];
  editor: IUser;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Folder path. */
  path: Scalars['String']['output'];
  type: SearchEntityType;
  updatedAt: Scalars['Date']['output'];
}

export interface ISearchDashboardFolder {
  __typename: 'SearchDashboardFolder';
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  /** Description about the entity's content. */
  detail: Scalars['String']['output'];
  editedAt: Scalars['Date']['output'];
  editor: IUser;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Folder path. */
  path: Scalars['String']['output'];
  type: SearchEntityType;
  updatedAt: Scalars['Date']['output'];
}

export type ISearchEntity =
  | IIdSearchEntity
  | IKeySearchEntity
  | ISearchAnalysis
  | ISearchDashboard
  | ISearchDashboardFolder
  | ISearchSchedule;

export enum SearchEntityType {
  Analysis = 'ANALYSIS',
  BucketDef = 'BUCKET_DEF',
  Cohort = 'COHORT',
  Dashboard = 'DASHBOARD',
  Event = 'EVENT',
  Field = 'FIELD',
  Filter = 'FILTER',
  Measure = 'MEASURE',
  Schedule = 'SCHEDULE',
  VirtualEvent = 'VIRTUAL_EVENT',
  /**     DASHBOARD_FOLDER */
  Workspace = 'WORKSPACE',
}

export interface ISearchHighlight {
  __typename: 'SearchHighlight';
  /** The name of the property which is highlighted, such as the "detail". */
  field: Scalars['String']['output'];
  highlightedRanges: Array<ISearchHighlightRange>;
}

export interface ISearchHighlightRange {
  __typename: 'SearchHighlightRange';
  /** exclusive end index of the highlighted term. */
  end: Scalars['Int']['output'];
  /** Inclusive start index of the highlighted term. */
  start: Scalars['Int']['output'];
}

export interface ISearchItem {
  __typename: 'SearchItem';
  entity: ISearchEntity;
  highlight: Array<ISearchHighlight>;
}

export enum SearchNamedMeasureOption {
  All = 'ALL',
  NoRollingControl = 'NO_ROLLING_CONTROL',
  OnlyRollingControl = 'ONLY_ROLLING_CONTROL',
}

export interface ISearchPaginated {
  __typename: 'SearchPaginated';
  entities: Array<ISearchItem>;
  pageInfo: IPageInfo;
}

export interface ISearchSchedule {
  __typename: 'SearchSchedule';
  categories: Array<IEntityCategory>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  /** Description about the entity's content. */
  detail: Scalars['String']['output'];
  editedAt: Scalars['Date']['output'];
  editor: IUser;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  scheduleType: ScheduleType;
  /** Null for dashboard schedule. */
  schema: Maybe<ISchema>;
  type: SearchEntityType;
  updatedAt: Scalars['Date']['output'];
}

export interface ISearchTagPayload {
  __typename: 'SearchTagPayload';
  defaultNodeIndex: Maybe<Scalars['Int']['output']>;
  mapping: Array<ITagMapping>;
  nodes: Array<ITagNode>;
}

export interface ISegmentConfig {
  __typename: 'SegmentConfig';
  writeKey: Maybe<Scalars['String']['output']>;
}

export interface ISegmentCriteria {
  __typename: 'SegmentCriteria';
  controlGroup: ICohort;
  variants: Array<ICohort>;
}

export interface ISegmentCriteriaInput {
  control: Scalars['ID']['input'];
  variants: Array<Scalars['ID']['input']>;
}

export interface ISignificance extends IAnalysis {
  __typename: 'Significance';
  container: Maybe<IAnalysisContainer>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  /**  Override data type from interface. */
  data: ISignificanceData;
  datePicker: IDatePicker;
  /**  do we need this? */
  definition: Scalars['String']['output'];
  description: Scalars['String']['output'];
  diagnosable: Scalars['Boolean']['output'];
  display: Scalars['String']['output'];
  end: Scalars['LocalDate']['output'];
  errorStatus: Maybe<AnalysisErrorStatus>;
  /**
   * Estimated analysis duration determined at submit time (in seconds).
   * Only available for running queries - to be used for progress indication,
   */
  estimatedDuration: Maybe<Scalars['Int']['output']>;
  executedAt: Scalars['Date']['output'];
  exportUrl: Maybe<Scalars['String']['output']>;
  failureMsg: Maybe<Scalars['String']['output']>;
  groupbys: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incidents: Array<IIncident>;
  isFavorite: Scalars['Boolean']['output'];
  kind: AnalysisKind;
  live: Scalars['Boolean']['output'];
  llmSummary: Maybe<ILlmSubjectSummary>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<Scalars['ID']['output']>;
  pref: IAnalysisPref;
  /** Data Table - specific properties */
  query: ISignificanceQuery;
  queryId: Scalars['ID']['output'];
  queryType: QueryType;
  /**  The SQL used to produce this result  */
  referenceSql: Maybe<Scalars['String']['output']>;
  richTextSummary: Maybe<IAnalysisRichTextSummary>;
  schema: ISchema;
  start: Scalars['LocalDate']['output'];
  status: AnalysisStatus;
  timeUnit: TimeUnit;
}

export interface ISignificanceConfig {
  __typename: 'SignificanceConfig';
  cohortConfig: ICohortConfig;
  defaultDatePicker: IDatePicker;
  defaultEnd: Scalars['LocalDate']['output'];
  defaultFormulaSamplingRate: Scalars['Int']['output'];
  defaultMetric: IMetricType;
  defaultMode: ISignificanceMode;
  defaultStart: Scalars['LocalDate']['output'];
  defaultSubject: ISubject;
  defaultTest: ISignificanceTest;
  defaultTimeUnit: TimeUnit;
  /**  Defined only of the schema supports Experiment mode  */
  experimentConfig: Maybe<IExperiment>;
  liveStartDate: Scalars['LocalDate']['output'];
  metrics: Array<IMetricType>;
  modes: Array<ISignificanceMode>;
  schema: Scalars['String']['output'];
  subjects: Array<ISubject>;
  tests: Array<ISignificanceTest>;
  timeUnits: Array<TimeUnit>;
  timezone: Scalars['String']['output'];
}

export type ISignificanceCriteria =
  | IBreakdownCriteria
  | IExperimentCriteria
  | ISegmentCriteria;

export interface ISignificanceData extends IAnalysisData {
  __typename: 'SignificanceData';
  hypotheses: Array<IHypothesis>;
  hypothesisResults: Array<IExperimentResult>;
  isEmpty: Scalars['Boolean']['output'];
  metric: Scalars['String']['output'];
  nullHypothesis: IHypothesis;
}

export interface ISignificanceExecuteInput {
  /**  Global filters by cohort  */
  cohortRefs: Array<ICohortRefInput>;
  confidenceLevel: Scalars['Int']['input'];
  criteria: ICriteriaInput;
  datePicker: IDatePickerInput;
  description: InputMaybe<Scalars['String']['input']>;
  display: InputMaybe<Scalars['String']['input']>;
  /**  Global filters by field  */
  filter: InputMaybe<IFilterInput>;
  /**
   * The list LLM Natural Language prompts (and response) used to generate this input. These should be
   * ordered in the reverse chronological order (i.e. newest/last message should be first)
   * Empty list if this input was not generated by a prompt.
   */
  llmChatMessages: Array<ILlmChatMessageInput>;
  metric: IMetricInput;
  samplePercentage: InputMaybe<Scalars['Int']['input']>;
  schemaId: Scalars['String']['input'];
  significanceLevel: Scalars['BigDecimal']['input'];
  sourceId: InputMaybe<Scalars['ID']['input']>;
  subject: Scalars['String']['input'];
  test: SignificanceTestKey;
  unit: TimeUnit;
}

export interface ISignificanceExecutePayload {
  __typename: 'SignificanceExecutePayload';
  entity: Maybe<IAnalysis>;
  errors: Array<IError>;
}

export type ISignificanceMetric =
  | IFunnelMetric
  | IMeasureMetric
  | IQueryMetric
  | IRetentionMetric;

export interface ISignificanceMode {
  __typename: 'SignificanceMode';
  key: SignificanceModeKey;
  name: Scalars['String']['output'];
}

export enum SignificanceModeKey {
  Breakdown = 'BREAKDOWN',
  Experiment = 'EXPERIMENT',
  Segment = 'SEGMENT',
}

export interface ISignificanceQuery extends IFormula {
  __typename: 'SignificanceQuery';
  cohortRefs: Array<ICohortRef>;
  confidenceLevel: Scalars['Int']['output'];
  criteria: ISignificanceCriteria;
  filter: Maybe<IFilter>;
  /** Any LLM chat messages which were used to create this Formula */
  llmChatMessages: Array<ILlmChatMessage>;
  metric: ISignificanceMetric;
  metricType: IMetricType;
  mode: ISignificanceMode;
  samplePercentage: Maybe<Scalars['Int']['output']>;
  /** analyzable-specific properties */
  schema: ISchema;
  significanceLevel: Scalars['BigDecimal']['output'];
  subject: ISubject;
  test: ISignificanceTest;
  /** significance - specific properties */
  timeUnit: TimeUnit;
}

export interface ISignificanceTemplate {
  __typename: 'SignificanceTemplate';
  datePicker: IDatePicker;
  end: Scalars['LocalDate']['output'];
  query: ISignificanceQuery;
  start: Scalars['LocalDate']['output'];
}

export interface ISignificanceTest {
  __typename: 'SignificanceTest';
  key: SignificanceTestKey;
  name: Scalars['String']['output'];
}

export enum SignificanceTestKey {
  OneTailed = 'ONE_TAILED',
  TwoTailed = 'TWO_TAILED',
}

export type ISimpleCohort =
  | IExpressionCohort
  | IFunnelCohort
  | IMeasureCohort
  | IPerformedCohort
  | IRetentionCohort;

export interface ISimpleCohortConfig {
  /** Default subject per type. */
  defaultSubject: ISubject;
  /** The default time window. It is guaranteed that it is one of the `timeWindows` values */
  defaultTimeWindow: ITimeWindow;
  /** List of available subjects for a specific cohort. Each cohort config might be having different set of available subjects. */
  subjects: Array<ISubject>;
  /** List of available time windows for a specific cohort */
  timeWindows: Array<ITimeWindow>;
}

export interface ISimpleCohortInput {
  basicSimpleCohort: InputMaybe<IBasicSimpleCohortInput>;
  namedSimpleCohort: InputMaybe<INamedCohortInput>;
  /**
   * The versionType will decide which cohort input is picked.
   * For example, if type is NAMED, namedSimpleCohort will be picked.
   */
  versionType: VersionType;
}

export interface ISimpleCohortType {
  __typename: 'SimpleCohortType';
  key: SimpleCohortTypeKey;
  name: Scalars['String']['output'];
}

export enum SimpleCohortTypeKey {
  Expression = 'EXPRESSION',
  Funnel = 'FUNNEL',
  Measure = 'MEASURE',
  Performed = 'PERFORMED',
  Retention = 'RETENTION',
}

export interface ISimpleMeasure {
  __typename: 'SimpleMeasure';
  categories: Array<IEntityCategory>;
  eventConditions: Array<IEventCondition>;
  format: Maybe<IMeasureDisplayFormat>;
  formula: Maybe<Scalars['String']['output']>;
  function: IMeasureFunction;
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentile: Maybe<Scalars['Float']['output']>;
  rollingControl: Maybe<IRollingControl>;
  schema: ISchema;
  /**  Opaque ID to key aliases */
  userAlias: IUserAliasQueryMeasure;
  varName: Scalars['String']['output'];
  version: Maybe<IVersion>;
}

export interface ISimpleMeasureInput {
  basicMeasure: InputMaybe<IBasicSimpleMeasureInput>;
  namedMeasure: InputMaybe<INamedSimpleMeasureInput>;
  type: MeasureVersionType;
  varName: InputMaybe<Scalars['String']['input']>;
}

export interface ISimpleMeasureProperties {
  __typename: 'SimpleMeasureProperties';
  cohortRefs: Array<ICohortRef>;
  filter: Maybe<IMeasureFilter>;
}

export interface ISimpleMeasurePropertiesInput {
  cohortRefs: Array<ICohortRefInput>;
  filter: InputMaybe<IMeasureFilterInput>;
}

export interface ISimplePredicate {
  __typename: 'SimplePredicate';
  field: IField;
  matchCase: Scalars['Boolean']['output'];
  operands: IOperands;
  relOp: IRelationalOperator;
}

export interface ISimplePredicateInput {
  field: Scalars['String']['input'];
  matchCase: Scalars['Boolean']['input'];
  operands: IOperandsInput;
  relOp: RelationalOperatorKey;
}

export interface ISlackAdminSource {
  __typename: 'SlackAdminSource';
  dummy: Scalars['Boolean']['output'];
}

export interface ISlackChannel {
  __typename: 'SlackChannel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: SlackChannelType;
}

export interface ISlackChannelDestination {
  __typename: 'SlackChannelDestination';
  channel: ISlackChannel;
  team: ISlackTeam;
}

export enum SlackChannelType {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

/**  ======== Deprecated ======== # */
export interface ISlackConfig {
  __typename: 'SlackConfig';
  channelId: Scalars['ID']['output'];
  configUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  slackChannelId: Scalars['ID']['output'];
  slackChannelName: Scalars['String']['output'];
  teamId: Scalars['ID']['output'];
  teamName: Scalars['String']['output'];
  workspaceId: Scalars['ID']['output'];
}

export interface ISlackConnectInput {
  destination: ISlackDestinationInput;
  source: ISlackSourceInput;
}

export interface ISlackConnectPayload {
  __typename: 'SlackConnectPayload';
  entity: Maybe<ISlackConnection>;
  errors: Array<IError>;
}

export interface ISlackConnection {
  __typename: 'SlackConnection';
  destination: ISlackDestination;
  source: ISlackSource;
}

export type ISlackDestination =
  | ISlackChannelDestination
  | ISlackMemberDestination;

export interface ISlackDestinationEntities {
  __typename: 'SlackDestinationEntities';
  channels: Array<ISlackChannel>;
  members: Array<ISlackMember>;
  team: ISlackTeam;
}

export interface ISlackDestinationInput {
  /** Required when type is CHANNEL. */
  channelId: InputMaybe<Scalars['ID']['input']>;
  /** Required when type is USER. */
  memberId: InputMaybe<Scalars['ID']['input']>;
  type: SlackDestinationType;
}

export enum SlackDestinationType {
  Channel = 'CHANNEL',
  Member = 'MEMBER',
}

export interface ISlackDisconnectInput {
  source: ISlackSourceInput;
}

export interface ISlackDisconnectPayload {
  __typename: 'SlackDisconnectPayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface ISlackEntitySource {
  __typename: 'SlackEntitySource';
  entityId: Scalars['ID']['output'];
  entityType: SlackEntityType;
}

export interface ISlackEntitySourceInput {
  entityId: Scalars['ID']['input'];
  entityType: SlackEntityType;
}

export enum SlackEntityType {
  Dashboard = 'DASHBOARD',
  Schedule = 'SCHEDULE',
}

export interface ISlackInstallation {
  __typename: 'SlackInstallation';
  member: ISlackMember;
  team: ISlackTeam;
  userId: Scalars['ID']['output'];
}

export interface ISlackMember {
  __typename: 'SlackMember';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

export interface ISlackMemberDestination {
  __typename: 'SlackMemberDestination';
  member: ISlackMember;
  team: ISlackTeam;
}

export interface ISlackOAuthCallbackInput {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
}

export interface ISlackOAuthCallbackPayload {
  __typename: 'SlackOAuthCallbackPayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface ISlackOAuthStart {
  __typename: 'SlackOAuthStart';
  authorizeUrl: Scalars['String']['output'];
}

export interface ISlackOAuthStartPayload {
  __typename: 'SlackOAuthStartPayload';
  entity: Maybe<ISlackOAuthStart>;
  errors: Array<IError>;
}

export type ISlackSource = ISlackAdminSource | ISlackEntitySource;

export interface ISlackSourceInput {
  /** Required when type is ENTITY. */
  entitySource: InputMaybe<ISlackEntitySourceInput>;
  type: SlackSourceType;
}

export enum SlackSourceType {
  Admin = 'ADMIN',
  Entity = 'ENTITY',
}

export interface ISlackTeam {
  __typename: 'SlackTeam';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

export interface ISlackUninstallPayload {
  __typename: 'SlackUninstallPayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface ISlice {
  /**  list of fields to display that produced this slice  */
  hint: Array<ISliceNameHint>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**
   * Null for these kinds of slices:
   * - Base slice
   * - Empty slice: a special slice when overall is disabled but no data is returned.
   */
  rank: Maybe<Scalars['Int']['output']>;
  userAlias: IUserAliasSlice;
}

export interface ISliceNameHint {
  __typename: 'SliceNameHint';
  /**
   * Where this slice comes from:
   * * either the field name which produced this slice
   * * "Cohort" (if the slice is from cohort)
   * * Subject's bucket's field name in case of Expression > Subject > Bucket
   */
  name: Scalars['String']['output'];
  /** The breakdown value */
  value: Scalars['String']['output'];
}

export interface IStartEndDateMeta {
  __typename: 'StartEndDateMeta';
  kind: EndDateConfigKind;
  startTimeUnit: EndDateTimeUnitKind;
}

export interface IStaticEndDateMeta {
  __typename: 'StaticEndDateMeta';
  kind: EndDateConfigKind;
  staticDate: Scalars['Date']['output'];
  staticDateAsLiveStart: Scalars['Boolean']['output'];
}

export enum StrategyKind {
  Bigquery = 'bigquery',
  Clickhouse = 'clickhouse',
  Databricks = 'databricks',
  Mysql = 'mysql',
  Presto = 'presto',
  Redshift = 'redshift',
  Snowflake = 'snowflake',
}

export interface IStructDefinitionInput {
  fields: Array<IStructFieldInput>;
}

export interface IStructDefinitionMeta {
  __typename: 'StructDefinitionMeta';
  fields: Array<IStructFieldMeta>;
}

export interface IStructFieldInput {
  name: Scalars['String']['input'];
  type: FieldType;
}

export interface IStructFieldMeta {
  __typename: 'StructFieldMeta';
  name: Scalars['String']['output'];
  type: FieldType;
}

/**  -------- Model Types -----------  */
export interface ISubFolder {
  __typename: 'SubFolder';
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isEmpty: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /**  null for root folder */
  parentId: Maybe<Scalars['ID']['output']>;
}

export interface ISubFolderCreateInput {
  name: Scalars['String']['input'];
  parentId: InputMaybe<Scalars['ID']['input']>;
}

export interface ISubFolderDeleteInput {
  folderId: Scalars['ID']['input'];
}

export interface ISubFolderDeletePayload {
  __typename: 'SubFolderDeletePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface ISubFolderMoveInput {
  id: Scalars['ID']['input'];
  parentId: InputMaybe<Scalars['ID']['input']>;
}

export interface ISubFolderRenameInput {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface ISubject {
  __typename: 'Subject';
  defaultFunnelOrder: IFunnelOrder;
  funnelOrders: Array<IFunnelOrder>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

/**  CDW table column object, already mapped or potentially to be added as a field */
export interface ITableColumn {
  __typename: 'TableColumn';
  column: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  type: FieldType;
  typeParams: IFieldTypeParams;
}

export interface ITableColumnPaginated {
  __typename: 'TableColumnPaginated';
  entities: Array<ITableColumn>;
  errors: Array<Scalars['String']['output']>;
  pageInfo: IPageInfo;
}

/**  An already mapped to Field Table column */
export interface ITableField {
  __typename: 'TableField';
  column: Scalars['String']['output'];
  tableKey: Scalars['String']['output'];
  type: FieldType;
  typeParams: IFieldTypeParams;
}

export interface ITableJoinMeta {
  __typename: 'TableJoinMeta';
  joinPairs: Array<ITableJoinPairMeta>;
  /** Optional SQL condition - advanced */
  sqlCondition: Maybe<Scalars['String']['output']>;
  /** "not null means that this is a temporal join */
  temporalCondition: Maybe<ITemporalJoinConditionMeta>;
}

export interface ITableJoinPairMeta {
  __typename: 'TableJoinPairMeta';
  dimTableFieldColumn: Scalars['String']['output'];
  factFieldKey: Scalars['String']['output'];
  relOp: JoinConditionOperator;
}

export interface ITableMeta {
  __typename: 'TableMeta';
  dateRangePredicateColumn: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partitionDelegates: Array<Scalars['String']['output']>;
}

/**  Tagged Message */
export interface ITag {
  __typename: 'Tag';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  kind: TagKind;
  message: IMessage;
  state: TagState;
  tagger: IUser;
  text: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
}

export interface ITagBranch {
  __typename: 'TagBranch';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}

export interface ITagBucketDefInput {
  field: Scalars['String']['input'];
}

export interface ITagCreateInput {
  kind: TagKind;
  messageId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}

export interface ITagCreatePayload {
  __typename: 'TagCreatePayload';
  entity: Maybe<ITag>;
  errors: Array<IError>;
}

export interface ITagFieldInlineBranch {
  __typename: 'TagFieldInlineBranch';
  count: Scalars['Int']['output'];
  isFavorite: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: FieldType;
}

export interface ITagFieldInput {
  /** Used when new array object predicate is added via Include option */
  arrayObjectContext: InputMaybe<IArrayObjectContext>;
  context: FieldContext;
  /**
   * Events are context specific. Please refer to this wiki for the scope.
   * - https://kubitai.atlassian.net/wiki/spaces/ENG/pages/1796800517/EFV+Event-Field-Value#Query
   */
  events: Array<IEventInput>;
  /** Required when context is MEASURE. */
  func: InputMaybe<Scalars['String']['input']>;
}

export interface ITagInlineBranch {
  __typename: 'TagInlineBranch';
  count: Scalars['Int']['output'];
  isFavorite: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: FieldType;
}

export enum TagKind {
  Context = 'CONTEXT',
  Hypothesis = 'HYPOTHESIS',
  Insight = 'INSIGHT',
  Task = 'TASK',
}

export interface ITagLeafAnyEvent {
  __typename: 'TagLeafAnyEvent';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface ITagLeafAnyTableEvent {
  __typename: 'TagLeafAnyTableEvent';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface ITagLeafBasicEvent {
  __typename: 'TagLeafBasicEvent';
  isFavorite: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface ITagLeafCompoundCohort {
  __typename: 'TagLeafCompoundCohort';
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
}

export interface ITagLeafCompoundMeasure {
  __typename: 'TagLeafCompoundMeasure';
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
}

export interface ITagLeafCustomBucketDef {
  __typename: 'TagLeafCustomBucketDef';
  kind: BucketKind;
  name: Scalars['String']['output'];
}

export interface ITagLeafDateBucketDef {
  __typename: 'TagLeafDateBucketDef';
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
}

export interface ITagLeafEnumBucketDef {
  __typename: 'TagLeafEnumBucketDef';
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
}

export interface ITagLeafField {
  __typename: 'TagLeafField';
  isFavorite: Scalars['Boolean']['output'];
  isGeo: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface ITagLeafFilter {
  __typename: 'TagLeafFilter';
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
}

export interface ITagLeafRangeBucketDef {
  __typename: 'TagLeafRangeBucketDef';
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
}

/**  bucket defs */
export interface ITagLeafSeparator {
  __typename: 'TagLeafSeparator';
  dummy: Maybe<Scalars['Boolean']['output']>;
}

export interface ITagLeafSimpleCohort {
  __typename: 'TagLeafSimpleCohort';
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
}

export interface ITagLeafSimpleMeasure {
  __typename: 'TagLeafSimpleMeasure';
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
}

export interface ITagLeafVirtualEvent {
  __typename: 'TagLeafVirtualEvent';
  id: Scalars['ID']['output'];
  isFavorite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
}

export interface ITagMapping {
  __typename: 'TagMapping';
  childrenIndex: Array<Scalars['Int']['output']>;
  parentIndex: Scalars['Int']['output'];
}

export interface ITagMeasureInput {
  measureOption: SearchNamedMeasureOption;
}

export type ITagNode =
  | ITagBranch
  | ITagFieldInlineBranch
  | ITagInlineBranch
  | ITagLeafAnyEvent
  | ITagLeafAnyTableEvent
  | ITagLeafBasicEvent
  | ITagLeafCompoundCohort
  | ITagLeafCompoundMeasure
  | ITagLeafCustomBucketDef
  | ITagLeafDateBucketDef
  | ITagLeafEnumBucketDef
  | ITagLeafField
  | ITagLeafFilter
  | ITagLeafRangeBucketDef
  | ITagLeafSeparator
  | ITagLeafSimpleCohort
  | ITagLeafSimpleMeasure
  | ITagLeafVirtualEvent
  | ITagRoot;

export enum TagOption {
  AnyEvent = 'ANY_EVENT',
  AnyTableEvent = 'ANY_TABLE_EVENT',
  BasicEvent = 'BASIC_EVENT',
  CompoundCohort = 'COMPOUND_COHORT',
  CompoundMeasure = 'COMPOUND_MEASURE',
  DateBucketDef = 'DATE_BUCKET_DEF',
  EnumBucketDef = 'ENUM_BUCKET_DEF',
  Field = 'FIELD',
  Filter = 'FILTER',
  RangeBucketDef = 'RANGE_BUCKET_DEF',
  SimpleCohort = 'SIMPLE_COHORT',
  SimpleMeasure = 'SIMPLE_MEASURE',
  VirtualEvent = 'VIRTUAL_EVENT',
}

export interface ITagOptionInput {
  bucketDef: InputMaybe<ITagBucketDefInput>;
  field: InputMaybe<ITagFieldInput>;
  measure: InputMaybe<ITagMeasureInput>;
  tag: TagOption;
}

export interface ITagRoot {
  __typename: 'TagRoot';
  dummy: Maybe<Scalars['Boolean']['output']>;
}

export enum TagState {
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  Invalid = 'INVALID',
  Open = 'OPEN',
  Verified = 'VERIFIED',
}

export interface ITagUpdateInput {
  state: TagState;
  tagId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}

export interface ITagUpdatePayload {
  __typename: 'TagUpdatePayload';
  entity: Maybe<ITag>;
  errors: Array<IError>;
}

export interface ITemporalJoinConditionMeta {
  __typename: 'TemporalJoinConditionMeta';
  /** Can be one or two temporal fields */
  dimTemporalKeys: Array<Scalars['String']['output']>;
  /** Can be null for First/Last Ever */
  factTemporalKey: Maybe<Scalars['String']['output']>;
  temporalJoinType: TemporalJoinType;
}

export enum TemporalJoinType {
  FirstAfter = 'FIRST_AFTER',
  FirstAtOrAfter = 'FIRST_AT_OR_AFTER',
  FirstAtOrBefore = 'FIRST_AT_OR_BEFORE',
  FirstBefore = 'FIRST_BEFORE',
  FirstBetween = 'FIRST_BETWEEN',
  FirstEver = 'FIRST_EVER',
  LastAfter = 'LAST_AFTER',
  LastAtOrAfter = 'LAST_AT_OR_AFTER',
  LastAtOrBefore = 'LAST_AT_OR_BEFORE',
  LastBefore = 'LAST_BEFORE',
  LastBetween = 'LAST_BETWEEN',
  LastEver = 'LAST_EVER',
}

export interface IThreadCommentAddInput {
  comment: ICommentInput;
  entity: IConversationEntityInput;
  threadId: Scalars['ID']['input'];
}

export interface IThreadCommentDeleteInput {
  commentId: Scalars['ID']['input'];
  entity: IConversationEntityInput;
  threadId: Scalars['ID']['input'];
}

export interface IThreadCommentUpdateInput {
  comment: ICommentInput;
  commentId: Scalars['ID']['input'];
  entity: IConversationEntityInput;
  threadId: Scalars['ID']['input'];
}

export interface IThreadReadInput {
  commentId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
}

export interface IThreadResolveInput {
  threadId: Scalars['ID']['input'];
}

export interface IThreadStartInput {
  comment: ICommentInput;
  entity: IConversationEntityInput;
}

export interface ITile {
  __typename: 'Tile';
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface ITileAddInput {
  description: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
}

export interface ITileDeleteInput {
  id: Scalars['ID']['input'];
}

export interface ITilePayload {
  __typename: 'TilePayload';
  entity: Maybe<ITile>;
  errors: Array<IError>;
}

export interface ITileUpdateInput {
  description: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
}

export interface ITilesPayload {
  __typename: 'TilesPayload';
  tiles: Array<ITile>;
}

export interface ITimeConfigInput {
  timezone: Scalars['String']['input'];
  weekStart: WeekStart;
}

export enum TimeFormat {
  TwelveHour = 'TWELVE_HOUR',
  TwentyFourHour = 'TWENTY_FOUR_HOUR',
}

export interface ITimeToConvertCohortConfig {
  __typename: 'TimeToConvertCohortConfig';
  operators: Array<ITimeToConvertOperator>;
  timeUnits: Array<TimeUnit>;
}

export interface ITimeToConvertConfig {
  __typename: 'TimeToConvertConfig';
  operator: ITimeToConvertOperator;
  timeUnit: TimeUnit;
  values: Array<Scalars['Int']['output']>;
}

export interface ITimeToConvertInput {
  operator: TimeToConvertOperatorKey;
  /** One of SECOND, MINUTE, HOUR, DAY */
  timeUnit: TimeUnit;
  /** All operators require exactly one value except BETWEEN */
  values: Array<Scalars['Int']['input']>;
}

export interface ITimeToConvertOperator {
  __typename: 'TimeToConvertOperator';
  key: TimeToConvertOperatorKey;
  name: Scalars['String']['output'];
}

export enum TimeToConvertOperatorKey {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEqual = 'NOT_EQUAL',
}

export enum TimeUnit {
  AllTime = 'ALL_TIME',
  Day = 'DAY',
  FourWeek = 'FOUR_WEEK',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Na = 'NA',
  Quarter = 'QUARTER',
  Second = 'SECOND',
  Week = 'WEEK',
  Year = 'YEAR',
}

export interface ITimeWindow {
  __typename: 'TimeWindow';
  key: TimeWindowKey;
  name: Scalars['String']['output'];
}

export enum TimeWindowKey {
  /** Retention only. */
  BetweenSinceStart = 'BETWEEN_SINCE_START',
  Current = 'CURRENT',
  InEach = 'IN_EACH',
  Overall = 'OVERALL',
  RollingBack = 'ROLLING_BACK',
  RollingBackBetween = 'ROLLING_BACK_BETWEEN',
  RollingForward = 'ROLLING_FORWARD',
  RollingForwardBetween = 'ROLLING_FORWARD_BETWEEN',
  /** Retention only. */
  Within = 'WITHIN',
}

export interface ITopPath {
  __typename: 'TopPath';
  funnel: IFunnel;
  rank: Scalars['Int']['output'];
}

export interface ITopPathsPathModeValue {
  __typename: 'TopPathsPathModeValue';
  base: Maybe<ITopPathsSlice>;
  slices: Array<ITopPathsSlice>;
}

export interface ITopPathsSlice extends ISlice {
  __typename: 'TopPathsSlice';
  /**  list of fields to display that produced this slice  */
  hint: Array<ISliceNameHint>;
  /**  Unique identifier among all the flows. */
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rank: Maybe<Scalars['Int']['output']>;
  topPaths: Array<ITopPath>;
  userAlias: IUserAliasSlice;
}

export interface IUploadEntity {
  __typename: 'UploadEntity';
  objectKey: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export enum UploadKind {
  Annotation = 'ANNOTATION',
  Image = 'IMAGE',
}

export interface IUser {
  __typename: 'User';
  colorSchemaSetting: IUserSetting;
  createdAt: Maybe<Scalars['Date']['output']>;
  defaultSchemaSetting: IUserSetting;
  defaultViewSetting: IUserSetting;
  email: Scalars['String']['output'];
  groups: Array<IUserGroup>;
  id: Scalars['ID']['output'];
  inviteExpireAt: Maybe<Scalars['Date']['output']>;
  invitedAt: Maybe<Scalars['Date']['output']>;
  lastLogin: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  picture: Scalars['String']['output'];
  quickAccessDictionarySetting: IUserSetting;
  /** Not include roles from the user's groups. */
  roles: Array<IRole>;
  slackInstallation: Maybe<ISlackInstallation>;
  state: UserState;
}

export interface IUserAliasPrefInput {
  replacement: Scalars['String']['input'];
  /**
   *  There are workarounds using custom type resolver, but they seem quite complex. Using the primitive String type in
   *  the input and manually deserializing to concrete UserAliasId seems much simpler. If we overcome this limitation
   *  we can change the type to UserAliasId w/o modifying Caprica because from Caprica perspective, userAliasId is
   *  mapped to String.
   */
  userAliasId: Scalars['String']['input'];
}

export type IUserAliasQuery =
  | IUserAliasQueryCohort
  | IUserAliasQueryMeasure
  | IUserAliasQueryStep;

export interface IUserAliasQueryCohort {
  __typename: 'UserAliasQueryCohort';
  aliasId: Scalars['UserAliasId']['output'];
}

export interface IUserAliasQueryMeasure {
  __typename: 'UserAliasQueryMeasure';
  aliasId: Scalars['UserAliasId']['output'];
}

export interface IUserAliasQueryStep {
  __typename: 'UserAliasQueryStep';
  aliasId: Scalars['UserAliasId']['output'];
}

export interface IUserAliasReplacement {
  __typename: 'UserAliasReplacement';
  aliasId: Scalars['UserAliasId']['output'];
  replacement: Scalars['String']['output'];
}

export type IUserAliasSlice =
  | IUserAliasSliceBase
  | IUserAliasSliceBreakdown
  | IUserAliasSliceNone;

export interface IUserAliasSliceBase {
  __typename: 'UserAliasSliceBase';
  aliasId: Scalars['UserAliasId']['output'];
}

export interface IUserAliasSliceBreakdown {
  __typename: 'UserAliasSliceBreakdown';
  aliasId: Scalars['UserAliasId']['output'];
  groupBys: Array<Scalars['UserAliasId']['output']>;
}

export interface IUserAliasSliceNone {
  __typename: 'UserAliasSliceNone';
  /** Dummy property to satisfy GraphQL requirement for at least one field */
  dummy: Maybe<Scalars['Boolean']['output']>;
}

export interface IUserDisableInput {
  /**
   * The id of the new owner who will take over all the entities from the disabled user.
   * Required. Nullable is just to be backward compatible.
   */
  newOwnerId: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
}

export interface IUserDisablePayload {
  __typename: 'UserDisablePayload';
  disabled: Maybe<Scalars['Boolean']['output']>;
  errors: Array<IError>;
}

export interface IUserEditInput {
  /**
   * Optional. Null means no change. (IMPORTANT) Empty will wipe out all the existing groups.
   * External groups will be ignored when updating the user's groups. (not supported)
   */
  groupIds: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional. Null means no change. (IMPORTANT) Empty will wipe out all the existing roles. */
  roleIds: InputMaybe<Array<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
}

export interface IUserEditPayload {
  __typename: 'UserEditPayload';
  entity: Maybe<IUser>;
  errors: Array<IError>;
}

export interface IUserEnableInput {
  userId: Scalars['ID']['input'];
}

export interface IUserEnablePayload {
  __typename: 'UserEnablePayload';
  enabled: Maybe<Scalars['Boolean']['output']>;
  errors: Array<IError>;
}

export interface IUserGroup {
  __typename: 'UserGroup';
  active: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  roles: Array<IRole>;
  type: UserGroupType;
  users: Array<IUser>;
}

export interface IUserGroupCreateInput {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  roleIds: Array<Scalars['ID']['input']>;
}

export interface IUserGroupCreatePayload {
  __typename: 'UserGroupCreatePayload';
  entity: Maybe<IUserGroup>;
  errors: Array<IError>;
}

export interface IUserGroupDisableInput {
  groupId: Scalars['ID']['input'];
}

export interface IUserGroupDisablePayload {
  __typename: 'UserGroupDisablePayload';
  disabled: Maybe<Scalars['Boolean']['output']>;
  errors: Array<IError>;
}

export interface IUserGroupEditInput {
  /** Optional. Null means no change. Not support editing the description of the external group (pass null). */
  description: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['ID']['input'];
  /** Optional. Null means no change. Not support editing the name of the external group (pass null). */
  name: InputMaybe<Scalars['String']['input']>;
  /** Optional. Null means no change. (IMPORTANT) Empty will wipe out all the existing roles. */
  roleIds: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface IUserGroupEditPayload {
  __typename: 'UserGroupEditPayload';
  entity: Maybe<IUserGroup>;
  errors: Array<IError>;
}

/** Not support disabling an external group. */
export interface IUserGroupEnableInput {
  groupId: Scalars['ID']['input'];
}

export interface IUserGroupEnablePayload {
  __typename: 'UserGroupEnablePayload';
  enabled: Maybe<Scalars['Boolean']['output']>;
  errors: Array<IError>;
}

export enum UserGroupType {
  External = 'EXTERNAL',
  Kubit = 'KUBIT',
}

export interface IUserGroupsPaginated {
  __typename: 'UserGroupsPaginated';
  entities: Array<IUserGroup>;
  pageInfo: IPageInfo;
}

export interface IUserInvite {
  __typename: 'UserInvite';
  error: Maybe<Scalars['String']['output']>;
  user: Maybe<IUser>;
}

export interface IUserInviteInput {
  defaultSchema: InputMaybe<IUserSettingInput>;
  defaultView: InputMaybe<IUserSettingInput>;
  email: Scalars['String']['input'];
  firstName: InputMaybe<Scalars['String']['input']>;
  lastName: InputMaybe<Scalars['String']['input']>;
  roleIds: Array<Scalars['ID']['input']>;
}

export interface IUserInvitePayload {
  __typename: 'UserInvitePayload';
  errors: Array<IError>;
  invites: Maybe<Array<IUserInvite>>;
}

export interface IUserInviteResendInput {
  userId: Scalars['ID']['input'];
}

export interface IUserInviteResendPayload {
  __typename: 'UserInviteResendPayload';
  entity: Maybe<IUser>;
  errors: Array<IError>;
}

export interface IUserInvitesInput {
  invites: Array<IUserInviteInput>;
}

export interface IUserLoginPayload {
  __typename: 'UserLoginPayload';
  entity: Maybe<IUser>;
  errors: Array<IError>;
  userIdHashed: Maybe<Scalars['String']['output']>;
}

export interface IUserLogoutPayload {
  __typename: 'UserLogoutPayload';
  errors: Array<IError>;
}

export interface IUserRevokeInput {
  userId: Scalars['ID']['input'];
}

export interface IUserRevokePayload {
  __typename: 'UserRevokePayload';
  errors: Array<IError>;
  revoked: Maybe<Scalars['Boolean']['output']>;
}

/**  -------- Model Types -----------  */
export interface IUserSetting {
  __typename: 'UserSetting';
  kind: UserSettingKind;
  value: Scalars['String']['output'];
}

export interface IUserSettingInput {
  kind: UserSettingKind;
  value: Scalars['String']['input'];
}

export enum UserSettingKind {
  ColorSchema = 'COLOR_SCHEMA',
  DashboardSidebar = 'DASHBOARD_SIDEBAR',
  DefaultSchema = 'DEFAULT_SCHEMA',
  DefaultView = 'DEFAULT_VIEW',
  ExecutionHistoryExpanded = 'EXECUTION_HISTORY_EXPANDED',
  JupyterHost = 'JUPYTER_HOST',
  ManagedView = 'MANAGED_VIEW',
  QuickAccessDictionary = 'QUICK_ACCESS_DICTIONARY',
  SidebarPinned = 'SIDEBAR_PINNED',
  SidebarSize = 'SIDEBAR_SIZE',
}

export interface IUserSettingPayload {
  __typename: 'UserSettingPayload';
  entities: Maybe<Array<Maybe<IUserSetting>>>;
  errors: Array<IError>;
}

export interface IUserSettingUpdateInput {
  userSettings: Array<IUserSettingInput>;
}

export enum UserState {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Pending = 'PENDING',
}

export interface IUserStatus {
  __typename: 'UserStatus';
  percentage: Scalars['Float']['output'];
  totalUsers: Scalars['Long']['output'];
  usersPerformedEvent: Scalars['Long']['output'];
}

export interface IUsersPaginated {
  __typename: 'UsersPaginated';
  entities: Array<IUser>;
  pageInfo: IPageInfo;
}

export interface IValueOperands {
  __typename: 'ValueOperands';
  values: Array<IFieldValue>;
}

export interface IValueOperandsInput {
  /** Multiple any values are not allowed. */
  values: Array<IFieldValueInput>;
}

/** A version type which includes named entity version specific properties which are common for all named entities. */
export interface IVersion {
  __typename: 'Version';
  /** The id of the base. Base groups all the related versions (i.e., version history). */
  baseId: Scalars['ID']['output'];
  comment: Scalars['String']['output'];
  /**
   * The creation date of the base (not the version) for now.
   * The latter should be presented as the edit date.
   */
  createdAt: Scalars['Date']['output'];
  /**
   * The creator of the base (not the version) for now.
   * In the future, we'll separate the creator of the base and creator of the version.
   * The latter should be presented as the editor.
   */
  creator: IUser;
  description: Scalars['String']['output'];
  /** The creation date of the version, i.e. edit timestamp. */
  editedAt: Scalars['Date']['output'];
  /** The creator of the version, i.e. the editor of the base entity */
  editor: IUser;
  /** The id of the entity instance which is used for the specific version. */
  entityId: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isLatestVersion: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** The version number of entity, e.g., 1, 2, 3 ... */
  version: Scalars['Int']['output'];
  /**
   * The id of the version.
   * Mostly, "versionId" is supposed to be the same as "entityId" (except Measure).
   * We'll make them consistent in the future and sunset "versionId".
   */
  versionId: Scalars['ID']['output'];
}

export enum VersionType {
  Basic = 'BASIC',
  Named = 'NAMED',
}

export interface IVirtualEvent extends IEventValue {
  __typename: 'VirtualEvent';
  categories: Array<IEntityCategory>;
  comment: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  description: Scalars['String']['output'];
  editedAt: Scalars['Date']['output'];
  editor: IUser;
  /** @deprecated Switch to eventsConditions. */
  eventConditions: Array<IBasicEventCondition>;
  eventsConditions: Array<IEventCondition>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isLatestVersion: Scalars['Boolean']['output'];
  isManaged: Scalars['Boolean']['output'];
  kind: EventKind;
  name: Scalars['String']['output'];
  schema: ISchema;
  /** @deprecated Use createdAt instead (consistent with everything else). */
  updatedAt: Scalars['Date']['output'];
  version: Scalars['Int']['output'];
}

export interface IVirtualEventCreateInput {
  categories: InputMaybe<Array<Scalars['ID']['input']>>;
  comment: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  eventConditions: Array<IEventConditionInput>;
  name: Scalars['String']['input'];
  schema: Scalars['String']['input'];
}

export interface IVirtualEventCreatePayload {
  __typename: 'VirtualEventCreatePayload';
  entity: Maybe<IVirtualEvent>;
  errors: Array<IError>;
}

export interface IVirtualEventDeleteInput {
  virtualEventId: Scalars['ID']['input'];
}

export interface IVirtualEventDeletePayload {
  __typename: 'VirtualEventDeletePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IVirtualEventEditInput {
  /** passing a list here will replace all previous categories with the new list */
  categories: InputMaybe<Array<Scalars['ID']['input']>>;
  comment: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  eventConditions: InputMaybe<Array<IEventConditionInput>>;
  name: InputMaybe<Scalars['String']['input']>;
  /**  This is the one where the edition is applied. */
  virtualEventId: Scalars['ID']['input'];
}

export interface IVirtualEventEditPayload {
  __typename: 'VirtualEventEditPayload';
  entity: Maybe<IVirtualEvent>;
  errors: Array<IError>;
}

export interface IVirtualEventPaginated {
  __typename: 'VirtualEventPaginated';
  entities: Array<IVirtualEvent>;
  pageInfo: IPageInfo;
}

export enum WeekStart {
  Monday = 'MONDAY',
  Sunday = 'SUNDAY',
}

/**  -------- Model Types -----------  */
export interface IWorkspace {
  __typename: 'Workspace';
  /**  Number of changed sections, if since=0, server will return everything */
  badge: Scalars['Int']['output'];
  categories: Array<ICategory>;
  createdAt: Scalars['Date']['output'];
  creator: IUser;
  description: Scalars['String']['output'];
  directs: Array<IChannel>;
  id: Scalars['ID']['output'];
  main: IChannel;
  name: Scalars['String']['output'];
  rows: Array<IWorkspaceRow>;
}

/**  -------- Model Types -----------  */
export interface IWorkspaceBadgeArgs {
  since: InputMaybe<Scalars['Int']['input']>;
}

/**  -------- Model Types -----------  */
export interface IWorkspaceCategoriesArgs {
  since: InputMaybe<Scalars['Int']['input']>;
}

/**  -------- Model Types -----------  */
export interface IWorkspaceDirectsArgs {
  since: InputMaybe<Scalars['Int']['input']>;
}

export interface IWorkspaceCreateInput {
  /**  json string */
  analyses: InputMaybe<Array<IWsAnalysisInput>>;
  comment: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
}

export interface IWorkspaceCreatePayload {
  __typename: 'WorkspaceCreatePayload';
  entity: Maybe<IWorkspace>;
  errors: Array<IError>;
}

export interface IWorkspaceDeleteInput {
  workspaceId: InputMaybe<Scalars['ID']['input']>;
}

export interface IWorkspaceDeletePayload {
  __typename: 'WorkspaceDeletePayload';
  errors: Array<IError>;
  message: Maybe<Scalars['String']['output']>;
}

export interface IWorkspaceEditInput {
  comment: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rows: Array<IWorkspaceRowInput>;
  workspaceId: Scalars['ID']['input'];
}

export interface IWorkspaceEditPayload {
  __typename: 'WorkspaceEditPayload';
  entity: Maybe<IWorkspace>;
  errors: Array<IError>;
}

export interface IWorkspaceNotification {
  __typename: 'WorkspaceNotification';
  badge: Scalars['Int']['output'];
  channelNotifications: Array<IChannelNotification>;
  /**  null means most recent active users didn't change */
  users: Array<IUser>;
  wsId: Scalars['ID']['output'];
}

export interface IWorkspacePaginated {
  __typename: 'WorkspacePaginated';
  entities: Array<IWorkspace>;
  pageInfo: IPageInfo;
}

export interface IWorkspaceReplaceAnalysisInput {
  newAnalysis: IWsAnalysisInput;
  targetAnalysisId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}

export interface IWorkspaceRow {
  __typename: 'WorkspaceRow';
  analyses: Array<IAnalysis>;
  id: Scalars['ID']['output'];
}

export interface IWorkspaceRowInput {
  analyses: InputMaybe<Array<InputMaybe<IWsAnalysisInput>>>;
}

export interface IWorkspaceScratchpadConvertInput {
  baseId: Scalars['ID']['input'];
}

export interface IWorkspaceScratchpadConvertPayload {
  __typename: 'WorkspaceScratchpadConvertPayload';
  errors: Array<IError>;
  scratchpad: Maybe<IScratchpad>;
}

export interface IWsAddAnalysesInput {
  analyses: InputMaybe<Array<IWsAnalysisInput>>;
  wsId: Scalars['ID']['input'];
}

export interface IWsAddAnalysesPayload {
  __typename: 'WsAddAnalysesPayload';
  entity: Maybe<IWorkspace>;
  errors: Array<IError>;
}

export interface IWsAnalysisInput {
  analysisId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  display: Scalars['String']['input'];
  pref: InputMaybe<IAnalysisPrefInput>;
}

export interface IWsDeleteAnalysisInput {
  analysisId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}

export interface IWsDeleteAnalysisPayload {
  __typename: 'WsDeleteAnalysisPayload';
  entity: Maybe<IWorkspace>;
  errors: Array<IError>;
}

export interface IWsReplaceAnalysisPayload {
  __typename: 'WsReplaceAnalysisPayload';
  entity: Maybe<IWorkspace>;
  errors: Array<IError>;
  newAnalysisId: Maybe<Scalars['ID']['output']>;
  warningMessage: Maybe<Scalars['String']['output']>;
}

export type INotificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type INotificationQuery = { __typename: 'Query' } & {
  user: { __typename: 'User' } & IUserPermissionFieldsFragment;
  notification: Maybe<
    { __typename: 'Notification' } & {
      wsNotifications: Array<
        { __typename: 'WorkspaceNotification' } & Pick<
          IWorkspaceNotification,
          'wsId' | 'badge'
        > & {
            users: Array<
              { __typename: 'User' } & Pick<
                IUser,
                'id' | 'name' | 'picture' | 'email' | 'lastLogin'
              >
            >;
            channelNotifications: Array<
              { __typename: 'ChannelNotification' } & Pick<
                IChannelNotification,
                'channelId' | 'badge'
              >
            >;
          }
      >;
    }
  >;
};

type ISearchCohortEntityFields_CohortSample_Fragment = {
  __typename: 'CohortSample';
} & Pick<ICohortSample, 'id' | 'display' | 'start' | 'end'> & {
    query: { __typename: 'CohortSampleQuery' };
    pref: { __typename: 'AnalysisPref' } & {
      aliasReplacements: Array<
        {
          __typename: 'UserAliasReplacement';
        } & IUserAliasReplacementFieldsFragment
      >;
    };
  };

type ISearchCohortEntityFields_DataTable_Fragment = {
  __typename: 'DataTable';
} & Pick<IDataTable, 'id' | 'display' | 'start' | 'end'> & {
    query: { __typename: 'DataTableQuery' };
    pref: { __typename: 'AnalysisPref' } & {
      aliasReplacements: Array<
        {
          __typename: 'UserAliasReplacement';
        } & IUserAliasReplacementFieldsFragment
      >;
    };
  };

type ISearchCohortEntityFields_Expression_Fragment = {
  __typename: 'Expression';
} & Pick<IExpression, 'id' | 'display' | 'start' | 'end'> & {
    query: { __typename: 'ExpressionQuery' };
    pref: { __typename: 'AnalysisPref' } & {
      aliasReplacements: Array<
        {
          __typename: 'UserAliasReplacement';
        } & IUserAliasReplacementFieldsFragment
      >;
    };
  };

type ISearchCohortEntityFields_Funnel_Fragment = {
  __typename: 'Funnel';
} & Pick<IFunnel, 'id' | 'display' | 'start' | 'end'> & {
    query: { __typename: 'FunnelQuery' } & {
      subject: Maybe<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
    } & IFunnelCohortAnalysisQueryFieldsFragment;
    pref: { __typename: 'AnalysisPref' } & {
      aliasReplacements: Array<
        {
          __typename: 'UserAliasReplacement';
        } & IUserAliasReplacementFieldsFragment
      >;
    };
  };

type ISearchCohortEntityFields_Path_Fragment = { __typename: 'Path' } & Pick<
  IPath,
  'id' | 'display' | 'start' | 'end'
> & {
    query: { __typename: 'PathQuery' };
    pref: { __typename: 'AnalysisPref' } & {
      aliasReplacements: Array<
        {
          __typename: 'UserAliasReplacement';
        } & IUserAliasReplacementFieldsFragment
      >;
    };
  };

type ISearchCohortEntityFields_Prediction_Fragment = {
  __typename: 'Prediction';
} & Pick<IPrediction, 'id' | 'display' | 'start' | 'end'> & {
    query: { __typename: 'PredictionQuery' };
    pref: { __typename: 'AnalysisPref' } & {
      aliasReplacements: Array<
        {
          __typename: 'UserAliasReplacement';
        } & IUserAliasReplacementFieldsFragment
      >;
    };
  };

type ISearchCohortEntityFields_Retention_Fragment = {
  __typename: 'Retention';
} & Pick<IRetention, 'id' | 'display' | 'start' | 'end'> & {
    query: {
      __typename: 'RetentionQuery';
    } & IRetentionCohortAnalysisQueryFieldsFragment;
    pref: { __typename: 'AnalysisPref' } & {
      aliasReplacements: Array<
        {
          __typename: 'UserAliasReplacement';
        } & IUserAliasReplacementFieldsFragment
      >;
    };
  };

type ISearchCohortEntityFields_Significance_Fragment = {
  __typename: 'Significance';
} & Pick<ISignificance, 'id' | 'display' | 'start' | 'end'> & {
    query: { __typename: 'SignificanceQuery' };
    pref: { __typename: 'AnalysisPref' } & {
      aliasReplacements: Array<
        {
          __typename: 'UserAliasReplacement';
        } & IUserAliasReplacementFieldsFragment
      >;
    };
  };

export type ISearchCohortEntityFieldsFragment =
  | ISearchCohortEntityFields_CohortSample_Fragment
  | ISearchCohortEntityFields_DataTable_Fragment
  | ISearchCohortEntityFields_Expression_Fragment
  | ISearchCohortEntityFields_Funnel_Fragment
  | ISearchCohortEntityFields_Path_Fragment
  | ISearchCohortEntityFields_Prediction_Fragment
  | ISearchCohortEntityFields_Retention_Fragment
  | ISearchCohortEntityFields_Significance_Fragment;

export type ISearchCohortAnalysesQueryVariables = Exact<{
  term: InputMaybe<Scalars['String']['input']>;
  schemaIds: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  queryTypes: InputMaybe<Array<QueryType> | QueryType>;
  kind: InputMaybe<AnalysisKind>;
  userOnly: InputMaybe<Scalars['Boolean']['input']>;
  statuses: InputMaybe<
    Array<InputMaybe<AnalysisStatus>> | InputMaybe<AnalysisStatus>
  >;
  pagination: IPagination;
  includes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  filter: InputMaybe<IAnalysisFilter>;
}>;

export type ISearchCohortAnalysesQuery = { __typename: 'Query' } & {
  searchAnalysis: Maybe<
    { __typename: 'AnalysesPaginated' } & {
      entities: Array<
        | ({
            __typename: 'CohortSample';
          } & ISearchCohortEntityFields_CohortSample_Fragment)
        | ({
            __typename: 'DataTable';
          } & ISearchCohortEntityFields_DataTable_Fragment)
        | ({
            __typename: 'Expression';
          } & ISearchCohortEntityFields_Expression_Fragment)
        | ({ __typename: 'Funnel' } & ISearchCohortEntityFields_Funnel_Fragment)
        | ({ __typename: 'Path' } & ISearchCohortEntityFields_Path_Fragment)
        | ({
            __typename: 'Prediction';
          } & ISearchCohortEntityFields_Prediction_Fragment)
        | ({
            __typename: 'Retention';
          } & ISearchCohortEntityFields_Retention_Fragment)
        | ({
            __typename: 'Significance';
          } & ISearchCohortEntityFields_Significance_Fragment)
      >;
    }
  >;
};

export type ICreateMessageTagMutationVariables = Exact<{
  input: ITagCreateInput;
}>;

export type ICreateMessageTagMutation = { __typename: 'Mutation' } & {
  tagCreate: { __typename: 'TagCreatePayload' } & {
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field'>>;
  };
};

export type IMessageDeleteMutationMutationVariables = Exact<{
  input: IMessageDeleteInput;
}>;

export type IMessageDeleteMutationMutation = { __typename: 'Mutation' } & {
  messageDelete: { __typename: 'MessageDeletePayload' } & Pick<
    IMessageDeletePayload,
    'id'
  >;
};

export type IUpdateMessageTagMutationVariables = Exact<{
  input: ITagUpdateInput;
}>;

export type IUpdateMessageTagMutation = { __typename: 'Mutation' } & {
  tagUpdate: { __typename: 'TagUpdatePayload' } & {
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field'>>;
  };
};

export type IMessageCreateMutationVariables = Exact<{
  input: IMessageCreateInput;
}>;

export type IMessageCreateMutation = { __typename: 'Mutation' } & {
  messageCreate: { __typename: 'MessageCreatePayload' } & {
    entity: Maybe<
      { __typename: 'Message' } & Pick<IMessage, 'id' | 'parent' | 'text'>
    >;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field'>>;
  };
};

export type IScreenshotMessageCreateMutationVariables = Exact<{
  input: IMessageCreateInput;
}>;

export type IScreenshotMessageCreateMutation = { __typename: 'Mutation' } & {
  messageCreate: { __typename: 'MessageCreatePayload' } & {
    entity: Maybe<
      { __typename: 'Message' } & Pick<
        IMessage,
        'id' | 'createdAt' | 'text'
      > & {
          annotation: Maybe<
            { __typename: 'Annotation' } & Pick<IAnnotation, 'url'>
          >;
          creator: { __typename: 'User' } & Pick<
            IUser,
            'id' | 'picture' | 'name'
          >;
        }
    >;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field'>>;
  };
};

export type IGetChannelQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  since: InputMaybe<Scalars['Int']['input']>;
  channelId: Scalars['ID']['input'];
  pagination: IPagination;
  userStates: InputMaybe<Array<UserState> | UserState>;
}>;

export type IGetChannelQuery = { __typename: 'Query' } & {
  users: { __typename: 'UsersPaginated' } & {
    entities: Array<{ __typename: 'User' } & IUserFieldsFragment>;
  };
  workspace: Maybe<
    { __typename: 'Workspace' } & Pick<IWorkspace, 'id' | 'name' | 'badge'> & {
        main: { __typename: 'Channel' } & Pick<IChannel, 'id' | 'lastViewedAt'>;
        directs: Array<
          { __typename: 'Channel' } & Pick<IChannel, 'id' | 'lastViewedAt'>
        >;
        rows: Array<
          { __typename: 'WorkspaceRow' } & IWorkspaceRowFieldsFragment
        >;
      }
  >;
  channel: Maybe<
    { __typename: 'Channel' } & Pick<
      IChannel,
      'id' | 'name' | 'kind' | 'badge' | 'lastViewedAt'
    > & {
        users: Array<{ __typename: 'User' } & IUserFieldsFragment>;
        messages: Array<
          { __typename: 'Message' } & Pick<
            IMessage,
            'id' | 'parent' | 'createdAt' | 'text' | 'formatted'
          > & {
              creator: { __typename: 'User' } & Pick<
                IUser,
                'id' | 'picture' | 'name'
              >;
              tags: Array<
                { __typename: 'Tag' } & Pick<ITag, 'id' | 'kind' | 'state'>
              >;
              analysis: Maybe<
                | ({ __typename: 'CohortSample' } & Pick<
                    ICohortSample,
                    'id' | 'display' | 'start' | 'end'
                  >)
                | ({ __typename: 'DataTable' } & Pick<
                    IDataTable,
                    'id' | 'display' | 'start' | 'end'
                  >)
                | ({ __typename: 'Expression' } & Pick<
                    IExpression,
                    'id' | 'display' | 'start' | 'end'
                  >)
                | ({ __typename: 'Funnel' } & Pick<
                    IFunnel,
                    'id' | 'display' | 'start' | 'end'
                  >)
                | ({ __typename: 'Path' } & Pick<
                    IPath,
                    'id' | 'display' | 'start' | 'end'
                  >)
                | ({ __typename: 'Prediction' } & Pick<
                    IPrediction,
                    'id' | 'display' | 'start' | 'end'
                  >)
                | ({ __typename: 'Retention' } & Pick<
                    IRetention,
                    'id' | 'display' | 'start' | 'end'
                  >)
                | ({ __typename: 'Significance' } & Pick<
                    ISignificance,
                    'id' | 'display' | 'start' | 'end'
                  >)
              >;
              annotation: Maybe<
                { __typename: 'Annotation' } & Pick<
                  IAnnotation,
                  'url' | 'imageUrl'
                >
              >;
            }
        >;
      }
  >;
};

export type IGetMessagesAfterQueryVariables = Exact<{
  messageId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
}>;

export type IGetMessagesAfterQuery = { __typename: 'Query' } & {
  messagesAfter: Maybe<
    { __typename: 'MessagesAfterPayload' } & Pick<
      IMessagesAfterPayload,
      'channelId'
    > & {
        messages: Maybe<
          Array<
            Maybe<
              { __typename: 'Message' } & Pick<
                IMessage,
                'id' | 'parent' | 'createdAt' | 'text' | 'formatted'
              > & {
                  creator: { __typename: 'User' } & Pick<
                    IUser,
                    'id' | 'picture' | 'name'
                  >;
                  tags: Array<
                    { __typename: 'Tag' } & Pick<ITag, 'id' | 'kind' | 'state'>
                  >;
                  analysis: Maybe<
                    | ({ __typename: 'CohortSample' } & Pick<
                        ICohortSample,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'DataTable' } & Pick<
                        IDataTable,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'Expression' } & Pick<
                        IExpression,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'Funnel' } & Pick<
                        IFunnel,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'Path' } & Pick<
                        IPath,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'Prediction' } & Pick<
                        IPrediction,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'Retention' } & Pick<
                        IRetention,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'Significance' } & Pick<
                        ISignificance,
                        'id' | 'display' | 'start' | 'end'
                      >)
                  >;
                  annotation: Maybe<
                    { __typename: 'Annotation' } & Pick<
                      IAnnotation,
                      'url' | 'imageUrl'
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type IGetMessagesBeforeQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  messageId: Scalars['ID']['input'];
  channelId: Scalars['ID']['input'];
}>;

export type IGetMessagesBeforeQuery = { __typename: 'Query' } & {
  messagesBefore: Maybe<
    { __typename: 'MessagesBeforePayload' } & Pick<
      IMessagesBeforePayload,
      'hasMore' | 'channelId'
    > & {
        messages: Maybe<
          Array<
            Maybe<
              { __typename: 'Message' } & Pick<
                IMessage,
                'id' | 'parent' | 'createdAt' | 'text' | 'formatted'
              > & {
                  creator: { __typename: 'User' } & Pick<
                    IUser,
                    'id' | 'picture' | 'name'
                  >;
                  tags: Array<
                    { __typename: 'Tag' } & Pick<ITag, 'id' | 'kind' | 'state'>
                  >;
                  analysis: Maybe<
                    | ({ __typename: 'CohortSample' } & Pick<
                        ICohortSample,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'DataTable' } & Pick<
                        IDataTable,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'Expression' } & Pick<
                        IExpression,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'Funnel' } & Pick<
                        IFunnel,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'Path' } & Pick<
                        IPath,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'Prediction' } & Pick<
                        IPrediction,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'Retention' } & Pick<
                        IRetention,
                        'id' | 'display' | 'start' | 'end'
                      >)
                    | ({ __typename: 'Significance' } & Pick<
                        ISignificance,
                        'id' | 'display' | 'start' | 'end'
                      >)
                  >;
                  annotation: Maybe<
                    { __typename: 'Annotation' } & Pick<
                      IAnnotation,
                      'url' | 'imageUrl'
                    >
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type IGetTagsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IGetTagsQuery = { __typename: 'Query' } & {
  workspace: Maybe<
    { __typename: 'Workspace' } & Pick<IWorkspace, 'id'> & {
        categories: Array<
          { __typename: 'Category' } & Pick<ICategory, 'kind'> & {
              tags: Array<
                { __typename: 'Tag' } & Pick<ITag, 'id'> & {
                    message: { __typename: 'Message' } & Pick<
                      IMessage,
                      'id' | 'parent' | 'createdAt' | 'text' | 'formatted'
                    > & {
                        creator: { __typename: 'User' } & Pick<
                          IUser,
                          'id' | 'picture' | 'name'
                        >;
                        tags: Array<
                          { __typename: 'Tag' } & Pick<
                            ITag,
                            'id' | 'kind' | 'state'
                          >
                        >;
                        analysis: Maybe<
                          | ({ __typename: 'CohortSample' } & Pick<
                              ICohortSample,
                              'id' | 'display' | 'start' | 'end'
                            >)
                          | ({ __typename: 'DataTable' } & Pick<
                              IDataTable,
                              'id' | 'display' | 'start' | 'end'
                            >)
                          | ({ __typename: 'Expression' } & Pick<
                              IExpression,
                              'id' | 'display' | 'start' | 'end'
                            >)
                          | ({ __typename: 'Funnel' } & Pick<
                              IFunnel,
                              'id' | 'display' | 'start' | 'end'
                            >)
                          | ({ __typename: 'Path' } & Pick<
                              IPath,
                              'id' | 'display' | 'start' | 'end'
                            >)
                          | ({ __typename: 'Prediction' } & Pick<
                              IPrediction,
                              'id' | 'display' | 'start' | 'end'
                            >)
                          | ({ __typename: 'Retention' } & Pick<
                              IRetention,
                              'id' | 'display' | 'start' | 'end'
                            >)
                          | ({ __typename: 'Significance' } & Pick<
                              ISignificance,
                              'id' | 'display' | 'start' | 'end'
                            >)
                        >;
                        annotation: Maybe<
                          { __typename: 'Annotation' } & Pick<
                            IAnnotation,
                            'url' | 'imageUrl'
                          >
                        >;
                      };
                  }
              >;
            }
        >;
      }
  >;
};

export type IPreloadUrlQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  kind: UploadKind;
}>;

export type IPreloadUrlQueryQuery = { __typename: 'Query' } & {
  preUpload: Maybe<
    { __typename: 'UploadEntity' } & Pick<IUploadEntity, 'url' | 'objectKey'>
  >;
};

export type IChannelViewMutationVariables = Exact<{
  input: IChannelViewInput;
}>;

export type IChannelViewMutation = { __typename: 'Mutation' } & {
  channelView: { __typename: 'ChannelViewPayload' } & {
    entity: Maybe<
      { __typename: 'ChannelView' } & Pick<
        IChannelView,
        'channelId' | 'userId' | 'viewedAt'
      >
    >;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field' | 'messages'>>;
  };
};

export type ILoginMutationVariables = Exact<{ [key: string]: never }>;

export type ILoginMutation = { __typename: 'Mutation' } & {
  userLogin: { __typename: 'UserLoginPayload' } & Pick<
    IUserLoginPayload,
    'userIdHashed'
  > & { entity: Maybe<{ __typename: 'User' } & IUserPermissionFieldsFragment> };
};

export type IDeleteVirtualEventMutationVariables = Exact<{
  input: IVirtualEventDeleteInput;
}>;

export type IDeleteVirtualEventMutation = { __typename: 'Mutation' } & {
  virtualEventDelete: { __typename: 'VirtualEventDeletePayload' } & Pick<
    IVirtualEventDeletePayload,
    'message'
  > & {
      errors: Array<
        { __typename: 'Error' } & Pick<IError, 'field' | 'messages'>
      >;
    };
};

export type INamedBucketDefCreateMutationVariables = Exact<{
  input: INamedBucketDefCreateInput;
}>;

export type INamedBucketDefCreateMutation = { __typename: 'Mutation' } & {
  namedBucketDefCreate: { __typename: 'NamedBucketDefCreatePayload' } & {
    entity: Maybe<
      { __typename: 'NamedBucketDef' } & INamedBucketDefFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field' | 'messages'>>;
  };
};

export type INamedBucketDefDeleteMutationVariables = Exact<{
  input: INamedBucketDefDeleteInput;
}>;

export type INamedBucketDefDeleteMutation = { __typename: 'Mutation' } & {
  namedBucketDefDelete: { __typename: 'NamedBucketDefDeletePayload' } & Pick<
    INamedBucketDefDeletePayload,
    'message'
  > & {
      errors: Array<
        { __typename: 'Error' } & Pick<IError, 'field' | 'messages'>
      >;
    };
};

export type INamedFilterDeleteMutationVariables = Exact<{
  input: INamedFilterDeleteInput;
}>;

export type INamedFilterDeleteMutation = { __typename: 'Mutation' } & {
  namedFilterDelete: { __typename: 'NamedFilterDeletePayload' } & Pick<
    INamedFilterDeletePayload,
    'message'
  > & {
      errors: Array<
        { __typename: 'Error' } & Pick<IError, 'field' | 'messages'>
      >;
    };
};

export type INamedBucketDefEditMutationVariables = Exact<{
  input: INamedBucketDefEditInput;
}>;

export type INamedBucketDefEditMutation = { __typename: 'Mutation' } & {
  namedBucketDefEdit: { __typename: 'NamedBucketDefEditPayload' } & {
    entity: Maybe<
      { __typename: 'NamedBucketDef' } & INamedBucketDefFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field' | 'messages'>>;
  };
};

export type IGetAnyEventQueryVariables = Exact<{ [key: string]: never }>;

export type IGetAnyEventQuery = { __typename: 'Query' } & {
  anyEvent: { __typename: 'AnyEvent' } & IAnyEventFieldsFragment;
};

export type IGetAnyTableEventQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
}>;

export type IGetAnyTableEventQuery = { __typename: 'Query' } & {
  anyTableEvent: { __typename: 'AnyTableEvent' } & IAnyTableEventFieldsFragment;
};

export type IGetBasicEventQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
}>;

export type IGetBasicEventQuery = { __typename: 'Query' } & {
  basicEvent: Maybe<
    { __typename: 'BasicEventValue' } & IBasicEventValueFieldsFragment
  >;
};

export type IGetDictionaryFieldsQueryVariables = Exact<{
  term: InputMaybe<Scalars['String']['input']>;
  schemaId: Scalars['ID']['input'];
  func: InputMaybe<Scalars['String']['input']>;
  context: FieldContext;
  events: Array<IEventInput> | IEventInput;
  includeFields: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type IGetDictionaryFieldsQuery = { __typename: 'Query' } & {
  fields: Maybe<
    Array<{ __typename: 'Field' } & IDictionaryFieldFieldsFragment>
  >;
};

export type IGetFieldQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
}>;

export type IGetFieldQuery = { __typename: 'Query' } & {
  field: Maybe<{ __typename: 'Field' } & IFieldFieldsFragment>;
};

export type IGetFieldValuesQueryVariables = Exact<{
  term: InputMaybe<Scalars['String']['input']>;
  schemaId: Scalars['ID']['input'];
  fieldKey: Scalars['ID']['input'];
  includeValues: Array<Scalars['String']['input']> | Scalars['String']['input'];
  parents: Array<Scalars['String']['input']> | Scalars['String']['input'];
  events: Array<IEventInput> | IEventInput;
  includeAny?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type IGetFieldValuesQuery = { __typename: 'Query' } & {
  fieldValues: Array<
    | ({ __typename: 'AnyFieldValue' } & IAnyFieldValueFieldsFragment)
    | ({ __typename: 'BasicFieldValue' } & IBasicFieldValueFieldsFragment)
  >;
};

export type IGetNamedBucketDefQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IGetNamedBucketDefQuery = { __typename: 'Query' } & {
  namedBucket: { __typename: 'NamedBucketDef' } & INamedBucketDefFieldsFragment;
};

export type INamedBucketDefsQueryVariables = Exact<{
  includes: InputMaybe<
    | Array<InputMaybe<Scalars['ID']['input']>>
    | InputMaybe<Scalars['ID']['input']>
  >;
  term: InputMaybe<Scalars['String']['input']>;
  kinds: InputMaybe<Array<InputMaybe<BucketKind>> | InputMaybe<BucketKind>>;
  schemaId: InputMaybe<Scalars['ID']['input']>;
  field: InputMaybe<Scalars['String']['input']>;
}>;

export type INamedBucketDefsQuery = { __typename: 'Query' } & {
  namedBucketDefs: Maybe<
    { __typename: 'NamedBucketDefPaginated' } & {
      entities: Array<
        { __typename: 'NamedBucketDef' } & INamedBucketDefFieldsFragment
      >;
    }
  >;
};

export type IGetNamedFiltersQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
  includeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  pagination: IPagination;
}>;

export type IGetNamedFiltersQuery = { __typename: 'Query' } & {
  namedFilters: Maybe<
    { __typename: 'NamedFilterPaginated' } & {
      entities: Array<
        { __typename: 'NamedFilter' } & INamedFilterFieldsFragment
      >;
    }
  >;
};

export type IGetVirtualEventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IGetVirtualEventQuery = { __typename: 'Query' } & {
  virtualEvent: { __typename: 'VirtualEvent' } & IVirtualEventFieldsFragment;
};

export type IGetVirtualEventsQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
  includeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  pagination: IPagination;
}>;

export type IGetVirtualEventsQuery = { __typename: 'Query' } & {
  virtualEvents: Maybe<
    { __typename: 'VirtualEventPaginated' } & {
      entities: Array<
        { __typename: 'VirtualEvent' } & IVirtualEventFieldsFragment
      >;
    }
  >;
};

export type IFormulaConfigQueryVariables = Exact<{
  schemaId: Scalars['String']['input'];
}>;

export type IFormulaConfigQuery = { __typename: 'Query' } & {
  formulaConfig: { __typename: 'FormulaConfig' } & Pick<
    IFormulaConfig,
    'timezone' | 'weekStart'
  >;
};

export type INestedFieldQueryQueryVariables = Exact<{
  field: Scalars['String']['input'];
  schemaId: Scalars['ID']['input'];
  context: FieldContext;
  func: InputMaybe<Scalars['String']['input']>;
  events: Array<IEventInput> | IEventInput;
  term: InputMaybe<Scalars['String']['input']>;
  includeValues: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type INestedFieldQueryQuery = { __typename: 'Query' } & {
  nestedField: Maybe<
    { __typename: 'NestedFieldConfig' } & Pick<
      INestedFieldConfig,
      'keys' | 'types'
    >
  >;
};

export type INestedFieldTypesQueryQueryVariables = Exact<{
  field: Scalars['String']['input'];
  schemaId: Scalars['ID']['input'];
  context: FieldContext;
  func: InputMaybe<Scalars['String']['input']>;
  events: Array<IEventInput> | IEventInput;
  term: InputMaybe<Scalars['String']['input']>;
  includeValues: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type INestedFieldTypesQueryQuery = { __typename: 'Query' } & {
  nestedField: Maybe<
    { __typename: 'NestedFieldConfig' } & Pick<INestedFieldConfig, 'types'>
  >;
};

type IFavoritedAnalysisFields_CohortSample_Fragment = {
  __typename: 'CohortSample';
} & Pick<ICohortSample, 'id' | 'queryType' | 'display' | 'description'> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IFavoritedAnalysisFields_DataTable_Fragment = {
  __typename: 'DataTable';
} & Pick<IDataTable, 'id' | 'queryType' | 'display' | 'description'> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IFavoritedAnalysisFields_Expression_Fragment = {
  __typename: 'Expression';
} & Pick<IExpression, 'id' | 'queryType' | 'display' | 'description'> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IFavoritedAnalysisFields_Funnel_Fragment = { __typename: 'Funnel' } & Pick<
  IFunnel,
  'id' | 'queryType' | 'display' | 'description'
> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IFavoritedAnalysisFields_Path_Fragment = { __typename: 'Path' } & Pick<
  IPath,
  'id' | 'queryType' | 'display' | 'description'
> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IFavoritedAnalysisFields_Prediction_Fragment = {
  __typename: 'Prediction';
} & Pick<IPrediction, 'id' | 'queryType' | 'display' | 'description'> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IFavoritedAnalysisFields_Retention_Fragment = {
  __typename: 'Retention';
} & Pick<IRetention, 'id' | 'queryType' | 'display' | 'description'> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IFavoritedAnalysisFields_Significance_Fragment = {
  __typename: 'Significance';
} & Pick<ISignificance, 'id' | 'queryType' | 'display' | 'description'> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

export type IFavoritedAnalysisFieldsFragment =
  | IFavoritedAnalysisFields_CohortSample_Fragment
  | IFavoritedAnalysisFields_DataTable_Fragment
  | IFavoritedAnalysisFields_Expression_Fragment
  | IFavoritedAnalysisFields_Funnel_Fragment
  | IFavoritedAnalysisFields_Path_Fragment
  | IFavoritedAnalysisFields_Prediction_Fragment
  | IFavoritedAnalysisFields_Retention_Fragment
  | IFavoritedAnalysisFields_Significance_Fragment;

export type IGetFavoritedAnalysesQueryVariables = Exact<{
  userOnly: InputMaybe<Scalars['Boolean']['input']>;
  schemaIds: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  kind: InputMaybe<AnalysisKind>;
  queryTypes: InputMaybe<Array<QueryType> | QueryType>;
  term: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<
    Array<InputMaybe<AnalysisStatus>> | InputMaybe<AnalysisStatus>
  >;
  includes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  filter: InputMaybe<IAnalysisFilter>;
  favoriteOnly: InputMaybe<Scalars['Boolean']['input']>;
  pagination: IPagination;
}>;

export type IGetFavoritedAnalysesQuery = { __typename: 'Query' } & {
  searchAnalysis: Maybe<
    { __typename: 'AnalysesPaginated' } & {
      entities: Array<
        | ({
            __typename: 'CohortSample';
          } & IFavoritedAnalysisFields_CohortSample_Fragment)
        | ({
            __typename: 'DataTable';
          } & IFavoritedAnalysisFields_DataTable_Fragment)
        | ({
            __typename: 'Expression';
          } & IFavoritedAnalysisFields_Expression_Fragment)
        | ({ __typename: 'Funnel' } & IFavoritedAnalysisFields_Funnel_Fragment)
        | ({ __typename: 'Path' } & IFavoritedAnalysisFields_Path_Fragment)
        | ({
            __typename: 'Prediction';
          } & IFavoritedAnalysisFields_Prediction_Fragment)
        | ({
            __typename: 'Retention';
          } & IFavoritedAnalysisFields_Retention_Fragment)
        | ({
            __typename: 'Significance';
          } & IFavoritedAnalysisFields_Significance_Fragment)
      >;
    }
  >;
};

export type ICalendarIncidentsQueryVariables = Exact<{
  typeIds: InputMaybe<
    | Array<InputMaybe<Scalars['ID']['input']>>
    | InputMaybe<Scalars['ID']['input']>
  >;
  start: InputMaybe<Scalars['LocalDate']['input']>;
  end: InputMaybe<Scalars['LocalDate']['input']>;
  keyword: InputMaybe<Scalars['String']['input']>;
}>;

export type ICalendarIncidentsQuery = { __typename: 'Query' } & {
  incidents: Maybe<
    Array<Maybe<{ __typename: 'Incident' } & IIncidentFieldsFragment>>
  >;
};

export type IIncidentFieldsFragment = { __typename: 'Incident' } & Pick<
  IIncident,
  'id' | 'name' | 'description' | 'start' | 'end' | 'createdAt'
> & {
    type: { __typename: 'IncidentType' } & Pick<IIncidentType, 'id' | 'name'>;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
  };

export type IIncidentCreateMutationVariables = Exact<{
  input: IIncidentCreateInput;
}>;

export type IIncidentCreateMutation = { __typename: 'Mutation' } & {
  incidentCreate: { __typename: 'IncidentCreatePayload' } & {
    entity: Maybe<{ __typename: 'Incident' } & IIncidentFieldsFragment>;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field' | 'messages'>>;
  };
};

export type IIncidentDeleteMutationVariables = Exact<{
  input: IIncidentDeleteInput;
}>;

export type IIncidentDeleteMutation = { __typename: 'Mutation' } & {
  incidentDelete: { __typename: 'IncidentDeletePayload' } & Pick<
    IIncidentDeletePayload,
    'message'
  > & {
      errors: Array<
        { __typename: 'Error' } & Pick<IError, 'field' | 'messages'>
      >;
    };
};

export type IIncidentEditMutationVariables = Exact<{
  input: IIncidentEditInput;
}>;

export type IIncidentEditMutation = { __typename: 'Mutation' } & {
  incidentEdit: { __typename: 'IncidentEditPayload' } & {
    entity: Maybe<{ __typename: 'Incident' } & IIncidentFieldsFragment>;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field' | 'messages'>>;
  };
};

export type ISearchSchedulesQueryVariables = Exact<{
  term: InputMaybe<Scalars['String']['input']>;
  types: Array<ScheduleType> | ScheduleType;
  schemaKey: InputMaybe<Scalars['String']['input']>;
  includes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  pagination: IPagination;
}>;

export type ISearchSchedulesQuery = { __typename: 'Query' } & {
  searchSchedules: Maybe<
    { __typename: 'SchedulePaginated' } & {
      entities: Array<{ __typename: 'Schedule' } & IScheduleFieldsFragment>;
    }
  >;
};

export type ITriggerScheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ITriggerScheduleMutation = { __typename: 'Mutation' } & {
  triggerSchedule: { __typename: 'ScheduleTriggerPayload' } & Pick<
    IScheduleTriggerPayload,
    'message'
  > & {
      errors: Array<
        { __typename: 'Error' } & Pick<IError, 'field' | 'messages'>
      >;
    };
};

export type IQueryExecuteMutationVariables = Exact<{
  input: IQueryExecuteInput;
}>;

export type IQueryExecuteMutation = { __typename: 'Mutation' } & {
  queryExecute: { __typename: 'QueryExecutePayload' } & {
    entity: Maybe<
      | ({ __typename: 'CohortSample' } & {
          query: { __typename: 'CohortSampleQuery' };
        } & IAnalysisMetaFields_CohortSample_Fragment)
      | ({ __typename: 'DataTable' } & {
          query: { __typename: 'DataTableQuery' };
        } & IAnalysisMetaFields_DataTable_Fragment)
      | ({ __typename: 'Expression' } & Pick<IExpression, 'geo'> & {
            comparisonConfig: Maybe<
              {
                __typename: 'ComparisonConfig';
              } & IComparisonConfigFieldsFragment
            >;
            query: {
              __typename: 'ExpressionQuery';
            } & IExpressionQueryFieldsFragment;
          } & IAnalysisMetaFields_Expression_Fragment)
      | ({ __typename: 'Funnel' } & {
          query: { __typename: 'FunnelQuery' };
        } & IAnalysisMetaFields_Funnel_Fragment)
      | ({ __typename: 'Path' } & {
          query: { __typename: 'PathQuery' };
        } & IAnalysisMetaFields_Path_Fragment)
      | ({ __typename: 'Prediction' } & {
          query: { __typename: 'PredictionQuery' };
        } & IAnalysisMetaFields_Prediction_Fragment)
      | ({ __typename: 'Retention' } & {
          query: { __typename: 'RetentionQuery' };
        } & IAnalysisMetaFields_Retention_Fragment)
      | ({ __typename: 'Significance' } & {
          query: { __typename: 'SignificanceQuery' };
        } & IAnalysisMetaFields_Significance_Fragment)
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IFunnelExecuteMutationVariables = Exact<{
  input: IFunnelExecuteInput;
}>;

export type IFunnelExecuteMutation = { __typename: 'Mutation' } & {
  funnelExecute: { __typename: 'QueryExecutePayload' } & {
    entity: Maybe<
      | ({ __typename: 'CohortSample' } & {
          query: { __typename: 'CohortSampleQuery' };
        } & IAnalysisMetaFields_CohortSample_Fragment)
      | ({ __typename: 'DataTable' } & {
          query: { __typename: 'DataTableQuery' };
        } & IAnalysisMetaFields_DataTable_Fragment)
      | ({ __typename: 'Expression' } & {
          query: { __typename: 'ExpressionQuery' };
        } & IAnalysisMetaFields_Expression_Fragment)
      | ({ __typename: 'Funnel' } & {
          query: { __typename: 'FunnelQuery' } & IFunnelQueryFieldsFragment;
        } & IAnalysisMetaFields_Funnel_Fragment)
      | ({ __typename: 'Path' } & {
          query: { __typename: 'PathQuery' };
        } & IAnalysisMetaFields_Path_Fragment)
      | ({ __typename: 'Prediction' } & {
          query: { __typename: 'PredictionQuery' };
        } & IAnalysisMetaFields_Prediction_Fragment)
      | ({ __typename: 'Retention' } & {
          query: { __typename: 'RetentionQuery' };
        } & IAnalysisMetaFields_Retention_Fragment)
      | ({ __typename: 'Significance' } & {
          query: { __typename: 'SignificanceQuery' };
        } & IAnalysisMetaFields_Significance_Fragment)
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IPathExecuteMutationVariables = Exact<{
  input: IPathExecuteInput;
}>;

export type IPathExecuteMutation = { __typename: 'Mutation' } & {
  pathExecute: { __typename: 'PathExecutePayload' } & {
    entity: Maybe<
      | ({ __typename: 'CohortSample' } & {
          query: { __typename: 'CohortSampleQuery' };
        } & IAnalysisMetaFields_CohortSample_Fragment)
      | ({ __typename: 'DataTable' } & {
          query: { __typename: 'DataTableQuery' };
        } & IAnalysisMetaFields_DataTable_Fragment)
      | ({ __typename: 'Expression' } & {
          query: { __typename: 'ExpressionQuery' };
        } & IAnalysisMetaFields_Expression_Fragment)
      | ({ __typename: 'Funnel' } & {
          query: { __typename: 'FunnelQuery' };
        } & IAnalysisMetaFields_Funnel_Fragment)
      | ({ __typename: 'Path' } & {
          query: { __typename: 'PathQuery' } & IPathQueryFieldsFragment;
        } & IAnalysisMetaFields_Path_Fragment)
      | ({ __typename: 'Prediction' } & {
          query: { __typename: 'PredictionQuery' };
        } & IAnalysisMetaFields_Prediction_Fragment)
      | ({ __typename: 'Retention' } & {
          query: { __typename: 'RetentionQuery' };
        } & IAnalysisMetaFields_Retention_Fragment)
      | ({ __typename: 'Significance' } & {
          query: { __typename: 'SignificanceQuery' };
        } & IAnalysisMetaFields_Significance_Fragment)
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IRetentionExecuteMutationVariables = Exact<{
  input: IRetentionExecuteInput;
}>;

export type IRetentionExecuteMutation = { __typename: 'Mutation' } & {
  retentionExecute: { __typename: 'RetentionExecutePayload' } & {
    entity: Maybe<
      | ({ __typename: 'CohortSample' } & {
          query: { __typename: 'CohortSampleQuery' };
        } & IAnalysisMetaFields_CohortSample_Fragment)
      | ({ __typename: 'DataTable' } & {
          query: { __typename: 'DataTableQuery' };
        } & IAnalysisMetaFields_DataTable_Fragment)
      | ({ __typename: 'Expression' } & {
          query: { __typename: 'ExpressionQuery' };
        } & IAnalysisMetaFields_Expression_Fragment)
      | ({ __typename: 'Funnel' } & {
          query: { __typename: 'FunnelQuery' };
        } & IAnalysisMetaFields_Funnel_Fragment)
      | ({ __typename: 'Path' } & {
          query: { __typename: 'PathQuery' };
        } & IAnalysisMetaFields_Path_Fragment)
      | ({ __typename: 'Prediction' } & {
          query: { __typename: 'PredictionQuery' };
        } & IAnalysisMetaFields_Prediction_Fragment)
      | ({ __typename: 'Retention' } & {
          query: {
            __typename: 'RetentionQuery';
          } & IRetentionQueryFieldsFragment;
        } & IAnalysisMetaFields_Retention_Fragment)
      | ({ __typename: 'Significance' } & {
          query: { __typename: 'SignificanceQuery' };
        } & IAnalysisMetaFields_Significance_Fragment)
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IPredictionExecuteMutationVariables = Exact<{
  input: IPredictionExecuteInput;
}>;

export type IPredictionExecuteMutation = { __typename: 'Mutation' } & {
  predictionExecute: { __typename: 'PredictionExecutePayload' } & {
    entity: Maybe<
      | ({ __typename: 'CohortSample' } & {
          query: { __typename: 'CohortSampleQuery' };
        } & IAnalysisMetaFields_CohortSample_Fragment)
      | ({ __typename: 'DataTable' } & {
          query: { __typename: 'DataTableQuery' };
        } & IAnalysisMetaFields_DataTable_Fragment)
      | ({ __typename: 'Expression' } & {
          query: { __typename: 'ExpressionQuery' };
        } & IAnalysisMetaFields_Expression_Fragment)
      | ({ __typename: 'Funnel' } & {
          query: { __typename: 'FunnelQuery' };
        } & IAnalysisMetaFields_Funnel_Fragment)
      | ({ __typename: 'Path' } & {
          query: { __typename: 'PathQuery' };
        } & IAnalysisMetaFields_Path_Fragment)
      | ({ __typename: 'Prediction' } & {
          query: {
            __typename: 'PredictionQuery';
          } & IPredictionQueryFieldsFragment;
        } & IAnalysisMetaFields_Prediction_Fragment)
      | ({ __typename: 'Retention' } & {
          query: { __typename: 'RetentionQuery' };
        } & IAnalysisMetaFields_Retention_Fragment)
      | ({ __typename: 'Significance' } & {
          query: { __typename: 'SignificanceQuery' };
        } & IAnalysisMetaFields_Significance_Fragment)
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDataTableExecuteMutationVariables = Exact<{
  input: IDataTableExecuteInput;
}>;

export type IDataTableExecuteMutation = { __typename: 'Mutation' } & {
  dataTableExecute: { __typename: 'DataTableExecutePayload' } & {
    entity: Maybe<
      | ({ __typename: 'CohortSample' } & {
          query: { __typename: 'CohortSampleQuery' };
        } & IAnalysisMetaFields_CohortSample_Fragment)
      | ({ __typename: 'DataTable' } & {
          comparisonConfig: Maybe<
            { __typename: 'ComparisonConfig' } & IComparisonConfigFieldsFragment
          >;
          query: {
            __typename: 'DataTableQuery';
          } & IDataTableQueryFieldsFragment;
        } & IAnalysisMetaFields_DataTable_Fragment)
      | ({ __typename: 'Expression' } & {
          query: { __typename: 'ExpressionQuery' };
        } & IAnalysisMetaFields_Expression_Fragment)
      | ({ __typename: 'Funnel' } & {
          query: { __typename: 'FunnelQuery' };
        } & IAnalysisMetaFields_Funnel_Fragment)
      | ({ __typename: 'Path' } & {
          query: { __typename: 'PathQuery' };
        } & IAnalysisMetaFields_Path_Fragment)
      | ({ __typename: 'Prediction' } & {
          query: { __typename: 'PredictionQuery' };
        } & IAnalysisMetaFields_Prediction_Fragment)
      | ({ __typename: 'Retention' } & {
          query: { __typename: 'RetentionQuery' };
        } & IAnalysisMetaFields_Retention_Fragment)
      | ({ __typename: 'Significance' } & {
          query: { __typename: 'SignificanceQuery' };
        } & IAnalysisMetaFields_Significance_Fragment)
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type ICohortExecuteMutationVariables = Exact<{
  input: ICohortExecuteInput;
}>;

export type ICohortExecuteMutation = { __typename: 'Mutation' } & {
  cohortExecute: { __typename: 'CohortExecutePayload' } & {
    entity: Maybe<
      | ({ __typename: 'CohortSample' } & {
          query: {
            __typename: 'CohortSampleQuery';
          } & ICohortSampleQueryFieldsFragment;
        } & IAnalysisMetaFields_CohortSample_Fragment)
      | ({ __typename: 'DataTable' } & {
          query: { __typename: 'DataTableQuery' };
        } & IAnalysisMetaFields_DataTable_Fragment)
      | ({ __typename: 'Expression' } & {
          query: { __typename: 'ExpressionQuery' };
        } & IAnalysisMetaFields_Expression_Fragment)
      | ({ __typename: 'Funnel' } & {
          query: { __typename: 'FunnelQuery' };
        } & IAnalysisMetaFields_Funnel_Fragment)
      | ({ __typename: 'Path' } & {
          query: { __typename: 'PathQuery' };
        } & IAnalysisMetaFields_Path_Fragment)
      | ({ __typename: 'Prediction' } & {
          query: { __typename: 'PredictionQuery' };
        } & IAnalysisMetaFields_Prediction_Fragment)
      | ({ __typename: 'Retention' } & {
          query: { __typename: 'RetentionQuery' };
        } & IAnalysisMetaFields_Retention_Fragment)
      | ({ __typename: 'Significance' } & {
          query: { __typename: 'SignificanceQuery' };
        } & IAnalysisMetaFields_Significance_Fragment)
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type ISliceNameHintFieldsFragment = {
  __typename: 'SliceNameHint';
} & Pick<ISliceNameHint, 'name' | 'value'>;

type ISliceUserAliasFields_UserAliasSliceBase_Fragment = {
  __typename: 'UserAliasSliceBase';
} & Pick<IUserAliasSliceBase, 'aliasId'>;

type ISliceUserAliasFields_UserAliasSliceBreakdown_Fragment = {
  __typename: 'UserAliasSliceBreakdown';
} & Pick<IUserAliasSliceBreakdown, 'aliasId' | 'groupBys'>;

type ISliceUserAliasFields_UserAliasSliceNone_Fragment = {
  __typename: 'UserAliasSliceNone';
};

export type ISliceUserAliasFieldsFragment =
  | ISliceUserAliasFields_UserAliasSliceBase_Fragment
  | ISliceUserAliasFields_UserAliasSliceBreakdown_Fragment
  | ISliceUserAliasFields_UserAliasSliceNone_Fragment;

export type IHighlightFieldsFragment = { __typename: 'Highlight' } & Pick<
  IHighlight,
  'date' | 'text' | 'value'
>;

export type IMovingAverageFieldsFragment = {
  __typename: 'MovingAverage';
} & Pick<IMovingAverage, 'values' | 'display'>;

export type IMovingSumFieldsFragment = { __typename: 'MovingSum' } & Pick<
  IMovingSum,
  'values' | 'display'
>;

export type IReadingFieldsFragment = { __typename: 'Reading' } & {
  ma: Maybe<{ __typename: 'MovingAverage' } & IMovingAverageFieldsFragment>;
  ma30: Maybe<{ __typename: 'MovingAverage' } & IMovingAverageFieldsFragment>;
  ms7: Maybe<{ __typename: 'MovingSum' } & IMovingSumFieldsFragment>;
  ms30: Maybe<{ __typename: 'MovingSum' } & IMovingSumFieldsFragment>;
  highlights: Array<{ __typename: 'Highlight' } & IHighlightFieldsFragment>;
};

export type ICumulativeSumFieldsFragment = {
  __typename: 'ExpressionCumulativeSum';
} & Pick<IExpressionCumulativeSum, 'display' | 'values'>;

export type IChartControlFieldsFragment = { __typename: 'ChartControl' } & Pick<
  IChartControl,
  'default'
> & {
    measureControls: Array<
      { __typename: 'MeasureControl' } & Pick<
        IMeasureControl,
        'name' | 'key' | 'charts' | 'isResultKey' | 'isCountFunction'
      > & {
          userAlias:
            | ({
                __typename: 'UserAliasQueryCohort';
              } & IUserAliasQueryCohortFieldsFragment)
            | ({
                __typename: 'UserAliasQueryMeasure';
              } & IUserAliasQueryMeasureFieldsFragment)
            | ({
                __typename: 'UserAliasQueryStep';
              } & IUserAliasQueryStepFieldsFragment);
        }
    >;
  };

export type IDateIntervalFieldsFragment = { __typename: 'DateInterval' } & Pick<
  IDateInterval,
  'start' | 'end'
>;

export type ICohortDateFieldsFragment = { __typename: 'CohortDate' } & Pick<
  ICohortDate,
  'date'
> & { interval: { __typename: 'DateInterval' } & IDateIntervalFieldsFragment };

export type IAnalysisPrefFieldsFragment = { __typename: 'AnalysisPref' } & Pick<
  IAnalysisPref,
  'chartPref'
> & {
    aliasReplacements: Array<
      {
        __typename: 'UserAliasReplacement';
      } & IUserAliasReplacementFieldsFragment
    >;
  };

export type IAnalysisRichTextSummaryFieldsFragment = {
  __typename: 'AnalysisRichTextSummary';
} & Pick<IAnalysisRichTextSummary, 'showInDashboard'> & {
    richText: { __typename: 'RichText' } & IRichTextFieldsFragment;
  };

type IAnalysisMetaFields_CohortSample_Fragment = {
  __typename: 'CohortSample';
} & Pick<
  ICohortSample,
  | 'id'
  | 'display'
  | 'description'
  | 'kind'
  | 'start'
  | 'end'
  | 'timeUnit'
  | 'queryType'
  | 'groupbys'
  | 'live'
  | 'status'
  | 'errorStatus'
  | 'failureMsg'
  | 'exportUrl'
  | 'executedAt'
  | 'estimatedDuration'
  | 'referenceSql'
  | 'createdAt'
  | 'isFavorite'
> & {
    pref: { __typename: 'AnalysisPref' } & IAnalysisPrefFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    llmSummary: Maybe<
      { __typename: 'LlmSubjectSummary' } & ILlmSubjectSummaryFieldsFragment
    >;
    richTextSummary: Maybe<
      {
        __typename: 'AnalysisRichTextSummary';
      } & IAnalysisRichTextSummaryFieldsFragment
    >;
    container: Maybe<
      | ({
          __typename: 'AnalysisDashboardContainer';
        } & IAnalysisContainerFields_AnalysisDashboardContainer_Fragment)
      | ({
          __typename: 'AnalysisWorkspaceContainer';
        } & IAnalysisContainerFields_AnalysisWorkspaceContainer_Fragment)
    >;
  };

type IAnalysisMetaFields_DataTable_Fragment = {
  __typename: 'DataTable';
} & Pick<
  IDataTable,
  | 'id'
  | 'display'
  | 'description'
  | 'kind'
  | 'start'
  | 'end'
  | 'timeUnit'
  | 'queryType'
  | 'groupbys'
  | 'live'
  | 'status'
  | 'errorStatus'
  | 'failureMsg'
  | 'exportUrl'
  | 'executedAt'
  | 'estimatedDuration'
  | 'referenceSql'
  | 'createdAt'
  | 'isFavorite'
> & {
    pref: { __typename: 'AnalysisPref' } & IAnalysisPrefFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    llmSummary: Maybe<
      { __typename: 'LlmSubjectSummary' } & ILlmSubjectSummaryFieldsFragment
    >;
    richTextSummary: Maybe<
      {
        __typename: 'AnalysisRichTextSummary';
      } & IAnalysisRichTextSummaryFieldsFragment
    >;
    container: Maybe<
      | ({
          __typename: 'AnalysisDashboardContainer';
        } & IAnalysisContainerFields_AnalysisDashboardContainer_Fragment)
      | ({
          __typename: 'AnalysisWorkspaceContainer';
        } & IAnalysisContainerFields_AnalysisWorkspaceContainer_Fragment)
    >;
  };

type IAnalysisMetaFields_Expression_Fragment = {
  __typename: 'Expression';
} & Pick<
  IExpression,
  | 'id'
  | 'display'
  | 'description'
  | 'kind'
  | 'start'
  | 'end'
  | 'timeUnit'
  | 'queryType'
  | 'groupbys'
  | 'live'
  | 'status'
  | 'errorStatus'
  | 'failureMsg'
  | 'exportUrl'
  | 'executedAt'
  | 'estimatedDuration'
  | 'referenceSql'
  | 'createdAt'
  | 'isFavorite'
> & {
    pref: { __typename: 'AnalysisPref' } & IAnalysisPrefFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    llmSummary: Maybe<
      { __typename: 'LlmSubjectSummary' } & ILlmSubjectSummaryFieldsFragment
    >;
    richTextSummary: Maybe<
      {
        __typename: 'AnalysisRichTextSummary';
      } & IAnalysisRichTextSummaryFieldsFragment
    >;
    container: Maybe<
      | ({
          __typename: 'AnalysisDashboardContainer';
        } & IAnalysisContainerFields_AnalysisDashboardContainer_Fragment)
      | ({
          __typename: 'AnalysisWorkspaceContainer';
        } & IAnalysisContainerFields_AnalysisWorkspaceContainer_Fragment)
    >;
  };

type IAnalysisMetaFields_Funnel_Fragment = { __typename: 'Funnel' } & Pick<
  IFunnel,
  | 'id'
  | 'display'
  | 'description'
  | 'kind'
  | 'start'
  | 'end'
  | 'timeUnit'
  | 'queryType'
  | 'groupbys'
  | 'live'
  | 'status'
  | 'errorStatus'
  | 'failureMsg'
  | 'exportUrl'
  | 'executedAt'
  | 'estimatedDuration'
  | 'referenceSql'
  | 'createdAt'
  | 'isFavorite'
> & {
    pref: { __typename: 'AnalysisPref' } & IAnalysisPrefFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    llmSummary: Maybe<
      { __typename: 'LlmSubjectSummary' } & ILlmSubjectSummaryFieldsFragment
    >;
    richTextSummary: Maybe<
      {
        __typename: 'AnalysisRichTextSummary';
      } & IAnalysisRichTextSummaryFieldsFragment
    >;
    container: Maybe<
      | ({
          __typename: 'AnalysisDashboardContainer';
        } & IAnalysisContainerFields_AnalysisDashboardContainer_Fragment)
      | ({
          __typename: 'AnalysisWorkspaceContainer';
        } & IAnalysisContainerFields_AnalysisWorkspaceContainer_Fragment)
    >;
  };

type IAnalysisMetaFields_Path_Fragment = { __typename: 'Path' } & Pick<
  IPath,
  | 'id'
  | 'display'
  | 'description'
  | 'kind'
  | 'start'
  | 'end'
  | 'timeUnit'
  | 'queryType'
  | 'groupbys'
  | 'live'
  | 'status'
  | 'errorStatus'
  | 'failureMsg'
  | 'exportUrl'
  | 'executedAt'
  | 'estimatedDuration'
  | 'referenceSql'
  | 'createdAt'
  | 'isFavorite'
> & {
    pref: { __typename: 'AnalysisPref' } & IAnalysisPrefFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    llmSummary: Maybe<
      { __typename: 'LlmSubjectSummary' } & ILlmSubjectSummaryFieldsFragment
    >;
    richTextSummary: Maybe<
      {
        __typename: 'AnalysisRichTextSummary';
      } & IAnalysisRichTextSummaryFieldsFragment
    >;
    container: Maybe<
      | ({
          __typename: 'AnalysisDashboardContainer';
        } & IAnalysisContainerFields_AnalysisDashboardContainer_Fragment)
      | ({
          __typename: 'AnalysisWorkspaceContainer';
        } & IAnalysisContainerFields_AnalysisWorkspaceContainer_Fragment)
    >;
  };

type IAnalysisMetaFields_Prediction_Fragment = {
  __typename: 'Prediction';
} & Pick<
  IPrediction,
  | 'id'
  | 'display'
  | 'description'
  | 'kind'
  | 'start'
  | 'end'
  | 'timeUnit'
  | 'queryType'
  | 'groupbys'
  | 'live'
  | 'status'
  | 'errorStatus'
  | 'failureMsg'
  | 'exportUrl'
  | 'executedAt'
  | 'estimatedDuration'
  | 'referenceSql'
  | 'createdAt'
  | 'isFavorite'
> & {
    pref: { __typename: 'AnalysisPref' } & IAnalysisPrefFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    llmSummary: Maybe<
      { __typename: 'LlmSubjectSummary' } & ILlmSubjectSummaryFieldsFragment
    >;
    richTextSummary: Maybe<
      {
        __typename: 'AnalysisRichTextSummary';
      } & IAnalysisRichTextSummaryFieldsFragment
    >;
    container: Maybe<
      | ({
          __typename: 'AnalysisDashboardContainer';
        } & IAnalysisContainerFields_AnalysisDashboardContainer_Fragment)
      | ({
          __typename: 'AnalysisWorkspaceContainer';
        } & IAnalysisContainerFields_AnalysisWorkspaceContainer_Fragment)
    >;
  };

type IAnalysisMetaFields_Retention_Fragment = {
  __typename: 'Retention';
} & Pick<
  IRetention,
  | 'id'
  | 'display'
  | 'description'
  | 'kind'
  | 'start'
  | 'end'
  | 'timeUnit'
  | 'queryType'
  | 'groupbys'
  | 'live'
  | 'status'
  | 'errorStatus'
  | 'failureMsg'
  | 'exportUrl'
  | 'executedAt'
  | 'estimatedDuration'
  | 'referenceSql'
  | 'createdAt'
  | 'isFavorite'
> & {
    pref: { __typename: 'AnalysisPref' } & IAnalysisPrefFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    llmSummary: Maybe<
      { __typename: 'LlmSubjectSummary' } & ILlmSubjectSummaryFieldsFragment
    >;
    richTextSummary: Maybe<
      {
        __typename: 'AnalysisRichTextSummary';
      } & IAnalysisRichTextSummaryFieldsFragment
    >;
    container: Maybe<
      | ({
          __typename: 'AnalysisDashboardContainer';
        } & IAnalysisContainerFields_AnalysisDashboardContainer_Fragment)
      | ({
          __typename: 'AnalysisWorkspaceContainer';
        } & IAnalysisContainerFields_AnalysisWorkspaceContainer_Fragment)
    >;
  };

type IAnalysisMetaFields_Significance_Fragment = {
  __typename: 'Significance';
} & Pick<
  ISignificance,
  | 'id'
  | 'display'
  | 'description'
  | 'kind'
  | 'start'
  | 'end'
  | 'timeUnit'
  | 'queryType'
  | 'groupbys'
  | 'live'
  | 'status'
  | 'errorStatus'
  | 'failureMsg'
  | 'exportUrl'
  | 'executedAt'
  | 'estimatedDuration'
  | 'referenceSql'
  | 'createdAt'
  | 'isFavorite'
> & {
    pref: { __typename: 'AnalysisPref' } & IAnalysisPrefFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    llmSummary: Maybe<
      { __typename: 'LlmSubjectSummary' } & ILlmSubjectSummaryFieldsFragment
    >;
    richTextSummary: Maybe<
      {
        __typename: 'AnalysisRichTextSummary';
      } & IAnalysisRichTextSummaryFieldsFragment
    >;
    container: Maybe<
      | ({
          __typename: 'AnalysisDashboardContainer';
        } & IAnalysisContainerFields_AnalysisDashboardContainer_Fragment)
      | ({
          __typename: 'AnalysisWorkspaceContainer';
        } & IAnalysisContainerFields_AnalysisWorkspaceContainer_Fragment)
    >;
  };

export type IAnalysisMetaFieldsFragment =
  | IAnalysisMetaFields_CohortSample_Fragment
  | IAnalysisMetaFields_DataTable_Fragment
  | IAnalysisMetaFields_Expression_Fragment
  | IAnalysisMetaFields_Funnel_Fragment
  | IAnalysisMetaFields_Path_Fragment
  | IAnalysisMetaFields_Prediction_Fragment
  | IAnalysisMetaFields_Retention_Fragment
  | IAnalysisMetaFields_Significance_Fragment;

export type IFlowFieldsFragment = { __typename: 'Flow' } & Pick<
  IFlow,
  'name' | 'key' | 'rank'
> & {
    steps: Array<
      { __typename: 'FlowStep' } & Pick<
        IFlowStep,
        'currentEvent' | 'nextEvent' | 'seq' | 'count'
      >
    >;
    userAlias:
      | ({
          __typename: 'UserAliasSliceBase';
        } & ISliceUserAliasFields_UserAliasSliceBase_Fragment)
      | ({
          __typename: 'UserAliasSliceBreakdown';
        } & ISliceUserAliasFields_UserAliasSliceBreakdown_Fragment)
      | ({
          __typename: 'UserAliasSliceNone';
        } & ISliceUserAliasFields_UserAliasSliceNone_Fragment);
    hint: Array<{ __typename: 'SliceNameHint' } & ISliceNameHintFieldsFragment>;
  };

export type ITopPathsSliceFieldsFragment = {
  __typename: 'TopPathsSlice';
} & Pick<ITopPathsSlice, 'name' | 'key' | 'rank'> & {
    userAlias:
      | ({
          __typename: 'UserAliasSliceBase';
        } & ISliceUserAliasFields_UserAliasSliceBase_Fragment)
      | ({
          __typename: 'UserAliasSliceBreakdown';
        } & ISliceUserAliasFields_UserAliasSliceBreakdown_Fragment)
      | ({
          __typename: 'UserAliasSliceNone';
        } & ISliceUserAliasFields_UserAliasSliceNone_Fragment);
    hint: Array<{ __typename: 'SliceNameHint' } & ISliceNameHintFieldsFragment>;
    topPaths: Array<
      { __typename: 'TopPath' } & Pick<ITopPath, 'rank'> & {
          funnel: { __typename: 'Funnel' } & {
            data: { __typename: 'FunnelData' } & IFunnelDataFieldsFragment;
            chartControl: {
              __typename: 'ChartControl';
            } & IChartControlFieldsFragment;
            query: { __typename: 'FunnelQuery' } & IFunnelQueryFieldsFragment;
          } & IAnalysisMetaFields_Funnel_Fragment;
        }
    >;
  };

export type IPathDataFieldsFragment = { __typename: 'PathData' } & Pick<
  IPathData,
  'isEmpty'
> & {
    modeValue:
      | ({ __typename: 'SankeyPathModeValue' } & {
          base: Maybe<{ __typename: 'Flow' } & IFlowFieldsFragment>;
          flows: Array<{ __typename: 'Flow' } & IFlowFieldsFragment>;
        })
      | ({ __typename: 'TopPathsPathModeValue' } & {
          base: Maybe<
            { __typename: 'TopPathsSlice' } & ITopPathsSliceFieldsFragment
          >;
          slices: Array<
            { __typename: 'TopPathsSlice' } & ITopPathsSliceFieldsFragment
          >;
        });
  };

export type IRetentionSliceFieldsFragment = {
  __typename: 'RetentionSlice';
} & Pick<IRetentionSlice, 'name' | 'key' | 'rowIndices' | 'rank'> & {
    hint: Array<{ __typename: 'SliceNameHint' } & ISliceNameHintFieldsFragment>;
    userAlias:
      | ({
          __typename: 'UserAliasSliceBase';
        } & ISliceUserAliasFields_UserAliasSliceBase_Fragment)
      | ({
          __typename: 'UserAliasSliceBreakdown';
        } & ISliceUserAliasFields_UserAliasSliceBreakdown_Fragment)
      | ({
          __typename: 'UserAliasSliceNone';
        } & ISliceUserAliasFields_UserAliasSliceNone_Fragment);
  };

export type IRetentionLiveFieldsFragment = {
  __typename: 'RetentionLive';
} & Pick<IRetentionLive, 'cohortLive' | 'retentionLive'>;

export type IRetentionRowFieldsFragment = { __typename: 'RetentionRow' } & Pick<
  IRetentionRow,
  | 'name'
  | 'key'
  | 'startIdentities'
  | 'returnIdentities'
  | 'churnIdentities'
  | 'retentions'
  | 'churns'
>;

export type IRetentionIntervalFieldsFragment = {
  __typename: 'RetentionInterval';
} & Pick<IRetentionInterval, 'start' | 'end'>;

export type IRetentionCohortStartFieldsFragment = {
  __typename: 'RetentionCohortStart';
} & Pick<IRetentionCohortStart, 'key' | 'name'> & {
    startInterval: {
      __typename: 'RetentionInterval';
    } & IRetentionIntervalFieldsFragment;
    actualInterval: {
      __typename: 'RetentionInterval';
    } & IRetentionIntervalFieldsFragment;
  };

export type IRetentionStandardAverageFieldsFragment = {
  __typename: 'RetentionStandardAverage';
} & Pick<IRetentionStandardAverage, 'key' | 'name' | 'rowIndices'>;

export type IReturnPeriodFieldsFragment = { __typename: 'ReturnPeriod' } & Pick<
  IReturnPeriod,
  'key' | 'name'
>;

export type ICohortStartRowFieldsFragment = {
  __typename: 'CohortStartRow';
} & Pick<ICohortStartRow, 'rowIndices'> & {
    cohortStart: {
      __typename: 'RetentionCohortStart';
    } & IRetentionCohortStartFieldsFragment;
    returnIntervals: Array<
      { __typename: 'RetentionInterval' } & IRetentionIntervalFieldsFragment
    >;
  };

export type IReturnPeriodRowFieldsFragment = {
  __typename: 'ReturnPeriodRow';
} & Pick<IReturnPeriodRow, 'rowIndices'> & {
    returnIntervals: Array<
      { __typename: 'RetentionInterval' } & IRetentionIntervalFieldsFragment
    >;
    returnPeriod: { __typename: 'ReturnPeriod' } & IReturnPeriodFieldsFragment;
  };

export type IRetentionStandardTableRowSelectorFieldsFragment = {
  __typename: 'RetentionStandardTableRowSelector';
} & {
  standardColumns: Array<
    { __typename: 'ReturnPeriod' } & IReturnPeriodFieldsFragment
  >;
  standardRows: Array<
    { __typename: 'CohortStartRow' } & ICohortStartRowFieldsFragment
  >;
  avgRetention: {
    __typename: 'RetentionStandardAverage';
  } & IRetentionStandardAverageFieldsFragment;
};

export type IRetentionOverTimeTableRowSelectorFieldsFragment = {
  __typename: 'RetentionOverTimeTableRowSelector';
} & {
  overTimeColumns: Array<
    { __typename: 'RetentionCohortStart' } & IRetentionCohortStartFieldsFragment
  >;
  overTimeRows: Array<
    { __typename: 'ReturnPeriodRow' } & IReturnPeriodRowFieldsFragment
  >;
};

export type IRetentionDataFieldsFragment = {
  __typename: 'RetentionData';
} & Pick<IRetentionData, 'isEmpty'> & {
    retentionLive: Array<
      { __typename: 'RetentionLive' } & IRetentionLiveFieldsFragment
    >;
    rows: Array<{ __typename: 'RetentionRow' } & IRetentionRowFieldsFragment>;
    base: Maybe<
      { __typename: 'RetentionSlice' } & IRetentionSliceFieldsFragment
    >;
    slices: Array<
      { __typename: 'RetentionSlice' } & IRetentionSliceFieldsFragment
    >;
    tableRowSelector: Maybe<
      | ({
          __typename: 'RetentionOverTimeTableRowSelector';
        } & IRetentionOverTimeTableRowSelectorFieldsFragment)
      | ({
          __typename: 'RetentionStandardTableRowSelector';
        } & IRetentionStandardTableRowSelectorFieldsFragment)
    >;
  };

export type ICorrelationKindFieldsFragment = {
  __typename: 'CorrelationKind';
} & Pick<ICorrelationKind, 'key' | 'display'>;

export type ICorrelationFieldsFragment = { __typename: 'Correlation' } & Pick<
  ICorrelation,
  | 'correlation'
  | 'marginOfError'
  | 'predictionLevel'
  | 'ppv'
  | 'npv'
  | 'specificity'
  | 'sensitivity'
  | 'pat'
>;

export type IUserStatusFieldsFragment = { __typename: 'UserStatus' } & Pick<
  IUserStatus,
  'totalUsers' | 'usersPerformedEvent' | 'percentage'
>;

export type IContingencyFieldsFragment = { __typename: 'Contingency' } & Pick<
  IContingency,
  'truePositive' | 'falsePositive' | 'trueNegative' | 'falseNegative'
>;

export type IEventFrequencyCorrelationFieldsFragment = {
  __typename: 'EventFrequencyCorrelation';
} & {
  correlation: { __typename: 'Correlation' } & ICorrelationFieldsFragment;
  userStatus: { __typename: 'UserStatus' } & IUserStatusFieldsFragment;
  contingency: { __typename: 'Contingency' } & IContingencyFieldsFragment;
};

export type IEventDayCorrelationFieldsFragment = {
  __typename: 'EventDayCorrelation';
} & Pick<IEventDayCorrelation, 'day' | 'strongestEventFrequencyCorrelation'> & {
    frequencyCorrelations: Array<
      {
        __typename: 'EventFrequencyCorrelation';
      } & IEventFrequencyCorrelationFieldsFragment
    >;
  };

export type IPredictionDataFieldsFragment = {
  __typename: 'PredictionData';
} & Pick<IPredictionData, 'events' | 'isEmpty'> & {
    correlationKinds: Array<
      { __typename: 'CorrelationKind' } & ICorrelationKindFieldsFragment
    >;
    eventCorrelations: Array<
      { __typename: 'EventCorrelation' } & Pick<IEventCorrelation, 'event'> & {
          eventDayCorrelations: Array<
            {
              __typename: 'EventDayCorrelation';
            } & IEventDayCorrelationFieldsFragment
          >;
        }
    >;
  };

export type IExpressionColumnFieldsFragment = {
  __typename: 'ExpressionColumn';
} & Pick<
  IExpressionColumn,
  | 'name'
  | 'measureKey'
  | 'key'
  | 'values'
  | 'basePercents'
  | 'percentsPreviousValue'
> & {
    cumulativeSum: {
      __typename: 'ExpressionCumulativeSum';
    } & ICumulativeSumFieldsFragment;
    reading: Maybe<{ __typename: 'Reading' } & IReadingFieldsFragment>;
  };

export type IExpressionSliceFieldsFragment = {
  __typename: 'ExpressionSlice';
} & Pick<
  IExpressionSlice,
  'name' | 'key' | 'variables' | 'rank' | 'resultMeasureColumnIndex'
> & {
    hint: Array<{ __typename: 'SliceNameHint' } & ISliceNameHintFieldsFragment>;
    userAlias:
      | ({
          __typename: 'UserAliasSliceBase';
        } & ISliceUserAliasFields_UserAliasSliceBase_Fragment)
      | ({
          __typename: 'UserAliasSliceBreakdown';
        } & ISliceUserAliasFields_UserAliasSliceBreakdown_Fragment)
      | ({
          __typename: 'UserAliasSliceNone';
        } & ISliceUserAliasFields_UserAliasSliceNone_Fragment);
  };

export type IExpressionStatisticsFieldsFragment = {
  __typename: 'ExpressionStatistics';
} & Pick<
  IExpressionStatistics,
  'min' | 'max' | 'avg' | 'stddev' | 'median' | 'percentile'
>;

export type IQueryModeXAxisFieldsFragment = { __typename: 'QueryModeXAxis' } & {
  cohortDates: Array<{ __typename: 'CohortDate' } & ICohortDateFieldsFragment>;
};

export type IHistogramModeXAxisFieldsFragment = {
  __typename: 'HistogramModeXAxis';
} & Pick<IHistogramModeXAxis, 'buckets'>;

export type IImpactAnalysisModeXAxisFieldsFragment = {
  __typename: 'ImpactAnalysisModeXAxis';
} & Pick<IImpactAnalysisModeXAxis, 'periods'>;

type IExpressionModeXAxisFields_HistogramModeXAxis_Fragment = {
  __typename: 'HistogramModeXAxis';
} & IHistogramModeXAxisFieldsFragment;

type IExpressionModeXAxisFields_ImpactAnalysisModeXAxis_Fragment = {
  __typename: 'ImpactAnalysisModeXAxis';
} & IImpactAnalysisModeXAxisFieldsFragment;

type IExpressionModeXAxisFields_QueryModeXAxis_Fragment = {
  __typename: 'QueryModeXAxis';
} & IQueryModeXAxisFieldsFragment;

export type IExpressionModeXAxisFieldsFragment =
  | IExpressionModeXAxisFields_HistogramModeXAxis_Fragment
  | IExpressionModeXAxisFields_ImpactAnalysisModeXAxis_Fragment
  | IExpressionModeXAxisFields_QueryModeXAxis_Fragment;

export type IExpressionDataFieldsFragment = {
  __typename: 'ExpressionData';
} & Pick<IExpressionData, 'dates' | 'live' | 'isEmpty'> & {
    expressionAxis: Maybe<
      | ({
          __typename: 'HistogramModeXAxis';
        } & IExpressionModeXAxisFields_HistogramModeXAxis_Fragment)
      | ({
          __typename: 'ImpactAnalysisModeXAxis';
        } & IExpressionModeXAxisFields_ImpactAnalysisModeXAxis_Fragment)
      | ({
          __typename: 'QueryModeXAxis';
        } & IExpressionModeXAxisFields_QueryModeXAxis_Fragment)
    >;
    columns: Array<
      { __typename: 'ExpressionColumn' } & IExpressionColumnFieldsFragment
    >;
    base: Maybe<
      { __typename: 'ExpressionSlice' } & IExpressionSliceFieldsFragment
    >;
    slices: Array<
      { __typename: 'ExpressionSlice' } & IExpressionSliceFieldsFragment
    >;
    statistics: Array<
      {
        __typename: 'ExpressionStatistics';
      } & IExpressionStatisticsFieldsFragment
    >;
  };

export type IDataTableColumnFieldsFragment = {
  __typename: 'DataTableColumn';
} & Pick<
  IDataTableColumn,
  'basePercents' | 'key' | 'measureKey' | 'name' | 'values'
>;

export type IDataTableSliceFieldsFragment = {
  __typename: 'DataTableSlice';
} & Pick<IDataTableSlice, 'key' | 'measures' | 'name' | 'rank'> & {
    userAlias:
      | ({
          __typename: 'UserAliasSliceBase';
        } & ISliceUserAliasFields_UserAliasSliceBase_Fragment)
      | ({
          __typename: 'UserAliasSliceBreakdown';
        } & ISliceUserAliasFields_UserAliasSliceBreakdown_Fragment)
      | ({
          __typename: 'UserAliasSliceNone';
        } & ISliceUserAliasFields_UserAliasSliceNone_Fragment);
    hint: Array<{ __typename: 'SliceNameHint' } & ISliceNameHintFieldsFragment>;
  };

export type IDataTableDataFieldsFragment = {
  __typename: 'DataTableData';
} & Pick<IDataTableData, 'dates' | 'live' | 'isEmpty'> & {
    columns: Array<
      { __typename: 'DataTableColumn' } & IDataTableColumnFieldsFragment
    >;
    base: Maybe<
      { __typename: 'DataTableSlice' } & IDataTableSliceFieldsFragment
    >;
    slices: Array<
      { __typename: 'DataTableSlice' } & IDataTableSliceFieldsFragment
    >;
  };

export type IFunnelPercentFieldsFragment = {
  __typename: 'FunnelPercent';
} & Pick<
  IFunnelPercent,
  'key' | 'values' | 'bounceCounts' | 'bouncePercents'
> & { reading: Maybe<{ __typename: 'Reading' } & IReadingFieldsFragment> };

export type IFunnelColumnFieldsFragment = { __typename: 'FunnelColumn' } & Pick<
  IFunnelColumn,
  'name' | 'key' | 'measureKey' | 'sliceKey' | 'funnelModeSliceKey' | 'values'
> & {
    percents: Array<
      { __typename: 'FunnelPercent' } & IFunnelPercentFieldsFragment
    >;
    statistics: Maybe<
      { __typename: 'FunnelStatistics' } & Pick<
        IFunnelStatistics,
        'avg' | 'median'
      >
    >;
  };

export type IFunnelSliceFieldsFragment = { __typename: 'FunnelSlice' } & Pick<
  IFunnelSlice,
  'name' | 'key' | 'measure' | 'variables' | 'rank'
> & {
    hint: Array<{ __typename: 'SliceNameHint' } & ISliceNameHintFieldsFragment>;
    userAlias:
      | ({
          __typename: 'UserAliasSliceBase';
        } & ISliceUserAliasFields_UserAliasSliceBase_Fragment)
      | ({
          __typename: 'UserAliasSliceBreakdown';
        } & ISliceUserAliasFields_UserAliasSliceBreakdown_Fragment)
      | ({
          __typename: 'UserAliasSliceNone';
        } & ISliceUserAliasFields_UserAliasSliceNone_Fragment);
  };

export type IFunnelDistributionBucketFieldsFragment = {
  __typename: 'FunnelDistributionBucket';
} & Pick<IFunnelDistributionBucket, 'startInclusive' | 'endExclusive'>;

export type IFunnelFrequencyXAxisFieldsFragment = {
  __typename: 'FunnelFrequencyXAxis';
} & {
  buckets: Array<
    {
      __typename: 'FunnelDistributionBucket';
    } & IFunnelDistributionBucketFieldsFragment
  >;
};

export type IFunnelTimeToConvertXAxisFieldsFragment = {
  __typename: 'FunnelTimeToConvertXAxis';
} & Pick<IFunnelTimeToConvertXAxis, 'timeUnit'> & {
    buckets: Array<
      {
        __typename: 'FunnelDistributionBucket';
      } & IFunnelDistributionBucketFieldsFragment
    >;
  };

export type IFunnelConversionXAxisFieldsFragment = {
  __typename: 'FunnelConversionXAxis';
} & {
  cohortDates: Array<{ __typename: 'CohortDate' } & ICohortDateFieldsFragment>;
};

type IFunnelXAxisFields_FunnelConversionXAxis_Fragment = {
  __typename: 'FunnelConversionXAxis';
} & IFunnelConversionXAxisFieldsFragment;

type IFunnelXAxisFields_FunnelFrequencyXAxis_Fragment = {
  __typename: 'FunnelFrequencyXAxis';
} & IFunnelFrequencyXAxisFieldsFragment;

type IFunnelXAxisFields_FunnelTimeToConvertXAxis_Fragment = {
  __typename: 'FunnelTimeToConvertXAxis';
} & IFunnelTimeToConvertXAxisFieldsFragment;

export type IFunnelXAxisFieldsFragment =
  | IFunnelXAxisFields_FunnelConversionXAxis_Fragment
  | IFunnelXAxisFields_FunnelFrequencyXAxis_Fragment
  | IFunnelXAxisFields_FunnelTimeToConvertXAxis_Fragment;

export type IFunnelDataFieldsFragment = { __typename: 'FunnelData' } & Pick<
  IFunnelData,
  'dates' | 'live' | 'isEmpty'
> & {
    columns: Array<
      { __typename: 'FunnelColumn' } & IFunnelColumnFieldsFragment
    >;
    funnelXAxis: Maybe<
      | ({
          __typename: 'FunnelConversionXAxis';
        } & IFunnelXAxisFields_FunnelConversionXAxis_Fragment)
      | ({
          __typename: 'FunnelFrequencyXAxis';
        } & IFunnelXAxisFields_FunnelFrequencyXAxis_Fragment)
      | ({
          __typename: 'FunnelTimeToConvertXAxis';
        } & IFunnelXAxisFields_FunnelTimeToConvertXAxis_Fragment)
    >;
    base: Maybe<{ __typename: 'FunnelSlice' } & IFunnelSliceFieldsFragment>;
    slices: Array<{ __typename: 'FunnelSlice' } & IFunnelSliceFieldsFragment>;
  };

export type IComparisonConfigFieldsFragment = {
  __typename: 'ComparisonConfig';
} & Pick<IComparisonConfig, 'offset' | 'timeUnit'>;

type IAnalysisInfoFields_CohortSample_Fragment = {
  __typename: 'CohortSample';
} & Pick<
  ICohortSample,
  | 'id'
  | 'display'
  | 'description'
  | 'executedAt'
  | 'queryType'
  | 'start'
  | 'end'
  | 'timeUnit'
> & {
    query: {
      __typename: 'CohortSampleQuery';
    } & ICohortSampleQueryFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
  };

type IAnalysisInfoFields_DataTable_Fragment = {
  __typename: 'DataTable';
} & Pick<
  IDataTable,
  | 'id'
  | 'display'
  | 'description'
  | 'executedAt'
  | 'queryType'
  | 'start'
  | 'end'
  | 'timeUnit'
> & {
    query: { __typename: 'DataTableQuery' } & IDataTableQueryFieldsFragment;
    comparisonConfig: Maybe<
      { __typename: 'ComparisonConfig' } & IComparisonConfigFieldsFragment
    >;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
  };

type IAnalysisInfoFields_Expression_Fragment = {
  __typename: 'Expression';
} & Pick<
  IExpression,
  | 'id'
  | 'display'
  | 'description'
  | 'executedAt'
  | 'queryType'
  | 'start'
  | 'end'
  | 'timeUnit'
> & {
    query: { __typename: 'ExpressionQuery' } & IExpressionQueryFieldsFragment;
    comparisonConfig: Maybe<
      { __typename: 'ComparisonConfig' } & IComparisonConfigFieldsFragment
    >;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
  };

type IAnalysisInfoFields_Funnel_Fragment = { __typename: 'Funnel' } & Pick<
  IFunnel,
  | 'id'
  | 'display'
  | 'description'
  | 'executedAt'
  | 'queryType'
  | 'start'
  | 'end'
  | 'timeUnit'
> & {
    query: { __typename: 'FunnelQuery' } & IFunnelQueryFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
  };

type IAnalysisInfoFields_Path_Fragment = { __typename: 'Path' } & Pick<
  IPath,
  | 'id'
  | 'display'
  | 'description'
  | 'executedAt'
  | 'queryType'
  | 'start'
  | 'end'
  | 'timeUnit'
> & {
    query: { __typename: 'PathQuery' } & IPathQueryFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
  };

type IAnalysisInfoFields_Prediction_Fragment = {
  __typename: 'Prediction';
} & Pick<
  IPrediction,
  | 'id'
  | 'display'
  | 'description'
  | 'executedAt'
  | 'queryType'
  | 'start'
  | 'end'
  | 'timeUnit'
> & {
    query: { __typename: 'PredictionQuery' } & IPredictionQueryFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
  };

type IAnalysisInfoFields_Retention_Fragment = {
  __typename: 'Retention';
} & Pick<
  IRetention,
  | 'id'
  | 'display'
  | 'description'
  | 'executedAt'
  | 'queryType'
  | 'start'
  | 'end'
  | 'timeUnit'
> & {
    query: { __typename: 'RetentionQuery' } & IRetentionQueryFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
  };

type IAnalysisInfoFields_Significance_Fragment = {
  __typename: 'Significance';
} & Pick<
  ISignificance,
  | 'id'
  | 'display'
  | 'description'
  | 'executedAt'
  | 'queryType'
  | 'start'
  | 'end'
  | 'timeUnit'
> & {
    query: {
      __typename: 'SignificanceQuery';
    } & ISignificanceQueryFieldsFragment;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
  };

export type IAnalysisInfoFieldsFragment =
  | IAnalysisInfoFields_CohortSample_Fragment
  | IAnalysisInfoFields_DataTable_Fragment
  | IAnalysisInfoFields_Expression_Fragment
  | IAnalysisInfoFields_Funnel_Fragment
  | IAnalysisInfoFields_Path_Fragment
  | IAnalysisInfoFields_Prediction_Fragment
  | IAnalysisInfoFields_Retention_Fragment
  | IAnalysisInfoFields_Significance_Fragment;

type IAnalysisSummaryInfoFields_CohortSample_Fragment = {
  __typename: 'CohortSample';
} & Pick<
  ICohortSample,
  'id' | 'queryType' | 'display' | 'createdAt' | 'description'
> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IAnalysisSummaryInfoFields_DataTable_Fragment = {
  __typename: 'DataTable';
} & Pick<
  IDataTable,
  'id' | 'queryType' | 'display' | 'createdAt' | 'description'
> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IAnalysisSummaryInfoFields_Expression_Fragment = {
  __typename: 'Expression';
} & Pick<
  IExpression,
  'id' | 'queryType' | 'display' | 'createdAt' | 'description'
> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IAnalysisSummaryInfoFields_Funnel_Fragment = {
  __typename: 'Funnel';
} & Pick<
  IFunnel,
  'id' | 'queryType' | 'display' | 'createdAt' | 'description'
> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IAnalysisSummaryInfoFields_Path_Fragment = { __typename: 'Path' } & Pick<
  IPath,
  'id' | 'queryType' | 'display' | 'createdAt' | 'description'
> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IAnalysisSummaryInfoFields_Prediction_Fragment = {
  __typename: 'Prediction';
} & Pick<
  IPrediction,
  'id' | 'queryType' | 'display' | 'createdAt' | 'description'
> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IAnalysisSummaryInfoFields_Retention_Fragment = {
  __typename: 'Retention';
} & Pick<
  IRetention,
  'id' | 'queryType' | 'display' | 'createdAt' | 'description'
> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

type IAnalysisSummaryInfoFields_Significance_Fragment = {
  __typename: 'Significance';
} & Pick<
  ISignificance,
  'id' | 'queryType' | 'display' | 'createdAt' | 'description'
> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id'>;
    pref: { __typename: 'AnalysisPref' } & Pick<IAnalysisPref, 'chartPref'>;
  };

export type IAnalysisSummaryInfoFieldsFragment =
  | IAnalysisSummaryInfoFields_CohortSample_Fragment
  | IAnalysisSummaryInfoFields_DataTable_Fragment
  | IAnalysisSummaryInfoFields_Expression_Fragment
  | IAnalysisSummaryInfoFields_Funnel_Fragment
  | IAnalysisSummaryInfoFields_Path_Fragment
  | IAnalysisSummaryInfoFields_Prediction_Fragment
  | IAnalysisSummaryInfoFields_Retention_Fragment
  | IAnalysisSummaryInfoFields_Significance_Fragment;

type IPopulateBuilderAnalysisFields_CohortSample_Fragment = {
  __typename: 'CohortSample';
} & {
  query: { __typename: 'CohortSampleQuery' } & ICohortSampleQueryFieldsFragment;
} & IAnalysisMetaFields_CohortSample_Fragment;

type IPopulateBuilderAnalysisFields_DataTable_Fragment = {
  __typename: 'DataTable';
} & {
  comparisonConfig: Maybe<
    { __typename: 'ComparisonConfig' } & IComparisonConfigFieldsFragment
  >;
  query: { __typename: 'DataTableQuery' } & IDataTableQueryFieldsFragment;
} & IAnalysisMetaFields_DataTable_Fragment;

type IPopulateBuilderAnalysisFields_Expression_Fragment = {
  __typename: 'Expression';
} & Pick<IExpression, 'geo'> & {
    comparisonConfig: Maybe<
      { __typename: 'ComparisonConfig' } & IComparisonConfigFieldsFragment
    >;
    query: { __typename: 'ExpressionQuery' } & IExpressionQueryFieldsFragment;
  } & IAnalysisMetaFields_Expression_Fragment;

type IPopulateBuilderAnalysisFields_Funnel_Fragment = {
  __typename: 'Funnel';
} & {
  query: { __typename: 'FunnelQuery' } & IFunnelQueryFieldsFragment;
} & IAnalysisMetaFields_Funnel_Fragment;

type IPopulateBuilderAnalysisFields_Path_Fragment = { __typename: 'Path' } & {
  query: { __typename: 'PathQuery' } & IPathQueryFieldsFragment;
} & IAnalysisMetaFields_Path_Fragment;

type IPopulateBuilderAnalysisFields_Prediction_Fragment = {
  __typename: 'Prediction';
} & {
  query: { __typename: 'PredictionQuery' } & IPredictionQueryFieldsFragment;
} & IAnalysisMetaFields_Prediction_Fragment;

type IPopulateBuilderAnalysisFields_Retention_Fragment = {
  __typename: 'Retention';
} & {
  query: { __typename: 'RetentionQuery' } & IRetentionQueryFieldsFragment;
} & IAnalysisMetaFields_Retention_Fragment;

type IPopulateBuilderAnalysisFields_Significance_Fragment = {
  __typename: 'Significance';
} & {
  query: { __typename: 'SignificanceQuery' } & ISignificanceQueryFieldsFragment;
} & IAnalysisMetaFields_Significance_Fragment;

export type IPopulateBuilderAnalysisFieldsFragment =
  | IPopulateBuilderAnalysisFields_CohortSample_Fragment
  | IPopulateBuilderAnalysisFields_DataTable_Fragment
  | IPopulateBuilderAnalysisFields_Expression_Fragment
  | IPopulateBuilderAnalysisFields_Funnel_Fragment
  | IPopulateBuilderAnalysisFields_Path_Fragment
  | IPopulateBuilderAnalysisFields_Prediction_Fragment
  | IPopulateBuilderAnalysisFields_Retention_Fragment
  | IPopulateBuilderAnalysisFields_Significance_Fragment;

export type ICohortSampleTemplateFieldsFragment = {
  __typename: 'CohortSampleTemplate';
} & Pick<ICohortSampleTemplate, 'start' | 'end'> & {
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    query: {
      __typename: 'CohortSampleQuery';
    } & ICohortSampleQueryFieldsFragment;
  };

export type IExpressionTemplateFieldsFragment = {
  __typename: 'ExpressionTemplate';
} & Pick<IExpressionTemplate, 'start' | 'end' | 'timeUnit'> & {
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    query: { __typename: 'ExpressionQuery' } & IExpressionQueryFieldsFragment;
    comparisonConfig: Maybe<
      { __typename: 'ComparisonConfig' } & IComparisonConfigFieldsFragment
    >;
  };

export type IFunnelTemplateFieldsFragment = {
  __typename: 'FunnelTemplate';
} & Pick<IFunnelTemplate, 'start' | 'end' | 'timeUnit'> & {
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    query: { __typename: 'FunnelQuery' } & IFunnelQueryFieldsFragment;
  };

export type IPathTemplateFieldsFragment = { __typename: 'PathTemplate' } & Pick<
  IPathTemplate,
  'start' | 'end'
> & {
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    query: { __typename: 'PathQuery' } & IPathQueryFieldsFragment;
  };

export type IRetentionTemplateFieldsFragment = {
  __typename: 'RetentionTemplate';
} & Pick<IRetentionTemplate, 'start' | 'end'> & {
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    query: { __typename: 'RetentionQuery' } & IRetentionQueryFieldsFragment;
  };

export type IDataTableTemplateFieldsFragment = {
  __typename: 'DataTableTemplate';
} & Pick<IDataTableTemplate, 'start' | 'end'> & {
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    query: { __typename: 'DataTableQuery' } & IDataTableQueryFieldsFragment;
    comparisonConfig: Maybe<
      { __typename: 'ComparisonConfig' } & IComparisonConfigFieldsFragment
    >;
  };

export type ISignificanceTemplateFieldsFragment = {
  __typename: 'SignificanceTemplate';
} & Pick<ISignificanceTemplate, 'start' | 'end'> & {
    datePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
    query: {
      __typename: 'SignificanceQuery';
    } & ISignificanceQueryFieldsFragment;
  };

type IFormulaTemplateFields_CohortSampleTemplate_Fragment = {
  __typename: 'CohortSampleTemplate';
} & ICohortSampleTemplateFieldsFragment;

type IFormulaTemplateFields_DataTableTemplate_Fragment = {
  __typename: 'DataTableTemplate';
} & IDataTableTemplateFieldsFragment;

type IFormulaTemplateFields_ExpressionTemplate_Fragment = {
  __typename: 'ExpressionTemplate';
} & IExpressionTemplateFieldsFragment;

type IFormulaTemplateFields_FunnelTemplate_Fragment = {
  __typename: 'FunnelTemplate';
} & IFunnelTemplateFieldsFragment;

type IFormulaTemplateFields_PathTemplate_Fragment = {
  __typename: 'PathTemplate';
} & IPathTemplateFieldsFragment;

type IFormulaTemplateFields_RetentionTemplate_Fragment = {
  __typename: 'RetentionTemplate';
} & IRetentionTemplateFieldsFragment;

type IFormulaTemplateFields_SignificanceTemplate_Fragment = {
  __typename: 'SignificanceTemplate';
} & ISignificanceTemplateFieldsFragment;

export type IFormulaTemplateFieldsFragment =
  | IFormulaTemplateFields_CohortSampleTemplate_Fragment
  | IFormulaTemplateFields_DataTableTemplate_Fragment
  | IFormulaTemplateFields_ExpressionTemplate_Fragment
  | IFormulaTemplateFields_FunnelTemplate_Fragment
  | IFormulaTemplateFields_PathTemplate_Fragment
  | IFormulaTemplateFields_RetentionTemplate_Fragment
  | IFormulaTemplateFields_SignificanceTemplate_Fragment;

export type ILlmCreateFormulaTemplateFieldsFragment = {
  __typename: 'LlmCreateFormulaTemplate';
} & {
  template: Maybe<
    | ({
        __typename: 'CohortSampleTemplate';
      } & IFormulaTemplateFields_CohortSampleTemplate_Fragment)
    | ({
        __typename: 'DataTableTemplate';
      } & IFormulaTemplateFields_DataTableTemplate_Fragment)
    | ({
        __typename: 'ExpressionTemplate';
      } & IFormulaTemplateFields_ExpressionTemplate_Fragment)
    | ({
        __typename: 'FunnelTemplate';
      } & IFormulaTemplateFields_FunnelTemplate_Fragment)
    | ({
        __typename: 'PathTemplate';
      } & IFormulaTemplateFields_PathTemplate_Fragment)
    | ({
        __typename: 'RetentionTemplate';
      } & IFormulaTemplateFields_RetentionTemplate_Fragment)
    | ({
        __typename: 'SignificanceTemplate';
      } & IFormulaTemplateFields_SignificanceTemplate_Fragment)
  >;
  promptMessage: {
    __typename: 'LlmChatMessage';
  } & ILlmChatMessageFieldsFragment;
  responseMessage: {
    __typename: 'LlmChatMessage';
  } & ILlmChatMessageFieldsFragment;
};

type IAnalysisFields_CohortSample_Fragment = { __typename: 'CohortSample' } & {
  data?: { __typename: 'CohortSampleData' } & ICohortDataFieldsFragment;
  query: { __typename: 'CohortSampleQuery' } & ICohortSampleQueryFieldsFragment;
};

type IAnalysisFields_DataTable_Fragment = { __typename: 'DataTable' } & {
  data?: { __typename: 'DataTableData' } & IDataTableDataFieldsFragment;
  comparisonData?: Maybe<
    { __typename: 'DataTableData' } & IDataTableDataFieldsFragment
  >;
  comparisonConfig: Maybe<
    { __typename: 'ComparisonConfig' } & IComparisonConfigFieldsFragment
  >;
  chartControl: { __typename: 'ChartControl' } & IChartControlFieldsFragment;
  query: { __typename: 'DataTableQuery' } & IDataTableQueryFieldsFragment;
};

type IAnalysisFields_Expression_Fragment = { __typename: 'Expression' } & Pick<
  IExpression,
  'geo'
> & {
    data?: { __typename: 'ExpressionData' } & IExpressionDataFieldsFragment;
    comparisonData?: Maybe<
      { __typename: 'ExpressionData' } & IExpressionDataFieldsFragment
    >;
    comparisonConfig: Maybe<
      { __typename: 'ComparisonConfig' } & IComparisonConfigFieldsFragment
    >;
    chartControl: { __typename: 'ChartControl' } & IChartControlFieldsFragment;
    incidents: Array<{ __typename: 'Incident' } & IIncidentFieldsFragment>;
    query: { __typename: 'ExpressionQuery' } & IExpressionQueryFieldsFragment;
  };

type IAnalysisFields_Funnel_Fragment = { __typename: 'Funnel' } & {
  data?: { __typename: 'FunnelData' } & IFunnelDataFieldsFragment;
  chartControl: { __typename: 'ChartControl' } & IChartControlFieldsFragment;
  incidents: Array<{ __typename: 'Incident' } & IIncidentFieldsFragment>;
  query: { __typename: 'FunnelQuery' } & IFunnelQueryFieldsFragment;
};

type IAnalysisFields_Path_Fragment = { __typename: 'Path' } & {
  data?: { __typename: 'PathData' } & IPathDataFieldsFragment;
  query: { __typename: 'PathQuery' } & IPathQueryFieldsFragment;
};

type IAnalysisFields_Prediction_Fragment = { __typename: 'Prediction' } & {
  data?: { __typename: 'PredictionData' } & IPredictionDataFieldsFragment;
  query: { __typename: 'PredictionQuery' } & IPredictionQueryFieldsFragment;
};

type IAnalysisFields_Retention_Fragment = { __typename: 'Retention' } & {
  data?: { __typename: 'RetentionData' } & IRetentionDataFieldsFragment;
  query: { __typename: 'RetentionQuery' } & IRetentionQueryFieldsFragment;
};

type IAnalysisFields_Significance_Fragment = { __typename: 'Significance' } & {
  data?: { __typename: 'SignificanceData' } & ISignificanceDataFieldsFragment;
  query: { __typename: 'SignificanceQuery' } & ISignificanceQueryFieldsFragment;
};

export type IAnalysisFieldsFragment =
  | IAnalysisFields_CohortSample_Fragment
  | IAnalysisFields_DataTable_Fragment
  | IAnalysisFields_Expression_Fragment
  | IAnalysisFields_Funnel_Fragment
  | IAnalysisFields_Path_Fragment
  | IAnalysisFields_Prediction_Fragment
  | IAnalysisFields_Retention_Fragment
  | IAnalysisFields_Significance_Fragment;

export type IAnalysisInfoMutationVariables = Exact<{
  input: IAnalysisInfoInput;
}>;

export type IAnalysisInfoMutation = { __typename: 'Mutation' } & {
  analysisInfo: { __typename: 'AnalysisInfoPayload' } & Pick<
    IAnalysisInfoPayload,
    'entity'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IAnalysisSetPrefMutationVariables = Exact<{
  input: IAnalysisSetPrefInput;
}>;

export type IAnalysisSetPrefMutation = { __typename: 'Mutation' } & {
  analysisSetChartPref: { __typename: 'AnalysisSetPrefPayload' } & Pick<
    IAnalysisSetPrefPayload,
    'entity'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IAnalysisSetSummaryRichTextMutationVariables = Exact<{
  input: IAnalysisSetSummaryRichTextInput;
}>;

export type IAnalysisSetSummaryRichTextMutation = { __typename: 'Mutation' } & {
  analysisSetSummaryRichText: {
    __typename: 'AnalysisSetSummaryRichTextPayload';
  } & Pick<IAnalysisSetSummaryRichTextPayload, 'entity'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type IAnalysisDeleteSummaryRichTextMutationVariables = Exact<{
  input: IAnalysisDeleteSummaryRichTextInput;
}>;

export type IAnalysisDeleteSummaryRichTextMutation = {
  __typename: 'Mutation';
} & {
  analysisDeleteSummaryRichText: {
    __typename: 'AnalysisDeleteSummaryRichTextPayload';
  } & Pick<IAnalysisDeleteSummaryRichTextPayload, 'entity'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type IAnalysisSetShowSummaryInDashboardMutationVariables = Exact<{
  input: IAnalysisSetShowSummaryInDashboardInput;
}>;

export type IAnalysisSetShowSummaryInDashboardMutation = {
  __typename: 'Mutation';
} & {
  analysisSetShowSummaryInDashboard: {
    __typename: 'AnalysisSetShowSummaryInDashboardPayload';
  } & Pick<IAnalysisSetShowSummaryInDashboardPayload, 'entity'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type IAnalysisPrepareCohortMutationVariables = Exact<{
  input: IAnalysisPrepareCohortInput;
}>;

export type IAnalysisPrepareCohortMutation = { __typename: 'Mutation' } & {
  analysisPrepareCohort: { __typename: 'AnalysisPrepareCohortPayload' } & {
    entity: Maybe<
      { __typename: 'AnalysisPrepareCohort' } & {
        analysis:
          | ({
              __typename: 'CohortSample';
            } & IAnalysisInfoFields_CohortSample_Fragment)
          | ({
              __typename: 'DataTable';
            } & IAnalysisInfoFields_DataTable_Fragment)
          | ({
              __typename: 'Expression';
            } & IAnalysisInfoFields_Expression_Fragment)
          | ({ __typename: 'Funnel' } & IAnalysisInfoFields_Funnel_Fragment)
          | ({ __typename: 'Path' } & IAnalysisInfoFields_Path_Fragment)
          | ({
              __typename: 'Prediction';
            } & IAnalysisInfoFields_Prediction_Fragment)
          | ({
              __typename: 'Retention';
            } & IAnalysisInfoFields_Retention_Fragment)
          | ({
              __typename: 'Significance';
            } & IAnalysisInfoFields_Significance_Fragment);
        expressionMeasure: Maybe<
          | ({ __typename: 'CompoundMeasure' } & Pick<ICompoundMeasure, 'id'>)
          | ({ __typename: 'SimpleMeasure' } & Pick<ISimpleMeasure, 'id'>)
        >;
      }
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IAnalysisCustomizeMutationVariables = Exact<{
  input: IAnalysisCustomizeInput;
}>;

export type IAnalysisCustomizeMutation = { __typename: 'Mutation' } & {
  analysisCustomize: { __typename: 'AnalysisCustomizePayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<
      | ({
          __typename: 'CohortSample';
        } & IPopulateBuilderAnalysisFields_CohortSample_Fragment)
      | ({
          __typename: 'DataTable';
        } & IPopulateBuilderAnalysisFields_DataTable_Fragment)
      | ({
          __typename: 'Expression';
        } & IPopulateBuilderAnalysisFields_Expression_Fragment)
      | ({
          __typename: 'Funnel';
        } & IPopulateBuilderAnalysisFields_Funnel_Fragment)
      | ({ __typename: 'Path' } & IPopulateBuilderAnalysisFields_Path_Fragment)
      | ({
          __typename: 'Prediction';
        } & IPopulateBuilderAnalysisFields_Prediction_Fragment)
      | ({
          __typename: 'Retention';
        } & IPopulateBuilderAnalysisFields_Retention_Fragment)
      | ({
          __typename: 'Significance';
        } & IPopulateBuilderAnalysisFields_Significance_Fragment)
    >;
  };
};

export type IAnalysisCopyMutationVariables = Exact<{
  input: IAnalysisCopyInput;
}>;

export type IAnalysisCopyMutation = { __typename: 'Mutation' } & {
  analysisCopy: { __typename: 'AnalysisCopyPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<
      | ({
          __typename: 'CohortSample';
        } & IPopulateBuilderAnalysisFields_CohortSample_Fragment)
      | ({
          __typename: 'DataTable';
        } & IPopulateBuilderAnalysisFields_DataTable_Fragment)
      | ({
          __typename: 'Expression';
        } & IPopulateBuilderAnalysisFields_Expression_Fragment)
      | ({
          __typename: 'Funnel';
        } & IPopulateBuilderAnalysisFields_Funnel_Fragment)
      | ({ __typename: 'Path' } & IPopulateBuilderAnalysisFields_Path_Fragment)
      | ({
          __typename: 'Prediction';
        } & IPopulateBuilderAnalysisFields_Prediction_Fragment)
      | ({
          __typename: 'Retention';
        } & IPopulateBuilderAnalysisFields_Retention_Fragment)
      | ({
          __typename: 'Significance';
        } & IPopulateBuilderAnalysisFields_Significance_Fragment)
    >;
  };
};

export type ICancelExecutionMutationVariables = Exact<{
  input: IAnalysisCancelInput;
}>;

export type ICancelExecutionMutation = { __typename: 'Mutation' } & {
  analysisCancel: { __typename: 'AnalysisCancelPayload' } & Pick<
    IAnalysisCancelPayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IAnalysisQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  populateBuilder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type IAnalysisQuery = { __typename: 'Query' } & {
  analysis: Maybe<
    | ({
        __typename: 'CohortSample';
      } & IAnalysisMetaFields_CohortSample_Fragment &
        IAnalysisFields_CohortSample_Fragment)
    | ({ __typename: 'DataTable' } & IAnalysisMetaFields_DataTable_Fragment &
        IAnalysisFields_DataTable_Fragment)
    | ({ __typename: 'Expression' } & IAnalysisMetaFields_Expression_Fragment &
        IAnalysisFields_Expression_Fragment)
    | ({ __typename: 'Funnel' } & IAnalysisMetaFields_Funnel_Fragment &
        IAnalysisFields_Funnel_Fragment)
    | ({ __typename: 'Path' } & IAnalysisMetaFields_Path_Fragment &
        IAnalysisFields_Path_Fragment)
    | ({ __typename: 'Prediction' } & IAnalysisMetaFields_Prediction_Fragment &
        IAnalysisFields_Prediction_Fragment)
    | ({ __typename: 'Retention' } & IAnalysisMetaFields_Retention_Fragment &
        IAnalysisFields_Retention_Fragment)
    | ({
        __typename: 'Significance';
      } & IAnalysisMetaFields_Significance_Fragment &
        IAnalysisFields_Significance_Fragment)
  >;
};

export type IGetAnalysisInfoQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
}>;

export type IGetAnalysisInfoQuery = { __typename: 'Query' } & {
  analysis: Maybe<
    | ({
        __typename: 'CohortSample';
      } & IAnalysisInfoFields_CohortSample_Fragment)
    | ({ __typename: 'DataTable' } & IAnalysisInfoFields_DataTable_Fragment)
    | ({ __typename: 'Expression' } & IAnalysisInfoFields_Expression_Fragment)
    | ({ __typename: 'Funnel' } & IAnalysisInfoFields_Funnel_Fragment)
    | ({ __typename: 'Path' } & IAnalysisInfoFields_Path_Fragment)
    | ({ __typename: 'Prediction' } & IAnalysisInfoFields_Prediction_Fragment)
    | ({ __typename: 'Retention' } & IAnalysisInfoFields_Retention_Fragment)
    | ({
        __typename: 'Significance';
      } & IAnalysisInfoFields_Significance_Fragment)
  >;
};

export type IGetAnalysisSummaryQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
}>;

export type IGetAnalysisSummaryQuery = { __typename: 'Query' } & {
  analysis: Maybe<
    | ({
        __typename: 'CohortSample';
      } & IAnalysisSummaryInfoFields_CohortSample_Fragment)
    | ({
        __typename: 'DataTable';
      } & IAnalysisSummaryInfoFields_DataTable_Fragment)
    | ({
        __typename: 'Expression';
      } & IAnalysisSummaryInfoFields_Expression_Fragment)
    | ({ __typename: 'Funnel' } & IAnalysisSummaryInfoFields_Funnel_Fragment)
    | ({ __typename: 'Path' } & IAnalysisSummaryInfoFields_Path_Fragment)
    | ({
        __typename: 'Prediction';
      } & IAnalysisSummaryInfoFields_Prediction_Fragment)
    | ({
        __typename: 'Retention';
      } & IAnalysisSummaryInfoFields_Retention_Fragment)
    | ({
        __typename: 'Significance';
      } & IAnalysisSummaryInfoFields_Significance_Fragment)
  >;
};

export type IAnalysisVisitFieldsFragment = {
  __typename: 'AnalysisVisit';
} & Pick<
  IAnalysisVisit,
  | 'createdAt'
  | 'description'
  | 'display'
  | 'id'
  | 'queryType'
  | 'status'
  | 'visitedAt'
> & { creator: { __typename: 'User' } & ICreatorFieldsFragment };

export type IAnalysisVisitMutationVariables = Exact<{
  input: IAnalysisVisitInput;
}>;

export type IAnalysisVisitMutation = { __typename: 'Mutation' } & {
  analysisVisit: { __typename: 'AnalysisVisitPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    visit: Maybe<
      { __typename: 'AnalysisVisit' } & IAnalysisVisitFieldsFragment
    >;
  };
};

export type ISearchAnalysisVisitsQueryVariables = Exact<{
  queryTypes: InputMaybe<Array<QueryType> | QueryType>;
  statuses: InputMaybe<
    Array<InputMaybe<AnalysisStatus>> | InputMaybe<AnalysisStatus>
  >;
  pagination: IPagination;
  schemaIds: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type ISearchAnalysisVisitsQuery = { __typename: 'Query' } & {
  searchAnalysisVisits: Maybe<
    { __typename: 'AnalysisVisitsPaginated' } & {
      entities: Array<
        { __typename: 'AnalysisVisit' } & IAnalysisVisitFieldsFragment
      >;
    }
  >;
};

export type IBasicEventValueFieldsFragment = {
  __typename: 'BasicEventValue';
} & Pick<
  IBasicEventValue,
  'isFavorite' | 'isManaged' | 'kind' | 'tableNames'
> & {
    value: { __typename: 'BasicFieldValue' } & IBasicFieldValueFieldsFragment;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };

export type IDictionaryBasicEventFieldsFragment = {
  __typename: 'DictionaryBasicEvent';
} & Pick<
  IDictionaryBasicEvent,
  | 'key'
  | 'name'
  | 'description'
  | 'isDisabled'
  | 'isRenamed'
  | 'isFavorite'
  | 'isManaged'
  | 'tableNames'
> & {
    entityCategories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };

export type IBasicEventToggleMutationVariables = Exact<{
  input: IBasicEventToggleInput;
}>;

export type IBasicEventToggleMutation = { __typename: 'Mutation' } & {
  basicEventToggle: { __typename: 'BasicEventTogglePayload' } & Pick<
    IBasicEventTogglePayload,
    'message'
  > & {
      errors: Array<
        { __typename: 'Error' } & Pick<IError, 'field' | 'messages'>
      >;
    };
};

export type IBasicEventRenameMutationVariables = Exact<{
  input: IBasicEventRenameInput;
}>;

export type IBasicEventRenameMutation = { __typename: 'Mutation' } & {
  basicEventRename: { __typename: 'BasicEventRenamePayload' } & Pick<
    IBasicEventRenamePayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IBasicEventAddCategoryMutationVariables = Exact<{
  input: IBasicEventEditCategoryInput;
}>;

export type IBasicEventAddCategoryMutation = { __typename: 'Mutation' } & {
  basicEventAddCategory: { __typename: 'BasicEventEditCategoryPayload' } & Pick<
    IBasicEventEditCategoryPayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IBasicEventRemoveCategoryMutationVariables = Exact<{
  input: IBasicEventEditCategoryInput;
}>;

export type IBasicEventRemoveCategoryMutation = { __typename: 'Mutation' } & {
  basicEventRemoveCategory: {
    __typename: 'BasicEventEditCategoryPayload';
  } & Pick<IBasicEventEditCategoryPayload, 'message'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type IBasicEventUpdateDescriptionMutationVariables = Exact<{
  input: IBasicEventUpdateDescriptionInput;
}>;

export type IBasicEventUpdateDescriptionMutation = {
  __typename: 'Mutation';
} & {
  basicEventUpdateDescription: {
    __typename: 'BasicEventUpdateDescriptionPayload';
  } & Pick<IBasicEventUpdateDescriptionPayload, 'message'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type IGetDictionaryBasicEventsQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
}>;

export type IGetDictionaryBasicEventsQuery = { __typename: 'Query' } & {
  dictionaryBasicEvents: Maybe<
    { __typename: 'DictionaryBasicEventsConfig' } & {
      values: Array<
        {
          __typename: 'DictionaryBasicEvent';
        } & IDictionaryBasicEventFieldsFragment
      >;
    }
  >;
};

export type INamedBucketDefAddCategoryMutationVariables = Exact<{
  input: INamedEntityEditCategoryInput;
}>;

export type INamedBucketDefAddCategoryMutation = { __typename: 'Mutation' } & {
  namedBucketDefAddCategory: {
    __typename: 'NamedEntityEditCategoryPayload';
  } & Pick<INamedEntityEditCategoryPayload, 'message'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type INamedBucketDefRemoveCategoryMutationVariables = Exact<{
  input: INamedEntityEditCategoryInput;
}>;

export type INamedBucketDefRemoveCategoryMutation = {
  __typename: 'Mutation';
} & {
  namedBucketDefRemoveCategory: {
    __typename: 'NamedEntityEditCategoryPayload';
  } & Pick<INamedEntityEditCategoryPayload, 'message'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type IQueryBasicConfigFieldsFragment = {
  __typename: 'QueryBasicConfig';
} & Pick<
  IQueryBasicConfig,
  'defaultStart' | 'defaultEnd' | 'liveStartDate' | 'timezone'
> & {
    dateKinds: Array<
      { __typename: 'DateKind' } & IDateKindSupportFieldsFragment
    >;
    logicOps: Array<
      { __typename: 'LogicalOperator' } & ILogicalOperatorFieldsFragment
    >;
    cohortConfig: { __typename: 'CohortConfig' } & ICohortConfigFieldsFragment;
    defaultDatePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
  };

export type IExpressionQuerySettingFieldsFragment = {
  __typename: 'ExpressionQuerySetting';
} & Pick<IExpressionQuerySetting, 'key' | 'name'>;

export type IExpressionQueryConfigFieldsFragment = {
  __typename: 'ExpressionQueryConfig';
} & {
  mode: { __typename: 'ExpressionMode' } & IExpressionModeFieldsFragment;
  settings: Array<
    {
      __typename: 'ExpressionQuerySetting';
    } & IExpressionQuerySettingFieldsFragment
  >;
};

export type IExpressionHistogramConfigFieldsFragment = {
  __typename: 'ExpressionHistogramConfig';
} & Pick<IExpressionHistogramConfig, 'subjectBucketKinds'> & {
    defaultSubject: { __typename: 'Subject' } & ISubjectFieldsFragment;
    mode: { __typename: 'ExpressionMode' } & IExpressionModeFieldsFragment;
    settings: Array<
      {
        __typename: 'ExpressionQuerySetting';
      } & IExpressionQuerySettingFieldsFragment
    >;
    subjects: Array<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
  };

export type IExpressionImpactConfigFieldsFragment = {
  __typename: 'ExpressionImpactConfig';
} & {
  defaultSubject: { __typename: 'Subject' } & ISubjectFieldsFragment;
  mode: { __typename: 'ExpressionMode' } & IExpressionModeFieldsFragment;
  settings: Array<
    {
      __typename: 'ExpressionQuerySetting';
    } & IExpressionQuerySettingFieldsFragment
  >;
  subjects: Array<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
};

export type IExpressionModeConfigsFieldsFragment = {
  __typename: 'ExpressionModeConfigs';
} & {
  histogramConfig: {
    __typename: 'ExpressionHistogramConfig';
  } & IExpressionHistogramConfigFieldsFragment;
  impactConfig: {
    __typename: 'ExpressionImpactConfig';
  } & IExpressionImpactConfigFieldsFragment;
  queryConfig: {
    __typename: 'ExpressionQueryConfig';
  } & IExpressionQueryConfigFieldsFragment;
};

export type IQueryConfigFieldsFragment = { __typename: 'QueryConfig' } & Pick<
  IQueryConfig,
  'defaultFormulaSamplingRate' | 'defaultTimeUnit'
> & {
    basicConfig: {
      __typename: 'QueryBasicConfig';
    } & IQueryBasicConfigFieldsFragment;
    measureFunctions: Array<
      { __typename: 'MeasureFunction' } & IMeasureFunctionFieldsFragment
    >;
    measureRelOps: Array<
      { __typename: 'RelationalOperator' } & IRelationalOperatorFieldsFragment
    >;
    defaultMode: {
      __typename: 'ExpressionMode';
    } & IExpressionModeFieldsFragment;
    modes: Array<
      { __typename: 'ExpressionMode' } & IExpressionModeFieldsFragment
    >;
    modeConfigs: {
      __typename: 'ExpressionModeConfigs';
    } & IExpressionModeConfigsFieldsFragment;
  };

export type IFunnelOrderFieldsFragment = { __typename: 'FunnelOrder' } & Pick<
  IFunnelOrder,
  'key' | 'name'
>;

export type IFunnelQuerySettingFieldsFragment = {
  __typename: 'FunnelQuerySetting';
} & Pick<IFunnelQuerySetting, 'key' | 'name'>;

export type IFunnelModeConfigFieldsFragment = {
  __typename: 'FunnelModeConfig';
} & Pick<
  IFunnelModeConfig,
  | 'partitionWindowTimeUnits'
  | 'defaultPartitionWindowTimeUnit'
  | 'timeUnits'
  | 'defaultTimeUnit'
> & {
    mode: { __typename: 'FunnelMode' } & IFunnelModeFieldsFragment;
    subjects: Array<
      { __typename: 'Subject' } & {
        defaultFunnelOrder: {
          __typename: 'FunnelOrder';
        } & IFunnelOrderFieldsFragment;
        funnelOrders: Array<
          { __typename: 'FunnelOrder' } & IFunnelOrderFieldsFragment
        >;
      } & ISubjectFieldsFragment
    >;
    defaultSubject: { __typename: 'Subject' } & Pick<ISubject, 'key'>;
    partitions: Array<
      | ({
          __typename: 'ConversionWindowPartition';
        } & IPartitionFields_ConversionWindowPartition_Fragment)
      | ({
          __typename: 'FieldPartition';
        } & IPartitionFields_FieldPartition_Fragment)
      | ({
          __typename: 'NonePartition';
        } & IPartitionFields_NonePartition_Fragment)
    >;
    defaultPartition:
      | ({
          __typename: 'ConversionWindowPartition';
        } & IPartitionFields_ConversionWindowPartition_Fragment)
      | ({
          __typename: 'FieldPartition';
        } & IPartitionFields_FieldPartition_Fragment)
      | ({
          __typename: 'NonePartition';
        } & IPartitionFields_NonePartition_Fragment);
    defaultPartitionValue: {
      __typename: 'PartitionValue';
    } & IPartitionValueFieldsFragment;
    orders: Array<{ __typename: 'FunnelOrder' } & IFunnelOrderFieldsFragment>;
    defaultOrder: { __typename: 'FunnelOrder' } & IFunnelOrderFieldsFragment;
  };

export type IFunnelConfigFieldsFragment = { __typename: 'FunnelConfig' } & Pick<
  IFunnelConfig,
  'defaultFormulaSamplingRate'
> & {
    basicConfig: {
      __typename: 'QueryBasicConfig';
    } & IQueryBasicConfigFieldsFragment;
    customOrders: Array<
      { __typename: 'FunnelOrder' } & IFunnelOrderFieldsFragment
    >;
    defaultCustomOrder: {
      __typename: 'FunnelOrder';
    } & IFunnelOrderFieldsFragment;
    defaultGroupby: { __typename: 'Groupby' } & IGroupbyFieldsFragment;
    defaultMode: { __typename: 'FunnelMode' } & IFunnelModeFieldsFragment;
    groupbys: Array<{ __typename: 'Groupby' } & IGroupbyFieldsFragment>;
    modeConfigs: Array<
      { __typename: 'FunnelModeConfig' } & IFunnelModeConfigFieldsFragment
    >;
    modes: Array<{ __typename: 'FunnelMode' } & IFunnelModeFieldsFragment>;
    settings: Array<
      { __typename: 'FunnelQuerySetting' } & IFunnelQuerySettingFieldsFragment
    >;
  };

export type IDataTableQuerySettingFieldsFragment = {
  __typename: 'DataTableQuerySetting';
} & Pick<IDataTableQuerySetting, 'key' | 'name'>;

export type IDataTableConfigFieldsFragment = {
  __typename: 'DataTableConfig';
} & Pick<IDataTableConfig, 'defaultFormulaSamplingRate' | 'defaultTimeUnit'> & {
    basicConfig: {
      __typename: 'QueryBasicConfig';
    } & IQueryBasicConfigFieldsFragment;
    defaultSubject: { __typename: 'Subject' } & ISubjectFieldsFragment;
    measureFunctions: Array<
      { __typename: 'MeasureFunction' } & IMeasureFunctionFieldsFragment
    >;
    measureRelOps: Array<
      { __typename: 'RelationalOperator' } & IRelationalOperatorFieldsFragment
    >;
    subjects: Array<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
    settings: Array<
      {
        __typename: 'DataTableQuerySetting';
      } & IDataTableQuerySettingFieldsFragment
    >;
  };

export type IPathQuerySettingFieldsFragment = {
  __typename: 'PathQuerySetting';
} & Pick<IPathQuerySetting, 'key' | 'name'>;

export type IPathConfigFieldsFragment = { __typename: 'PathConfig' } & Pick<
  IPathConfig,
  | 'defaultStart'
  | 'defaultEnd'
  | 'liveStartDate'
  | 'timezone'
  | 'defaultFormulaSamplingRate'
> & {
    logicOps: Array<
      { __typename: 'LogicalOperator' } & ILogicalOperatorFieldsFragment
    >;
    subjects: Array<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
    partitions: Array<
      | ({
          __typename: 'ConversionWindowPartition';
        } & IPartitionFields_ConversionWindowPartition_Fragment)
      | ({
          __typename: 'FieldPartition';
        } & IPartitionFields_FieldPartition_Fragment)
      | ({
          __typename: 'NonePartition';
        } & IPartitionFields_NonePartition_Fragment)
    >;
    defaultPartition:
      | ({
          __typename: 'ConversionWindowPartition';
        } & IPartitionFields_ConversionWindowPartition_Fragment)
      | ({
          __typename: 'FieldPartition';
        } & IPartitionFields_FieldPartition_Fragment)
      | ({
          __typename: 'NonePartition';
        } & IPartitionFields_NonePartition_Fragment);
    defaultSubject: { __typename: 'Subject' } & ISubjectFieldsFragment;
    cohortConfig: { __typename: 'CohortConfig' } & ICohortConfigFieldsFragment;
    defaultGroupby: { __typename: 'Groupby' } & IGroupbyFieldsFragment;
    groupbys: Array<{ __typename: 'Groupby' } & IGroupbyFieldsFragment>;
    modes: Array<{ __typename: 'PathMode' } & Pick<IPathMode, 'key' | 'name'>>;
    defaultMode: { __typename: 'PathMode' } & Pick<IPathMode, 'key'>;
    settings: Array<
      { __typename: 'PathQuerySetting' } & IPathQuerySettingFieldsFragment
    >;
    defaultDatePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
  };

export type IRetentionQuerySettingFieldsFragment = {
  __typename: 'RetentionQuerySetting';
} & Pick<IRetentionQuerySetting, 'key' | 'name'>;

export type IRetentionConfigFieldsFragment = {
  __typename: 'RetentionConfig';
} & Pick<
  IRetentionConfig,
  | 'defaultStart'
  | 'defaultEnd'
  | 'liveStartDate'
  | 'timezone'
  | 'cohortUnits'
  | 'retentionUnits'
  | 'defaultFormulaSamplingRate'
> & {
    logicOps: Array<
      { __typename: 'LogicalOperator' } & ILogicalOperatorFieldsFragment
    >;
    subjects: Array<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
    defaultSubject: { __typename: 'Subject' } & ISubjectFieldsFragment;
    cohortConfig: { __typename: 'CohortConfig' } & ICohortConfigFieldsFragment;
    calculations: Array<
      {
        __typename: 'RetentionCalculation';
      } & IRetentionCalculationFieldsFragment
    >;
    defaultCalculation: {
      __typename: 'RetentionCalculation';
    } & IRetentionCalculationFieldsFragment;
    calculationWindows: Array<
      {
        __typename: 'RetentionCalculationWindow';
      } & IRetentionCalculationWindowFieldsFragment
    >;
    defaultCalculationWindow: {
      __typename: 'RetentionCalculationWindow';
    } & IRetentionCalculationWindowFieldsFragment;
    availableRetentionUnits: Array<
      { __typename: 'AvailableRetentionUnit' } & Pick<
        IAvailableRetentionUnit,
        'cohortUnit' | 'retentionUnits'
      >
    >;
    defaultAttribution: {
      __typename: 'Attribution';
    } & IAttributionFieldsFragment;
    attributions: Array<
      { __typename: 'Attribution' } & IAttributionFieldsFragment
    >;
    defaultGroupby: { __typename: 'Groupby' } & IGroupbyFieldsFragment;
    groupbys: Array<{ __typename: 'Groupby' } & IGroupbyFieldsFragment>;
    retentionViews: Array<
      { __typename: 'RetentionView' } & IRetentionViewFieldsFragment
    >;
    defaultRetentionView: {
      __typename: 'RetentionView';
    } & IRetentionViewFieldsFragment;
    settings: Array<
      {
        __typename: 'RetentionQuerySetting';
      } & IRetentionQuerySettingFieldsFragment
    >;
    defaultDatePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
  };

export type IQueryConfigQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
}>;

export type IQueryConfigQuery = { __typename: 'Query' } & {
  queryConfig: Maybe<
    { __typename: 'QueryConfig' } & IQueryConfigFieldsFragment
  >;
};

export type IFunnelConfigQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
}>;

export type IFunnelConfigQuery = { __typename: 'Query' } & {
  funnelConfig: Maybe<
    { __typename: 'FunnelConfig' } & IFunnelConfigFieldsFragment
  >;
};

export type IDataTableConfigQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
}>;

export type IDataTableConfigQuery = { __typename: 'Query' } & {
  dataTableConfig: {
    __typename: 'DataTableConfig';
  } & IDataTableConfigFieldsFragment;
};

export type IPathConfigQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
}>;

export type IPathConfigQuery = { __typename: 'Query' } & {
  pathConfig: Maybe<{ __typename: 'PathConfig' } & IPathConfigFieldsFragment>;
};

export type IRetentionConfigQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
}>;

export type IRetentionConfigQuery = { __typename: 'Query' } & {
  retentionConfig: Maybe<
    { __typename: 'RetentionConfig' } & IRetentionConfigFieldsFragment
  >;
};

export type ISignificanceConfigQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
}>;

export type ISignificanceConfigQuery = { __typename: 'Query' } & {
  significanceConfig: {
    __typename: 'SignificanceConfig';
  } & ISignificanceConfigFieldsFragment;
};

export type IPredictionConfigQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
}>;

export type IPredictionConfigQuery = { __typename: 'Query' } & {
  predictionConfig: Maybe<
    { __typename: 'PredictionConfig' } & Pick<
      IPredictionConfig,
      'defaultStart' | 'defaultEnd' | 'liveStartDate' | 'timezone'
    > & {
        logicOps: Array<
          { __typename: 'LogicalOperator' } & ILogicalOperatorFieldsFragment
        >;
        cohortConfig: {
          __typename: 'CohortConfig';
        } & ICohortConfigFieldsFragment;
        defaultDatePicker:
          | ({
              __typename: 'DatePickerFixed';
            } & IDatePickerFields_DatePickerFixed_Fragment)
          | ({
              __typename: 'DatePickerLast';
            } & IDatePickerFields_DatePickerLast_Fragment)
          | ({
              __typename: 'DatePickerLastFull';
            } & IDatePickerFields_DatePickerLastFull_Fragment)
          | ({
              __typename: 'DatePickerSince';
            } & IDatePickerFields_DatePickerSince_Fragment)
          | ({
              __typename: 'DatePickerStartOf';
            } & IDatePickerFields_DatePickerStartOf_Fragment);
      }
  >;
};

export type IAttributionFieldsFragment = { __typename: 'Attribution' } & Pick<
  IAttribution,
  'key' | 'name'
>;

export type IGroupbyFieldsFragment = { __typename: 'Groupby' } & Pick<
  IGroupby,
  'key' | 'name'
>;

export type IRetentionViewFieldsFragment = {
  __typename: 'RetentionView';
} & Pick<IRetentionView, 'key' | 'name'>;

export type IDateKindFieldsFragment = { __typename: 'DateKind' } & Pick<
  IDateKind,
  'key' | 'name'
>;

export type IDateKindSupportFieldsFragment = { __typename: 'DateKind' } & Pick<
  IDateKind,
  'key' | 'name' | 'supportedTimeUnits'
>;

export type IFunnelModeFieldsFragment = { __typename: 'FunnelMode' } & Pick<
  IFunnelMode,
  'name' | 'key'
>;

export type IPathMergeEventFieldsFragment = {
  __typename: 'PathMergeEvent';
} & Pick<IPathMergeEvent, 'name' | 'isNameAutoGenerated'> & {
    eventConditions: Array<
      { __typename: 'EventCondition' } & IEventConditionFieldsFragment
    >;
  };

export type IPathExpandEventFieldsFragment = {
  __typename: 'PathExpandEvent';
} & {
  field: { __typename: 'Field' } & IFieldFieldsFragment;
  eventCondition: {
    __typename: 'EventCondition';
  } & IEventConditionFieldsFragment;
};

export type IPathFoldEventFieldsFragment = { __typename: 'PathFoldEvent' } & {
  eventCondition: {
    __typename: 'EventCondition';
  } & IEventConditionFieldsFragment;
};

export type IDateBucketFieldsFragment = { __typename: 'DateBucket' } & Pick<
  IDateBucket,
  'name' | 'kind' | 'minDate' | 'maxDate'
>;

export type IEnumBucketFieldsFragment = { __typename: 'EnumBucket' } & Pick<
  IEnumBucket,
  'name' | 'kind' | 'isCustomName'
> & {
    values: Array<
      { __typename: 'BasicFieldValue' } & Pick<IBasicFieldValue, 'key' | 'name'>
    >;
  };

export type IRangeBucketFieldsFragment = { __typename: 'RangeBucket' } & Pick<
  IRangeBucket,
  'name' | 'kind' | 'min' | 'max' | 'isCustomName'
>;

type IBucketFields_DateBucket_Fragment = {
  __typename: 'DateBucket';
} & IDateBucketFieldsFragment;

type IBucketFields_EnumBucket_Fragment = {
  __typename: 'EnumBucket';
} & IEnumBucketFieldsFragment;

type IBucketFields_RangeBucket_Fragment = {
  __typename: 'RangeBucket';
} & IRangeBucketFieldsFragment;

export type IBucketFieldsFragment =
  | IBucketFields_DateBucket_Fragment
  | IBucketFields_EnumBucket_Fragment
  | IBucketFields_RangeBucket_Fragment;

export type INamedBucketDefFieldsFragment = {
  __typename: 'NamedBucketDef';
} & Pick<
  INamedBucketDef,
  | 'id'
  | 'name'
  | 'type'
  | 'kind'
  | 'version'
  | 'isLatestVersion'
  | 'isDisabled'
  | 'comment'
  | 'description'
  | 'createdAt'
  | 'editedAt'
  | 'enumBucketSplitOthers'
  | 'isFavorite'
  | 'isManaged'
> & {
    buckets: Array<
      | ({ __typename: 'DateBucket' } & IBucketFields_DateBucket_Fragment)
      | ({ __typename: 'EnumBucket' } & IBucketFields_EnumBucket_Fragment)
      | ({ __typename: 'RangeBucket' } & IBucketFields_RangeBucket_Fragment)
    >;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    editor: { __typename: 'User' } & IEditorFieldsFragment;
    enumBucketField: Maybe<{ __typename: 'Field' } & IFieldFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };

export type IBasicBucketDefFieldsFragment = {
  __typename: 'BasicBucketDef';
} & Pick<IBasicBucketDef, 'id' | 'type' | 'kind' | 'enumBucketSplitOthers'> & {
    buckets: Array<
      | ({ __typename: 'DateBucket' } & IBucketFields_DateBucket_Fragment)
      | ({ __typename: 'EnumBucket' } & IBucketFields_EnumBucket_Fragment)
      | ({ __typename: 'RangeBucket' } & IBucketFields_RangeBucket_Fragment)
    >;
  };

type IBucketDefFields_BasicBucketDef_Fragment = {
  __typename: 'BasicBucketDef';
} & IBasicBucketDefFieldsFragment;

type IBucketDefFields_NamedBucketDef_Fragment = {
  __typename: 'NamedBucketDef';
} & INamedBucketDefFieldsFragment;

export type IBucketDefFieldsFragment =
  | IBucketDefFields_BasicBucketDef_Fragment
  | IBucketDefFields_NamedBucketDef_Fragment;

export type IDurationFieldsFragment = { __typename: 'Duration' } & Pick<
  IDuration,
  'timeUnit' | 'value'
>;

export type INegativeFunnelStepFieldsFragment = { __typename: 'FunnelStep' } & {
  stepConditions: Array<
    { __typename: 'EventCondition' } & IEventConditionFieldsFragment
  >;
} & IFunnelStepBriefInfoFieldsFragment;

export type IFunnelStepFieldsFragment = { __typename: 'FunnelStep' } & {
  stepConditions: Array<
    { __typename: 'EventCondition' } & IEventConditionFieldsFragment
  >;
  conversionWindow: Maybe<{ __typename: 'Duration' } & IDurationFieldsFragment>;
} & IFunnelStepBriefInfoFieldsFragment;

export type IFunnelStepOrderFieldsFragment = {
  __typename: 'FunnelOrder';
} & Pick<IFunnelOrder, 'name' | 'key'>;

export type IRetentionCalculationFieldsFragment = {
  __typename: 'RetentionCalculation';
} & Pick<IRetentionCalculation, 'key' | 'name'>;

export type IRetentionCalculationWindowFieldsFragment = {
  __typename: 'RetentionCalculationWindow';
} & Pick<IRetentionCalculationWindow, 'key' | 'name'>;

export type IBreakdownFieldsFragment = { __typename: 'Breakdown' } & Pick<
  IBreakdown,
  'overall' | 'order'
> & {
    groupbys: Array<
      { __typename: 'BreakdownField' } & {
        field: { __typename: 'Field' } & IFieldFieldsFragment;
        bucketDef: Maybe<
          | ({
              __typename: 'BasicBucketDef';
            } & IBucketDefFields_BasicBucketDef_Fragment)
          | ({
              __typename: 'NamedBucketDef';
            } & IBucketDefFields_NamedBucketDef_Fragment)
        >;
        predicate: Maybe<
          | ({
              __typename: 'ArrayObjectPredicate';
            } & IPredicateFields_ArrayObjectPredicate_Fragment)
          | ({
              __typename: 'SimplePredicate';
            } & IPredicateFields_SimplePredicate_Fragment)
        >;
      }
    >;
    cohortRefs: Array<{ __typename: 'CohortRef' } & ICohortRefFieldsFragment>;
  };

export type IExpressionModeFieldsFragment = {
  __typename: 'ExpressionMode';
} & Pick<IExpressionMode, 'key' | 'name'>;

export type IExpressionQueryFieldsFragment = {
  __typename: 'ExpressionQuery';
} & Pick<
  IExpressionQuery,
  | 'name'
  | 'isNameAutoGenerated'
  | 'timeWindow'
  | 'includeMissingDates'
  | 'samplePercentage'
> & { expressionSettings: IExpressionQuery['settings'] } & {
    filter: Maybe<
      | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
      | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
    >;
    breakdown: Maybe<{ __typename: 'Breakdown' } & IBreakdownFieldsFragment>;
    dateKind: { __typename: 'DateKind' } & IDateKindFieldsFragment;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    subjectBucketDef: Maybe<
      | ({
          __typename: 'BasicBucketDef';
        } & IBucketDefFields_BasicBucketDef_Fragment)
      | ({
          __typename: 'NamedBucketDef';
        } & IBucketDefFields_NamedBucketDef_Fragment)
    >;
    subject: Maybe<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
    triggerSubject: Maybe<
      { __typename: 'Subject' } & Pick<ISubject, 'key' | 'name'>
    >;
    triggerCondition: Maybe<
      { __typename: 'EventCondition' } & IEventConditionFieldsFragment
    >;
    cohortRefs: Array<{ __typename: 'CohortRef' } & ICohortRefFieldsFragment>;
    compoundMeasureUserAlias: Maybe<
      {
        __typename: 'UserAliasQueryMeasure';
      } & IUserAliasQueryMeasureFieldsFragment
    >;
    measure:
      | ({
          __typename: 'CompoundMeasure';
        } & IMeasureFields_CompoundMeasure_Fragment)
      | ({
          __typename: 'SimpleMeasure';
        } & IMeasureFields_SimpleMeasure_Fragment);
    measureProperties:
      | ({
          __typename: 'CompoundMeasureProperties';
        } & IMeasurePropertiesFields_CompoundMeasureProperties_Fragment)
      | ({
          __typename: 'SimpleMeasureProperties';
        } & IMeasurePropertiesFields_SimpleMeasureProperties_Fragment);
    expressionMode: {
      __typename: 'ExpressionMode';
    } & IExpressionModeFieldsFragment;
    llmChatMessages: Array<
      { __typename: 'LlmChatMessage' } & ILlmChatMessageFieldsFragment
    >;
  };

export type IFunnelQueryFieldsFragment = { __typename: 'FunnelQuery' } & Pick<
  IFunnelQuery,
  'timeWindow' | 'samplePercentage' | 'timeUnit'
> & { funnelSettings: IFunnelQuery['settings'] } & {
    steps: Array<{ __typename: 'FunnelStep' } & IFunnelStepFieldsFragment>;
    stepOrders: Array<
      { __typename: 'FunnelOrder' } & IFunnelStepOrderFieldsFragment
    >;
    negativeSteps: Array<
      { __typename: 'FunnelStep' } & INegativeFunnelStepFieldsFragment
    >;
    dateKind: { __typename: 'DateKind' } & IDateKindFieldsFragment;
    filter: Maybe<
      | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
      | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
    >;
    breakdown: Maybe<{ __typename: 'Breakdown' } & IBreakdownFieldsFragment>;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    partitions: Array<
      { __typename: 'PartitionValue' } & IPartitionValueFieldsFragment
    >;
    subject: Maybe<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
    order: { __typename: 'FunnelOrder' } & Pick<IFunnelOrder, 'key' | 'name'>;
    cohortRefs: Array<{ __typename: 'CohortRef' } & ICohortRefFieldsFragment>;
    groupby: Maybe<{ __typename: 'Groupby' } & IGroupbyFieldsFragment>;
    mode: Maybe<{ __typename: 'FunnelMode' } & IFunnelModeFieldsFragment>;
    modeSlices: Array<
      { __typename: 'FunnelModeSlice' } & IFunnelModeSliceFieldsFragment
    >;
    llmChatMessages: Array<
      { __typename: 'LlmChatMessage' } & ILlmChatMessageFieldsFragment
    >;
  };

export type IPathQueryFieldsFragment = { __typename: 'PathQuery' } & Pick<
  IPathQuery,
  'samplePercentage'
> & { pathSettings: IPathQuery['settings'] } & {
    startConditions: Array<
      { __typename: 'EventCondition' } & IEventConditionFieldsFragment
    >;
    endConditions: Array<
      { __typename: 'EventCondition' } & IEventConditionFieldsFragment
    >;
    filter: Maybe<
      | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
      | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
    >;
    direction: { __typename: 'PathDirection' } & Pick<
      IPathDirection,
      'key' | 'name'
    >;
    breakdown: Maybe<{ __typename: 'Breakdown' } & IBreakdownFieldsFragment>;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    partitions: Array<
      { __typename: 'PartitionValue' } & IPartitionValueFieldsFragment
    >;
    subject: Maybe<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
    cohortRefs: Array<{ __typename: 'CohortRef' } & ICohortRefFieldsFragment>;
    groupby: Maybe<{ __typename: 'Groupby' } & IGroupbyFieldsFragment>;
    mergeEvents: Array<
      { __typename: 'PathMergeEvent' } & IPathMergeEventFieldsFragment
    >;
    expandEvents: Array<
      { __typename: 'PathExpandEvent' } & IPathExpandEventFieldsFragment
    >;
    foldEvents: Array<
      { __typename: 'PathFoldEvent' } & IPathFoldEventFieldsFragment
    >;
    pathMode: { __typename: 'PathMode' } & Pick<IPathMode, 'name' | 'key'>;
    llmChatMessages: Array<
      { __typename: 'LlmChatMessage' } & ILlmChatMessageFieldsFragment
    >;
  };

export type IRetentionQueryFieldsFragment = {
  __typename: 'RetentionQuery';
} & Pick<
  IRetentionQuery,
  | 'cohortUnit'
  | 'retentionUnit'
  | 'timeWindow'
  | 'customTimeBrackets'
  | 'samplePercentage'
> & { retentionSettings: IRetentionQuery['settings'] } & {
    startConditions: Array<
      { __typename: 'EventCondition' } & IEventConditionFieldsFragment
    >;
    returnConditions: Array<
      { __typename: 'EventCondition' } & IEventConditionFieldsFragment
    >;
    filter: Maybe<
      | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
      | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
    >;
    breakdown: Maybe<{ __typename: 'Breakdown' } & IBreakdownFieldsFragment>;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    calculation: {
      __typename: 'RetentionCalculation';
    } & IRetentionCalculationFieldsFragment;
    calculationWindow: {
      __typename: 'RetentionCalculationWindow';
    } & IRetentionCalculationWindowFieldsFragment;
    subject: Maybe<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
    cohortRefs: Array<{ __typename: 'CohortRef' } & ICohortRefFieldsFragment>;
    attribution: Maybe<
      { __typename: 'Attribution' } & IAttributionFieldsFragment
    >;
    groupby: Maybe<{ __typename: 'Groupby' } & IGroupbyFieldsFragment>;
    view: { __typename: 'RetentionView' } & IRetentionViewFieldsFragment;
    llmChatMessages: Array<
      { __typename: 'LlmChatMessage' } & ILlmChatMessageFieldsFragment
    >;
  };

export type IPredictionQueryFieldsFragment = {
  __typename: 'PredictionQuery';
} & Pick<IPredictionQuery, 'window' | 'samplePercentage'> & {
    sourceCohortRef: { __typename: 'CohortRef' } & ICohortRefFieldsFragment;
    targetCohortRef: { __typename: 'CohortRef' } & ICohortRefFieldsFragment;
    eventCondition: Maybe<
      { __typename: 'EventCondition' } & IEventConditionFieldsFragment
    >;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
  };

export type IDataTableQueryFieldsFragment = {
  __typename: 'DataTableQuery';
} & Pick<IDataTableQuery, 'timeWindow' | 'samplePercentage'> & {
    dataTableSettings: IDataTableQuery['settings'];
  } & {
    filter: Maybe<
      | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
      | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
    >;
    breakdown: Maybe<{ __typename: 'Breakdown' } & IBreakdownFieldsFragment>;
    dateKind: { __typename: 'DateKind' } & IDateKindFieldsFragment;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    cohortRefs: Array<{ __typename: 'CohortRef' } & ICohortRefFieldsFragment>;
    measures: Array<
      | ({
          __typename: 'CompoundMeasure';
        } & IMeasureFields_CompoundMeasure_Fragment)
      | ({
          __typename: 'SimpleMeasure';
        } & IMeasureFields_SimpleMeasure_Fragment)
    >;
    measuresProperties: Array<
      | ({
          __typename: 'CompoundMeasureProperties';
        } & IMeasurePropertiesFields_CompoundMeasureProperties_Fragment)
      | ({
          __typename: 'SimpleMeasureProperties';
        } & IMeasurePropertiesFields_SimpleMeasureProperties_Fragment)
    >;
    llmChatMessages: Array<
      { __typename: 'LlmChatMessage' } & ILlmChatMessageFieldsFragment
    >;
  };

export type IExpressionCohortConfigFieldsFragment = {
  __typename: 'ExpressionCohortConfig';
} & {
  operators: Array<
    {
      __typename: 'ExpressionCohortOperator';
    } & IExpressionCohortOperatorFieldsFragment
  >;
  timeWindows: Array<{ __typename: 'TimeWindow' } & ITimeWindowFieldsFragment>;
  defaultTimeWindow: { __typename: 'TimeWindow' } & ITimeWindowFieldsFragment;
  subjects: Array<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
  defaultSubject: { __typename: 'Subject' } & ISubjectFieldsFragment;
  percentileOperators: Array<
    { __typename: 'RelationalOperator' } & IRelationalOperatorFieldsFragment
  >;
};

export type IFunnelCohortConfigFieldsFragment = {
  __typename: 'FunnelCohortConfig';
} & {
  operators: Array<
    { __typename: 'FunnelCohortOperator' } & IFunnelCohortOperatorFieldsFragment
  >;
  timeWindows: Array<{ __typename: 'TimeWindow' } & ITimeWindowFieldsFragment>;
  defaultTimeWindow: { __typename: 'TimeWindow' } & ITimeWindowFieldsFragment;
  subjects: Array<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
  defaultSubject: { __typename: 'Subject' } & ISubjectFieldsFragment;
  ttcConfig: {
    __typename: 'TimeToConvertCohortConfig';
  } & ITimeToConvertCohortConfigFieldsFragment;
};

export type IMeasureCohortConfigFieldsFragment = {
  __typename: 'MeasureCohortConfig';
} & {
  operators: Array<
    {
      __typename: 'MeasureCohortOperator';
    } & IMeasureCohortOperatorFieldsFragment
  >;
  timeWindows: Array<{ __typename: 'TimeWindow' } & ITimeWindowFieldsFragment>;
  functions: Array<
    { __typename: 'MeasureFunction' } & IMeasureFunctionFieldsFragment
  >;
  defaultTimeWindow: { __typename: 'TimeWindow' } & ITimeWindowFieldsFragment;
  subjects: Array<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
  defaultSubject: { __typename: 'Subject' } & ISubjectFieldsFragment;
  percentileOperators: Array<
    { __typename: 'RelationalOperator' } & IRelationalOperatorFieldsFragment
  >;
};

export type IPerformedCohortConfigFieldsFragment = {
  __typename: 'PerformedCohortConfig';
} & {
  operators: Array<
    {
      __typename: 'PerformedCohortOperator';
    } & IPerformedCohortOperatorFieldsFragment
  >;
  timeWindows: Array<{ __typename: 'TimeWindow' } & ITimeWindowFieldsFragment>;
  defaultTimeWindow: { __typename: 'TimeWindow' } & ITimeWindowFieldsFragment;
  subjects: Array<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
  defaultSubject: { __typename: 'Subject' } & ISubjectFieldsFragment;
};

export type IRetentionCohortConfigFieldsFragment = {
  __typename: 'RetentionCohortConfig';
} & {
  operators: Array<
    {
      __typename: 'RetentionCohortOperator';
    } & IRetentionCohortOperatorFieldsFragment
  >;
  returnedOperators: Array<
    { __typename: 'RelationalOperator' } & IRelationalOperatorFieldsFragment
  >;
  timeWindows: Array<{ __typename: 'TimeWindow' } & ITimeWindowFieldsFragment>;
  defaultTimeWindow: { __typename: 'TimeWindow' } & ITimeWindowFieldsFragment;
  subjects: Array<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
  defaultSubject: { __typename: 'Subject' } & ISubjectFieldsFragment;
};

export type ICohortConfigFieldsFragment = { __typename: 'CohortConfig' } & Pick<
  ICohortConfig,
  'defaultSamplingRate'
> & {
    logicOps: Array<
      { __typename: 'LogicalOperator' } & ILogicalOperatorFieldsFragment
    >;
    simpleCohortTypes: Array<
      { __typename: 'SimpleCohortType' } & ISimpleCohortTypeFieldsFragment
    >;
    performedConfig: {
      __typename: 'PerformedCohortConfig';
    } & IPerformedCohortConfigFieldsFragment;
    measureConfig: {
      __typename: 'MeasureCohortConfig';
    } & IMeasureCohortConfigFieldsFragment;
    expressionConfig: {
      __typename: 'ExpressionCohortConfig';
    } & IExpressionCohortConfigFieldsFragment;
    funnelConfig: {
      __typename: 'FunnelCohortConfig';
    } & IFunnelCohortConfigFieldsFragment;
    retentionConfig: {
      __typename: 'RetentionCohortConfig';
    } & IRetentionCohortConfigFieldsFragment;
  };

export type ICohortExecuteConfigFieldsFragment = {
  __typename: 'CohortExecuteConfig';
} & Pick<
  ICohortExecuteConfig,
  'defaultStart' | 'defaultEnd' | 'timezone' | 'liveStartDate'
> & {
    cohortConfig: { __typename: 'CohortConfig' } & ICohortConfigFieldsFragment;
    operations: Array<
      {
        __typename: 'CohortSampleOperation';
      } & ICohortSampleOperationFieldsFragment
    >;
    defaultOperation: {
      __typename: 'CohortSampleOperation';
    } & ICohortSampleOperationFieldsFragment;
    defaultDatePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
  };

export type ICohortExecuteConfigQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
}>;

export type ICohortExecuteConfigQuery = { __typename: 'Query' } & {
  cohortExecuteConfig: {
    __typename: 'CohortExecuteConfig';
  } & ICohortExecuteConfigFieldsFragment;
};

export type IUserAliasQueryCohortFieldsFragment = {
  __typename: 'UserAliasQueryCohort';
} & Pick<IUserAliasQueryCohort, 'aliasId'>;

export type IPercentileFilterFieldsFragment = {
  __typename: 'PercentileFilter';
} & Pick<IPercentileFilter, 'values'> & {
    operator: {
      __typename: 'RelationalOperator';
    } & IRelationalOperatorFieldsFragment;
  };

export type ITimeWindowFieldsFragment = { __typename: 'TimeWindow' } & Pick<
  ITimeWindow,
  'name' | 'key'
>;

export type ISimpleCohortTypeFieldsFragment = {
  __typename: 'SimpleCohortType';
} & Pick<ISimpleCohortType, 'name' | 'key'>;

export type IExpressionCohortOperatorFieldsFragment = {
  __typename: 'ExpressionCohortOperator';
} & Pick<IExpressionCohortOperator, 'name'> & {
    expressionKey: IExpressionCohortOperator['key'];
  };

export type IFunnelCohortOperatorFieldsFragment = {
  __typename: 'FunnelCohortOperator';
} & Pick<IFunnelCohortOperator, 'name'> & {
    funnelKey: IFunnelCohortOperator['key'];
  };

export type ITimeToConvertOperatorFieldsFragment = {
  __typename: 'TimeToConvertOperator';
} & Pick<ITimeToConvertOperator, 'key' | 'name'>;

export type ITimeToConvertConfigFieldsFragment = {
  __typename: 'TimeToConvertConfig';
} & Pick<ITimeToConvertConfig, 'timeUnit' | 'values'> & {
    operator: {
      __typename: 'TimeToConvertOperator';
    } & ITimeToConvertOperatorFieldsFragment;
  };

export type ITimeToConvertCohortConfigFieldsFragment = {
  __typename: 'TimeToConvertCohortConfig';
} & Pick<ITimeToConvertCohortConfig, 'timeUnits'> & {
    operators: Array<
      {
        __typename: 'TimeToConvertOperator';
      } & ITimeToConvertOperatorFieldsFragment
    >;
  };

export type IMeasureCohortOperatorFieldsFragment = {
  __typename: 'MeasureCohortOperator';
} & Pick<IMeasureCohortOperator, 'name'> & {
    measureKey: IMeasureCohortOperator['key'];
  };

export type IPerformedCohortOperatorFieldsFragment = {
  __typename: 'PerformedCohortOperator';
} & Pick<IPerformedCohortOperator, 'name'> & {
    performedKey: IPerformedCohortOperator['key'];
  };

export type IRetentionCohortOperatorFieldsFragment = {
  __typename: 'RetentionCohortOperator';
} & Pick<IRetentionCohortOperator, 'name'> & {
    retentionKey: IRetentionCohortOperator['key'];
  };

export type IExpressionCohortFieldsFragment = {
  __typename: 'ExpressionCohort';
} & Pick<
  IExpressionCohort,
  | 'createdAt'
  | 'measureId'
  | 'id'
  | 'name'
  | 'operatorValues'
  | 'timeWindowValues'
  | 'isFavorite'
  | 'isManaged'
> & {
    analysis: { __typename: 'Expression' } & Pick<
      IExpression,
      'id' | 'display'
    > & {
        pref: { __typename: 'AnalysisPref' } & {
          aliasReplacements: Array<
            {
              __typename: 'UserAliasReplacement';
            } & IUserAliasReplacementFieldsFragment
          >;
        };
        query: { __typename: 'ExpressionQuery' } & {
          measure:
            | ({
                __typename: 'CompoundMeasure';
              } & IMeasureFields_CompoundMeasure_Fragment)
            | ({
                __typename: 'SimpleMeasure';
              } & IMeasureFields_SimpleMeasure_Fragment);
        };
      };
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    filter: Maybe<
      | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
      | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
    >;
    operator: {
      __typename: 'ExpressionCohortOperator';
    } & IExpressionCohortOperatorFieldsFragment;
    percentileFilter: Maybe<
      { __typename: 'PercentileFilter' } & IPercentileFilterFieldsFragment
    >;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    subject: { __typename: 'Subject' } & ISubjectFieldsFragment;
    timeWindow: { __typename: 'TimeWindow' } & ITimeWindowFieldsFragment;
    type: { __typename: 'SimpleCohortType' } & ISimpleCohortTypeFieldsFragment;
    userAlias: {
      __typename: 'UserAliasQueryCohort';
    } & IUserAliasQueryCohortFieldsFragment;
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
    datePicker: Maybe<
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment)
    >;
  };

export type IFunnelCohortAnalysisQueryFieldsFragment = {
  __typename: 'FunnelQuery';
} & Pick<IFunnelQuery, 'timeUnit'> & {
    mode: Maybe<{ __typename: 'FunnelMode' } & Pick<IFunnelMode, 'key'>>;
    partitions: Array<
      { __typename: 'PartitionValue' } & IPartitionValueFieldsFragment
    >;
    steps: Array<
      { __typename: 'FunnelStep' } & IFunnelStepBriefInfoFieldsFragment
    >;
    modeSlices: Array<
      { __typename: 'FunnelModeSlice' } & IFunnelModeSliceFieldsFragment
    >;
  };

export type IRetentionCohortAnalysisQueryFieldsFragment = {
  __typename: 'RetentionQuery';
} & Pick<IRetentionQuery, 'retentionUnit'> & {
    attribution: Maybe<
      { __typename: 'Attribution' } & Pick<IAttribution, 'key'>
    >;
  };

export type IFunnelCohortFieldsFragment = { __typename: 'FunnelCohort' } & Pick<
  IFunnelCohort,
  | 'createdAt'
  | 'id'
  | 'name'
  | 'timeWindowValues'
  | 'isFavorite'
  | 'isManaged'
  | 'durationStartDate'
  | 'lookForwardWindow'
> & { funnelOperatorValues: IFunnelCohort['operatorValues'] } & {
    analysis: { __typename: 'Funnel' } & Pick<IFunnel, 'id' | 'display'> & {
        pref: { __typename: 'AnalysisPref' } & {
          aliasReplacements: Array<
            {
              __typename: 'UserAliasReplacement';
            } & IUserAliasReplacementFieldsFragment
          >;
        };
        query: { __typename: 'FunnelQuery' } & {
          steps: Array<
            { __typename: 'FunnelStep' } & Pick<IFunnelStep, 'name' | 'seq'> & {
                userAlias: { __typename: 'UserAliasQueryStep' } & Pick<
                  IUserAliasQueryStep,
                  'aliasId'
                >;
              }
          >;
        } & IFunnelCohortAnalysisQueryFieldsFragment;
      };
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    filter: Maybe<
      | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
      | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
    >;
    operator: {
      __typename: 'FunnelCohortOperator';
    } & IFunnelCohortOperatorFieldsFragment;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    subject: { __typename: 'Subject' } & ISubjectFieldsFragment;
    timeWindow: { __typename: 'TimeWindow' } & ITimeWindowFieldsFragment;
    type: { __typename: 'SimpleCohortType' } & ISimpleCohortTypeFieldsFragment;
    userAlias: {
      __typename: 'UserAliasQueryCohort';
    } & IUserAliasQueryCohortFieldsFragment;
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
    datePicker: Maybe<
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment)
    >;
    timeToConvert: Maybe<
      { __typename: 'TimeToConvertConfig' } & ITimeToConvertConfigFieldsFragment
    >;
  };

export type IMeasureCohortFieldsFragment = {
  __typename: 'MeasureCohort';
} & Pick<
  IMeasureCohort,
  | 'createdAt'
  | 'id'
  | 'name'
  | 'operatorValues'
  | 'timeWindowValues'
  | 'isFavorite'
  | 'isManaged'
> & {
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    filter: Maybe<
      | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
      | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
    >;
    measure:
      | ({
          __typename: 'CompoundMeasure';
        } & IMeasureFields_CompoundMeasure_Fragment)
      | ({
          __typename: 'SimpleMeasure';
        } & IMeasureFields_SimpleMeasure_Fragment);
    operator: {
      __typename: 'MeasureCohortOperator';
    } & IMeasureCohortOperatorFieldsFragment;
    percentileFilter: Maybe<
      { __typename: 'PercentileFilter' } & IPercentileFilterFieldsFragment
    >;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    subject: { __typename: 'Subject' } & ISubjectFieldsFragment;
    timeWindow: { __typename: 'TimeWindow' } & ITimeWindowFieldsFragment;
    type: { __typename: 'SimpleCohortType' } & ISimpleCohortTypeFieldsFragment;
    userAlias: {
      __typename: 'UserAliasQueryCohort';
    } & IUserAliasQueryCohortFieldsFragment;
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
    datePicker: Maybe<
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment)
    >;
  };

export type IPerformedCohortFieldsFragment = {
  __typename: 'PerformedCohort';
} & Pick<
  IPerformedCohort,
  'createdAt' | 'id' | 'name' | 'timeWindowValues' | 'isFavorite' | 'isManaged'
> & { performedOperatorValues: IPerformedCohort['operatorValues'] } & {
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    eventConditions: Array<
      { __typename: 'EventCondition' } & IEventConditionFieldsFragment
    >;
    filter: Maybe<
      | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
      | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
    >;
    operator: {
      __typename: 'PerformedCohortOperator';
    } & IPerformedCohortOperatorFieldsFragment;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    subject: { __typename: 'Subject' } & ISubjectFieldsFragment;
    timeWindow: { __typename: 'TimeWindow' } & ITimeWindowFieldsFragment;
    type: { __typename: 'SimpleCohortType' } & ISimpleCohortTypeFieldsFragment;
    userAlias: {
      __typename: 'UserAliasQueryCohort';
    } & IUserAliasQueryCohortFieldsFragment;
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
    datePicker: Maybe<
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment)
    >;
  };

export type IRetentionCohortFieldsFragment = {
  __typename: 'RetentionCohort';
} & Pick<
  IRetentionCohort,
  | 'createdAt'
  | 'id'
  | 'name'
  | 'timeWindowValues'
  | 'isFavorite'
  | 'isManaged'
  | 'durationStartDate'
  | 'lookForwardWindow'
> & { retentionOperatorValues: IRetentionCohort['operatorValues'] } & {
    analysis: { __typename: 'Retention' } & Pick<
      IRetention,
      'id' | 'display' | 'timeUnit'
    > & {
        query: { __typename: 'RetentionQuery' } & Pick<
          IRetentionQuery,
          'retentionUnit' | 'customTimeBrackets'
        > &
          IRetentionCohortAnalysisQueryFieldsFragment;
      };
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    filter: Maybe<
      | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
      | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
    >;
    operator: {
      __typename: 'RetentionCohortOperator';
    } & IRetentionCohortOperatorFieldsFragment;
    returnedOperator: Maybe<
      { __typename: 'RelationalOperator' } & IRelationalOperatorFieldsFragment
    >;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    subject: { __typename: 'Subject' } & ISubjectFieldsFragment;
    timeWindow: { __typename: 'TimeWindow' } & ITimeWindowFieldsFragment;
    type: { __typename: 'SimpleCohortType' } & ISimpleCohortTypeFieldsFragment;
    userAlias: {
      __typename: 'UserAliasQueryCohort';
    } & IUserAliasQueryCohortFieldsFragment;
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
    datePicker: Maybe<
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment)
    >;
  };

type ISimpleCohortFields_ExpressionCohort_Fragment = {
  __typename: 'ExpressionCohort';
} & IExpressionCohortFieldsFragment;

type ISimpleCohortFields_FunnelCohort_Fragment = {
  __typename: 'FunnelCohort';
} & IFunnelCohortFieldsFragment;

type ISimpleCohortFields_MeasureCohort_Fragment = {
  __typename: 'MeasureCohort';
} & IMeasureCohortFieldsFragment;

type ISimpleCohortFields_PerformedCohort_Fragment = {
  __typename: 'PerformedCohort';
} & IPerformedCohortFieldsFragment;

type ISimpleCohortFields_RetentionCohort_Fragment = {
  __typename: 'RetentionCohort';
} & IRetentionCohortFieldsFragment;

export type ISimpleCohortFieldsFragment =
  | ISimpleCohortFields_ExpressionCohort_Fragment
  | ISimpleCohortFields_FunnelCohort_Fragment
  | ISimpleCohortFields_MeasureCohort_Fragment
  | ISimpleCohortFields_PerformedCohort_Fragment
  | ISimpleCohortFields_RetentionCohort_Fragment;

export type ICompoundCohortFieldsFragment = {
  __typename: 'CompoundCohort';
} & Pick<
  ICompoundCohort,
  'createdAt' | 'id' | 'name' | 'isFavorite' | 'isManaged'
> & {
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    logicOps: Array<
      { __typename: 'LogicalOperator' } & ILogicalOperatorFieldsFragment
    >;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    userAlias: {
      __typename: 'UserAliasQueryCohort';
    } & IUserAliasQueryCohortFieldsFragment;
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    simpleCohorts: Array<
      | ({
          __typename: 'ExpressionCohort';
        } & ISimpleCohortFields_ExpressionCohort_Fragment)
      | ({
          __typename: 'FunnelCohort';
        } & ISimpleCohortFields_FunnelCohort_Fragment)
      | ({
          __typename: 'MeasureCohort';
        } & ISimpleCohortFields_MeasureCohort_Fragment)
      | ({
          __typename: 'PerformedCohort';
        } & ISimpleCohortFields_PerformedCohort_Fragment)
      | ({
          __typename: 'RetentionCohort';
        } & ISimpleCohortFields_RetentionCohort_Fragment)
    >;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };

type ICohortFields_CompoundCohort_Fragment = {
  __typename: 'CompoundCohort';
} & ICompoundCohortFieldsFragment;

type ICohortFields_ExpressionCohort_Fragment = {
  __typename: 'ExpressionCohort';
} & IExpressionCohortFieldsFragment;

type ICohortFields_FunnelCohort_Fragment = {
  __typename: 'FunnelCohort';
} & IFunnelCohortFieldsFragment;

type ICohortFields_MeasureCohort_Fragment = {
  __typename: 'MeasureCohort';
} & IMeasureCohortFieldsFragment;

type ICohortFields_PerformedCohort_Fragment = {
  __typename: 'PerformedCohort';
} & IPerformedCohortFieldsFragment;

type ICohortFields_RetentionCohort_Fragment = {
  __typename: 'RetentionCohort';
} & IRetentionCohortFieldsFragment;

export type ICohortFieldsFragment =
  | ICohortFields_CompoundCohort_Fragment
  | ICohortFields_ExpressionCohort_Fragment
  | ICohortFields_FunnelCohort_Fragment
  | ICohortFields_MeasureCohort_Fragment
  | ICohortFields_PerformedCohort_Fragment
  | ICohortFields_RetentionCohort_Fragment;

export type ICohortRefPropsFieldsFragment = {
  __typename: 'CohortRefProps';
} & Pick<ICohortRefProps, 'samplePercentage'> & {
    dateRange: Maybe<{ __typename: 'DateRange' } & IDateRangeFieldsFragment>;
  };

export type ICohortRefFieldsFragment = { __typename: 'CohortRef' } & {
  cohort:
    | ({ __typename: 'CompoundCohort' } & ICohortFields_CompoundCohort_Fragment)
    | ({
        __typename: 'ExpressionCohort';
      } & ICohortFields_ExpressionCohort_Fragment)
    | ({ __typename: 'FunnelCohort' } & ICohortFields_FunnelCohort_Fragment)
    | ({ __typename: 'MeasureCohort' } & ICohortFields_MeasureCohort_Fragment)
    | ({
        __typename: 'PerformedCohort';
      } & ICohortFields_PerformedCohort_Fragment)
    | ({
        __typename: 'RetentionCohort';
      } & ICohortFields_RetentionCohort_Fragment);
  props: { __typename: 'CohortRefProps' } & ICohortRefPropsFieldsFragment;
};

export type ICohortInspectFieldFieldsFragment = { __typename: 'Field' } & Pick<
  IField,
  'key' | 'name' | 'isFactField'
> & {
    nestedFieldMetadata: Maybe<
      { __typename: 'NestedFieldMetadata' } & Pick<INestedFieldMetadata, 'key'>
    >;
  };

export type IInspectSubjectTableTableColumnFieldsFragment = {
  __typename: 'InspectSubjectTableTableColumn';
} & {
  cells: Array<
    { __typename: 'InspectSubjectTableCell' } & Pick<
      IInspectSubjectTableCell,
      'value'
    >
  >;
  header: { __typename: 'InspectSubjectTableHeader' } & {
    field: { __typename: 'Field' } & Pick<
      IField,
      'key' | 'name' | 'isFactField'
    >;
  };
};

export type IInspectSubjectTableSummaryFieldsFragment = {
  __typename: 'InspectSubjectTableSummary';
} & Pick<IInspectSubjectTableSummary, 'tableSize' | 'totalCount'>;

export type IInspectSubjectTableFieldsFragment = {
  __typename: 'InspectSubjectTable';
} & {
  columns: Array<
    {
      __typename: 'InspectSubjectTableTableColumn';
    } & IInspectSubjectTableTableColumnFieldsFragment
  >;
  summary: {
    __typename: 'InspectSubjectTableSummary';
  } & IInspectSubjectTableSummaryFieldsFragment;
};

export type IInspectErrorFieldsFragment = { __typename: 'InspectError' } & Pick<
  IInspectError,
  'message' | 'status'
>;

export type IInspectSubjectMutationVariables = Exact<{
  input: IInspectSubjectInput;
}>;

export type IInspectSubjectMutation = { __typename: 'Mutation' } & {
  inspectSubject: Maybe<
    { __typename: 'InspectSubjectPayload' } & Pick<
      IInspectSubjectPayload,
      'exportUrl'
    > & {
        data: Maybe<
          { __typename: 'InspectSubjectData' } & {
            inspectTable: {
              __typename: 'InspectSubjectTable';
            } & IInspectSubjectTableFieldsFragment;
          }
        >;
        errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
        error: Maybe<
          { __typename: 'InspectError' } & IInspectErrorFieldsFragment
        >;
      }
  >;
};

export type INamedCohortCreateMutationVariables = Exact<{
  input: INamedCohortCreateInput;
}>;

export type INamedCohortCreateMutation = { __typename: 'Mutation' } & {
  namedCohortCreate: { __typename: 'NamedCohortCreatePayload' } & {
    entity: Maybe<
      | ({
          __typename: 'CompoundCohort';
        } & ICohortFields_CompoundCohort_Fragment)
      | ({
          __typename: 'ExpressionCohort';
        } & ICohortFields_ExpressionCohort_Fragment)
      | ({ __typename: 'FunnelCohort' } & ICohortFields_FunnelCohort_Fragment)
      | ({ __typename: 'MeasureCohort' } & ICohortFields_MeasureCohort_Fragment)
      | ({
          __typename: 'PerformedCohort';
        } & ICohortFields_PerformedCohort_Fragment)
      | ({
          __typename: 'RetentionCohort';
        } & ICohortFields_RetentionCohort_Fragment)
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type INamedCohortEditMutationVariables = Exact<{
  input: INamedCohortEditInput;
}>;

export type INamedCohortEditMutation = { __typename: 'Mutation' } & {
  namedCohortEdit: { __typename: 'NamedCohortEditPayload' } & {
    entity: Maybe<
      | ({
          __typename: 'CompoundCohort';
        } & ICohortFields_CompoundCohort_Fragment)
      | ({
          __typename: 'ExpressionCohort';
        } & ICohortFields_ExpressionCohort_Fragment)
      | ({ __typename: 'FunnelCohort' } & ICohortFields_FunnelCohort_Fragment)
      | ({ __typename: 'MeasureCohort' } & ICohortFields_MeasureCohort_Fragment)
      | ({
          __typename: 'PerformedCohort';
        } & ICohortFields_PerformedCohort_Fragment)
      | ({
          __typename: 'RetentionCohort';
        } & ICohortFields_RetentionCohort_Fragment)
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type INamedCohortDisableMutationVariables = Exact<{
  input: INamedCohortDisableInput;
}>;

export type INamedCohortDisableMutation = { __typename: 'Mutation' } & {
  namedCohortDisable: { __typename: 'NamedCohortDisablePayload' } & Pick<
    INamedCohortDisablePayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type INamedCohortAddCategoryMutationVariables = Exact<{
  input: INamedEntityEditCategoryInput;
}>;

export type INamedCohortAddCategoryMutation = { __typename: 'Mutation' } & {
  namedCohortAddCategory: {
    __typename: 'NamedEntityEditCategoryPayload';
  } & Pick<INamedEntityEditCategoryPayload, 'message'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type INamedCohortRemoveCategoryMutationVariables = Exact<{
  input: INamedEntityEditCategoryInput;
}>;

export type INamedCohortRemoveCategoryMutation = { __typename: 'Mutation' } & {
  namedCohortRemoveCategory: {
    __typename: 'NamedEntityEditCategoryPayload';
  } & Pick<INamedEntityEditCategoryPayload, 'message'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type INamedCohortQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type INamedCohortQueryQuery = { __typename: 'Query' } & {
  namedCohort:
    | ({ __typename: 'CompoundCohort' } & ICohortFields_CompoundCohort_Fragment)
    | ({
        __typename: 'ExpressionCohort';
      } & ICohortFields_ExpressionCohort_Fragment)
    | ({ __typename: 'FunnelCohort' } & ICohortFields_FunnelCohort_Fragment)
    | ({ __typename: 'MeasureCohort' } & ICohortFields_MeasureCohort_Fragment)
    | ({
        __typename: 'PerformedCohort';
      } & ICohortFields_PerformedCohort_Fragment)
    | ({
        __typename: 'RetentionCohort';
      } & ICohortFields_RetentionCohort_Fragment);
};

export type IGetNamedCohortsQueryVariables = Exact<{
  schemaId: InputMaybe<Scalars['ID']['input']>;
  includes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
  includeCompound: InputMaybe<Scalars['Boolean']['input']>;
  pagination: InputMaybe<IPagination>;
}>;

export type IGetNamedCohortsQuery = { __typename: 'Query' } & {
  namedCohorts: { __typename: 'NamedCohortsPaginated' } & {
    entities: Array<
      | ({
          __typename: 'CompoundCohort';
        } & ICohortFields_CompoundCohort_Fragment)
      | ({
          __typename: 'ExpressionCohort';
        } & ICohortFields_ExpressionCohort_Fragment)
      | ({ __typename: 'FunnelCohort' } & ICohortFields_FunnelCohort_Fragment)
      | ({ __typename: 'MeasureCohort' } & ICohortFields_MeasureCohort_Fragment)
      | ({
          __typename: 'PerformedCohort';
        } & ICohortFields_PerformedCohort_Fragment)
      | ({
          __typename: 'RetentionCohort';
        } & ICohortFields_RetentionCohort_Fragment)
    >;
    pageInfo: { __typename: 'PageInfo' } & IPageInfoFieldsFragment;
  };
};

type IDictionaryNamedCohortFields_CompoundCohort_Fragment = {
  __typename: 'CompoundCohort';
} & Pick<ICompoundCohort, 'id' | 'isFavorite' | 'isManaged'> & {
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };

type IDictionaryNamedCohortFields_ExpressionCohort_Fragment = {
  __typename: 'ExpressionCohort';
} & Pick<IExpressionCohort, 'id' | 'isFavorite' | 'isManaged'> & {
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };

type IDictionaryNamedCohortFields_FunnelCohort_Fragment = {
  __typename: 'FunnelCohort';
} & Pick<IFunnelCohort, 'id' | 'isFavorite' | 'isManaged'> & {
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };

type IDictionaryNamedCohortFields_MeasureCohort_Fragment = {
  __typename: 'MeasureCohort';
} & Pick<IMeasureCohort, 'id' | 'isFavorite' | 'isManaged'> & {
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };

type IDictionaryNamedCohortFields_PerformedCohort_Fragment = {
  __typename: 'PerformedCohort';
} & Pick<IPerformedCohort, 'id' | 'isFavorite' | 'isManaged'> & {
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };

type IDictionaryNamedCohortFields_RetentionCohort_Fragment = {
  __typename: 'RetentionCohort';
} & Pick<IRetentionCohort, 'id' | 'isFavorite' | 'isManaged'> & {
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };

export type IDictionaryNamedCohortFieldsFragment =
  | IDictionaryNamedCohortFields_CompoundCohort_Fragment
  | IDictionaryNamedCohortFields_ExpressionCohort_Fragment
  | IDictionaryNamedCohortFields_FunnelCohort_Fragment
  | IDictionaryNamedCohortFields_MeasureCohort_Fragment
  | IDictionaryNamedCohortFields_PerformedCohort_Fragment
  | IDictionaryNamedCohortFields_RetentionCohort_Fragment;

export type IGetDictionaryNamedCohortsQueryVariables = Exact<{
  schemaId: InputMaybe<Scalars['ID']['input']>;
  includes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
  includeCompound: InputMaybe<Scalars['Boolean']['input']>;
  pagination: InputMaybe<IPagination>;
}>;

export type IGetDictionaryNamedCohortsQuery = { __typename: 'Query' } & {
  namedCohorts: { __typename: 'NamedCohortsPaginated' } & {
    entities: Array<
      | ({
          __typename: 'CompoundCohort';
        } & IDictionaryNamedCohortFields_CompoundCohort_Fragment)
      | ({
          __typename: 'ExpressionCohort';
        } & IDictionaryNamedCohortFields_ExpressionCohort_Fragment)
      | ({
          __typename: 'FunnelCohort';
        } & IDictionaryNamedCohortFields_FunnelCohort_Fragment)
      | ({
          __typename: 'MeasureCohort';
        } & IDictionaryNamedCohortFields_MeasureCohort_Fragment)
      | ({
          __typename: 'PerformedCohort';
        } & IDictionaryNamedCohortFields_PerformedCohort_Fragment)
      | ({
          __typename: 'RetentionCohort';
        } & IDictionaryNamedCohortFields_RetentionCohort_Fragment)
    >;
    pageInfo: { __typename: 'PageInfo' } & IPageInfoFieldsFragment;
  };
};

export type IGetCohortInspectFieldsQueryVariables = Exact<{
  term: InputMaybe<Scalars['String']['input']>;
  schemaId: Scalars['ID']['input'];
  func: InputMaybe<Scalars['String']['input']>;
  context: FieldContext;
  events: Array<IEventInput> | IEventInput;
  includeFields: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type IGetCohortInspectFieldsQuery = { __typename: 'Query' } & {
  fields: Maybe<
    Array<{ __typename: 'Field' } & ICohortInspectFieldFieldsFragment>
  >;
};

export type ICohortSampleTableSummaryFieldsFragment = {
  __typename: 'CohortSampleTableSummary';
} & Pick<ICohortSampleTableSummary, 'totalCount' | 'tableSize'>;

export type ICohortSampleTableCaptionFieldsFragment = {
  __typename: 'CohortSampleTableCaption';
} & Pick<ICohortSampleTableCaption, 'caption'>;

export type ICohortSampleTableHeaderFieldsFragment = {
  __typename: 'CohortSampleTableHeader';
} & Pick<ICohortSampleTableHeader, 'header' | 'subheader' | 'tooltip'>;

export type ICohortSampleTableCellFieldsFragment = {
  __typename: 'CohortSampleTableCell';
} & Pick<ICohortSampleTableCell, 'value'>;

export type ICohortSampleTableColumnFieldsFragment = {
  __typename: 'CohortSampleTableColumn';
} & Pick<ICohortSampleTableColumn, 'columnType'> & {
    header: {
      __typename: 'CohortSampleTableHeader';
    } & ICohortSampleTableHeaderFieldsFragment;
    cells: Array<
      {
        __typename: 'CohortSampleTableCell';
      } & ICohortSampleTableCellFieldsFragment
    >;
  };

export type ICohortSampleDataSummaryFieldsFragment = {
  __typename: 'CohortSampleDataSummary';
} & Pick<ICohortSampleDataSummary, 'text' | 'number'>;

export type ICohortSampleTableFieldsFragment = {
  __typename: 'CohortSampleTable';
} & {
  columns: Array<
    {
      __typename: 'CohortSampleTableColumn';
    } & ICohortSampleTableColumnFieldsFragment
  >;
  summary: {
    __typename: 'CohortSampleTableSummary';
  } & ICohortSampleTableSummaryFieldsFragment;
  caption: {
    __typename: 'CohortSampleTableCaption';
  } & ICohortSampleTableCaptionFieldsFragment;
};

export type ICohortDataFieldsFragment = {
  __typename: 'CohortSampleData';
} & Pick<ICohortSampleData, 'subjectName' | 'isEmpty'> & {
    tables: Array<
      { __typename: 'CohortSampleTable' } & ICohortSampleTableFieldsFragment
    >;
    summary: Maybe<
      {
        __typename: 'CohortSampleDataSummary';
      } & ICohortSampleDataSummaryFieldsFragment
    >;
  };

export type ICohortSampleOperationFieldsFragment = {
  __typename: 'CohortSampleOperation';
} & Pick<ICohortSampleOperation, 'key' | 'name'> & {
    logicOp: { __typename: 'LogicalOperator' } & ILogicalOperatorFieldsFragment;
  };

export type ICompareExpandEventFieldsFragment = {
  __typename: 'CompareExpandEvent';
} & {
  field: { __typename: 'Field' } & IFieldFieldsFragment;
  eventCondition: {
    __typename: 'EventCondition';
  } & IEventConditionFieldsFragment;
};

export type ICompareMergeEventFieldsFragment = {
  __typename: 'CompareMergeEvent';
} & Pick<ICompareMergeEvent, 'name' | 'isNameAutoGenerated'> & {
    eventConditions: Array<
      { __typename: 'EventCondition' } & IEventConditionFieldsFragment
    >;
  };

export type ICohortCompareFieldsFragment = { __typename: 'CohortCompare' } & {
  expandEvents: Array<
    { __typename: 'CompareExpandEvent' } & ICompareExpandEventFieldsFragment
  >;
  mergeEvents: Array<
    { __typename: 'CompareMergeEvent' } & ICompareMergeEventFieldsFragment
  >;
};

export type ICohortSampleQueryFieldsFragment = {
  __typename: 'CohortSampleQuery';
} & Pick<ICohortSampleQuery, 'samplePercentage' | 'sampleAbsolute'> & {
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    cohort:
      | ({
          __typename: 'CompoundCohort';
        } & ICohortFields_CompoundCohort_Fragment)
      | ({
          __typename: 'ExpressionCohort';
        } & ICohortFields_ExpressionCohort_Fragment)
      | ({ __typename: 'FunnelCohort' } & ICohortFields_FunnelCohort_Fragment)
      | ({ __typename: 'MeasureCohort' } & ICohortFields_MeasureCohort_Fragment)
      | ({
          __typename: 'PerformedCohort';
        } & ICohortFields_PerformedCohort_Fragment)
      | ({
          __typename: 'RetentionCohort';
        } & ICohortFields_RetentionCohort_Fragment);
    operation: Maybe<
      {
        __typename: 'CohortSampleOperation';
      } & ICohortSampleOperationFieldsFragment
    >;
    compare: Maybe<
      { __typename: 'CohortCompare' } & ICohortCompareFieldsFragment
    >;
    dateRange: Maybe<{ __typename: 'DateRange' } & IDateRangeFieldsFragment>;
    llmChatMessages: Array<
      { __typename: 'LlmChatMessage' } & ILlmChatMessageFieldsFragment
    >;
  };

export type ICommentReactionFieldsFragment = {
  __typename: 'CommentReaction';
} & Pick<ICommentReaction, 'emojiKey'> & {
    users: Array<{ __typename: 'User' } & IBriefUserInfoFieldsFragment>;
  };

export type ICommentFieldsFragment = { __typename: 'Comment' } & Pick<
  IComment,
  'createdAt' | 'id' | 'isRead'
> & {
    attachedImageEmbed: Maybe<
      { __typename: 'ImageEmbed' } & IImageEmbedFieldsFragment
    >;
    creator: { __typename: 'User' } & IBriefUserInfoFieldsFragment;
    mentions: Array<{ __typename: 'User' } & IBriefUserInfoFieldsFragment>;
    message: Maybe<{ __typename: 'RichText' } & IRichTextFieldsFragment>;
    reactions: Array<
      { __typename: 'CommentReaction' } & ICommentReactionFieldsFragment
    >;
  };

export type IConversationEntityFieldsFragment = {
  __typename: 'ConversationEntity';
} & Pick<IConversationEntity, 'id' | 'type'>;

export type IConversationThreadFieldsFragment = {
  __typename: 'ConversationThread';
} & Pick<
  IConversationThread,
  'createdAt' | 'hasUnreadComments' | 'id' | 'isResolved'
> & {
    comments: Array<{ __typename: 'Comment' } & ICommentFieldsFragment>;
    creator: { __typename: 'User' } & IBriefUserInfoFieldsFragment;
    entity: {
      __typename: 'ConversationEntity';
    } & IConversationEntityFieldsFragment;
    participants: Array<{ __typename: 'User' } & IBriefUserInfoFieldsFragment>;
  };

export type IConversationThreadCommentAddMutationVariables = Exact<{
  input: IThreadCommentAddInput;
}>;

export type IConversationThreadCommentAddMutation = {
  __typename: 'Mutation';
} & {
  conversationThreadCommentAdd: { __typename: 'ConversationThreadPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    thread: Maybe<
      { __typename: 'ConversationThread' } & IConversationThreadFieldsFragment
    >;
  };
};

export type IConversationThreadReadMutationVariables = Exact<{
  input: IThreadReadInput;
}>;

export type IConversationThreadReadMutation = { __typename: 'Mutation' } & {
  conversationThreadRead: { __typename: 'ConversationThreadPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    thread: Maybe<
      { __typename: 'ConversationThread' } & IConversationThreadFieldsFragment
    >;
  };
};

export type IConversationThreadStartMutationVariables = Exact<{
  input: IThreadStartInput;
}>;

export type IConversationThreadStartMutation = { __typename: 'Mutation' } & {
  conversationThreadStart: { __typename: 'ConversationThreadPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    thread: Maybe<
      { __typename: 'ConversationThread' } & IConversationThreadFieldsFragment
    >;
  };
};

export type IConversationThreadResolveMutationVariables = Exact<{
  input: IThreadResolveInput;
}>;

export type IConversationThreadResolveMutation = { __typename: 'Mutation' } & {
  conversationThreadResolve: {
    __typename: 'ConversationThreadResolvePayload';
  } & Pick<IConversationThreadResolvePayload, 'resolved'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type IConversationThreadCommentImageEmbedAddMutationVariables = Exact<{
  [key: string]: never;
}>;

export type IConversationThreadCommentImageEmbedAddMutation = {
  __typename: 'Mutation';
} & {
  conversationThreadCommentImageEmbedAdd: {
    __typename: 'CommentImageEmbedAddPayload';
  } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    uploadConfig: Maybe<
      { __typename: 'ConversationThreadCommentImageEmbedUploadConfig' } & {
        imageEmbed: { __typename: 'ImageEmbed' } & IImageEmbedFieldsFragment;
        postUploadConfig: {
          __typename: 'PostUploadConfig';
        } & IPostUploadConfigFieldsFragment;
      }
    >;
  };
};

export type IConversationThreadCommentUpdateMutationVariables = Exact<{
  input: IThreadCommentUpdateInput;
}>;

export type IConversationThreadCommentUpdateMutation = {
  __typename: 'Mutation';
} & {
  conversationThreadCommentUpdate: {
    __typename: 'ConversationThreadPayload';
  } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    thread: Maybe<
      { __typename: 'ConversationThread' } & IConversationThreadFieldsFragment
    >;
  };
};

export type IConversationThreadCommentDeleteMutationVariables = Exact<{
  input: IThreadCommentDeleteInput;
}>;

export type IConversationThreadCommentDeleteMutation = {
  __typename: 'Mutation';
} & {
  conversationThreadCommentDelete: {
    __typename: 'ConversationThreadPayload';
  } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    thread: Maybe<
      { __typename: 'ConversationThread' } & IConversationThreadFieldsFragment
    >;
  };
};

export type ICommentReactionAddMutationVariables = Exact<{
  input: ICommentReactionAddInput;
}>;

export type ICommentReactionAddMutation = { __typename: 'Mutation' } & {
  conversationCommentReactionAdd: {
    __typename: 'ConversationThreadPayload';
  } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    thread: Maybe<
      { __typename: 'ConversationThread' } & IConversationThreadFieldsFragment
    >;
  };
};

export type ICommentReactionRemoveMutationVariables = Exact<{
  input: ICommentReactionDeleteInput;
}>;

export type ICommentReactionRemoveMutation = { __typename: 'Mutation' } & {
  conversationCommentReactionDelete: {
    __typename: 'ConversationThreadPayload';
  } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    thread: Maybe<
      { __typename: 'ConversationThread' } & IConversationThreadFieldsFragment
    >;
  };
};

export type IGetEntityConversationThreadsQueryVariables = Exact<{
  ids: Array<IConversationEntityInput> | IConversationEntityInput;
}>;

export type IGetEntityConversationThreadsQuery = { __typename: 'Query' } & {
  entityConversationThreads: Array<
    { __typename: 'ConversationThread' } & IConversationThreadFieldsFragment
  >;
};

export type ISubFolderFieldsFragment = { __typename: 'SubFolder' } & Pick<
  ISubFolder,
  'id' | 'name' | 'parentId' | 'isEmpty' | 'isDisabled'
>;

export type IDashboardTemplateFieldsFragment = {
  __typename: 'Dashboard';
} & Pick<
  IDashboard,
  | 'baseId'
  | 'name'
  | 'description'
  | 'isPublished'
  | 'isFavorite'
  | 'isSharedWithMe'
  | 'isLatestVersion'
> & {
    path: Array<{ __typename: 'SubFolder' } & ISubFolderFieldsFragment>;
    permission: {
      __typename: 'EntityPermission';
    } & IEntityPermissionFieldsFragment;
  };

export type IDashboardFolderFieldsFragment = {
  __typename: 'DashboardFolder';
} & Pick<IDashboardFolder, 'id' | 'name' | 'parentId' | 'isDisabled'> & {
    path: Array<{ __typename: 'SubFolder' } & ISubFolderFieldsFragment>;
    subFolders: Array<{ __typename: 'SubFolder' } & ISubFolderFieldsFragment>;
    templates: Array<
      { __typename: 'Dashboard' } & IDashboardTemplateFieldsFragment
    >;
  };

export type IDashboardFilterFieldsFragment = {
  __typename: 'DashboardFilter';
} & {
  dateRange: Maybe<{ __typename: 'DateRange' } & IDateRangeFieldsFragment>;
  filter: Maybe<
    | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
    | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
  >;
  schema: Maybe<{ __typename: 'Schema' } & ISchemaFieldsFragment>;
  datePicker: Maybe<
    | ({
        __typename: 'DatePickerFixed';
      } & IDatePickerFields_DatePickerFixed_Fragment)
    | ({
        __typename: 'DatePickerLast';
      } & IDatePickerFields_DatePickerLast_Fragment)
    | ({
        __typename: 'DatePickerLastFull';
      } & IDatePickerFields_DatePickerLastFull_Fragment)
    | ({
        __typename: 'DatePickerSince';
      } & IDatePickerFields_DatePickerSince_Fragment)
    | ({
        __typename: 'DatePickerStartOf';
      } & IDatePickerFields_DatePickerStartOf_Fragment)
  >;
};

export type IDashboardAnalysisColumnFieldsFragment = {
  __typename: 'DashboardAnalysisColumn';
} & Pick<IDashboardAnalysisColumn, 'colSpan'> & {
    analysis:
      | ({
          __typename: 'CohortSample';
        } & IAnalysisSummaryInfoFields_CohortSample_Fragment)
      | ({
          __typename: 'DataTable';
        } & IAnalysisSummaryInfoFields_DataTable_Fragment)
      | ({
          __typename: 'Expression';
        } & IAnalysisSummaryInfoFields_Expression_Fragment)
      | ({ __typename: 'Funnel' } & IAnalysisSummaryInfoFields_Funnel_Fragment)
      | ({ __typename: 'Path' } & IAnalysisSummaryInfoFields_Path_Fragment)
      | ({
          __typename: 'Prediction';
        } & IAnalysisSummaryInfoFields_Prediction_Fragment)
      | ({
          __typename: 'Retention';
        } & IAnalysisSummaryInfoFields_Retention_Fragment)
      | ({
          __typename: 'Significance';
        } & IAnalysisSummaryInfoFields_Significance_Fragment);
  };

export type IDashboardRichTextColumnFieldsFragment = {
  __typename: 'DashboardRichTextColumn';
} & Pick<IDashboardRichTextColumn, 'colSpan'> & {
    richText: { __typename: 'RichText' } & IRichTextFieldsFragment;
  };

export type IDashboardExternalEmbedColumnFieldsFragment = {
  __typename: 'DashboardExternalEmbedColumn';
} & Pick<IDashboardExternalEmbedColumn, 'colSpan'> & {
    externalEmbed: {
      __typename: 'ExternalEmbed';
    } & IExternalEmbedFieldsFragment;
  };

export type IDashboardImageEmbedColumnFieldsFragment = {
  __typename: 'DashboardImageEmbedColumn';
} & Pick<IDashboardImageEmbedColumn, 'colSpan'> & {
    imageEmbed: { __typename: 'ImageEmbed' } & IImageEmbedFieldsFragment;
  };

type IDashboardColumnFields_DashboardAnalysisColumn_Fragment = {
  __typename: 'DashboardAnalysisColumn';
} & IDashboardAnalysisColumnFieldsFragment;

type IDashboardColumnFields_DashboardExternalEmbedColumn_Fragment = {
  __typename: 'DashboardExternalEmbedColumn';
} & IDashboardExternalEmbedColumnFieldsFragment;

type IDashboardColumnFields_DashboardImageEmbedColumn_Fragment = {
  __typename: 'DashboardImageEmbedColumn';
} & IDashboardImageEmbedColumnFieldsFragment;

type IDashboardColumnFields_DashboardRichTextColumn_Fragment = {
  __typename: 'DashboardRichTextColumn';
} & IDashboardRichTextColumnFieldsFragment;

export type IDashboardColumnFieldsFragment =
  | IDashboardColumnFields_DashboardAnalysisColumn_Fragment
  | IDashboardColumnFields_DashboardExternalEmbedColumn_Fragment
  | IDashboardColumnFields_DashboardImageEmbedColumn_Fragment
  | IDashboardColumnFields_DashboardRichTextColumn_Fragment;

export type IDashboardRowFieldsFragment = { __typename: 'DashboardRow' } & Pick<
  IDashboardRow,
  'id' | 'minHeight'
> & {
    columns: Array<
      | ({
          __typename: 'DashboardAnalysisColumn';
        } & IDashboardColumnFields_DashboardAnalysisColumn_Fragment)
      | ({
          __typename: 'DashboardExternalEmbedColumn';
        } & IDashboardColumnFields_DashboardExternalEmbedColumn_Fragment)
      | ({
          __typename: 'DashboardImageEmbedColumn';
        } & IDashboardColumnFields_DashboardImageEmbedColumn_Fragment)
      | ({
          __typename: 'DashboardRichTextColumn';
        } & IDashboardColumnFields_DashboardRichTextColumn_Fragment)
    >;
  };

export type IDashboardInstanceFieldsFragment = {
  __typename: 'Dashboard';
} & Pick<
  IDashboard,
  | 'id'
  | 'exportUrl'
  | 'createdAt'
  | 'versionCreatedAt'
  | 'versionEditedAt'
  | 'refreshedAt'
  | 'isDefault'
  | 'isDeleted'
  | 'isLatestInstance'
> & {
    rows: Array<{ __typename: 'DashboardRow' } & IDashboardRowFieldsFragment>;
    versionCreator: { __typename: 'User' } & ICreatorFieldsFragment;
    versionEditor: { __typename: 'User' } & ICreatorFieldsFragment;
    filter: Maybe<
      { __typename: 'DashboardFilter' } & IDashboardFilterFieldsFragment
    >;
    llmSummary: Maybe<
      { __typename: 'LlmSubjectSummary' } & ILlmSubjectSummaryFieldsFragment
    >;
  } & IDashboardTemplateFieldsFragment;

export type IDashboardImageEmbedUploadConfigFieldsFragment = {
  __typename: 'DashboardImageEmbedUploadConfig';
} & {
  imageEmbed: { __typename: 'ImageEmbed' } & IImageEmbedFieldsFragment;
  postUploadConfig: {
    __typename: 'PostUploadConfig';
  } & IPostUploadConfigFieldsFragment;
};

export type IDashboardCreateMutationVariables = Exact<{
  input: IDashboardCreateInput;
}>;

export type IDashboardCreateMutation = { __typename: 'Mutation' } & {
  dashboardCreate: { __typename: 'DashboardPayload' } & {
    entity: Maybe<
      { __typename: 'Dashboard' } & IDashboardTemplateFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardAddAnalysesMutationVariables = Exact<{
  input: IDashboardAddAnalysesInput;
}>;

export type IDashboardAddAnalysesMutation = { __typename: 'Mutation' } & {
  dashboardAddAnalyses: { __typename: 'DashboardPayload' } & {
    entity: Maybe<
      { __typename: 'Dashboard' } & IDashboardInstanceFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardSetFilterMutationVariables = Exact<{
  input: IDashboardSetFilterInput;
}>;

export type IDashboardSetFilterMutation = { __typename: 'Mutation' } & {
  dashboardSetFilter: { __typename: 'DashboardPayload' } & {
    entity: Maybe<
      { __typename: 'Dashboard' } & IDashboardInstanceFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardDeleteMutationVariables = Exact<{
  input: IDashboardDeleteInput;
}>;

export type IDashboardDeleteMutation = { __typename: 'Mutation' } & {
  dashboardDelete: { __typename: 'DashboardDeletePayload' } & Pick<
    IDashboardDeletePayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IDashboardMoveMutationVariables = Exact<{
  input: IDashboardMoveInput;
}>;

export type IDashboardMoveMutation = { __typename: 'Mutation' } & {
  dashboardMove: { __typename: 'DashboardPayload' } & {
    entity: Maybe<
      { __typename: 'Dashboard' } & IDashboardTemplateFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardFolderCreateMutationVariables = Exact<{
  input: ISubFolderCreateInput;
}>;

export type IDashboardFolderCreateMutation = { __typename: 'Mutation' } & {
  dashboardFolderCreate: { __typename: 'DashboardFolderPayload' } & {
    entity: Maybe<
      { __typename: 'DashboardFolder' } & IDashboardFolderFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardFolderDeleteMutationVariables = Exact<{
  input: ISubFolderDeleteInput;
}>;

export type IDashboardFolderDeleteMutation = { __typename: 'Mutation' } & {
  dashboardFolderDelete: { __typename: 'SubFolderDeletePayload' } & Pick<
    ISubFolderDeletePayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IDashboardFolderRenameMutationVariables = Exact<{
  input: ISubFolderRenameInput;
}>;

export type IDashboardFolderRenameMutation = { __typename: 'Mutation' } & {
  dashboardFolderRename: { __typename: 'DashboardFolderPayload' } & {
    entity: Maybe<
      { __typename: 'DashboardFolder' } & IDashboardFolderFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardReplaceAnalysisMutationVariables = Exact<{
  input: IDashboardReplaceAnalysisInput;
}>;

export type IDashboardReplaceAnalysisMutation = { __typename: 'Mutation' } & {
  dashboardReplaceAnalysis: {
    __typename: 'DashboardReplaceAnalysisPayload';
  } & Pick<
    IDashboardReplaceAnalysisPayload,
    'newAnalysisId' | 'warningMessage'
  > & {
      entity: Maybe<
        { __typename: 'Dashboard' } & IDashboardInstanceFieldsFragment
      >;
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type IDashboardCloneMutationVariables = Exact<{
  input: IDashboardCloneInput;
}>;

export type IDashboardCloneMutation = { __typename: 'Mutation' } & {
  dashboardClone: { __typename: 'DashboardPayload' } & {
    entity: Maybe<
      { __typename: 'Dashboard' } & IDashboardTemplateFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardUnpublishMutationVariables = Exact<{
  input: IDashboardUnpublishInput;
}>;

export type IDashboardUnpublishMutation = { __typename: 'Mutation' } & {
  dashboardUnpublish: { __typename: 'DashboardUnpublishPayload' } & {
    entity: Maybe<
      { __typename: 'Dashboard' } & IDashboardTemplateFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardExecuteMutationVariables = Exact<{
  input: IDashboardExecuteInput;
}>;

export type IDashboardExecuteMutation = { __typename: 'Mutation' } & {
  dashboardExecute: { __typename: 'DashboardExecutePayload' } & {
    dashboard: Maybe<
      { __typename: 'Dashboard' } & IDashboardInstanceFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardEntityPermissionEditMutationVariables = Exact<{
  input: IEntityPermissionEditInput;
}>;

export type IDashboardEntityPermissionEditMutation = {
  __typename: 'Mutation';
} & {
  entityPermissionEdit: { __typename: 'EntityPermissionEditPayload' } & {
    entity: Maybe<
      { __typename: 'EntityPermission' } & IEntityPermissionFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardRefreshMutationVariables = Exact<{
  input: IDashboardRefreshInput;
}>;

export type IDashboardRefreshMutation = { __typename: 'Mutation' } & {
  dashboardRefresh: { __typename: 'DashboardRefreshPayload' } & {
    dashboard: Maybe<
      { __typename: 'Dashboard' } & IDashboardInstanceFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardVisitMutationVariables = Exact<{
  input: IDashboardVisitInput;
}>;

export type IDashboardVisitMutation = { __typename: 'Mutation' } & {
  dashboardVisit: { __typename: 'DashboardVisitPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    visit: Maybe<
      { __typename: 'DashboardVisit' } & Pick<IDashboardVisit, 'baseId'>
    >;
  };
};

export type IDashboardDuplicateAnalysisMutationVariables = Exact<{
  input: IDashboardDuplicateAnalysisInput;
}>;

export type IDashboardDuplicateAnalysisMutation = { __typename: 'Mutation' } & {
  dashboardDuplicateAnalysis: { __typename: 'DashboardPayload' } & {
    entity: Maybe<
      { __typename: 'Dashboard' } & IDashboardInstanceFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardNameEditMutationVariables = Exact<{
  input: IDashboardNameEditInput;
}>;

export type IDashboardNameEditMutation = { __typename: 'Mutation' } & {
  dashboardNameEdit: { __typename: 'DashboardPayload' } & {
    entity: Maybe<
      { __typename: 'Dashboard' } & IDashboardInstanceFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardGridUpdateMutationVariables = Exact<{
  input: IDashboardGridUpdateInput;
}>;

export type IDashboardGridUpdateMutation = { __typename: 'Mutation' } & {
  dashboardGridUpdate: { __typename: 'DashboardPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<
      { __typename: 'Dashboard' } & IDashboardInstanceFieldsFragment
    >;
  };
};

export type IDashboardRichTextAddMutationVariables = Exact<{
  input: IDashboardRichTextAddInput;
}>;

export type IDashboardRichTextAddMutation = { __typename: 'Mutation' } & {
  dashboardRichTextAdd: { __typename: 'DashboardRichTextAddPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    richText: Maybe<{ __typename: 'RichText' } & IRichTextFieldsFragment>;
  };
};

export type IDashboardRichTextEditMutationVariables = Exact<{
  input: IDashboardRichTextEditInput;
}>;

export type IDashboardRichTextEditMutation = { __typename: 'Mutation' } & {
  dashboardRichTextEdit: { __typename: 'DashboardRichTextEditPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    richText: Maybe<{ __typename: 'RichText' } & IRichTextFieldsFragment>;
  };
};

export type IDashboardExternalEmbedAddMutationVariables = Exact<{
  input: IDashboardExternalEmbedAddInput;
}>;

export type IDashboardExternalEmbedAddMutation = { __typename: 'Mutation' } & {
  dashboardExternalEmbedAdd: {
    __typename: 'DashboardExternalEmbedAddPayload';
  } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    externalEmbed: Maybe<
      { __typename: 'ExternalEmbed' } & IExternalEmbedFieldsFragment
    >;
  };
};

export type IDashboardExternalEmbedEditMutationVariables = Exact<{
  input: IDashboardExternalEmbedEditInput;
}>;

export type IDashboardExternalEmbedEditMutation = { __typename: 'Mutation' } & {
  dashboardExternalEmbedEdit: {
    __typename: 'DashboardExternalEmbedEditPayload';
  } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    externalEmbed: Maybe<
      { __typename: 'ExternalEmbed' } & IExternalEmbedFieldsFragment
    >;
  };
};

export type IDashboardImageEmbedAddMutationVariables = Exact<{
  input: IDashboardImageEmbedPostUploadConfigInput;
}>;

export type IDashboardImageEmbedAddMutation = { __typename: 'Mutation' } & {
  dashboardImageEmbedAdd: { __typename: 'DashboardImageEmbedPayload' } & {
    uploadConfig: Maybe<
      {
        __typename: 'DashboardImageEmbedUploadConfig';
      } & IDashboardImageEmbedUploadConfigFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDashboardImageEmbedEditMutationVariables = Exact<{
  input: IDashboardImageEmbedEditInput;
}>;

export type IDashboardImageEmbedEditMutation = { __typename: 'Mutation' } & {
  dashboardImageEmbedEdit: Maybe<
    { __typename: 'DashboardImageEmbedPayload' } & {
      uploadConfig: Maybe<
        {
          __typename: 'DashboardImageEmbedUploadConfig';
        } & IDashboardImageEmbedUploadConfigFieldsFragment
      >;
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    }
  >;
};

export type IDashboardAnalysisAddMutationVariables = Exact<{
  input: IDashboardAnalysisAddInput;
}>;

export type IDashboardAnalysisAddMutation = { __typename: 'Mutation' } & {
  dashboardAnalysisAdd: { __typename: 'DashboardAnalysisAddPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    analysis: Maybe<
      | ({
          __typename: 'CohortSample';
        } & IAnalysisSummaryInfoFields_CohortSample_Fragment)
      | ({
          __typename: 'DataTable';
        } & IAnalysisSummaryInfoFields_DataTable_Fragment)
      | ({
          __typename: 'Expression';
        } & IAnalysisSummaryInfoFields_Expression_Fragment)
      | ({ __typename: 'Funnel' } & IAnalysisSummaryInfoFields_Funnel_Fragment)
      | ({ __typename: 'Path' } & IAnalysisSummaryInfoFields_Path_Fragment)
      | ({
          __typename: 'Prediction';
        } & IAnalysisSummaryInfoFields_Prediction_Fragment)
      | ({
          __typename: 'Retention';
        } & IAnalysisSummaryInfoFields_Retention_Fragment)
      | ({
          __typename: 'Significance';
        } & IAnalysisSummaryInfoFields_Significance_Fragment)
    >;
  };
};

export type IDashboardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  baseId: Scalars['ID']['input'];
}>;

export type IDashboardQuery = { __typename: 'Query' } & {
  dashboard: { __typename: 'Dashboard' } & IDashboardInstanceFieldsFragment;
  folderOfDashboard: {
    __typename: 'DashboardFolder';
  } & IDashboardFolderFieldsFragment;
};

export type IDashboardFromTemplateQueryVariables = Exact<{
  baseId: Scalars['ID']['input'];
}>;

export type IDashboardFromTemplateQuery = { __typename: 'Query' } & {
  dashboardFromTemplate: {
    __typename: 'Dashboard';
  } & IDashboardInstanceFieldsFragment;
  folderOfDashboard: {
    __typename: 'DashboardFolder';
  } & IDashboardFolderFieldsFragment;
};

export type IDashboardConfigQueryVariables = Exact<{ [key: string]: never }>;

export type IDashboardConfigQuery = { __typename: 'Query' } & {
  dashboardConfig: { __typename: 'DashboardConfig' } & Pick<
    IDashboardConfig,
    'defaultStart' | 'defaultEnd'
  > & {
      defaultDatePicker:
        | ({
            __typename: 'DatePickerFixed';
          } & IDatePickerFields_DatePickerFixed_Fragment)
        | ({
            __typename: 'DatePickerLast';
          } & IDatePickerFields_DatePickerLast_Fragment)
        | ({
            __typename: 'DatePickerLastFull';
          } & IDatePickerFields_DatePickerLastFull_Fragment)
        | ({
            __typename: 'DatePickerSince';
          } & IDatePickerFields_DatePickerSince_Fragment)
        | ({
            __typename: 'DatePickerStartOf';
          } & IDatePickerFields_DatePickerStartOf_Fragment);
      logicOps: Array<
        { __typename: 'LogicalOperator' } & ILogicalOperatorFieldsFragment
      >;
    };
};

export type IDashboardFolderQueryVariables = Exact<{
  id: InputMaybe<Scalars['ID']['input']>;
}>;

export type IDashboardFolderQuery = { __typename: 'Query' } & {
  dashboardFolder: {
    __typename: 'DashboardFolder';
  } & IDashboardFolderFieldsFragment;
};

export type IDashboardRedirectQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IDashboardRedirectQueryQuery = { __typename: 'Query' } & {
  dashboard: { __typename: 'Dashboard' } & Pick<IDashboard, 'baseId'>;
};

export type IGetDashboardInstanceQueryVariables = Exact<{
  baseId: Scalars['ID']['input'];
}>;

export type IGetDashboardInstanceQuery = { __typename: 'Query' } & {
  dashboardFromTemplate: {
    __typename: 'Dashboard';
  } & IDashboardInstanceFieldsFragment;
};

export type IGetDashboardTemplatesByScopeQueryVariables = Exact<{
  term: InputMaybe<Scalars['String']['input']>;
  scopes: Array<DashboardTemplateScope> | DashboardTemplateScope;
}>;

export type IGetDashboardTemplatesByScopeQuery = { __typename: 'Query' } & {
  dashboardTemplatesByScope: Array<
    { __typename: 'DashboardTemplateGroup' } & Pick<
      IDashboardTemplateGroup,
      'scope'
    > & {
        entities: Array<
          { __typename: 'Dashboard' } & IDashboardTemplateFieldsFragment
        >;
      }
  >;
};

export type IRawSqlDefinitionMetaFieldsFragment = {
  __typename: 'RawSqlDefinitionMeta';
} & Pick<IRawSqlDefinitionMeta, 'column' | 'rawSql' | 'fullDataRequired'>;

export type IMappedStringDefinitionMetaFieldsFragment = {
  __typename: 'MappedStringDefinitionMeta';
} & Pick<
  IMappedStringDefinitionMeta,
  'column' | 'mappedColumn' | 'mapElse' | 'mapNull'
> & {
    values: Array<
      { __typename: 'MappedValuePair' } & Pick<
        IMappedValuePair,
        'original' | 'mapped'
      >
    >;
  };

type IColumnDefinitionMetaFields_MappedStringDefinitionMeta_Fragment = {
  __typename: 'MappedStringDefinitionMeta';
} & IMappedStringDefinitionMetaFieldsFragment;

type IColumnDefinitionMetaFields_RawSqlDefinitionMeta_Fragment = {
  __typename: 'RawSqlDefinitionMeta';
} & IRawSqlDefinitionMetaFieldsFragment;

export type IColumnDefinitionMetaFieldsFragment =
  | IColumnDefinitionMetaFields_MappedStringDefinitionMeta_Fragment
  | IColumnDefinitionMetaFields_RawSqlDefinitionMeta_Fragment;

export type IStructFieldMetaFieldsFragment = {
  __typename: 'StructFieldMeta';
} & Pick<IStructFieldMeta, 'type' | 'name'>;

export type IStructDefinitionMetaFieldsFragment = {
  __typename: 'StructDefinitionMeta';
} & {
  fields: Array<
    { __typename: 'StructFieldMeta' } & IStructFieldMetaFieldsFragment
  >;
};

export type IMapDefinitionMetaFieldsFragment = {
  __typename: 'MapDefinitionMeta';
} & Pick<IMapDefinitionMeta, 'keyType' | 'valueType'>;

export type IFieldTypeParamsFieldsFragment = {
  __typename: 'FieldTypeParams';
} & Pick<
  IFieldTypeParams,
  'fixedTz' | 'linearDistribution' | 'arrayItemType'
> & {
    customDefinition: Maybe<
      | ({
          __typename: 'MappedStringDefinitionMeta';
        } & IColumnDefinitionMetaFields_MappedStringDefinitionMeta_Fragment)
      | ({
          __typename: 'RawSqlDefinitionMeta';
        } & IColumnDefinitionMetaFields_RawSqlDefinitionMeta_Fragment)
    >;
    structDefinition: Maybe<
      {
        __typename: 'StructDefinitionMeta';
      } & IStructDefinitionMetaFieldsFragment
    >;
    mapDefinition: Maybe<
      { __typename: 'MapDefinitionMeta' } & IMapDefinitionMetaFieldsFragment
    >;
  };

export type ITableFieldFieldsFragment = { __typename: 'TableField' } & Pick<
  ITableField,
  'tableKey' | 'column' | 'type'
> & {
    typeParams: {
      __typename: 'FieldTypeParams';
    } & IFieldTypeParamsFieldsFragment;
  };

export type ISchemaFieldMetaFieldsFragment = {
  __typename: 'SchemaFieldMeta';
} & Pick<
  ISchemaFieldMeta,
  | 'column'
  | 'name'
  | 'type'
  | 'key'
  | 'filter'
  | 'groupby'
  | 'deprecated'
  | 'description'
  | 'fieldClass'
> & {
    tableFields: Array<
      { __typename: 'TableField' } & ITableFieldFieldsFragment
    >;
    derivedDefinition: Maybe<
      | ({
          __typename: 'HardCodedDerivedFieldMeta';
        } & IHardCodedDerivedFieldMetaFieldsFragment)
      | ({
          __typename: 'RawSqlDerivedFieldMeta';
        } & IRawSqlDerivedFieldMetaFieldsFragment)
    >;
  };

export type ITableJoinMetaFieldsFragment = {
  __typename: 'TableJoinMeta';
} & Pick<ITableJoinMeta, 'sqlCondition'> & {
    joinPairs: Array<
      { __typename: 'TableJoinPairMeta' } & Pick<
        ITableJoinPairMeta,
        'factFieldKey' | 'dimTableFieldColumn' | 'relOp'
      >
    >;
    temporalCondition: Maybe<
      { __typename: 'TemporalJoinConditionMeta' } & Pick<
        ITemporalJoinConditionMeta,
        'temporalJoinType' | 'factTemporalKey' | 'dimTemporalKeys'
      >
    >;
  };

export type ICustomJoinMetaFieldsFragment = {
  __typename: 'CustomJoinMeta';
} & Pick<ICustomJoinMeta, 'description'>;

export type ITableMetaFieldsFragment = { __typename: 'TableMeta' } & Pick<
  ITableMeta,
  'key' | 'name' | 'dateRangePredicateColumn' | 'partitionDelegates'
>;

export type IFactFieldsFragment = { __typename: 'FactDataModel' } & Pick<
  IFactDataModel,
  'key' | 'tableKeys'
> & {
    fields: Array<
      { __typename: 'SchemaFieldMeta' } & ISchemaFieldMetaFieldsFragment
    >;
  };

export type IDimensionFieldsFragment = {
  __typename: 'DimensionDataModel';
} & Pick<IDimensionDataModel, 'key' | 'tableKeys'> & {
    fields: Array<
      { __typename: 'SchemaFieldMeta' } & ISchemaFieldMetaFieldsFragment
    >;
    join:
      | ({ __typename: 'CustomJoinMeta' } & ICustomJoinMetaFieldsFragment)
      | ({ __typename: 'TableJoinMeta' } & ITableJoinMetaFieldsFragment);
  };

export type ITableColumnFieldsFragment = { __typename: 'TableColumn' } & Pick<
  ITableColumn,
  'column' | 'type' | 'description'
> & {
    typeParams: {
      __typename: 'FieldTypeParams';
    } & IFieldTypeParamsFieldsFragment;
  };

export type ICdwObjectPathComponentFieldsFragment = {
  __typename: 'CdwObjectPathComponent';
} & Pick<ICdwObjectPathComponent, 'name' | 'displayType'>;

export type ICdwTableFieldsFragment = { __typename: 'CdwTable' } & Pick<
  ICdwTable,
  'shortName' | 'sqlName'
>;

export type ICdwObjectsContainerFieldsFragment = {
  __typename: 'CdwObjectsContainer';
} & {
  path: Array<
    {
      __typename: 'CdwObjectPathComponent';
    } & ICdwObjectPathComponentFieldsFragment
  >;
  containers: Array<
    {
      __typename: 'CdwObjectPathComponent';
    } & ICdwObjectPathComponentFieldsFragment
  >;
  tables: Array<{ __typename: 'CdwTable' } & ICdwTableFieldsFragment>;
};

export type IBasicConnectionMetaFieldsFragment = {
  __typename: 'BasicConnectionMeta';
} & Pick<
  IBasicConnectionMeta,
  'strategy' | 'jdbcUrl' | 'username' | 'timeout' | 'authType'
>;

export type IBigQueryConnectionMetaFieldsFragment = {
  __typename: 'BigQueryConnectionMeta';
} & Pick<
  IBigQueryConnectionMeta,
  | 'strategy'
  | 'jdbcUrl'
  | 'account'
  | 'projectId'
  | 'computeProjectId'
  | 'dataset'
  | 'timeout'
>;

export type ICurrentEndDateMetaFieldsFragment = {
  __typename: 'CurrentEndDateMeta';
} & Pick<ICurrentEndDateMeta, 'kind'>;

export type IStartEndDateMetaFieldsFragment = {
  __typename: 'StartEndDateMeta';
} & Pick<IStartEndDateMeta, 'kind' | 'startTimeUnit'>;

export type IStaticEndDateMetaFieldsFragment = {
  __typename: 'StaticEndDateMeta';
} & Pick<IStaticEndDateMeta, 'kind' | 'staticDate' | 'staticDateAsLiveStart'>;

export type IRollingEndDateMetaFieldsFragment = {
  __typename: 'RollingEndDateMeta';
} & Pick<IRollingEndDateMeta, 'kind' | 'rollingCount' | 'rollingTimeUnit'>;

export type IDataRefreshConfigMetaFieldsFragment = {
  __typename: 'DataRefreshConfigMeta';
} & Pick<
  IDataRefreshConfigMeta,
  | 'lookBackSeconds'
  | 'minimumRefreshSeconds'
  | 'pfvStringMaxLength'
  | 'pfvMaxNumOfValuesPerKey'
>;

export type ISchemaDsConfigFieldsFragment = {
  __typename: 'SchemaDsConfig';
} & Pick<ISchemaDsConfig, 'dateDt' | 'timezone' | 'weekStart'> & {
    path: Array<
      {
        __typename: 'CdwObjectPathComponent';
      } & ICdwObjectPathComponentFieldsFragment
    >;
    connection:
      | ({
          __typename: 'BasicConnectionMeta';
        } & IBasicConnectionMetaFieldsFragment)
      | ({
          __typename: 'BigQueryConnectionMeta';
        } & IBigQueryConnectionMetaFieldsFragment);
    endDate:
      | ({
          __typename: 'CurrentEndDateMeta';
        } & ICurrentEndDateMetaFieldsFragment)
      | ({
          __typename: 'RollingEndDateMeta';
        } & IRollingEndDateMetaFieldsFragment)
      | ({ __typename: 'StartEndDateMeta' } & IStartEndDateMetaFieldsFragment)
      | ({
          __typename: 'StaticEndDateMeta';
        } & IStaticEndDateMetaFieldsFragment);
  };

export type IDataModelTemporalFieldRefFieldsFragment = {
  __typename: 'DataModelTemporalFieldRef';
} & Pick<IDataModelTemporalFieldRef, 'fieldKey'> & {
    columnRefs: Array<
      { __typename: 'DataModelTemporalColumnRef' } & Pick<
        IDataModelTemporalColumnRef,
        'tableKey' | 'column' | 'isAutoGenerated'
      >
    >;
  };

export type IDataModelTemporalFieldRefsFieldsFragment = {
  __typename: 'DataModelTemporalFieldRefs';
} & Pick<IDataModelTemporalFieldRefs, 'viewKey'> & {
    ts: Maybe<
      {
        __typename: 'DataModelTemporalFieldRef';
      } & IDataModelTemporalFieldRefFieldsFragment
    >;
    hourOfDay: Maybe<
      {
        __typename: 'DataModelTemporalFieldRef';
      } & IDataModelTemporalFieldRefFieldsFragment
    >;
    date: {
      __typename: 'DataModelTemporalFieldRef';
    } & IDataModelTemporalFieldRefFieldsFragment;
    dayOfWeek: {
      __typename: 'DataModelTemporalFieldRef';
    } & IDataModelTemporalFieldRefFieldsFragment;
    week: {
      __typename: 'DataModelTemporalFieldRef';
    } & IDataModelTemporalFieldRefFieldsFragment;
    fourWeek: {
      __typename: 'DataModelTemporalFieldRef';
    } & IDataModelTemporalFieldRefFieldsFragment;
    month: {
      __typename: 'DataModelTemporalFieldRef';
    } & IDataModelTemporalFieldRefFieldsFragment;
    quarter: {
      __typename: 'DataModelTemporalFieldRef';
    } & IDataModelTemporalFieldRefFieldsFragment;
    year: {
      __typename: 'DataModelTemporalFieldRef';
    } & IDataModelTemporalFieldRefFieldsFragment;
  };

export type IFunnelPartitionFieldsFragment = {
  __typename: 'FunnelPartition';
} & Pick<IFunnelPartition, 'fieldKey' | 'name' | 'key'>;

export type ISchemaDataModelFieldsFragment = {
  __typename: 'SchemaDataModel';
} & Pick<
  ISchemaDataModel,
  'key' | 'name' | 'disabled' | 'version' | 'lockedTtlSeconds' | 'description'
> & {
    tables: Array<{ __typename: 'TableMeta' } & ITableMetaFieldsFragment>;
    eventTemporals: {
      __typename: 'DataModelTemporalFieldRefs';
    } & IDataModelTemporalFieldRefsFieldsFragment;
    installTemporals: Maybe<
      {
        __typename: 'DataModelTemporalFieldRefs';
      } & IDataModelTemporalFieldRefsFieldsFragment
    >;
    fact: { __typename: 'FactDataModel' } & IFactFieldsFragment;
    dimensions: Array<
      { __typename: 'DimensionDataModel' } & IDimensionFieldsFragment
    >;
    derivedFields: Array<
      { __typename: 'SchemaFieldMeta' } & ISchemaFieldMetaFieldsFragment
    >;
    dsConfig: { __typename: 'SchemaDsConfig' } & ISchemaDsConfigFieldsFragment;
    subjects: Array<
      { __typename: 'DataModelSubjectRef' } & Pick<
        IDataModelSubjectRef,
        'viewKey' | 'fieldKey' | 'subjectKey' | 'name'
      >
    >;
    sampling: { __typename: 'DataModelSamplingConfig' } & Pick<
      IDataModelSamplingConfig,
      'default' | 'cohort'
    >;
    funnelPartitions: Array<
      { __typename: 'FunnelPartition' } & IFunnelPartitionFieldsFragment
    >;
    dataRefresh: {
      __typename: 'DataRefreshConfigMeta';
    } & IDataRefreshConfigMetaFieldsFragment;
  };

export type IPreviewColumnDataFieldsFragment = {
  __typename: 'PreviewColumnData';
} & Pick<IPreviewColumnData, 'column' | 'type' | 'values'>;

export type IDataModelCreateMutationVariables = Exact<{
  input: IDataModelCreateInput;
}>;

export type IDataModelCreateMutation = { __typename: 'Mutation' } & {
  dataModelCreate: { __typename: 'DataModelPayload' } & {
    entity: Maybe<
      { __typename: 'SchemaDataModel' } & ISchemaDataModelFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field' | 'messages'>>;
  };
};

export type IDataModelUpdateMutationVariables = Exact<{
  input: IDataModelUpdateInput;
}>;

export type IDataModelUpdateMutation = { __typename: 'Mutation' } & {
  dataModelUpdate: { __typename: 'DataModelPayload' } & {
    entity: Maybe<
      { __typename: 'SchemaDataModel' } & ISchemaDataModelFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field' | 'messages'>>;
  };
};

export type ISchemaDataModelQueryVariables = Exact<{
  schemaKey: Scalars['String']['input'];
}>;

export type ISchemaDataModelQuery = { __typename: 'Query' } & {
  schemaDataModel: {
    __typename: 'SchemaDataModel';
  } & ISchemaDataModelFieldsFragment;
};

export type IDataModelListSchemaTableColumnsQueryVariables = Exact<{
  schemaKey: Scalars['String']['input'];
  viewKey: InputMaybe<Scalars['String']['input']>;
  tableKey: InputMaybe<Scalars['String']['input']>;
  sqlTableName: InputMaybe<Scalars['String']['input']>;
  connection?: InputMaybe<IConnectionInput>;
  term?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<IPagination>;
}>;

export type IDataModelListSchemaTableColumnsQuery = { __typename: 'Query' } & {
  dataModelListSchemaTableColumns: {
    __typename: 'TableColumnPaginated';
  } & Pick<ITableColumnPaginated, 'errors'> & {
      entities: Array<
        { __typename: 'TableColumn' } & ITableColumnFieldsFragment
      >;
      pageInfo: { __typename: 'PageInfo' } & IPageInfoFieldsFragment;
    };
};

export type IDataModelListCdwTableColumnsQueryVariables = Exact<{
  connection: IConnectionInput;
  sqlTableName: Scalars['String']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<IPagination>;
}>;

export type IDataModelListCdwTableColumnsQuery = { __typename: 'Query' } & {
  dataModelListCdwTableColumns: { __typename: 'TableColumnPaginated' } & Pick<
    ITableColumnPaginated,
    'errors'
  > & {
      entities: Array<
        { __typename: 'TableColumn' } & ITableColumnFieldsFragment
      >;
      pageInfo: { __typename: 'PageInfo' } & IPageInfoFieldsFragment;
    };
};

export type IDataModelListCdwObjectsQueryVariables = Exact<{
  schemaKey: InputMaybe<Scalars['String']['input']>;
  connection: InputMaybe<IConnectionInput>;
  path: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
}>;

export type IDataModelListCdwObjectsQuery = { __typename: 'Query' } & {
  dataModelListCdwObjects: { __typename: 'DataModelCdwObjectsResult' } & Pick<
    IDataModelCdwObjectsResult,
    'errors'
  > & {
      result: Maybe<
        {
          __typename: 'CdwObjectsContainer';
        } & ICdwObjectsContainerFieldsFragment
      >;
    };
};

export type IDataModelTestConnectionQueryVariables = Exact<{
  connection: IConnectionInput;
}>;

export type IDataModelTestConnectionQuery = { __typename: 'Query' } & {
  dataModelTestConnection: {
    __typename: 'DataModelTestConnectionResult';
  } & Pick<IDataModelTestConnectionResult, 'success' | 'errors'>;
};

export type IDataModelPreviewColumnsDataQueryVariables = Exact<{
  schemaKey: InputMaybe<Scalars['String']['input']>;
  tableKey: InputMaybe<Scalars['String']['input']>;
  connection: InputMaybe<IConnectionInput>;
  sqlTableName: InputMaybe<Scalars['String']['input']>;
  draftColumns: Array<IColumnWithTypeInput> | IColumnWithTypeInput;
  selectColumns: Array<IColumnWithTypeInput> | IColumnWithTypeInput;
  expandReferences: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
}>;

export type IDataModelPreviewColumnsDataQuery = { __typename: 'Query' } & {
  dataModelPreviewColumnsData: { __typename: 'PreviewColumnsData' } & Pick<
    IPreviewColumnsData,
    'sqlQuery' | 'errors'
  > & {
      columns: Array<
        { __typename: 'PreviewColumnData' } & IPreviewColumnDataFieldsFragment
      >;
    };
};

export type IDataRefreshMetaFieldsFragment = {
  __typename: 'DataRefreshMeta';
} & Pick<IDataRefreshMeta, 'latestRefreshAt' | 'refreshState'>;

export type IRefreshEventDataMutationVariables = Exact<{
  input: IEventRefreshInput;
}>;

export type IRefreshEventDataMutation = { __typename: 'Mutation' } & {
  eventRefresh: { __typename: 'EventRefreshPayload' } & Pick<
    IEventRefreshPayload,
    'entity'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IRefreshFieldDataMutationVariables = Exact<{
  input: IFieldRefreshInput;
}>;

export type IRefreshFieldDataMutation = { __typename: 'Mutation' } & {
  fieldRefresh: { __typename: 'FieldRefreshPayload' } & Pick<
    IFieldRefreshPayload,
    'entity'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IGetEventDataRefreshQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
}>;

export type IGetEventDataRefreshQuery = { __typename: 'Query' } & {
  eventRefreshMeta: {
    __typename: 'DataRefreshMeta';
  } & IDataRefreshMetaFieldsFragment;
};

export type IGetFieldDataRefreshQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
  fieldKey: Scalars['String']['input'];
}>;

export type IGetFieldDataRefreshQuery = { __typename: 'Query' } & {
  fieldRefreshMeta: {
    __typename: 'DataRefreshMeta';
  } & IDataRefreshMetaFieldsFragment;
};

export type IComputeAbsoluteTimePeriodQueryVariables = Exact<{
  input: IRelativeTimePeriodComputeInput;
}>;

export type IComputeAbsoluteTimePeriodQuery = { __typename: 'Query' } & {
  absoluteTimePeriodCompute: { __typename: 'DateRange' } & Pick<
    IDateRange,
    'start' | 'end'
  >;
};

export type IEntityCategoryFieldsFragment = {
  __typename: 'EntityCategory';
} & Pick<IEntityCategory, 'id' | 'name' | 'color' | 'isEmpty'> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id' | 'name'>;
  };

export type IEntityCategoryCreateMutationVariables = Exact<{
  input: IEntityCategoryCreateInput;
}>;

export type IEntityCategoryCreateMutation = { __typename: 'Mutation' } & {
  entityCategoryCreate: { __typename: 'EntityCategoryCreatePayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };
};

export type IGetEntityCategoriesQueryVariables = Exact<{
  schemaIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
  includes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  pagination: IPagination;
}>;

export type IGetEntityCategoriesQuery = { __typename: 'Query' } & {
  entityCategories: Maybe<
    { __typename: 'EntityCategoriesPaginated' } & {
      entities: Array<
        { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
      >;
    }
  >;
};

type ITagNodeFields_TagBranch_Fragment = { __typename: 'TagBranch' } & Pick<
  ITagBranch,
  'name' | 'count'
>;

type ITagNodeFields_TagFieldInlineBranch_Fragment = {
  __typename: 'TagFieldInlineBranch';
} & Pick<
  ITagFieldInlineBranch,
  'key' | 'count' | 'name' | 'isFavorite' | 'type'
>;

type ITagNodeFields_TagInlineBranch_Fragment = {
  __typename: 'TagInlineBranch';
} & Pick<ITagInlineBranch, 'key' | 'count' | 'name' | 'isFavorite' | 'type'>;

type ITagNodeFields_TagLeafAnyEvent_Fragment = {
  __typename: 'TagLeafAnyEvent';
} & Pick<ITagLeafAnyEvent, 'key' | 'name'>;

type ITagNodeFields_TagLeafAnyTableEvent_Fragment = {
  __typename: 'TagLeafAnyTableEvent';
} & Pick<ITagLeafAnyTableEvent, 'key' | 'name'>;

type ITagNodeFields_TagLeafBasicEvent_Fragment = {
  __typename: 'TagLeafBasicEvent';
} & Pick<ITagLeafBasicEvent, 'key' | 'name' | 'isFavorite'>;

type ITagNodeFields_TagLeafCompoundCohort_Fragment = {
  __typename: 'TagLeafCompoundCohort';
} & Pick<ITagLeafCompoundCohort, 'id' | 'name' | 'isFavorite'>;

type ITagNodeFields_TagLeafCompoundMeasure_Fragment = {
  __typename: 'TagLeafCompoundMeasure';
} & Pick<ITagLeafCompoundMeasure, 'id' | 'name' | 'isFavorite'>;

type ITagNodeFields_TagLeafCustomBucketDef_Fragment = {
  __typename: 'TagLeafCustomBucketDef';
} & Pick<ITagLeafCustomBucketDef, 'kind' | 'name'>;

type ITagNodeFields_TagLeafDateBucketDef_Fragment = {
  __typename: 'TagLeafDateBucketDef';
} & Pick<ITagLeafDateBucketDef, 'id' | 'name' | 'isFavorite'>;

type ITagNodeFields_TagLeafEnumBucketDef_Fragment = {
  __typename: 'TagLeafEnumBucketDef';
} & Pick<ITagLeafEnumBucketDef, 'id' | 'name' | 'isFavorite'>;

type ITagNodeFields_TagLeafField_Fragment = {
  __typename: 'TagLeafField';
} & Pick<ITagLeafField, 'key' | 'name' | 'isFavorite' | 'isGeo'>;

type ITagNodeFields_TagLeafFilter_Fragment = {
  __typename: 'TagLeafFilter';
} & Pick<ITagLeafFilter, 'id' | 'name' | 'isFavorite'>;

type ITagNodeFields_TagLeafRangeBucketDef_Fragment = {
  __typename: 'TagLeafRangeBucketDef';
} & Pick<ITagLeafRangeBucketDef, 'id' | 'name' | 'isFavorite'>;

type ITagNodeFields_TagLeafSeparator_Fragment = {
  __typename: 'TagLeafSeparator';
} & Pick<ITagLeafSeparator, 'dummy'>;

type ITagNodeFields_TagLeafSimpleCohort_Fragment = {
  __typename: 'TagLeafSimpleCohort';
} & Pick<ITagLeafSimpleCohort, 'id' | 'name' | 'isFavorite'>;

type ITagNodeFields_TagLeafSimpleMeasure_Fragment = {
  __typename: 'TagLeafSimpleMeasure';
} & Pick<ITagLeafSimpleMeasure, 'id' | 'name' | 'isFavorite'>;

type ITagNodeFields_TagLeafVirtualEvent_Fragment = {
  __typename: 'TagLeafVirtualEvent';
} & Pick<ITagLeafVirtualEvent, 'id' | 'name' | 'isFavorite'>;

type ITagNodeFields_TagRoot_Fragment = { __typename: 'TagRoot' } & Pick<
  ITagRoot,
  'dummy'
>;

export type ITagNodeFieldsFragment =
  | ITagNodeFields_TagBranch_Fragment
  | ITagNodeFields_TagFieldInlineBranch_Fragment
  | ITagNodeFields_TagInlineBranch_Fragment
  | ITagNodeFields_TagLeafAnyEvent_Fragment
  | ITagNodeFields_TagLeafAnyTableEvent_Fragment
  | ITagNodeFields_TagLeafBasicEvent_Fragment
  | ITagNodeFields_TagLeafCompoundCohort_Fragment
  | ITagNodeFields_TagLeafCompoundMeasure_Fragment
  | ITagNodeFields_TagLeafCustomBucketDef_Fragment
  | ITagNodeFields_TagLeafDateBucketDef_Fragment
  | ITagNodeFields_TagLeafEnumBucketDef_Fragment
  | ITagNodeFields_TagLeafField_Fragment
  | ITagNodeFields_TagLeafFilter_Fragment
  | ITagNodeFields_TagLeafRangeBucketDef_Fragment
  | ITagNodeFields_TagLeafSeparator_Fragment
  | ITagNodeFields_TagLeafSimpleCohort_Fragment
  | ITagNodeFields_TagLeafSimpleMeasure_Fragment
  | ITagNodeFields_TagLeafVirtualEvent_Fragment
  | ITagNodeFields_TagRoot_Fragment;

export type ITagMappingFieldsFragment = { __typename: 'TagMapping' } & Pick<
  ITagMapping,
  'parentIndex' | 'childrenIndex'
>;

export type ISearchTagsQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
  searchTerm: InputMaybe<Scalars['String']['input']>;
  tags: Array<ITagOptionInput> | ITagOptionInput;
  managedOnly: Scalars['Boolean']['input'];
}>;

export type ISearchTagsQuery = { __typename: 'Query' } & {
  searchTags: { __typename: 'SearchTagPayload' } & Pick<
    ISearchTagPayload,
    'defaultNodeIndex'
  > & {
      nodes: Array<
        | ({ __typename: 'TagBranch' } & ITagNodeFields_TagBranch_Fragment)
        | ({
            __typename: 'TagFieldInlineBranch';
          } & ITagNodeFields_TagFieldInlineBranch_Fragment)
        | ({
            __typename: 'TagInlineBranch';
          } & ITagNodeFields_TagInlineBranch_Fragment)
        | ({
            __typename: 'TagLeafAnyEvent';
          } & ITagNodeFields_TagLeafAnyEvent_Fragment)
        | ({
            __typename: 'TagLeafAnyTableEvent';
          } & ITagNodeFields_TagLeafAnyTableEvent_Fragment)
        | ({
            __typename: 'TagLeafBasicEvent';
          } & ITagNodeFields_TagLeafBasicEvent_Fragment)
        | ({
            __typename: 'TagLeafCompoundCohort';
          } & ITagNodeFields_TagLeafCompoundCohort_Fragment)
        | ({
            __typename: 'TagLeafCompoundMeasure';
          } & ITagNodeFields_TagLeafCompoundMeasure_Fragment)
        | ({
            __typename: 'TagLeafCustomBucketDef';
          } & ITagNodeFields_TagLeafCustomBucketDef_Fragment)
        | ({
            __typename: 'TagLeafDateBucketDef';
          } & ITagNodeFields_TagLeafDateBucketDef_Fragment)
        | ({
            __typename: 'TagLeafEnumBucketDef';
          } & ITagNodeFields_TagLeafEnumBucketDef_Fragment)
        | ({
            __typename: 'TagLeafField';
          } & ITagNodeFields_TagLeafField_Fragment)
        | ({
            __typename: 'TagLeafFilter';
          } & ITagNodeFields_TagLeafFilter_Fragment)
        | ({
            __typename: 'TagLeafRangeBucketDef';
          } & ITagNodeFields_TagLeafRangeBucketDef_Fragment)
        | ({
            __typename: 'TagLeafSeparator';
          } & ITagNodeFields_TagLeafSeparator_Fragment)
        | ({
            __typename: 'TagLeafSimpleCohort';
          } & ITagNodeFields_TagLeafSimpleCohort_Fragment)
        | ({
            __typename: 'TagLeafSimpleMeasure';
          } & ITagNodeFields_TagLeafSimpleMeasure_Fragment)
        | ({
            __typename: 'TagLeafVirtualEvent';
          } & ITagNodeFields_TagLeafVirtualEvent_Fragment)
        | ({ __typename: 'TagRoot' } & ITagNodeFields_TagRoot_Fragment)
      >;
      mapping: Array<{ __typename: 'TagMapping' } & ITagMappingFieldsFragment>;
    };
};

export type IAnyEventFieldsFragment = { __typename: 'AnyEvent' } & Pick<
  IAnyEvent,
  'kind' | 'name'
>;

export type IAnyTableEventFieldsFragment = {
  __typename: 'AnyTableEvent';
} & Pick<IAnyTableEvent, 'kind' | 'name' | 'key'>;

export type IEventConditionFieldsFragment = { __typename: 'EventCondition' } & {
  field: Maybe<{ __typename: 'Field' } & IFieldFieldsFragment>;
  events: Array<
    | ({ __typename: 'AnyEvent' } & IAnyEventFieldsFragment)
    | ({ __typename: 'AnyTableEvent' } & IAnyTableEventFieldsFragment)
    | ({ __typename: 'BasicEventValue' } & IBasicEventValueFieldsFragment)
    | ({ __typename: 'VirtualEvent' } & IVirtualEventFieldsFragment)
  >;
  filter: Maybe<
    | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
    | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
  >;
};

export type IExternalEmbedFieldsFragment = {
  __typename: 'ExternalEmbed';
} & Pick<IExternalEmbed, 'id' | 'url'>;

export type IFavoriteBasicEventMutationVariables = Exact<{
  input: IFavoriteBasicEventInput;
}>;

export type IFavoriteBasicEventMutation = { __typename: 'Mutation' } & {
  favoriteBasicEvent: { __typename: 'FavoritePayload' } & Pick<
    IFavoritePayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IFavoriteFieldMutationVariables = Exact<{
  input: IFavoriteFieldInput;
}>;

export type IFavoriteFieldMutation = { __typename: 'Mutation' } & {
  favoriteField: { __typename: 'FavoritePayload' } & Pick<
    IFavoritePayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IFavoriteVersionEntityMutationVariables = Exact<{
  input: IFavoriteVersionEntityInput;
}>;

export type IFavoriteVersionEntityMutation = { __typename: 'Mutation' } & {
  favoriteVersionEntity: { __typename: 'FavoritePayload' } & Pick<
    IFavoritePayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IFavoriteAnalysisMutationVariables = Exact<{
  input: IFavoriteAnalysisInput;
}>;

export type IFavoriteAnalysisMutation = { __typename: 'Mutation' } & {
  favoriteAnalysis: { __typename: 'FavoritePayload' } & Pick<
    IFavoritePayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type INestedFieldMetadataFieldsFragment = {
  __typename: 'NestedFieldMetadata';
} & Pick<INestedFieldMetadata, 'type' | 'name' | 'fieldKey' | 'key'>;

export type IBasicFieldValueFieldsFragment = {
  __typename: 'BasicFieldValue';
} & Pick<IBasicFieldValue, 'key' | 'name' | 'isDisabled' | 'description'>;

export type IAnyFieldValueFieldsFragment = {
  __typename: 'AnyFieldValue';
} & Pick<IAnyFieldValue, 'name'>;

export type IFieldValueParentFieldsFragment = {
  __typename: 'FieldValueParent';
} & Pick<IFieldValueParent, 'key'>;

export type IParentFieldValueFieldsFragment = {
  __typename: 'ParentFieldValue';
} & Pick<IParentFieldValue, 'refreshable'> & {
    valueParent: Maybe<
      { __typename: 'FieldValueParent' } & IFieldValueParentFieldsFragment
    >;
  };

export type IFieldFieldsFragment = { __typename: 'Field' } & Pick<
  IField,
  | 'key'
  | 'name'
  | 'type'
  | 'bucketKinds'
  | 'valueHint'
  | 'description'
  | 'searchable'
  | 'isFavorite'
  | 'isManaged'
  | 'isGeo'
  | 'tableNames'
  | 'isFactField'
> & {
    pfv: { __typename: 'ParentFieldValue' } & IParentFieldValueFieldsFragment;
    relOps: Array<
      { __typename: 'RelationalOperator' } & IRelationalOperatorFieldsFragment
    >;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
    nestedFieldMetadata: Maybe<
      { __typename: 'NestedFieldMetadata' } & INestedFieldMetadataFieldsFragment
    >;
  };

export type IHardCodedDerivedFieldMetaFieldsFragment = {
  __typename: 'HardCodedDerivedFieldMeta';
} & Pick<IHardCodedDerivedFieldMeta, 'description'>;

export type IRawSqlDerivedFieldMetaFieldsFragment = {
  __typename: 'RawSqlDerivedFieldMeta';
} & Pick<IRawSqlDerivedFieldMeta, 'rawSql' | 'fullDataRequired'>;

export type IDictionaryFieldFieldsFragment = { __typename: 'Field' } & Pick<
  IField,
  | 'key'
  | 'column'
  | 'type'
  | 'name'
  | 'description'
  | 'isFavorite'
  | 'isManaged'
  | 'tableNames'
> & {
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
    nestedFieldMetadata: Maybe<
      { __typename: 'NestedFieldMetadata' } & INestedFieldMetadataFieldsFragment
    >;
    derivedDefinition: Maybe<
      | ({
          __typename: 'HardCodedDerivedFieldMeta';
        } & IHardCodedDerivedFieldMetaFieldsFragment)
      | ({
          __typename: 'RawSqlDerivedFieldMeta';
        } & IRawSqlDerivedFieldMetaFieldsFragment)
    >;
  };

export type IFieldAddCategoryMutationVariables = Exact<{
  input: IFieldEditCategoryInput;
}>;

export type IFieldAddCategoryMutation = { __typename: 'Mutation' } & {
  fieldAddCategory: { __typename: 'FieldEditCategoryPayload' } & Pick<
    IFieldEditCategoryPayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IFieldRemoveCategoryMutationVariables = Exact<{
  input: IFieldEditCategoryInput;
}>;

export type IFieldRemoveCategoryMutation = { __typename: 'Mutation' } & {
  fieldRemoveCategory: { __typename: 'FieldEditCategoryPayload' } & Pick<
    IFieldEditCategoryPayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

type IOperandsFields_FieldOperands_Fragment = {
  __typename: 'FieldOperands';
} & { fields: Array<{ __typename: 'Field' } & IFieldFieldsFragment> };

type IOperandsFields_ValueOperands_Fragment = {
  __typename: 'ValueOperands';
} & {
  values: Array<
    | ({ __typename: 'AnyFieldValue' } & IAnyFieldValueFieldsFragment)
    | ({ __typename: 'BasicFieldValue' } & IBasicFieldValueFieldsFragment)
  >;
};

export type IOperandsFieldsFragment =
  | IOperandsFields_FieldOperands_Fragment
  | IOperandsFields_ValueOperands_Fragment;

export type ISimplePredicateFieldsFragment = {
  __typename: 'SimplePredicate';
} & Pick<ISimplePredicate, 'matchCase'> & {
    field: { __typename: 'Field' } & IFieldFieldsFragment;
    relOp: {
      __typename: 'RelationalOperator';
    } & IRelationalOperatorFieldsFragment;
    operands:
      | ({
          __typename: 'FieldOperands';
        } & IOperandsFields_FieldOperands_Fragment)
      | ({
          __typename: 'ValueOperands';
        } & IOperandsFields_ValueOperands_Fragment);
  };

export type IArrayObjectPredicateFieldsFragment = {
  __typename: 'ArrayObjectPredicate';
} & {
  elementPredicates: Array<
    { __typename: 'SimplePredicate' } & ISimplePredicateFieldsFragment
  >;
};

type IPredicateFields_ArrayObjectPredicate_Fragment = {
  __typename: 'ArrayObjectPredicate';
} & IArrayObjectPredicateFieldsFragment;

type IPredicateFields_SimplePredicate_Fragment = {
  __typename: 'SimplePredicate';
} & ISimplePredicateFieldsFragment;

export type IPredicateFieldsFragment =
  | IPredicateFields_ArrayObjectPredicate_Fragment
  | IPredicateFields_SimplePredicate_Fragment;

export type IConditionFieldsFragment = { __typename: 'Condition' } & {
  predicates: Array<
    | ({
        __typename: 'ArrayObjectPredicate';
      } & IPredicateFields_ArrayObjectPredicate_Fragment)
    | ({
        __typename: 'SimplePredicate';
      } & IPredicateFields_SimplePredicate_Fragment)
  >;
  logicOps: Array<
    { __typename: 'LogicalOperator' } & ILogicalOperatorFieldsFragment
  >;
};

export type IBasicFilterFieldsFragment = { __typename: 'BasicFilter' } & Pick<
  IBasicFilter,
  'type'
> & {
    conditions: Array<{ __typename: 'Condition' } & IConditionFieldsFragment>;
    logicOps: Array<
      { __typename: 'LogicalOperator' } & ILogicalOperatorFieldsFragment
    >;
  };

export type INamedFilterFieldsFragment = { __typename: 'NamedFilter' } & Pick<
  INamedFilter,
  | 'type'
  | 'id'
  | 'name'
  | 'description'
  | 'version'
  | 'comment'
  | 'isLatestVersion'
  | 'isDisabled'
  | 'createdAt'
  | 'editedAt'
  | 'isFavorite'
  | 'isManaged'
> & {
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    editor: { __typename: 'User' } & IEditorFieldsFragment;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    conditions: Array<{ __typename: 'Condition' } & IConditionFieldsFragment>;
    logicOps: Array<
      { __typename: 'LogicalOperator' } & ILogicalOperatorFieldsFragment
    >;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };

type IFilterFields_BasicFilter_Fragment = {
  __typename: 'BasicFilter';
} & IBasicFilterFieldsFragment;

type IFilterFields_NamedFilter_Fragment = {
  __typename: 'NamedFilter';
} & INamedFilterFieldsFragment;

export type IFilterFieldsFragment =
  | IFilterFields_BasicFilter_Fragment
  | IFilterFields_NamedFilter_Fragment;

export type IGetNamedFilterQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IGetNamedFilterQuery = { __typename: 'Query' } & {
  namedFilter: { __typename: 'NamedFilter' } & INamedFilterFieldsFragment;
};

export type INamedFilterAddCategoryMutationVariables = Exact<{
  input: INamedEntityEditCategoryInput;
}>;

export type INamedFilterAddCategoryMutation = { __typename: 'Mutation' } & {
  namedFilterAddCategory: {
    __typename: 'NamedEntityEditCategoryPayload';
  } & Pick<INamedEntityEditCategoryPayload, 'message'> & {
      errors: Array<
        { __typename: 'Error' } & Pick<IError, 'field' | 'messages'>
      >;
    };
};

export type INamedFilterRemoveCategoryMutationVariables = Exact<{
  input: INamedEntityEditCategoryInput;
}>;

export type INamedFilterRemoveCategoryMutation = { __typename: 'Mutation' } & {
  namedFilterRemoveCategory: {
    __typename: 'NamedEntityEditCategoryPayload';
  } & Pick<INamedEntityEditCategoryPayload, 'message'> & {
      errors: Array<
        { __typename: 'Error' } & Pick<IError, 'field' | 'messages'>
      >;
    };
};

export type IUserSettingFieldsFragment = { __typename: 'UserSetting' } & Pick<
  IUserSetting,
  'kind' | 'value'
>;

export type ICreatorFieldsFragment = { __typename: 'User' } & Pick<
  IUser,
  'id' | 'name' | 'email' | 'picture'
>;

export type IEditorFieldsFragment = { __typename: 'User' } & Pick<
  IUser,
  'id' | 'name' | 'email' | 'picture'
>;

export type IUserFieldsFragment = { __typename: 'User' } & Pick<
  IUser,
  'id' | 'email' | 'name' | 'picture' | 'lastLogin' | 'createdAt' | 'state'
> & {
    defaultSchemaSetting: {
      __typename: 'UserSetting';
    } & IUserSettingFieldsFragment;
    defaultViewSetting: {
      __typename: 'UserSetting';
    } & IUserSettingFieldsFragment;
    quickAccessDictionarySetting: {
      __typename: 'UserSetting';
    } & IUserSettingFieldsFragment;
    slackInstallation: Maybe<
      { __typename: 'SlackInstallation' } & ISlackInstallationFieldsFragment
    >;
  };

export type IPageInfoFieldsFragment = { __typename: 'PageInfo' } & Pick<
  IPageInfo,
  'total' | 'last' | 'hasMore' | 'first'
>;

export type IErrorFieldsFragment = { __typename: 'Error' } & Pick<
  IError,
  'field' | 'messages'
>;

export type ISubjectFieldsFragment = { __typename: 'Subject' } & Pick<
  ISubject,
  'key' | 'name'
>;

export type ISchemaFieldsFragment = { __typename: 'Schema' } & Pick<
  ISchema,
  | 'id'
  | 'name'
  | 'supportsAnyEvent'
  | 'disabled'
  | 'latestDataAt'
  | 'description'
  | 'requiredPermission'
  | 'isInternal'
>;

export type ILogicalOperatorFieldsFragment = {
  __typename: 'LogicalOperator';
} & Pick<ILogicalOperator, 'key' | 'name'>;

export type IMeasureFunctionFieldsFragment = {
  __typename: 'MeasureFunction';
} & Pick<
  IMeasureFunction,
  | 'key'
  | 'name'
  | 'fieldRequired'
  | 'requirePercentile'
  | 'forceBreakdownOverall'
>;

export type IRelationalOperatorFieldsFragment = {
  __typename: 'RelationalOperator';
} & Pick<
  IRelationalOperator,
  'key' | 'name' | 'values' | 'supportCaseInsensitive'
>;

export type IUserAliasQueryMeasureFieldsFragment = {
  __typename: 'UserAliasQueryMeasure';
} & Pick<IUserAliasQueryMeasure, 'aliasId'>;

export type IVersionFieldsFragment = { __typename: 'Version' } & Pick<
  IVersion,
  | 'baseId'
  | 'comment'
  | 'createdAt'
  | 'editedAt'
  | 'description'
  | 'entityId'
  | 'isDisabled'
  | 'isLatestVersion'
  | 'name'
  | 'version'
  | 'versionId'
> & {
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    editor: { __typename: 'User' } & IEditorFieldsFragment;
  };

export type IDateRangeFieldsFragment = { __typename: 'DateRange' } & Pick<
  IDateRange,
  'start' | 'end'
>;

type IPartitionFields_ConversionWindowPartition_Fragment = {
  __typename: 'ConversionWindowPartition';
} & Pick<IConversionWindowPartition, 'key' | 'name'>;

type IPartitionFields_FieldPartition_Fragment = {
  __typename: 'FieldPartition';
} & Pick<IFieldPartition, 'key' | 'name'> & {
    field: { __typename: 'Field' } & Pick<IField, 'type'>;
  };

type IPartitionFields_NonePartition_Fragment = {
  __typename: 'NonePartition';
} & Pick<INonePartition, 'key' | 'name'>;

export type IPartitionFieldsFragment =
  | IPartitionFields_ConversionWindowPartition_Fragment
  | IPartitionFields_FieldPartition_Fragment
  | IPartitionFields_NonePartition_Fragment;

export type IPartitionValueFieldsFragment = { __typename: 'PartitionValue' } & {
  partition:
    | ({
        __typename: 'ConversionWindowPartition';
      } & IPartitionFields_ConversionWindowPartition_Fragment)
    | ({
        __typename: 'FieldPartition';
      } & IPartitionFields_FieldPartition_Fragment)
    | ({
        __typename: 'NonePartition';
      } & IPartitionFields_NonePartition_Fragment);
  conversionWindow: Maybe<
    { __typename: 'Duration' } & Pick<IDuration, 'value' | 'timeUnit'>
  >;
};

export type IUserAliasReplacementFieldsFragment = {
  __typename: 'UserAliasReplacement';
} & Pick<IUserAliasReplacement, 'aliasId' | 'replacement'>;

export type IEntityRoleAssignmentFieldsFragment = {
  __typename: 'EntityRoleAssignment';
} & Pick<IEntityRoleAssignment, 'role'> & {
    groups: Array<{ __typename: 'UserGroup' } & Pick<IUserGroup, 'id'>>;
    users: Array<
      { __typename: 'User' } & Pick<IUser, 'id' | 'email' | 'name' | 'picture'>
    >;
  };

export type IEntityPermissionFieldsFragment = {
  __typename: 'EntityPermission';
} & Pick<IEntityPermission, 'defaultPublicRole' | 'entityId' | 'entityType'> & {
    roleAssignments: Array<
      {
        __typename: 'EntityRoleAssignment';
      } & IEntityRoleAssignmentFieldsFragment
    >;
    owner: { __typename: 'User' } & ICreatorFieldsFragment;
  };

export type ISchemaConfigFieldsFragment = { __typename: 'SchemaConfig' } & Pick<
  ISchemaConfig,
  'defaultSchemaId'
> & {
    schemas: Array<{ __typename: 'Schema' } & ISchemaFieldsFragment>;
    allSchemas: Array<{ __typename: 'Schema' } & ISchemaFieldsFragment>;
  };

export type IPermissionConfigFieldsFragment = {
  __typename: 'PermissionConfig';
} & Pick<IPermissionConfig, 'enablePermissionControl'> & {
    schemas: Array<
      { __typename: 'Schema' } & Pick<
        ISchema,
        'id' | 'name' | 'requiredPermission'
      >
    >;
    allSchema: { __typename: 'Schema' } & Pick<ISchema, 'id' | 'name'>;
  };

export type ICustomerInfoFieldsFragment = { __typename: 'CustomerInfo' } & Pick<
  ICustomerInfo,
  'name' | 'createdAt' | 'warehouse'
> & {
    analyticsConfig: { __typename: 'AnalyticsConfig' } & Pick<
      IAnalyticsConfig,
      'enabled'
    > & {
        segment: Maybe<
          { __typename: 'SegmentConfig' } & Pick<ISegmentConfig, 'writeKey'>
        >;
      };
  };

export type IDatePickerFixedFieldsFragment = {
  __typename: 'DatePickerFixed';
} & Pick<IDatePickerFixed, 'start' | 'end'>;

export type IDatePickerLastFieldsFragment = {
  __typename: 'DatePickerLast';
} & Pick<IDatePickerLast, 'period' | 'unit'>;

export type IDatePickerLastFullFieldsFragment = {
  __typename: 'DatePickerLastFull';
} & Pick<IDatePickerLastFull, 'unit' | 'period'>;

export type IDatePickerSinceFieldsFragment = {
  __typename: 'DatePickerSince';
} & Pick<IDatePickerSince, 'start'>;

export type IDatePickerStartOfFieldsFragment = {
  __typename: 'DatePickerStartOf';
} & Pick<IDatePickerStartOf, 'unit'>;

type IDatePickerFields_DatePickerFixed_Fragment = {
  __typename: 'DatePickerFixed';
} & IDatePickerFixedFieldsFragment;

type IDatePickerFields_DatePickerLast_Fragment = {
  __typename: 'DatePickerLast';
} & IDatePickerLastFieldsFragment;

type IDatePickerFields_DatePickerLastFull_Fragment = {
  __typename: 'DatePickerLastFull';
} & IDatePickerLastFullFieldsFragment;

type IDatePickerFields_DatePickerSince_Fragment = {
  __typename: 'DatePickerSince';
} & IDatePickerSinceFieldsFragment;

type IDatePickerFields_DatePickerStartOf_Fragment = {
  __typename: 'DatePickerStartOf';
} & IDatePickerStartOfFieldsFragment;

export type IDatePickerFieldsFragment =
  | IDatePickerFields_DatePickerFixed_Fragment
  | IDatePickerFields_DatePickerLast_Fragment
  | IDatePickerFields_DatePickerLastFull_Fragment
  | IDatePickerFields_DatePickerSince_Fragment
  | IDatePickerFields_DatePickerStartOf_Fragment;

export type IUserAliasQueryStepFieldsFragment = {
  __typename: 'UserAliasQueryStep';
} & Pick<IUserAliasQueryStep, 'aliasId'>;

export type IFunnelStepBriefInfoFieldsFragment = {
  __typename: 'FunnelStep';
} & Pick<IFunnelStep, 'name' | 'seq'> & {
    userAlias: {
      __typename: 'UserAliasQueryStep';
    } & IUserAliasQueryStepFieldsFragment;
  };

export type IFunnelModeSliceFieldsFragment = {
  __typename: 'FunnelModeSlice';
} & Pick<IFunnelModeSlice, 'name' | 'key' | 'measureSelection'>;

export type IAnalysisDashboardContainerFieldsFragment = {
  __typename: 'AnalysisDashboardContainer';
} & Pick<
  IAnalysisDashboardContainer,
  'id' | 'baseId' | 'name' | 'isLatestInstance' | 'isDefault'
> & {
    permission: {
      __typename: 'EntityPermission';
    } & IEntityPermissionFieldsFragment;
  };

export type IAnalysisWorkspaceContainerFieldsFragment = {
  __typename: 'AnalysisWorkspaceContainer';
} & Pick<IAnalysisWorkspaceContainer, 'name' | 'baseId'>;

type IAnalysisContainerFields_AnalysisDashboardContainer_Fragment = {
  __typename: 'AnalysisDashboardContainer';
} & IAnalysisDashboardContainerFieldsFragment;

type IAnalysisContainerFields_AnalysisWorkspaceContainer_Fragment = {
  __typename: 'AnalysisWorkspaceContainer';
} & IAnalysisWorkspaceContainerFieldsFragment;

export type IAnalysisContainerFieldsFragment =
  | IAnalysisContainerFields_AnalysisDashboardContainer_Fragment
  | IAnalysisContainerFields_AnalysisWorkspaceContainer_Fragment;

export type IFunnelSettingFieldsFragment = {
  __typename: 'FunnelSetting';
} & Pick<IFunnelSetting, 'defaultConversionRate'>;

export type IInspectSettingFieldsFragment = { __typename: 'InspectSetting' } & {
  schemaInspectSettings: Array<
    { __typename: 'SchemaInspectSetting' } & {
      fields: Array<{ __typename: 'Field' } & IFieldFieldsFragment>;
      schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    }
  >;
};

export type IReportSettingFieldsFragment = { __typename: 'ReportSetting' } & {
  funnel: { __typename: 'FunnelSetting' } & IFunnelSettingFieldsFragment;
  inspect: { __typename: 'InspectSetting' } & IInspectSettingFieldsFragment;
};

export type IMaxSeatsFieldsFragment = { __typename: 'MaxSeats' } & Pick<
  IMaxSeats,
  'maxSeats' | 'occupiedSeats' | 'availableSeats'
>;

export type IMaxSchemasFieldsFragment = { __typename: 'MaxSchemas' } & Pick<
  IMaxSchemas,
  'maxSchemas' | 'usedSchemas' | 'availableSchemas'
>;

export type IMtuPlanFeatureFragment = { __typename: 'PlanFeature' } & Pick<
  IPlanFeature,
  'display' | 'subFeatures'
>;

export type IMtuPlanFieldsFragment = { __typename: 'MTUPlan' } & Pick<
  IMtuPlan,
  'mtuLimit' | 'overageCharge'
> & {
    contractPeriod: { __typename: 'ContractPeriod' } & Pick<
      IContractPeriod,
      'start' | 'end'
    >;
    included: Array<{ __typename: 'PlanFeature' } & IMtuPlanFeatureFragment>;
    notIncluded: Array<{ __typename: 'PlanFeature' } & IMtuPlanFeatureFragment>;
    refreshQuota: { __typename: 'ScheduledRefreshStatus' } & Pick<
      IScheduledRefreshStatus,
      'activeCount' | 'limit'
    >;
  };

export type ICustomerPlanFieldsFragment = { __typename: 'CustomerPlan' } & {
  maxSeats: Maybe<{ __typename: 'MaxSeats' } & IMaxSeatsFieldsFragment>;
  maxSchemas: Maybe<{ __typename: 'MaxSchemas' } & IMaxSchemasFieldsFragment>;
  mtuPlan: Maybe<{ __typename: 'MTUPlan' } & IMtuPlanFieldsFragment>;
};

export type IAllowedDomainSettingFieldsFragment = {
  __typename: 'AllowedDomainSetting';
} & Pick<IAllowedDomainSetting, 'allowedDomains' | 'createdAt' | 'editedAt'> & {
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    editor: { __typename: 'User' } & IEditorFieldsFragment;
  };

export type IReportSettingEditMutationVariables = Exact<{
  input: IReportSettingEditInput;
}>;

export type IReportSettingEditMutation = { __typename: 'Mutation' } & {
  reportSettingEdit: { __typename: 'ReportSettingEditPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<
      { __typename: 'ReportSetting' } & IReportSettingFieldsFragment
    >;
  };
};

export type IAllowedDomainSettingEditMutationVariables = Exact<{
  input: IAllowedDomainSettingEditInput;
}>;

export type IAllowedDomainSettingEditMutation = { __typename: 'Mutation' } & {
  allowedDomainSettingEdit: {
    __typename: 'AllowedDomainSettingEditPayload';
  } & {
    entity: Maybe<
      {
        __typename: 'AllowedDomainSetting';
      } & IAllowedDomainSettingFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type ICustomerSetMtuReportMutationVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  populateBuilder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ICustomerSetMtuReportMutation = { __typename: 'Mutation' } & {
  customerSetMTUReport: { __typename: 'CustomerSetMTUReportPayload' } & {
    analysis: Maybe<
      | ({
          __typename: 'CohortSample';
        } & IAnalysisMetaFields_CohortSample_Fragment &
          IAnalysisFields_CohortSample_Fragment)
      | ({ __typename: 'DataTable' } & IAnalysisMetaFields_DataTable_Fragment &
          IAnalysisFields_DataTable_Fragment)
      | ({
          __typename: 'Expression';
        } & IAnalysisMetaFields_Expression_Fragment &
          IAnalysisFields_Expression_Fragment)
      | ({ __typename: 'Funnel' } & IAnalysisMetaFields_Funnel_Fragment &
          IAnalysisFields_Funnel_Fragment)
      | ({ __typename: 'Path' } & IAnalysisMetaFields_Path_Fragment &
          IAnalysisFields_Path_Fragment)
      | ({
          __typename: 'Prediction';
        } & IAnalysisMetaFields_Prediction_Fragment &
          IAnalysisFields_Prediction_Fragment)
      | ({ __typename: 'Retention' } & IAnalysisMetaFields_Retention_Fragment &
          IAnalysisFields_Retention_Fragment)
      | ({
          __typename: 'Significance';
        } & IAnalysisMetaFields_Significance_Fragment &
          IAnalysisFields_Significance_Fragment)
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IGeoConfigQueryVariables = Exact<{ [key: string]: never }>;

export type IGeoConfigQuery = { __typename: 'Query' } & {
  geoConfig: { __typename: 'GeoConfig' } & Pick<IGeoConfig, 'mapFileUrl'>;
};

export type IBootstrapQueryQueryVariables = Exact<{
  jupiterHostKind: UserSettingKind;
  quickAccessDictionaryKind: UserSettingKind;
  dashboardSidebarKind: UserSettingKind;
  executionHistoryExpandedKind: UserSettingKind;
  defaultViewKind: UserSettingKind;
  defaultSchemaKind: UserSettingKind;
  sidebarPinnedKind: UserSettingKind;
  sidebarSizeKind: UserSettingKind;
  colorSchemaKind: UserSettingKind;
}>;

export type IBootstrapQueryQuery = { __typename: 'Query' } & {
  globalConfig: { __typename: 'GlobalConfig' } & Pick<
    IGlobalConfig,
    | 'enabledFeatures'
    | 'slackSupportLink'
    | 'timeUnits'
    | 'defaultEnd'
    | 'timezone'
    | 'preventBasicEventMetadataUpdates'
    | 'llmApiEnabled'
  > & {
      formatSetting: {
        __typename: 'FormatSetting';
      } & IFormatSettingFieldsFragment;
      reportSetting: {
        __typename: 'ReportSetting';
      } & IReportSettingFieldsFragment;
    };
  scheduleConfig: Maybe<
    { __typename: 'ScheduleConfig' } & Pick<IScheduleConfig, 'domains'>
  >;
  jupyterHostSetting: Maybe<
    { __typename: 'UserSetting' } & IUserSettingFieldsFragment
  >;
  quickAccessDictionarySetting: Maybe<
    { __typename: 'UserSetting' } & IUserSettingFieldsFragment
  >;
  dashboardSidebarSetting: Maybe<
    { __typename: 'UserSetting' } & IUserSettingFieldsFragment
  >;
  executionHistoryExpandedSetting: Maybe<
    { __typename: 'UserSetting' } & IUserSettingFieldsFragment
  >;
  defaultViewSetting: Maybe<
    { __typename: 'UserSetting' } & IUserSettingFieldsFragment
  >;
  defaultSchemaSetting: Maybe<
    { __typename: 'UserSetting' } & IUserSettingFieldsFragment
  >;
  sidebarPinnedSetting: Maybe<
    { __typename: 'UserSetting' } & IUserSettingFieldsFragment
  >;
  sidebarSizeSetting: Maybe<
    { __typename: 'UserSetting' } & IUserSettingFieldsFragment
  >;
  defaultColorSchemaSetting: Maybe<
    { __typename: 'UserSetting' } & IUserSettingFieldsFragment
  >;
  incidentTypes: Maybe<
    Array<
      Maybe<{ __typename: 'IncidentType' } & Pick<IIncidentType, 'id' | 'name'>>
    >
  >;
  schemaConfig: Maybe<
    { __typename: 'SchemaConfig' } & ISchemaConfigFieldsFragment
  >;
  permissionConfig: {
    __typename: 'PermissionConfig';
  } & IPermissionConfigFieldsFragment;
  customerInfo: { __typename: 'CustomerInfo' } & ICustomerInfoFieldsFragment;
  customerPlan: { __typename: 'CustomerPlan' } & ICustomerPlanFieldsFragment;
};

export type IGetAllowedDomainSettingQueryVariables = Exact<{
  [key: string]: never;
}>;

export type IGetAllowedDomainSettingQuery = { __typename: 'Query' } & {
  allowedDomainSetting: Maybe<
    { __typename: 'AllowedDomainSetting' } & IAllowedDomainSettingFieldsFragment
  >;
};

export type ICustomerPlanQueryVariables = Exact<{ [key: string]: never }>;

export type ICustomerPlanQuery = { __typename: 'Query' } & {
  customerPlan: { __typename: 'CustomerPlan' } & ICustomerPlanFieldsFragment;
};

export type ICustomerPlanMtuReportQueryVariables = Exact<{
  populateBuilder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ICustomerPlanMtuReportQuery = { __typename: 'Query' } & {
  customerPlan: { __typename: 'CustomerPlan' } & {
    mtuPlan: Maybe<
      { __typename: 'MTUPlan' } & {
        mtuReport: Maybe<
          | ({
              __typename: 'CohortSample';
            } & IAnalysisMetaFields_CohortSample_Fragment &
              IAnalysisFields_CohortSample_Fragment)
          | ({
              __typename: 'DataTable';
            } & IAnalysisMetaFields_DataTable_Fragment &
              IAnalysisFields_DataTable_Fragment)
          | ({
              __typename: 'Expression';
            } & IAnalysisMetaFields_Expression_Fragment &
              IAnalysisFields_Expression_Fragment)
          | ({ __typename: 'Funnel' } & IAnalysisMetaFields_Funnel_Fragment &
              IAnalysisFields_Funnel_Fragment)
          | ({ __typename: 'Path' } & IAnalysisMetaFields_Path_Fragment &
              IAnalysisFields_Path_Fragment)
          | ({
              __typename: 'Prediction';
            } & IAnalysisMetaFields_Prediction_Fragment &
              IAnalysisFields_Prediction_Fragment)
          | ({
              __typename: 'Retention';
            } & IAnalysisMetaFields_Retention_Fragment &
              IAnalysisFields_Retention_Fragment)
          | ({
              __typename: 'Significance';
            } & IAnalysisMetaFields_Significance_Fragment &
              IAnalysisFields_Significance_Fragment)
        >;
      }
    >;
  };
};

export type IImageEmbedFieldsFragment = { __typename: 'ImageEmbed' } & Pick<
  IImageEmbed,
  'id' | 'serveUrl'
>;

export type IPostUploadConfigFieldsFragment = {
  __typename: 'PostUploadConfig';
} & Pick<
  IPostUploadConfig,
  | 'endpoint'
  | 'amzAlgorithm'
  | 'amzCredential'
  | 'amzDate'
  | 'amzSignature'
  | 'amzSecurityToken'
  | 'key'
  | 'policy'
>;

export type IUploadEntityFieldsFragment = { __typename: 'UploadEntity' } & Pick<
  IUploadEntity,
  'url' | 'objectKey'
>;

export type ILlmConfigFieldsFragment = { __typename: 'LlmConfig' } & Pick<
  ILlmConfig,
  | 'enabled'
  | 'projectId'
  | 'organizationId'
  | 'modelName'
  | 'assistantInstructions'
  | 'defaultAssistantInstructions'
>;

export type ILlmChatMessageFieldsFragment = {
  __typename: 'LlmChatMessage';
} & Pick<ILlmChatMessage, 'text' | 'sender' | 'createdAt'> & {
    attachments: Array<
      { __typename: 'LlmAttachment' } & Pick<
        ILlmAttachment,
        'llmFileId' | 'originalS3Key'
      >
    >;
  };

export type ILlmSummarySectionsFieldsFragment = {
  __typename: 'LlmSummarySections';
} & Pick<
  ILlmSummarySections,
  'executiveSummary' | 'keyInsights' | 'summaryStatistics' | 'recommendations'
>;

export type ILlmSubjectSummaryFieldsFragment = {
  __typename: 'LlmSubjectSummary';
} & Pick<ILlmSubjectSummary, 'text' | 'richText' | 'updatedAt'> & {
    sections: {
      __typename: 'LlmSummarySections';
    } & ILlmSummarySectionsFieldsFragment;
  };

export type ILlmSummarizeResponseFieldsFragment = {
  __typename: 'LlmSummarizeResponse';
} & Pick<ILlmSummarizeResponse, 'error'> & {
    summary: Maybe<
      { __typename: 'LlmSubjectSummary' } & ILlmSubjectSummaryFieldsFragment
    >;
    thread: Array<
      { __typename: 'LlmChatMessage' } & ILlmChatMessageFieldsFragment
    >;
  };

export type ILlmConversationUserPromptFieldsFragment = {
  __typename: 'LlmConversationUserPrompt';
} & Pick<
  ILlmConversationUserPrompt,
  'id' | 'message' | 'abTestGroup' | 'createdAt'
>;

export type ILlmConversationResponseTextFieldsFragment = {
  __typename: 'LlmConversationResponseText';
} & Pick<
  ILlmConversationResponseText,
  | 'id'
  | 'message'
  | 'abTestGroup'
  | 'responseTimeMs'
  | 'debugInfo'
  | 'createdAt'
>;

export type ILlmConversationResponseErrorFieldsFragment = {
  __typename: 'LlmConversationResponseError';
} & Pick<
  ILlmConversationResponseError,
  | 'id'
  | 'message'
  | 'abTestGroup'
  | 'responseTimeMs'
  | 'debugInfo'
  | 'createdAt'
>;

export type ILlmConversationResponseFormulaFieldsFragment = {
  __typename: 'LlmConversationResponseFormula';
} & Pick<
  ILlmConversationResponseFormula,
  | 'id'
  | 'message'
  | 'queryType'
  | 'queryId'
  | 'queryDefinition'
  | 'abTestGroup'
  | 'responseTimeMs'
  | 'debugInfo'
  | 'createdAt'
>;

export type ILlmConversationMessagesFieldsFragment = {
  __typename: 'LlmConversationMessages';
} & {
  list: Array<
    | ({
        __typename: 'LlmConversationResponseError';
      } & ILlmConversationResponseErrorFieldsFragment)
    | ({
        __typename: 'LlmConversationResponseFormula';
      } & ILlmConversationResponseFormulaFieldsFragment)
    | ({
        __typename: 'LlmConversationResponseText';
      } & ILlmConversationResponseTextFieldsFragment)
    | ({
        __typename: 'LlmConversationUserPrompt';
      } & ILlmConversationUserPromptFieldsFragment)
  >;
};

export type ILlmConversationFieldsFragment = {
  __typename: 'LlmConversation';
} & Pick<ILlmConversation, 'schemaId'> & {
    messages: {
      __typename: 'LlmConversationMessages';
    } & ILlmConversationMessagesFieldsFragment;
  };

export type ILlmUpdateApiConfigMutationVariables = Exact<{
  input: ILLmConfigInput;
}>;

export type ILlmUpdateApiConfigMutation = { __typename: 'Mutation' } & {
  llmUpdateApiConfig: { __typename: 'LlmUpdateConfigPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<{ __typename: 'LlmConfig' } & ILlmConfigFieldsFragment>;
  };
};

export type ILlmSummarizeEntityMutationVariables = Exact<{
  input: ILlmSummarizeInput;
}>;

export type ILlmSummarizeEntityMutation = { __typename: 'Mutation' } & {
  llmSummarizeEntity: { __typename: 'LlmSummarizePayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<
      {
        __typename: 'LlmSummarizeResponse';
      } & ILlmSummarizeResponseFieldsFragment
    >;
  };
};

export type ILlmCreateFormulaTemplateMutationVariables = Exact<{
  input: ILlmCreateFormulaTemplateInput;
}>;

export type ILlmCreateFormulaTemplateMutation = { __typename: 'Mutation' } & {
  llmCreateFormulaTemplate: {
    __typename: 'LlmCreateFormulaTemplatePayload';
  } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<
      {
        __typename: 'LlmCreateFormulaTemplate';
      } & ILlmCreateFormulaTemplateFieldsFragment
    >;
  };
};

export type ILlmProcessConversationPromptMutationVariables = Exact<{
  input: ILlmConversationPromptInput;
}>;

export type ILlmProcessConversationPromptMutation = {
  __typename: 'Mutation';
} & {
  llmProcessConversationPrompt: { __typename: 'LlmProcessPromptPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<
      {
        __typename: 'LlmConversationMessages';
      } & ILlmConversationMessagesFieldsFragment
    >;
  };
};

export type ILlmResetConversationMutationVariables = Exact<{
  input: ILlmResetConversationInput;
}>;

export type ILlmResetConversationMutation = { __typename: 'Mutation' } & {
  llmResetConversation: { __typename: 'LlmResetConversationPayload' } & Pick<
    ILlmResetConversationPayload,
    'entity'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type ILlmTempImagePreUploadQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ILlmTempImagePreUploadQuery = { __typename: 'Query' } & {
  llmTempImagePreUpload: {
    __typename: 'UploadEntity';
  } & IUploadEntityFieldsFragment;
};

export type ILlmConfigQueryVariables = Exact<{ [key: string]: never }>;

export type ILlmConfigQuery = { __typename: 'Query' } & {
  llmConfig: { __typename: 'LlmConfig' } & ILlmConfigFieldsFragment;
};

export type ILlmSchemaConversationQueryVariables = Exact<{
  schemaId: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
}>;

export type ILlmSchemaConversationQuery = { __typename: 'Query' } & {
  llmSchemaConversation: Maybe<
    { __typename: 'LlmConversation' } & ILlmConversationFieldsFragment
  >;
};

export type IManageBasicEventMutationVariables = Exact<{
  input: Array<IManageBasicEventInput> | IManageBasicEventInput;
}>;

export type IManageBasicEventMutation = { __typename: 'Mutation' } & {
  manageBasicEvent: { __typename: 'ManageEntityPayload' } & Pick<
    IManageEntityPayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IManageFieldMutationVariables = Exact<{
  input: Array<IManageFieldInput> | IManageFieldInput;
}>;

export type IManageFieldMutation = { __typename: 'Mutation' } & {
  manageField: { __typename: 'ManageEntityPayload' } & Pick<
    IManageEntityPayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IManageVersionEntityMutationVariables = Exact<{
  input: Array<IManageVersionEntityInput> | IManageVersionEntityInput;
}>;

export type IManageVersionEntityMutation = { __typename: 'Mutation' } & {
  manageVersionEntity: { __typename: 'ManageEntityPayload' } & Pick<
    IManageEntityPayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IMeasureFilterFieldsFragment = {
  __typename: 'MeasureFilter';
} & Pick<IMeasureFilter, 'values'> & {
    relOp: {
      __typename: 'RelationalOperator';
    } & IRelationalOperatorFieldsFragment;
  };

export type ISimpleMeasurePropertiesFieldsFragment = {
  __typename: 'SimpleMeasureProperties';
} & {
  cohortRefs: Array<{ __typename: 'CohortRef' } & ICohortRefFieldsFragment>;
  filter: Maybe<{ __typename: 'MeasureFilter' } & IMeasureFilterFieldsFragment>;
};

export type ICompoundMeasurePropertiesFieldsFragment = {
  __typename: 'CompoundMeasureProperties';
} & {
  resultFilter: Maybe<
    { __typename: 'MeasureFilter' } & IMeasureFilterFieldsFragment
  >;
  measures: Array<
    {
      __typename: 'SimpleMeasureProperties';
    } & ISimpleMeasurePropertiesFieldsFragment
  >;
};

type IMeasurePropertiesFields_CompoundMeasureProperties_Fragment = {
  __typename: 'CompoundMeasureProperties';
} & ICompoundMeasurePropertiesFieldsFragment;

type IMeasurePropertiesFields_SimpleMeasureProperties_Fragment = {
  __typename: 'SimpleMeasureProperties';
} & ISimpleMeasurePropertiesFieldsFragment;

export type IMeasurePropertiesFieldsFragment =
  | IMeasurePropertiesFields_CompoundMeasureProperties_Fragment
  | IMeasurePropertiesFields_SimpleMeasureProperties_Fragment;

export type IRollingControlFieldsFragment = {
  __typename: 'RollingControl';
} & Pick<IRollingControl, 'function' | 'window'>;

export type IMeasureDisplayFormatFieldsFragment = {
  __typename: 'MeasureDisplayFormat';
} & Pick<
  IMeasureDisplayFormat,
  'kind' | 'decimalPlace' | 'calculationUnit' | 'calculationValue' | 'unit'
>;

export type ISimpleMeasureFieldsFragment = {
  __typename: 'SimpleMeasure';
} & Pick<
  ISimpleMeasure,
  | 'id'
  | 'name'
  | 'percentile'
  | 'isFavorite'
  | 'isManaged'
  | 'formula'
  | 'varName'
  | 'key'
> & {
    eventConditions: Array<
      { __typename: 'EventCondition' } & IEventConditionFieldsFragment
    >;
    function: {
      __typename: 'MeasureFunction';
    } & IMeasureFunctionFieldsFragment;
    rollingControl: Maybe<
      { __typename: 'RollingControl' } & IRollingControlFieldsFragment
    >;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    userAlias: {
      __typename: 'UserAliasQueryMeasure';
    } & IUserAliasQueryMeasureFieldsFragment;
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
    format: Maybe<
      {
        __typename: 'MeasureDisplayFormat';
      } & IMeasureDisplayFormatFieldsFragment
    >;
  };

export type ICompoundMeasureFieldsFragment = {
  __typename: 'CompoundMeasure';
} & Pick<
  ICompoundMeasure,
  'id' | 'name' | 'isFavorite' | 'isManaged' | 'formula' | 'key'
> & {
    rollingControl: Maybe<
      { __typename: 'RollingControl' } & IRollingControlFieldsFragment
    >;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    userAlias: {
      __typename: 'UserAliasQueryMeasure';
    } & IUserAliasQueryMeasureFieldsFragment;
    version: Maybe<{ __typename: 'Version' } & IVersionFieldsFragment>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
    measures: Array<
      { __typename: 'SimpleMeasure' } & ISimpleMeasureFieldsFragment
    >;
    format: Maybe<
      {
        __typename: 'MeasureDisplayFormat';
      } & IMeasureDisplayFormatFieldsFragment
    >;
  };

type IMeasureFields_CompoundMeasure_Fragment = {
  __typename: 'CompoundMeasure';
} & ICompoundMeasureFieldsFragment;

type IMeasureFields_SimpleMeasure_Fragment = {
  __typename: 'SimpleMeasure';
} & ISimpleMeasureFieldsFragment;

export type IMeasureFieldsFragment =
  | IMeasureFields_CompoundMeasure_Fragment
  | IMeasureFields_SimpleMeasure_Fragment;

export type IValidateMeasureFormulaQueryVariables = Exact<{
  input: IMeasureFormulaInput;
}>;

export type IValidateMeasureFormulaQuery = { __typename: 'Query' } & {
  measureFormulaValidate: {
    __typename: 'MeasureFormulaValidationResult';
  } & Pick<IMeasureFormulaValidationResult, 'validationError'>;
};

export type INamedMeasureCreateMutationVariables = Exact<{
  input: INamedMeasureCreateInput;
}>;

export type INamedMeasureCreateMutation = { __typename: 'Mutation' } & {
  namedMeasureCreate: { __typename: 'NamedMeasureCreatePayload' } & {
    entity: Maybe<
      | ({
          __typename: 'CompoundMeasure';
        } & IMeasureFields_CompoundMeasure_Fragment)
      | ({
          __typename: 'SimpleMeasure';
        } & IMeasureFields_SimpleMeasure_Fragment)
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type INamedMeasureEditMutationVariables = Exact<{
  input: INamedMeasureEditInput;
}>;

export type INamedMeasureEditMutation = { __typename: 'Mutation' } & {
  namedMeasureEdit: { __typename: 'NamedMeasureEditPayload' } & {
    entity: Maybe<
      | ({
          __typename: 'CompoundMeasure';
        } & IMeasureFields_CompoundMeasure_Fragment)
      | ({
          __typename: 'SimpleMeasure';
        } & IMeasureFields_SimpleMeasure_Fragment)
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type INamedMeasureDeleteMutationVariables = Exact<{
  input: INamedMeasureDeleteInput;
}>;

export type INamedMeasureDeleteMutation = { __typename: 'Mutation' } & {
  namedMeasureDelete: { __typename: 'NamedMeasureDeletePayload' } & Pick<
    INamedMeasureDeletePayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type INamedMeasureAddCategoryMutationVariables = Exact<{
  input: INamedEntityEditCategoryInput;
}>;

export type INamedMeasureAddCategoryMutation = { __typename: 'Mutation' } & {
  namedMeasureAddCategory: {
    __typename: 'NamedEntityEditCategoryPayload';
  } & Pick<INamedEntityEditCategoryPayload, 'message'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type INamedMeasureRemoveCategoryMutationVariables = Exact<{
  input: INamedEntityEditCategoryInput;
}>;

export type INamedMeasureRemoveCategoryMutation = { __typename: 'Mutation' } & {
  namedMeasureRemoveCategory: {
    __typename: 'NamedEntityEditCategoryPayload';
  } & Pick<INamedEntityEditCategoryPayload, 'message'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type INamedMeasuresQueryQueryVariables = Exact<{
  schemaId: Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
  includeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  searchNamedMeasureOption: SearchNamedMeasureOption;
  pagination: IPagination;
}>;

export type INamedMeasuresQueryQuery = { __typename: 'Query' } & {
  namedMeasures: Maybe<
    { __typename: 'NamedMeasuresPaginated' } & {
      entities: Array<
        | ({
            __typename: 'CompoundMeasure';
          } & IMeasureFields_CompoundMeasure_Fragment)
        | ({
            __typename: 'SimpleMeasure';
          } & IMeasureFields_SimpleMeasure_Fragment)
      >;
    }
  >;
};

export type IGetNamedMeasureQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IGetNamedMeasureQuery = { __typename: 'Query' } & {
  namedMeasure:
    | ({
        __typename: 'CompoundMeasure';
      } & IMeasureFields_CompoundMeasure_Fragment)
    | ({ __typename: 'SimpleMeasure' } & IMeasureFields_SimpleMeasure_Fragment);
};

export type IPermissionFieldsFragment = { __typename: 'Permission' } & Pick<
  IPermission,
  'key' | 'name' | 'action'
> & {
    assignableSchemas: Array<
      { __typename: 'Schema' } & Pick<ISchema, 'id' | 'name'>
    >;
  };

export type IPermissionAssignmentFieldsFragment = {
  __typename: 'PermissionAssignment';
} & {
  permission: { __typename: 'Permission' } & IPermissionFieldsFragment;
  schemas: Array<{ __typename: 'Schema' } & Pick<ISchema, 'id' | 'name'>>;
};

export type IRoleMetaFieldsFragment = { __typename: 'Role' } & Pick<
  IRole,
  'id' | 'name' | 'description' | 'type' | 'active'
>;

export type IRoleWithPermissionsFieldsFragment = { __typename: 'Role' } & {
  permissionAssignments: Array<
    { __typename: 'PermissionAssignment' } & IPermissionAssignmentFieldsFragment
  >;
} & IRoleMetaFieldsFragment;

export type IUserGroupMetaFieldsFragment = { __typename: 'UserGroup' } & Pick<
  IUserGroup,
  'active' | 'type' | 'id' | 'name' | 'description'
>;

export type IUserGroupFieldsFragment = { __typename: 'UserGroup' } & {
  users: Array<{ __typename: 'User' } & IUserFieldsFragment>;
  roles: Array<{ __typename: 'Role' } & Pick<IRole, 'id' | 'name'>>;
} & IUserGroupMetaFieldsFragment;

export type IUserPermissionFieldsFragment = { __typename: 'User' } & {
  groups: Array<
    { __typename: 'UserGroup' } & {
      roles: Array<{ __typename: 'Role' } & IRoleWithPermissionsFieldsFragment>;
    } & IUserGroupMetaFieldsFragment
  >;
  roles: Array<{ __typename: 'Role' } & IRoleWithPermissionsFieldsFragment>;
} & IUserFieldsFragment;

export type IFormatSettingFieldsFragment = {
  __typename: 'FormatSetting';
} & Pick<IFormatSetting, 'date' | 'time' | 'locale' | 'currency'>;

export type IFormatSettingConfigFieldsFragment = {
  __typename: 'FormatSettingConfig';
} & Pick<
  IFormatSettingConfig,
  'dateFormats' | 'timeFormats' | 'locales' | 'currencies'
>;

export type IUserTableFieldsFragment = { __typename: 'User' } & Pick<
  IUser,
  'inviteExpireAt' | 'invitedAt'
> & {
    roles: Array<{ __typename: 'Role' } & IRoleMetaFieldsFragment>;
  } & IUserFieldsFragment;

export type IAdminNotificationSettingsFieldsFragment = {
  __typename: 'AdminNotificationSettings';
} & Pick<IAdminNotificationSettings, 'emails'> & {
    slackDestination: Maybe<
      | ({
          __typename: 'SlackChannelDestination';
        } & ISlackDestinationFields_SlackChannelDestination_Fragment)
      | ({
          __typename: 'SlackMemberDestination';
        } & ISlackDestinationFields_SlackMemberDestination_Fragment)
    >;
    notifications: Array<
      { __typename: 'AdminNotification' } & Pick<
        IAdminNotification,
        'destinationTypes'
      > & {
          event: { __typename: 'AdminNotificationEvent' } & Pick<
            IAdminNotificationEvent,
            'key' | 'name'
          >;
        }
    >;
  };

export type IRoleCreateMutationVariables = Exact<{
  input: IRoleCreateInput;
}>;

export type IRoleCreateMutation = { __typename: 'Mutation' } & {
  roleCreate: { __typename: 'RoleCreatePayload' } & {
    entity: Maybe<{ __typename: 'Role' } & Pick<IRole, 'id' | 'name'>>;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IRoleEditMutationVariables = Exact<{
  input: IRoleEditInput;
}>;

export type IRoleEditMutation = { __typename: 'Mutation' } & {
  roleEdit: { __typename: 'RoleEditPayload' } & {
    entity: Maybe<{ __typename: 'Role' } & Pick<IRole, 'id' | 'name'>>;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IRoleDisableMutationVariables = Exact<{
  input: IRoleDisableInput;
}>;

export type IRoleDisableMutation = { __typename: 'Mutation' } & {
  roleDisable: { __typename: 'RoleDisablePayload' } & Pick<
    IRoleDisablePayload,
    'disabled'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IRoleEnableMutationVariables = Exact<{
  input: IRoleEnableInput;
}>;

export type IRoleEnableMutation = { __typename: 'Mutation' } & {
  roleEnable: { __typename: 'RoleEnablePayload' } & Pick<
    IRoleEnablePayload,
    'enabled'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IRoleDefaultMutationVariables = Exact<{
  input: IRoleDefaultInput;
}>;

export type IRoleDefaultMutation = { __typename: 'Mutation' } & {
  roleDefault: { __typename: 'RoleDefaultPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IUserEditMutationVariables = Exact<{
  input: IUserEditInput;
}>;

export type IUserEditMutation = { __typename: 'Mutation' } & {
  userEdit: { __typename: 'UserEditPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IUserDisableMutationVariables = Exact<{
  input: IUserDisableInput;
}>;

export type IUserDisableMutation = { __typename: 'Mutation' } & {
  userDisable: { __typename: 'UserDisablePayload' } & Pick<
    IUserDisablePayload,
    'disabled'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IUserEnableMutationVariables = Exact<{
  input: IUserEnableInput;
}>;

export type IUserEnableMutation = { __typename: 'Mutation' } & {
  userEnable: { __typename: 'UserEnablePayload' } & Pick<
    IUserEnablePayload,
    'enabled'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IUserGroupCreateMutationVariables = Exact<{
  input: IUserGroupCreateInput;
}>;

export type IUserGroupCreateMutation = { __typename: 'Mutation' } & {
  userGroupCreate: { __typename: 'UserGroupCreatePayload' } & {
    entity: Maybe<{ __typename: 'UserGroup' } & IUserGroupFieldsFragment>;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IUserGroupEditMutationVariables = Exact<{
  input: IUserGroupEditInput;
}>;

export type IUserGroupEditMutation = { __typename: 'Mutation' } & {
  userGroupEdit: { __typename: 'UserGroupEditPayload' } & {
    entity: Maybe<{ __typename: 'UserGroup' } & IUserGroupFieldsFragment>;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IUserGroupDisableMutationVariables = Exact<{
  input: IUserGroupDisableInput;
}>;

export type IUserGroupDisableMutation = { __typename: 'Mutation' } & {
  userGroupDisable: { __typename: 'UserGroupDisablePayload' } & Pick<
    IUserGroupDisablePayload,
    'disabled'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IUserGroupEnableMutationVariables = Exact<{
  input: IUserGroupEnableInput;
}>;

export type IUserGroupEnableMutation = { __typename: 'Mutation' } & {
  userGroupEnable: { __typename: 'UserGroupEnablePayload' } & Pick<
    IUserGroupEnablePayload,
    'enabled'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IUserInviteResendMutationVariables = Exact<{
  input: IUserInviteResendInput;
}>;

export type IUserInviteResendMutation = { __typename: 'Mutation' } & {
  userInviteResend: { __typename: 'UserInviteResendPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IUserInviteMutationVariables = Exact<{
  input: IUserInvitesInput;
}>;

export type IUserInviteMutation = { __typename: 'Mutation' } & {
  userInvite: { __typename: 'UserInvitePayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    invites: Maybe<
      Array<
        { __typename: 'UserInvite' } & Pick<IUserInvite, 'error'> & {
            user: Maybe<
              { __typename: 'User' } & Pick<IUser, 'id' | 'name' | 'email'>
            >;
          }
      >
    >;
  };
};

export type IUserRevokeMutationVariables = Exact<{
  input: IUserRevokeInput;
}>;

export type IUserRevokeMutation = { __typename: 'Mutation' } & {
  userRevoke: { __typename: 'UserRevokePayload' } & Pick<
    IUserRevokePayload,
    'revoked'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IFormatSettingEditMutationVariables = Exact<{
  input: IFormatSettingEditInput;
}>;

export type IFormatSettingEditMutation = { __typename: 'Mutation' } & {
  formatSettingEdit: { __typename: 'FormatSettingEditPayload' } & {
    entity: Maybe<
      { __typename: 'FormatSetting' } & IFormatSettingFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IAdminNotificationSettingsSetMutationVariables = Exact<{
  input: IAdminNotificationSettingsInput;
}>;

export type IAdminNotificationSettingsSetMutation = {
  __typename: 'Mutation';
} & {
  adminNotificationSettingsSet: {
    __typename: 'AdminNotificationSettingPayload';
  } & {
    entity: Maybe<
      {
        __typename: 'AdminNotificationSettings';
      } & IAdminNotificationSettingsFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IUserPermissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IUserPermissionQuery = { __typename: 'Query' } & {
  user: { __typename: 'User' } & IUserPermissionFieldsFragment;
};

export type IUserGroupsQueryVariables = Exact<{
  term: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<UserGroupType>;
  includeDisabled: Scalars['Boolean']['input'];
  includes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  pagination: IPagination;
}>;

export type IUserGroupsQuery = { __typename: 'Query' } & {
  userGroups: { __typename: 'UserGroupsPaginated' } & {
    entities: Array<{ __typename: 'UserGroup' } & IUserGroupFieldsFragment>;
  };
};

export type IUserGroupPermissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IUserGroupPermissionQuery = { __typename: 'Query' } & {
  userGroup: { __typename: 'UserGroup' } & IUserGroupFieldsFragment;
};

export type IPermissionsQueryVariables = Exact<{
  pagination: IPagination;
}>;

export type IPermissionsQuery = { __typename: 'Query' } & {
  permissions: { __typename: 'PermissionsPaginated' } & {
    entities: Array<{ __typename: 'Permission' } & IPermissionFieldsFragment>;
  };
};

export type IRolesQueryVariables = Exact<{
  term: InputMaybe<Scalars['String']['input']>;
  includeDisabled: Scalars['Boolean']['input'];
  includes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  pagination: IPagination;
}>;

export type IRolesQuery = { __typename: 'Query' } & {
  roles: { __typename: 'RolesPaginated' } & {
    entities: Array<{ __typename: 'Role' } & IRoleMetaFieldsFragment>;
  };
};

export type IRolesWithPermissionsQueryVariables = Exact<{
  term: InputMaybe<Scalars['String']['input']>;
  includeDisabled: Scalars['Boolean']['input'];
  includes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  pagination: IPagination;
}>;

export type IRolesWithPermissionsQuery = { __typename: 'Query' } & {
  roles: { __typename: 'RolesPaginated' } & {
    entities: Array<
      { __typename: 'Role' } & IRoleWithPermissionsFieldsFragment
    >;
  };
};

export type IRolePermissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IRolePermissionQuery = { __typename: 'Query' } & {
  role: { __typename: 'Role' } & IRoleWithPermissionsFieldsFragment;
};

export type IUsersTableQueryVariables = Exact<{
  term: InputMaybe<Scalars['String']['input']>;
  includes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  pagination: IPagination;
  userStates: InputMaybe<Array<UserState> | UserState>;
}>;

export type IUsersTableQuery = { __typename: 'Query' } & {
  users: { __typename: 'UsersPaginated' } & {
    entities: Array<{ __typename: 'User' } & IUserTableFieldsFragment>;
  };
};

export type IUsersWithBasicInfoQueryVariables = Exact<{
  term: InputMaybe<Scalars['String']['input']>;
  includes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  pagination: IPagination;
  userStates: InputMaybe<Array<UserState> | UserState>;
}>;

export type IUsersWithBasicInfoQuery = { __typename: 'Query' } & {
  users: { __typename: 'UsersPaginated' } & {
    entities: Array<{ __typename: 'User' } & IUserFieldsFragment>;
  };
};

export type IDefaultRoleQueryVariables = Exact<{ [key: string]: never }>;

export type IDefaultRoleQuery = { __typename: 'Query' } & {
  defaultRole: { __typename: 'Role' } & Pick<IRole, 'id' | 'name'>;
};

export type IRolePermissionAndAllPermissionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  pagination: IPagination;
}>;

export type IRolePermissionAndAllPermissionsQuery = { __typename: 'Query' } & {
  role: { __typename: 'Role' } & IRoleWithPermissionsFieldsFragment;
  permissions: { __typename: 'PermissionsPaginated' } & {
    entities: Array<{ __typename: 'Permission' } & IPermissionFieldsFragment>;
  };
};

export type IFormatSettingConfigQueryVariables = Exact<{
  [key: string]: never;
}>;

export type IFormatSettingConfigQuery = { __typename: 'Query' } & {
  formatSettingConfig: {
    __typename: 'FormatSettingConfig';
  } & IFormatSettingConfigFieldsFragment;
};

export type IAdminNotificationSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type IAdminNotificationSettingsQuery = { __typename: 'Query' } & {
  adminNotificationSettings: {
    __typename: 'AdminNotificationSettings';
  } & IAdminNotificationSettingsFieldsFragment;
};

export type IRecentDashboardVisitFieldsFragment = {
  __typename: 'RecentDashboardVisit';
} & Pick<
  IRecentDashboardVisit,
  | 'dashboardBaseId'
  | 'display'
  | 'description'
  | 'createdAt'
  | 'visitedAt'
  | 'isFavorite'
  | 'isDeleted'
> & {
    lastEditor: { __typename: 'User' } & Pick<IUser, 'id' | 'name' | 'picture'>;
    creator: { __typename: 'User' } & Pick<IUser, 'id' | 'name' | 'picture'>;
  };

export type IRecentAnalysisVisitFieldsFragment = {
  __typename: 'RecentAnalysisVisit';
} & Pick<
  IRecentAnalysisVisit,
  | 'analysisId'
  | 'queryType'
  | 'display'
  | 'description'
  | 'createdAt'
  | 'visitedAt'
  | 'status'
  | 'isFavorite'
> & {
    lastEditor: { __typename: 'User' } & Pick<IUser, 'id' | 'name' | 'picture'>;
    creator: { __typename: 'User' } & Pick<IUser, 'id' | 'name' | 'picture'>;
  };

export type IRecentActivityQueryVariables = Exact<{ [key: string]: never }>;

export type IRecentActivityQuery = { __typename: 'Query' } & {
  recentActivity: Array<
    | ({
        __typename: 'RecentAnalysisVisit';
      } & IRecentAnalysisVisitFieldsFragment)
    | ({
        __typename: 'RecentDashboardVisit';
      } & IRecentDashboardVisitFieldsFragment)
  >;
};

export type IRichTextFieldsFragment = { __typename: 'RichText' } & Pick<
  IRichText,
  'id' | 'html'
>;

export type ICreateScheduleMutationVariables = Exact<{
  input: IScheduleInput;
}>;

export type ICreateScheduleMutation = { __typename: 'Mutation' } & {
  createSchedule: { __typename: 'ScheduleCreatePayload' } & {
    schedule: Maybe<{ __typename: 'Schedule' } & IScheduleFieldsFragment>;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field' | 'messages'>>;
  };
};

export type IDeleteScheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IDeleteScheduleMutation = { __typename: 'Mutation' } & {
  deleteSchedule: { __typename: 'ScheduleDeletePayload' } & Pick<
    IScheduleDeletePayload,
    'message'
  > & {
      errors: Array<
        { __typename: 'Error' } & Pick<IError, 'field' | 'messages'>
      >;
    };
};

export type IScheduleHistoryFieldsFragment = { __typename: 'Schedule' } & Pick<
  ISchedule,
  | 'id'
  | 'name'
  | 'description'
  | 'type'
  | 'cron'
  | 'timezone'
  | 'paused'
  | 'emailList'
  | 'alertOnly'
  | 'lastRunStatus'
  | 'nextRunAt'
  | 'lastRunAt'
  | 'entityUrl'
> & {
    entity:
      | ({ __typename: 'AnalysisScheduleEntity' } & {
          item:
            | ({ __typename: 'CohortSample' } & Pick<
                ICohortSample,
                'id' | 'display' | 'queryType'
              >)
            | ({ __typename: 'DataTable' } & Pick<
                IDataTable,
                'id' | 'display' | 'queryType'
              >)
            | ({ __typename: 'Expression' } & Pick<
                IExpression,
                'id' | 'display' | 'queryType'
              >)
            | ({ __typename: 'Funnel' } & Pick<
                IFunnel,
                'id' | 'display' | 'queryType'
              >)
            | ({ __typename: 'Path' } & Pick<
                IPath,
                'id' | 'display' | 'queryType'
              >)
            | ({ __typename: 'Prediction' } & Pick<
                IPrediction,
                'id' | 'display' | 'queryType'
              >)
            | ({ __typename: 'Retention' } & Pick<
                IRetention,
                'id' | 'display' | 'queryType'
              >)
            | ({ __typename: 'Significance' } & Pick<
                ISignificance,
                'id' | 'display' | 'queryType'
              >);
          alertThresholds: { __typename: 'AlertThresholds' } & {
            list: Array<
              | ({ __typename: 'AlertThresholdAnomaly' } & Pick<
                  IAlertThresholdAnomaly,
                  'kind'
                >)
              | ({ __typename: 'AlertThresholdCustom' } & Pick<
                  IAlertThresholdCustom,
                  'kind' | 'compareValue' | 'valueIsPercent'
                > & {
                    compareOp: { __typename: 'AlertThresholdCompareOp' } & Pick<
                      IAlertThresholdCompareOp,
                      'key' | 'display' | 'requireComparison'
                    >;
                    logicOp: Maybe<
                      { __typename: 'LogicalOperator' } & Pick<
                        ILogicalOperator,
                        'key' | 'name'
                      >
                    >;
                  })
            >;
          };
        })
      | ({ __typename: 'CohortScheduleEntity' } & Pick<
          ICohortScheduleEntity,
          'brazeRemoveOutdated'
        > & {
            item:
              | ({ __typename: 'CompoundCohort' } & Pick<ICompoundCohort, 'id'>)
              | ({ __typename: 'ExpressionCohort' } & Pick<
                  IExpressionCohort,
                  'id'
                >)
              | ({ __typename: 'FunnelCohort' } & Pick<IFunnelCohort, 'id'>)
              | ({ __typename: 'MeasureCohort' } & Pick<IMeasureCohort, 'id'>)
              | ({ __typename: 'PerformedCohort' } & Pick<
                  IPerformedCohort,
                  'id'
                >)
              | ({ __typename: 'RetentionCohort' } & Pick<
                  IRetentionCohort,
                  'id'
                >);
          })
      | ({ __typename: 'DashboardScheduleEntity' } & {
          item: { __typename: 'Dashboard' } & IDashboardInstanceFieldsFragment;
        });
    recipients: Array<
      Maybe<
        { __typename: 'User' } & Pick<
          IUser,
          'id' | 'email' | 'name' | 'picture' | 'lastLogin'
        >
      >
    >;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
  };

export type IScheduleFieldsFragment = { __typename: 'Schedule' } & Pick<
  ISchedule,
  | 'id'
  | 'name'
  | 'description'
  | 'type'
  | 'cron'
  | 'timezone'
  | 'paused'
  | 'emailList'
  | 'alertOnly'
  | 'lastRunStatus'
  | 'nextRunAt'
  | 'lastRunAt'
  | 'entityUrl'
> & {
    slackDestination: Maybe<
      | ({
          __typename: 'SlackChannelDestination';
        } & ISlackDestinationFields_SlackChannelDestination_Fragment)
      | ({
          __typename: 'SlackMemberDestination';
        } & ISlackDestinationFields_SlackMemberDestination_Fragment)
    >;
    entity:
      | ({ __typename: 'AnalysisScheduleEntity' } & {
          item:
            | ({
                __typename: 'CohortSample';
              } & IAnalysisInfoFields_CohortSample_Fragment)
            | ({
                __typename: 'DataTable';
              } & IAnalysisInfoFields_DataTable_Fragment)
            | ({
                __typename: 'Expression';
              } & IAnalysisInfoFields_Expression_Fragment)
            | ({ __typename: 'Funnel' } & IAnalysisInfoFields_Funnel_Fragment)
            | ({ __typename: 'Path' } & IAnalysisInfoFields_Path_Fragment)
            | ({
                __typename: 'Prediction';
              } & IAnalysisInfoFields_Prediction_Fragment)
            | ({
                __typename: 'Retention';
              } & IAnalysisInfoFields_Retention_Fragment)
            | ({
                __typename: 'Significance';
              } & IAnalysisInfoFields_Significance_Fragment);
          alertThresholds: { __typename: 'AlertThresholds' } & {
            list: Array<
              | ({ __typename: 'AlertThresholdAnomaly' } & Pick<
                  IAlertThresholdAnomaly,
                  'kind'
                >)
              | ({ __typename: 'AlertThresholdCustom' } & Pick<
                  IAlertThresholdCustom,
                  'kind' | 'compareValue' | 'valueIsPercent'
                > & {
                    compareOp: { __typename: 'AlertThresholdCompareOp' } & Pick<
                      IAlertThresholdCompareOp,
                      'key' | 'display' | 'requireComparison'
                    >;
                    logicOp: Maybe<
                      { __typename: 'LogicalOperator' } & Pick<
                        ILogicalOperator,
                        'key' | 'name'
                      >
                    >;
                  })
            >;
          };
        })
      | ({ __typename: 'CohortScheduleEntity' } & Pick<
          ICohortScheduleEntity,
          'brazeRemoveOutdated'
        > & {
            item:
              | ({ __typename: 'CompoundCohort' } & Pick<ICompoundCohort, 'id'>)
              | ({ __typename: 'ExpressionCohort' } & Pick<
                  IExpressionCohort,
                  'id'
                >)
              | ({ __typename: 'FunnelCohort' } & Pick<IFunnelCohort, 'id'>)
              | ({ __typename: 'MeasureCohort' } & Pick<IMeasureCohort, 'id'>)
              | ({ __typename: 'PerformedCohort' } & Pick<
                  IPerformedCohort,
                  'id'
                >)
              | ({ __typename: 'RetentionCohort' } & Pick<
                  IRetentionCohort,
                  'id'
                >);
          })
      | ({ __typename: 'DashboardScheduleEntity' } & {
          item: { __typename: 'Dashboard' } & IDashboardInstanceFieldsFragment;
          alertAnalyses: Array<
            | ({ __typename: 'CohortSample' } & Pick<
                ICohortSample,
                'id' | 'queryType' | 'display' | 'createdAt'
              >)
            | ({ __typename: 'DataTable' } & Pick<
                IDataTable,
                'id' | 'queryType' | 'display' | 'createdAt'
              >)
            | ({ __typename: 'Expression' } & Pick<
                IExpression,
                'id' | 'queryType' | 'display' | 'createdAt'
              >)
            | ({ __typename: 'Funnel' } & Pick<
                IFunnel,
                'id' | 'queryType' | 'display' | 'createdAt'
              >)
            | ({ __typename: 'Path' } & Pick<
                IPath,
                'id' | 'queryType' | 'display' | 'createdAt'
              >)
            | ({ __typename: 'Prediction' } & Pick<
                IPrediction,
                'id' | 'queryType' | 'display' | 'createdAt'
              >)
            | ({ __typename: 'Retention' } & Pick<
                IRetention,
                'id' | 'queryType' | 'display' | 'createdAt'
              >)
            | ({ __typename: 'Significance' } & Pick<
                ISignificance,
                'id' | 'queryType' | 'display' | 'createdAt'
              >)
          >;
        });
    recipients: Array<
      Maybe<
        { __typename: 'User' } & Pick<
          IUser,
          'id' | 'email' | 'name' | 'picture' | 'lastLogin'
        >
      >
    >;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
  };

export type IPauseScheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IPauseScheduleMutation = { __typename: 'Mutation' } & {
  pauseSchedule: { __typename: 'SchedulePausePayload' } & Pick<
    ISchedulePausePayload,
    'message'
  > & {
      errors: Array<
        { __typename: 'Error' } & Pick<IError, 'field' | 'messages'>
      >;
    };
};

export type IResumeScheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IResumeScheduleMutation = { __typename: 'Mutation' } & {
  resumeSchedule: { __typename: 'ScheduleResumePayload' } & Pick<
    IScheduleResumePayload,
    'message'
  > & {
      errors: Array<
        { __typename: 'Error' } & Pick<IError, 'field' | 'messages'>
      >;
    };
};

export type IScheduleConfigQueryVariables = Exact<{ [key: string]: never }>;

export type IScheduleConfigQuery = { __typename: 'Query' } & {
  scheduleConfig: Maybe<
    { __typename: 'ScheduleConfig' } & Pick<IScheduleConfig, 'names'> & {
        limits: Array<
          { __typename: 'ScheduleTypeLimit' } & Pick<
            IScheduleTypeLimit,
            'type' | 'exceeded' | 'maxCount'
          >
        >;
        alertThresholdCompareOps: Array<
          { __typename: 'AlertThresholdCompareOp' } & Pick<
            IAlertThresholdCompareOp,
            'key' | 'display' | 'requireComparison'
          >
        >;
      }
  >;
};

export type IGetScheduleQueryVariables = Exact<{
  scheduleId: Scalars['ID']['input'];
}>;

export type IGetScheduleQuery = { __typename: 'Query' } & {
  scheduleGet: { __typename: 'Schedule' } & IScheduleFieldsFragment;
};

export type IScheduleHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
  scheduleId: Scalars['ID']['input'];
}>;

export type IScheduleHistoryQuery = { __typename: 'Query' } & {
  scheduleHistory: Maybe<
    Array<
      Maybe<
        | ({ __typename: 'AnalysesRun' } & Pick<
            IAnalysesRun,
            | 'id'
            | 'runAt'
            | 'outcome'
            | 'screenshotUrl'
            | 'entityUrl'
            | 'createdAt'
          > & {
              schedule: {
                __typename: 'Schedule';
              } & IScheduleHistoryFieldsFragment;
            })
        | ({ __typename: 'BrazeCohortImportRun' } & Pick<
            IBrazeCohortImportRun,
            'id' | 'runAt' | 'outcome' | 'createdAt' | 'importedUsers'
          > & {
              schedule: {
                __typename: 'Schedule';
              } & IScheduleHistoryFieldsFragment;
            })
      >
    >
  >;
};

export type IUpdateScheduleMutationVariables = Exact<{
  input: IScheduleInput;
  id: Scalars['ID']['input'];
}>;

export type IUpdateScheduleMutation = { __typename: 'Mutation' } & {
  updateSchedule: { __typename: 'ScheduleCreatePayload' } & {
    schedule: Maybe<{ __typename: 'Schedule' } & IScheduleFieldsFragment>;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field' | 'messages'>>;
  };
};

export type IImageEmbedNoteFieldsFragment = { __typename: 'ImageEmbedNote' } & {
  imageEmbed: { __typename: 'ImageEmbed' } & IImageEmbedFieldsFragment;
};

export type IDashboardNoteFieldsFragment = { __typename: 'DashboardNote' } & {
  dashboard: { __typename: 'Dashboard' } & IDashboardInstanceFieldsFragment;
};

export type IReportNoteFieldsFragment = { __typename: 'ReportNote' } & {
  analysis:
    | ({
        __typename: 'CohortSample';
      } & IAnalysisInfoFields_CohortSample_Fragment)
    | ({ __typename: 'DataTable' } & IAnalysisInfoFields_DataTable_Fragment)
    | ({ __typename: 'Expression' } & IAnalysisInfoFields_Expression_Fragment)
    | ({ __typename: 'Funnel' } & IAnalysisInfoFields_Funnel_Fragment)
    | ({ __typename: 'Path' } & IAnalysisInfoFields_Path_Fragment)
    | ({ __typename: 'Prediction' } & IAnalysisInfoFields_Prediction_Fragment)
    | ({ __typename: 'Retention' } & IAnalysisInfoFields_Retention_Fragment)
    | ({
        __typename: 'Significance';
      } & IAnalysisInfoFields_Significance_Fragment);
};

export type ICohortNoteFieldsFragment = { __typename: 'CohortNote' } & {
  cohort:
    | ({ __typename: 'CompoundCohort' } & ICohortFields_CompoundCohort_Fragment)
    | ({
        __typename: 'ExpressionCohort';
      } & ICohortFields_ExpressionCohort_Fragment)
    | ({ __typename: 'FunnelCohort' } & ICohortFields_FunnelCohort_Fragment)
    | ({ __typename: 'MeasureCohort' } & ICohortFields_MeasureCohort_Fragment)
    | ({
        __typename: 'PerformedCohort';
      } & ICohortFields_PerformedCohort_Fragment)
    | ({
        __typename: 'RetentionCohort';
      } & ICohortFields_RetentionCohort_Fragment);
};

export type IScratchpadBasicFragmentFragment = {
  __typename: 'Scratchpad';
} & Pick<IScratchpad, 'id' | 'title' | 'createdAt' | 'editedAt' | 'shared'> & {
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    editor: { __typename: 'User' } & IEditorFieldsFragment;
    permission: {
      __typename: 'EntityPermission';
    } & IEntityPermissionFieldsFragment;
  };

export type IRichTextNoteFieldsFragment = { __typename: 'RichTextNote' } & {
  richText: { __typename: 'RichText' } & IRichTextFieldsFragment;
};

export type IScratchpadWithNotesFragmentFragment = {
  __typename: 'Scratchpad';
} & {
  notes: Maybe<
    Array<
      Maybe<
        { __typename: 'Note' } & Pick<INote, 'id' | 'seq'> & {
            content:
              | ({ __typename: 'CohortNote' } & ICohortNoteFieldsFragment)
              | ({ __typename: 'DashboardNote' } & IDashboardNoteFieldsFragment)
              | ({
                  __typename: 'ImageEmbedNote';
                } & IImageEmbedNoteFieldsFragment)
              | ({ __typename: 'ReportNote' } & IReportNoteFieldsFragment)
              | ({ __typename: 'RichTextNote' } & IRichTextNoteFieldsFragment);
          }
      >
    >
  >;
} & IScratchpadBasicFragmentFragment;

export type ICreateScratchpadMutationVariables = Exact<{
  input: IScratchpadCreateInput;
}>;

export type ICreateScratchpadMutation = { __typename: 'Mutation' } & {
  scratchpadCreate: { __typename: 'ScratchpadCreatePayload' } & {
    entity: Maybe<
      { __typename: 'Scratchpad' } & IScratchpadBasicFragmentFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IAddScratchpadNoteMutationVariables = Exact<{
  input: IScratchpadNoteAddInput;
}>;

export type IAddScratchpadNoteMutation = { __typename: 'Mutation' } & {
  scratchpadNoteAdd: { __typename: 'ScratchpadNoteAddPayload' } & {
    entity: Maybe<{ __typename: 'Scratchpad' } & Pick<IScratchpad, 'id'>>;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IDeleteScratchpadNoteMutationVariables = Exact<{
  input: IScratchpadNoteDeleteInput;
}>;

export type IDeleteScratchpadNoteMutation = { __typename: 'Mutation' } & {
  scratchpadNoteDelete: { __typename: 'ScratchpadNoteDeletePayload' } & {
    entity: Maybe<{ __typename: 'Scratchpad' } & Pick<IScratchpad, 'id'>>;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IMoveScratchpadNoteMutationVariables = Exact<{
  input: IScratchpadNoteMoveInput;
}>;

export type IMoveScratchpadNoteMutation = { __typename: 'Mutation' } & {
  scratchpadNoteMove: { __typename: 'ScratchpadNoteMovePayload' } & {
    entity: Maybe<{ __typename: 'Scratchpad' } & Pick<IScratchpad, 'id'>>;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IEditScratchpadMutationVariables = Exact<{
  input: IScratchpadEditInput;
}>;

export type IEditScratchpadMutation = { __typename: 'Mutation' } & {
  scratchpadEdit: { __typename: 'ScratchpadEditPayload' } & {
    entity: Maybe<{ __typename: 'Scratchpad' } & Pick<IScratchpad, 'id'>>;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IEditScratchpadTextNoteMutationVariables = Exact<{
  input: IScratchpadTextNoteEditInput;
}>;

export type IEditScratchpadTextNoteMutation = { __typename: 'Mutation' } & {
  scratchpadTextNoteEdit: { __typename: 'ScratchpadTextNoteEditPayload' } & {
    entity: Maybe<{ __typename: 'RichTextNote' } & IRichTextNoteFieldsFragment>;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IGetScratchpadsQueryVariables = Exact<{ [key: string]: never }>;

export type IGetScratchpadsQuery = { __typename: 'Query' } & {
  scratchpads: { __typename: 'ScratchpadsPayload' } & {
    entities: Array<
      { __typename: 'Scratchpad' } & IScratchpadBasicFragmentFragment
    >;
  };
};

export type IGetScratchpadQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IGetScratchpadQuery = { __typename: 'Query' } & {
  scratchpadGet: {
    __typename: 'Scratchpad';
  } & IScratchpadWithNotesFragmentFragment;
};

export type IDeleteScratchpadMutationVariables = Exact<{
  input: IScratchpadDeleteInput;
}>;

export type IDeleteScratchpadMutation = { __typename: 'Mutation' } & {
  scratchpadDelete: { __typename: 'ScratchpadDeletePayload' } & Pick<
    IScratchpadDeletePayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IVisitScratchpadMutationVariables = Exact<{
  input: IScratchpadVisitInput;
}>;

export type IVisitScratchpadMutation = { __typename: 'Mutation' } & {
  scratchpadVisit: { __typename: 'ScratchpadVisitPayload' } & {
    entity: Maybe<
      { __typename: 'Scratchpad' } & IScratchpadBasicFragmentFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IScratchpadEntityPermissionEditMutationVariables = Exact<{
  input: IEntityPermissionEditInput;
}>;

export type IScratchpadEntityPermissionEditMutation = {
  __typename: 'Mutation';
} & {
  entityPermissionEdit: { __typename: 'EntityPermissionEditPayload' } & {
    entity: Maybe<
      { __typename: 'EntityPermission' } & IEntityPermissionFieldsFragment
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type ICreateScratchpadImageEmbedUploadConfigMutationVariables = Exact<{
  input: IScratchpadImageEmbedPostUploadConfigInput;
}>;

export type ICreateScratchpadImageEmbedUploadConfigMutation = {
  __typename: 'Mutation';
} & {
  createScratchpadImageEmbedUploadConfig: {
    __typename: 'ScratchpadImageEmbedUploadConfig';
  } & {
    imageEmbed: { __typename: 'ImageEmbed' } & IImageEmbedFieldsFragment;
    postUploadConfig: {
      __typename: 'PostUploadConfig';
    } & IPostUploadConfigFieldsFragment;
  };
};

export type IBreakdownCriteriaFieldsFragment = {
  __typename: 'BreakdownCriteria';
} & Pick<IBreakdownCriteria, 'controlGroup' | 'variants'> & {
    field: { __typename: 'Field' } & IFieldFieldsFragment;
  };

export type IExperimentCriteriaFieldsFragment = {
  __typename: 'ExperimentCriteria';
} & Pick<IExperimentCriteria, 'experiment'> & {
    criteriaControlGroup: IExperimentCriteria['controlGroup'];
    criteriaVariants: IExperimentCriteria['variants'];
  } & {
    experimentField: { __typename: 'Field' } & IFieldFieldsFragment;
    variationField: { __typename: 'Field' } & IFieldFieldsFragment;
  };

export type ISegmentCriteriaFieldsFragment = {
  __typename: 'SegmentCriteria';
} & {
  segmentControlGroup:
    | ({ __typename: 'CompoundCohort' } & ICohortFields_CompoundCohort_Fragment)
    | ({
        __typename: 'ExpressionCohort';
      } & ICohortFields_ExpressionCohort_Fragment)
    | ({ __typename: 'FunnelCohort' } & ICohortFields_FunnelCohort_Fragment)
    | ({ __typename: 'MeasureCohort' } & ICohortFields_MeasureCohort_Fragment)
    | ({
        __typename: 'PerformedCohort';
      } & ICohortFields_PerformedCohort_Fragment)
    | ({
        __typename: 'RetentionCohort';
      } & ICohortFields_RetentionCohort_Fragment);
  segmentVariants: Array<
    | ({ __typename: 'CompoundCohort' } & ICohortFields_CompoundCohort_Fragment)
    | ({
        __typename: 'ExpressionCohort';
      } & ICohortFields_ExpressionCohort_Fragment)
    | ({ __typename: 'FunnelCohort' } & ICohortFields_FunnelCohort_Fragment)
    | ({ __typename: 'MeasureCohort' } & ICohortFields_MeasureCohort_Fragment)
    | ({
        __typename: 'PerformedCohort';
      } & ICohortFields_PerformedCohort_Fragment)
    | ({
        __typename: 'RetentionCohort';
      } & ICohortFields_RetentionCohort_Fragment)
  >;
};

export type IFunnelMetricFieldsFragment = { __typename: 'FunnelMetric' } & Pick<
  IFunnelMetric,
  'convertedOnStep' | 'ttcMetric'
> & {
    funnel: { __typename: 'Funnel' } & Pick<IFunnel, 'id' | 'display'> & {
        query: { __typename: 'FunnelQuery' } & {
          steps: Array<
            { __typename: 'FunnelStep' } & IFunnelStepFieldsFragment
          >;
          mode: Maybe<{ __typename: 'FunnelMode' } & Pick<IFunnelMode, 'key'>>;
          modeSlices: Array<
            { __typename: 'FunnelModeSlice' } & IFunnelModeSliceFieldsFragment
          >;
        };
        pref: { __typename: 'AnalysisPref' } & {
          aliasReplacements: Array<
            {
              __typename: 'UserAliasReplacement';
            } & IUserAliasReplacementFieldsFragment
          >;
        };
      };
  };

export type IMeasureMetricFieldsFragment = { __typename: 'MeasureMetric' } & {
  measure:
    | ({
        __typename: 'CompoundMeasure';
      } & IMeasureFields_CompoundMeasure_Fragment)
    | ({ __typename: 'SimpleMeasure' } & IMeasureFields_SimpleMeasure_Fragment);
};

export type IQueryMetricFieldsFragment = { __typename: 'QueryMetric' } & {
  expression: { __typename: 'Expression' } & Pick<
    IExpression,
    'id' | 'display'
  > & {
      pref: { __typename: 'AnalysisPref' } & {
        aliasReplacements: Array<
          {
            __typename: 'UserAliasReplacement';
          } & IUserAliasReplacementFieldsFragment
        >;
      };
    };
  measure:
    | ({
        __typename: 'CompoundMeasure';
      } & IMeasureFields_CompoundMeasure_Fragment)
    | ({ __typename: 'SimpleMeasure' } & IMeasureFields_SimpleMeasure_Fragment);
};

export type IRetentionMetricFieldsFragment = {
  __typename: 'RetentionMetric';
} & {
  retention: { __typename: 'Retention' } & Pick<IRetention, 'id' | 'display'>;
};

export type IMetricTypeFieldsFragment = { __typename: 'MetricType' } & Pick<
  IMetricType,
  'key' | 'name'
>;

export type ISignificanceModeFieldsFragment = {
  __typename: 'SignificanceMode';
} & Pick<ISignificanceMode, 'key' | 'name'>;

export type ISignificanceTestFieldsFragment = {
  __typename: 'SignificanceTest';
} & Pick<ISignificanceTest, 'key' | 'name'>;

export type IExperimentFieldsFragment = { __typename: 'Experiment' } & {
  experimentField: { __typename: 'Field' } & IFieldFieldsFragment;
  variantField: { __typename: 'Field' } & IFieldFieldsFragment;
};

export type ISignificanceQueryFieldsFragment = {
  __typename: 'SignificanceQuery';
} & Pick<
  ISignificanceQuery,
  'confidenceLevel' | 'samplePercentage' | 'significanceLevel' | 'timeUnit'
> & {
    cohortRefs: Array<{ __typename: 'CohortRef' } & ICohortRefFieldsFragment>;
    criteria:
      | ({ __typename: 'BreakdownCriteria' } & IBreakdownCriteriaFieldsFragment)
      | ({
          __typename: 'ExperimentCriteria';
        } & IExperimentCriteriaFieldsFragment)
      | ({ __typename: 'SegmentCriteria' } & ISegmentCriteriaFieldsFragment);
    filter: Maybe<
      | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
      | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
    >;
    metric:
      | ({ __typename: 'FunnelMetric' } & IFunnelMetricFieldsFragment)
      | ({ __typename: 'MeasureMetric' } & IMeasureMetricFieldsFragment)
      | ({ __typename: 'QueryMetric' } & IQueryMetricFieldsFragment)
      | ({ __typename: 'RetentionMetric' } & IRetentionMetricFieldsFragment);
    metricType: { __typename: 'MetricType' } & IMetricTypeFieldsFragment;
    significanceMode: {
      __typename: 'SignificanceMode';
    } & ISignificanceModeFieldsFragment;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    significanceSubject: { __typename: 'Subject' } & ISubjectFieldsFragment;
    test: { __typename: 'SignificanceTest' } & ISignificanceTestFieldsFragment;
    llmChatMessages: Array<
      { __typename: 'LlmChatMessage' } & ILlmChatMessageFieldsFragment
    >;
  };

export type ISignificanceExecuteMutationVariables = Exact<{
  input: ISignificanceExecuteInput;
}>;

export type ISignificanceExecuteMutation = { __typename: 'Mutation' } & {
  significanceExecute: { __typename: 'SignificanceExecutePayload' } & {
    entity: Maybe<
      | ({ __typename: 'CohortSample' } & {
          query: { __typename: 'CohortSampleQuery' };
        } & IAnalysisMetaFields_CohortSample_Fragment)
      | ({ __typename: 'DataTable' } & {
          query: { __typename: 'DataTableQuery' };
        } & IAnalysisMetaFields_DataTable_Fragment)
      | ({ __typename: 'Expression' } & {
          query: { __typename: 'ExpressionQuery' };
        } & IAnalysisMetaFields_Expression_Fragment)
      | ({ __typename: 'Funnel' } & {
          query: { __typename: 'FunnelQuery' };
        } & IAnalysisMetaFields_Funnel_Fragment)
      | ({ __typename: 'Path' } & {
          query: { __typename: 'PathQuery' };
        } & IAnalysisMetaFields_Path_Fragment)
      | ({ __typename: 'Prediction' } & {
          query: { __typename: 'PredictionQuery' };
        } & IAnalysisMetaFields_Prediction_Fragment)
      | ({ __typename: 'Retention' } & {
          query: { __typename: 'RetentionQuery' };
        } & IAnalysisMetaFields_Retention_Fragment)
      | ({ __typename: 'Significance' } & {
          query: {
            __typename: 'SignificanceQuery';
          } & ISignificanceQueryFieldsFragment;
        } & IAnalysisMetaFields_Significance_Fragment)
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IHypothesisFieldsFragment = { __typename: 'Hypothesis' } & Pick<
  IHypothesis,
  'mean' | 'observedCount' | 'sampleSize' | 'standardDeviation' | 'variant'
>;

export type IHypothesisStatsDataFieldsFragment = {
  __typename: 'HypothesisStatsData';
} & Pick<
  IHypothesisStatsData,
  | 'chanceToOutperform'
  | 'conversionRate'
  | 'criticalValue'
  | 'dof'
  | 'effectSize'
  | 'executedSimulations'
  | 'pValue'
  | 'simulationsExecutionTime'
  | 'standardError'
  | 'statisticalPower'
  | 'statisticalSignificance'
  | 'testScore'
  | 'delta'
  | 'lift'
  | 'errorMessage'
> & {
    confidenceInterval: { __typename: 'ConfidenceInterval' } & Pick<
      IConfidenceInterval,
      'lowerBound' | 'upperBound'
    >;
  };

export type INullHypothesisStatsDataFieldsFragment = {
  __typename: 'NullHypothesisStatsData';
} & Pick<
  INullHypothesisStatsData,
  'conversionRate' | 'standardError' | 'errorMessage'
>;

export type IExperimentResultFieldsFragment = {
  __typename: 'ExperimentResult';
} & {
  hypothesesStats: Array<
    { __typename: 'HypothesisStatsData' } & IHypothesisStatsDataFieldsFragment
  >;
  nullHypothesisStats: {
    __typename: 'NullHypothesisStatsData';
  } & INullHypothesisStatsDataFieldsFragment;
};

export type ISignificanceDataFieldsFragment = {
  __typename: 'SignificanceData';
} & Pick<ISignificanceData, 'isEmpty' | 'metric'> & {
    hypotheses: Array<{ __typename: 'Hypothesis' } & IHypothesisFieldsFragment>;
    hypothesisResults: Array<
      { __typename: 'ExperimentResult' } & IExperimentResultFieldsFragment
    >;
    nullHypothesis: { __typename: 'Hypothesis' } & IHypothesisFieldsFragment;
  };

export type ISignificanceConfigFieldsFragment = {
  __typename: 'SignificanceConfig';
} & Pick<
  ISignificanceConfig,
  | 'defaultEnd'
  | 'defaultFormulaSamplingRate'
  | 'defaultStart'
  | 'defaultTimeUnit'
  | 'liveStartDate'
  | 'schema'
  | 'timeUnits'
  | 'timezone'
> & {
    cohortConfig: { __typename: 'CohortConfig' } & ICohortConfigFieldsFragment;
    defaultMetric: { __typename: 'MetricType' } & IMetricTypeFieldsFragment;
    metrics: Array<{ __typename: 'MetricType' } & IMetricTypeFieldsFragment>;
    defaultMode: {
      __typename: 'SignificanceMode';
    } & ISignificanceModeFieldsFragment;
    modes: Array<
      { __typename: 'SignificanceMode' } & ISignificanceModeFieldsFragment
    >;
    defaultSubject: { __typename: 'Subject' } & ISubjectFieldsFragment;
    subjects: Array<{ __typename: 'Subject' } & ISubjectFieldsFragment>;
    experimentConfig: Maybe<
      { __typename: 'Experiment' } & IExperimentFieldsFragment
    >;
    defaultTest: {
      __typename: 'SignificanceTest';
    } & ISignificanceTestFieldsFragment;
    tests: Array<
      { __typename: 'SignificanceTest' } & ISignificanceTestFieldsFragment
    >;
    defaultDatePicker:
      | ({
          __typename: 'DatePickerFixed';
        } & IDatePickerFields_DatePickerFixed_Fragment)
      | ({
          __typename: 'DatePickerLast';
        } & IDatePickerFields_DatePickerLast_Fragment)
      | ({
          __typename: 'DatePickerLastFull';
        } & IDatePickerFields_DatePickerLastFull_Fragment)
      | ({
          __typename: 'DatePickerSince';
        } & IDatePickerFields_DatePickerSince_Fragment)
      | ({
          __typename: 'DatePickerStartOf';
        } & IDatePickerFields_DatePickerStartOf_Fragment);
  };

export type ISlackMemberFieldsFragment = { __typename: 'SlackMember' } & Pick<
  ISlackMember,
  'id' | 'name'
>;

export type ISlackTeamFieldsFragment = { __typename: 'SlackTeam' } & Pick<
  ISlackTeam,
  'id' | 'name'
>;

export type ISlackChannelFieldsFragment = { __typename: 'SlackChannel' } & Pick<
  ISlackChannel,
  'id' | 'name' | 'type'
>;

export type ISlackDestinationEntitiesFieldsFragment = {
  __typename: 'SlackDestinationEntities';
} & {
  team: { __typename: 'SlackTeam' } & ISlackTeamFieldsFragment;
  channels: Array<{ __typename: 'SlackChannel' } & ISlackChannelFieldsFragment>;
  members: Array<{ __typename: 'SlackMember' } & ISlackMemberFieldsFragment>;
};

export type ISlackInstallationFieldsFragment = {
  __typename: 'SlackInstallation';
} & {
  member: { __typename: 'SlackMember' } & ISlackMemberFieldsFragment;
  team: { __typename: 'SlackTeam' } & ISlackTeamFieldsFragment;
};

export type ISlackEntitySourceFieldsFragment = {
  __typename: 'SlackEntitySource';
} & Pick<ISlackEntitySource, 'entityType' | 'entityId'>;

export type ISlackAdminSourceFieldsFragment = {
  __typename: 'SlackAdminSource';
};

type ISlackSourceFields_SlackAdminSource_Fragment = {
  __typename: 'SlackAdminSource';
} & ISlackAdminSourceFieldsFragment;

type ISlackSourceFields_SlackEntitySource_Fragment = {
  __typename: 'SlackEntitySource';
} & ISlackEntitySourceFieldsFragment;

export type ISlackSourceFieldsFragment =
  | ISlackSourceFields_SlackAdminSource_Fragment
  | ISlackSourceFields_SlackEntitySource_Fragment;

export type ISlackChannelDestinationFieldsFragment = {
  __typename: 'SlackChannelDestination';
} & {
  team: { __typename: 'SlackTeam' } & ISlackTeamFieldsFragment;
  channel: { __typename: 'SlackChannel' } & ISlackChannelFieldsFragment;
};

export type ISlackMemberDestinationFieldsFragment = {
  __typename: 'SlackMemberDestination';
} & {
  team: { __typename: 'SlackTeam' } & ISlackTeamFieldsFragment;
  member: { __typename: 'SlackMember' } & ISlackMemberFieldsFragment;
};

type ISlackDestinationFields_SlackChannelDestination_Fragment = {
  __typename: 'SlackChannelDestination';
} & ISlackChannelDestinationFieldsFragment;

type ISlackDestinationFields_SlackMemberDestination_Fragment = {
  __typename: 'SlackMemberDestination';
} & ISlackMemberDestinationFieldsFragment;

export type ISlackDestinationFieldsFragment =
  | ISlackDestinationFields_SlackChannelDestination_Fragment
  | ISlackDestinationFields_SlackMemberDestination_Fragment;

export type ISlackConnectionFieldsFragment = {
  __typename: 'SlackConnection';
} & {
  source:
    | ({
        __typename: 'SlackAdminSource';
      } & ISlackSourceFields_SlackAdminSource_Fragment)
    | ({
        __typename: 'SlackEntitySource';
      } & ISlackSourceFields_SlackEntitySource_Fragment);
  destination:
    | ({
        __typename: 'SlackChannelDestination';
      } & ISlackDestinationFields_SlackChannelDestination_Fragment)
    | ({
        __typename: 'SlackMemberDestination';
      } & ISlackDestinationFields_SlackMemberDestination_Fragment);
};

export type ISlackConnectMutationVariables = Exact<{
  input: ISlackConnectInput;
}>;

export type ISlackConnectMutation = { __typename: 'Mutation' } & {
  slackConnect: { __typename: 'SlackConnectPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<
      { __typename: 'SlackConnection' } & ISlackConnectionFieldsFragment
    >;
  };
};

export type ISlackDisconnectMutationVariables = Exact<{
  input: ISlackDisconnectInput;
}>;

export type ISlackDisconnectMutation = { __typename: 'Mutation' } & {
  slackDisconnect: { __typename: 'SlackDisconnectPayload' } & Pick<
    ISlackDisconnectPayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type ISlackOAuthCallbackMutationVariables = Exact<{
  input: ISlackOAuthCallbackInput;
}>;

export type ISlackOAuthCallbackMutation = { __typename: 'Mutation' } & {
  slackOAuthCallback: { __typename: 'SlackOAuthCallbackPayload' } & Pick<
    ISlackOAuthCallbackPayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type ISlackOAuthStartMutationVariables = Exact<{ [key: string]: never }>;

export type ISlackOAuthStartMutation = { __typename: 'Mutation' } & {
  slackOAuthStart: { __typename: 'SlackOAuthStartPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<
      { __typename: 'SlackOAuthStart' } & Pick<ISlackOAuthStart, 'authorizeUrl'>
    >;
  };
};

export type ISlackUninstallMutationVariables = Exact<{ [key: string]: never }>;

export type ISlackUninstallMutation = { __typename: 'Mutation' } & {
  slackUninstall: { __typename: 'SlackUninstallPayload' } & Pick<
    ISlackUninstallPayload,
    'message'
  > & { errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment> };
};

export type IGetSlackDestinationEntitiesQueryVariables = Exact<{
  term: Scalars['String']['input'];
  channelLimit: Scalars['Int']['input'];
}>;

export type IGetSlackDestinationEntitiesQuery = { __typename: 'Query' } & {
  slackDestinationEntities: {
    __typename: 'SlackDestinationEntities';
  } & ISlackDestinationEntitiesFieldsFragment;
};

export type IGetSlackConnectionQueryVariables = Exact<{
  input: ISlackSourceInput;
}>;

export type IGetSlackConnectionQuery = { __typename: 'Query' } & {
  slackConnection: Maybe<
    { __typename: 'SlackConnection' } & ISlackConnectionFieldsFragment
  >;
};

export type ITileFieldsFragment = { __typename: 'Tile' } & Pick<
  ITile,
  'createdAt' | 'description' | 'icon' | 'id' | 'title' | 'url'
> & { creator: { __typename: 'User' } & ICreatorFieldsFragment };

export type IAddTileMutationVariables = Exact<{
  input: ITileAddInput;
}>;

export type IAddTileMutation = { __typename: 'Mutation' } & {
  tileAdd: { __typename: 'TilePayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<{ __typename: 'Tile' } & ITileFieldsFragment>;
  };
};

export type IDeleteTileMutationVariables = Exact<{
  input: ITileDeleteInput;
}>;

export type IDeleteTileMutation = { __typename: 'Mutation' } & {
  tileDelete: { __typename: 'TilePayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<{ __typename: 'Tile' } & ITileFieldsFragment>;
  };
};

export type IUpdateTileMutationVariables = Exact<{
  input: ITileUpdateInput;
}>;

export type IUpdateTileMutation = { __typename: 'Mutation' } & {
  tileUpdate: { __typename: 'TilePayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    entity: Maybe<{ __typename: 'Tile' } & ITileFieldsFragment>;
  };
};

export type IGetTilesQueryVariables = Exact<{ [key: string]: never }>;

export type IGetTilesQuery = { __typename: 'Query' } & {
  tilesGet: { __typename: 'TilesPayload' } & {
    tiles: Array<{ __typename: 'Tile' } & ITileFieldsFragment>;
  };
};

export type ISearchHighlightFieldsFragment = {
  __typename: 'SearchHighlight';
} & Pick<ISearchHighlight, 'field'> & {
    highlightedRanges: Array<
      { __typename: 'SearchHighlightRange' } & Pick<
        ISearchHighlightRange,
        'start' | 'end'
      >
    >;
  };

export type IIdSearchEntityFieldsFragment = {
  __typename: 'IdSearchEntity';
} & Pick<
  IIdSearchEntity,
  | 'type'
  | 'name'
  | 'detail'
  | 'id'
  | 'createdAt'
  | 'editedAt'
  | 'updatedAt'
  | 'isDisabled'
> & { nullableBaseId: IIdSearchEntity['baseId'] } & {
    nullableSchema: Maybe<
      { __typename: 'Schema' } & Pick<ISchema, 'id' | 'name'>
    >;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    editor: { __typename: 'User' } & IEditorFieldsFragment;
  };

export type IKeySearchEntityFieldsFragment = {
  __typename: 'KeySearchEntity';
} & Pick<
  IKeySearchEntity,
  'type' | 'detail' | 'name' | 'key' | 'isDisabled'
> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id' | 'name'>;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };

export type ISearchDashboardFieldsFragment = {
  __typename: 'SearchDashboard';
} & Pick<
  ISearchDashboard,
  | 'type'
  | 'name'
  | 'detail'
  | 'id'
  | 'baseId'
  | 'path'
  | 'createdAt'
  | 'editedAt'
  | 'updatedAt'
  | 'isDisabled'
> & {
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    editor: { __typename: 'User' } & IEditorFieldsFragment;
  };

export type IUniversalSearchAnalysisFieldsFragment = {
  __typename: 'SearchAnalysis';
} & Pick<
  ISearchAnalysis,
  | 'type'
  | 'name'
  | 'detail'
  | 'id'
  | 'queryType'
  | 'status'
  | 'createdAt'
  | 'editedAt'
  | 'updatedAt'
  | 'isDisabled'
> & {
    schema: { __typename: 'Schema' } & Pick<ISchema, 'id' | 'name'>;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    editor: { __typename: 'User' } & IEditorFieldsFragment;
  };

export type ISearchDashboardFolderFieldsFragment = {
  __typename: 'SearchDashboardFolder';
} & Pick<
  ISearchDashboardFolder,
  | 'type'
  | 'name'
  | 'detail'
  | 'id'
  | 'path'
  | 'createdAt'
  | 'editedAt'
  | 'updatedAt'
  | 'isDisabled'
> & {
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    editor: { __typename: 'User' } & IEditorFieldsFragment;
  };

export type ISearchScheduleFieldsFragment = {
  __typename: 'SearchSchedule';
} & Pick<
  ISearchSchedule,
  | 'type'
  | 'scheduleType'
  | 'name'
  | 'detail'
  | 'id'
  | 'createdAt'
  | 'editedAt'
  | 'updatedAt'
  | 'isDisabled'
> & {
    nullableSchema: Maybe<
      { __typename: 'Schema' } & Pick<ISchema, 'id' | 'name'>
    >;
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    editor: { __typename: 'User' } & IEditorFieldsFragment;
  };

export type ISearchItemFieldsFragment = { __typename: 'SearchItem' } & {
  entity:
    | ({ __typename: 'IdSearchEntity' } & IIdSearchEntityFieldsFragment)
    | ({ __typename: 'KeySearchEntity' } & IKeySearchEntityFieldsFragment)
    | ({
        __typename: 'SearchAnalysis';
      } & IUniversalSearchAnalysisFieldsFragment)
    | ({ __typename: 'SearchDashboard' } & ISearchDashboardFieldsFragment)
    | ({
        __typename: 'SearchDashboardFolder';
      } & ISearchDashboardFolderFieldsFragment)
    | ({ __typename: 'SearchSchedule' } & ISearchScheduleFieldsFragment);
  highlight: Array<
    { __typename: 'SearchHighlight' } & ISearchHighlightFieldsFragment
  >;
};

export type ISearchQueryVariables = Exact<{
  term: InputMaybe<Scalars['String']['input']>;
  types: Array<SearchEntityType> | SearchEntityType;
  schemaIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  categoryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  editorIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  failedReports: Scalars['Boolean']['input'];
  lastUpdateDateRange: InputMaybe<IDateRangeInput>;
  timezone: InputMaybe<Scalars['String']['input']>;
  isDisabled: InputMaybe<Scalars['Boolean']['input']>;
  favoriteOnly: Scalars['Boolean']['input'];
  queryTypes: Array<QueryType> | QueryType;
  pagination: IPagination;
  activeSchemas: Scalars['Boolean']['input'];
}>;

export type ISearchQuery = { __typename: 'Query' } & {
  search: { __typename: 'SearchPaginated' } & {
    entities: Array<{ __typename: 'SearchItem' } & ISearchItemFieldsFragment>;
    pageInfo: { __typename: 'PageInfo' } & IPageInfoFieldsFragment;
  };
};

export type IUserSettingUpdateMutationVariables = Exact<{
  input: IUserSettingUpdateInput;
}>;

export type IUserSettingUpdateMutation = { __typename: 'Mutation' } & {
  userSettingUpdate: { __typename: 'UserSettingPayload' } & {
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IBriefUserInfoFieldsFragment = { __typename: 'User' } & Pick<
  IUser,
  'id' | 'name' | 'email' | 'picture'
>;

export type ISearchUsersQueryVariables = Exact<{
  term: InputMaybe<Scalars['String']['input']>;
  includes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  pagination: IPagination;
  userStates: Array<UserState> | UserState;
}>;

export type ISearchUsersQuery = { __typename: 'Query' } & {
  users: { __typename: 'UsersPaginated' } & {
    entities: Array<{ __typename: 'User' } & IBriefUserInfoFieldsFragment>;
  };
};

export type IVirtualEventFieldsFragment = { __typename: 'VirtualEvent' } & Pick<
  IVirtualEvent,
  | 'kind'
  | 'comment'
  | 'description'
  | 'id'
  | 'name'
  | 'version'
  | 'isLatestVersion'
  | 'createdAt'
  | 'updatedAt'
  | 'isDisabled'
  | 'editedAt'
  | 'isFavorite'
  | 'isManaged'
> & {
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    editor: { __typename: 'User' } & IEditorFieldsFragment;
    schema: { __typename: 'Schema' } & ISchemaFieldsFragment;
    eventsConditions: Array<
      { __typename: 'EventCondition' } & {
        field: Maybe<{ __typename: 'Field' } & IFieldFieldsFragment>;
        events: Array<
          | ({ __typename: 'AnyEvent' } & IAnyEventFieldsFragment)
          | ({ __typename: 'AnyTableEvent' } & IAnyTableEventFieldsFragment)
          | ({ __typename: 'BasicEventValue' } & IBasicEventValueFieldsFragment)
          | { __typename: 'VirtualEvent' }
        >;
        filter: Maybe<
          | ({ __typename: 'BasicFilter' } & IFilterFields_BasicFilter_Fragment)
          | ({ __typename: 'NamedFilter' } & IFilterFields_NamedFilter_Fragment)
        >;
      }
    >;
    categories: Array<
      { __typename: 'EntityCategory' } & IEntityCategoryFieldsFragment
    >;
  };

export type ICreateVirtualEventMutationVariables = Exact<{
  input: IVirtualEventCreateInput;
}>;

export type ICreateVirtualEventMutation = { __typename: 'Mutation' } & {
  virtualEventCreate: { __typename: 'VirtualEventCreatePayload' } & {
    entity: Maybe<{ __typename: 'VirtualEvent' } & IVirtualEventFieldsFragment>;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IUpdateVirtualEventMutationVariables = Exact<{
  input: IVirtualEventEditInput;
}>;

export type IUpdateVirtualEventMutation = { __typename: 'Mutation' } & {
  virtualEventEdit: { __typename: 'VirtualEventEditPayload' } & {
    entity: Maybe<{ __typename: 'VirtualEvent' } & IVirtualEventFieldsFragment>;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IVirtualEventAddCategoryMutationVariables = Exact<{
  input: INamedEntityEditCategoryInput;
}>;

export type IVirtualEventAddCategoryMutation = { __typename: 'Mutation' } & {
  virtualEventAddCategory: {
    __typename: 'NamedEntityEditCategoryPayload';
  } & Pick<INamedEntityEditCategoryPayload, 'message'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type IVirtualEventRemoveCategoryMutationVariables = Exact<{
  input: INamedEntityEditCategoryInput;
}>;

export type IVirtualEventRemoveCategoryMutation = { __typename: 'Mutation' } & {
  virtualEventRemoveCategory: {
    __typename: 'NamedEntityEditCategoryPayload';
  } & Pick<INamedEntityEditCategoryPayload, 'message'> & {
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type ICreateNamedFilterMutationVariables = Exact<{
  input: INamedFilterCreateInput;
}>;

export type ICreateNamedFilterMutation = { __typename: 'Mutation' } & {
  namedFilterCreate: { __typename: 'NamedFilterCreatePayload' } & {
    entity: Maybe<{ __typename: 'NamedFilter' } & INamedFilterFieldsFragment>;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IUpdateNamedFilterMutationVariables = Exact<{
  input: INamedFilterEditInput;
}>;

export type IUpdateNamedFilterMutation = { __typename: 'Mutation' } & {
  namedFilterEdit: { __typename: 'NamedFilterEditPayload' } & {
    entity: Maybe<{ __typename: 'NamedFilter' } & INamedFilterFieldsFragment>;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IWorkspaceRowFieldsFragment = { __typename: 'WorkspaceRow' } & Pick<
  IWorkspaceRow,
  'id'
> & {
    analyses: Array<
      | ({ __typename: 'CohortSample' } & Pick<
          ICohortSample,
          'id' | 'display' | 'queryType'
        > & {
            pref: { __typename: 'AnalysisPref' } & Pick<
              IAnalysisPref,
              'chartPref'
            >;
          })
      | ({ __typename: 'DataTable' } & Pick<
          IDataTable,
          'id' | 'display' | 'queryType'
        > & {
            pref: { __typename: 'AnalysisPref' } & Pick<
              IAnalysisPref,
              'chartPref'
            >;
          })
      | ({ __typename: 'Expression' } & Pick<
          IExpression,
          'id' | 'display' | 'queryType'
        > & {
            pref: { __typename: 'AnalysisPref' } & Pick<
              IAnalysisPref,
              'chartPref'
            >;
          })
      | ({ __typename: 'Funnel' } & Pick<
          IFunnel,
          'id' | 'display' | 'queryType'
        > & {
            pref: { __typename: 'AnalysisPref' } & Pick<
              IAnalysisPref,
              'chartPref'
            >;
          })
      | ({ __typename: 'Path' } & Pick<
          IPath,
          'id' | 'display' | 'queryType'
        > & {
            pref: { __typename: 'AnalysisPref' } & Pick<
              IAnalysisPref,
              'chartPref'
            >;
          })
      | ({ __typename: 'Prediction' } & Pick<
          IPrediction,
          'id' | 'display' | 'queryType'
        > & {
            pref: { __typename: 'AnalysisPref' } & Pick<
              IAnalysisPref,
              'chartPref'
            >;
          })
      | ({ __typename: 'Retention' } & Pick<
          IRetention,
          'id' | 'display' | 'queryType'
        > & {
            pref: { __typename: 'AnalysisPref' } & Pick<
              IAnalysisPref,
              'chartPref'
            >;
          })
      | ({ __typename: 'Significance' } & Pick<
          ISignificance,
          'id' | 'display' | 'queryType'
        > & {
            pref: { __typename: 'AnalysisPref' } & Pick<
              IAnalysisPref,
              'chartPref'
            >;
          })
    >;
  };

export type IWorkspaceEntityFragment = { __typename: 'Workspace' } & Pick<
  IWorkspace,
  'id' | 'name' | 'description' | 'createdAt'
> & {
    creator: { __typename: 'User' } & ICreatorFieldsFragment;
    rows: Array<{ __typename: 'WorkspaceRow' } & IWorkspaceRowFieldsFragment>;
  };

export type IWorkspaceCreateMutationVariables = Exact<{
  input: IWorkspaceCreateInput;
}>;

export type IWorkspaceCreateMutation = { __typename: 'Mutation' } & {
  workspaceCreate: { __typename: 'WorkspaceCreatePayload' } & {
    entity: Maybe<{ __typename: 'Workspace' } & IWorkspaceEntityFragment>;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field' | 'messages'>>;
  };
};

export type IWorkspaceEditMutationVariables = Exact<{
  input: IWorkspaceEditInput;
}>;

export type IWorkspaceEditMutation = { __typename: 'Mutation' } & {
  workspaceEdit: { __typename: 'WorkspaceEditPayload' } & {
    entity: Maybe<{ __typename: 'Workspace' } & IWorkspaceEntityFragment>;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field' | 'messages'>>;
  };
};

export type IWorkspaceAddAnalysesMutationVariables = Exact<{
  input: IWsAddAnalysesInput;
}>;

export type IWorkspaceAddAnalysesMutation = { __typename: 'Mutation' } & {
  wsAddAnalyses: { __typename: 'WsAddAnalysesPayload' } & {
    entity: Maybe<{ __typename: 'Workspace' } & IWorkspaceEntityFragment>;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field' | 'messages'>>;
  };
};

export type IWorkspaceDeleteAnalysisMutationVariables = Exact<{
  input: IWsDeleteAnalysisInput;
}>;

export type IWorkspaceDeleteAnalysisMutation = { __typename: 'Mutation' } & {
  wsDeleteAnalysis: { __typename: 'WsDeleteAnalysisPayload' } & {
    entity: Maybe<{ __typename: 'Workspace' } & IWorkspaceEntityFragment>;
    errors: Array<{ __typename: 'Error' } & Pick<IError, 'field' | 'messages'>>;
  };
};

export type IWorkspaceReplaceAnalysesMutationVariables = Exact<{
  input: IWorkspaceReplaceAnalysisInput;
}>;

export type IWorkspaceReplaceAnalysesMutation = { __typename: 'Mutation' } & {
  wsReplaceAnalysis: { __typename: 'WsReplaceAnalysisPayload' } & Pick<
    IWsReplaceAnalysisPayload,
    'newAnalysisId' | 'warningMessage'
  > & {
      entity: Maybe<{ __typename: 'Workspace' } & IWorkspaceEntityFragment>;
      errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
    };
};

export type IWorkspaceDeleteMutationVariables = Exact<{
  input: IWorkspaceDeleteInput;
}>;

export type IWorkspaceDeleteMutation = { __typename: 'Mutation' } & {
  workspaceDelete: { __typename: 'WorkspaceDeletePayload' } & Pick<
    IWorkspaceDeletePayload,
    'message'
  > & {
      errors: Array<
        { __typename: 'Error' } & Pick<IError, 'field' | 'messages'>
      >;
    };
};

export type IWorkspaceToScratchpadMutationVariables = Exact<{
  input: IWorkspaceScratchpadConvertInput;
}>;

export type IWorkspaceToScratchpadMutation = { __typename: 'Mutation' } & {
  result: { __typename: 'WorkspaceScratchpadConvertPayload' } & {
    scratchpad: Maybe<
      { __typename: 'Scratchpad' } & Pick<IScratchpad, 'id' | 'title'>
    >;
    errors: Array<{ __typename: 'Error' } & IErrorFieldsFragment>;
  };
};

export type IWorkspaceListQueryVariables = Exact<{
  pagination: IPagination;
  includes: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  term: InputMaybe<Scalars['String']['input']>;
}>;

export type IWorkspaceListQuery = { __typename: 'Query' } & {
  workspaceList: Maybe<
    { __typename: 'WorkspacePaginated' } & {
      entities: Array<
        { __typename: 'Workspace' } & Pick<IWorkspace, 'id' | 'name'>
      >;
      pageInfo: { __typename: 'PageInfo' } & IPageInfoFieldsFragment;
    }
  >;
};

export type IGetWorkspaceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withLastViewedAt?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type IGetWorkspaceQuery = { __typename: 'Query' } & {
  workspace: Maybe<
    { __typename: 'Workspace' } & {
      main: { __typename: 'Channel' } & MakeMaybe<
        Pick<IChannel, 'id' | 'lastViewedAt'>,
        'lastViewedAt'
      >;
    } & IWorkspaceEntityFragment
  >;
};
